webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings_js__ = __webpack_require__(12);







var service = {
	getUser: function getUser(loginUser) {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_user', loginUser);
	},
	getUsers: function getUsers(ctx, filter) {
		var query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		query += '&search=' + ctx.filter;
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_users?' + query).then(function (response) {
			return response.data;
		});
	},
	getProdajalci: function getProdajalci() {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_prodajalci').then(function (response) {
			return response.data;
		});
	},
	addUser: function addUser(user) {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/add_user', user).then(function (response) {
			return response.data;
		});
	},
	removeUser: function removeUser(user) {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/remove_user', user).then(function (response) {
			return response.data;
		});
	},
	addFiltersToQueryVozilaFiltered: function addFiltersToQueryVozilaFiltered(filter, user) {
		var filtersQuery = '';
		if (filter.konto_destinacije) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filter.konto_destinacije), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					filtersQuery += '&konto[]=' + encodeURIComponent(item);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
		filtersQuery += '&st_narocila_kupca=' + encodeURIComponent(filter.st_narocila_kupca);
		filtersQuery += '&st_narocila_vozila=' + encodeURIComponent(filter.st_narocila_vozila);
		filtersQuery += '&ogrodje=' + encodeURIComponent(filter.ogrodje);
		filtersQuery += '&model=' + encodeURIComponent(filter.model);
		filtersQuery += '&verzija=' + encodeURIComponent(filter.verzija);
		filtersQuery += '&barva=' + encodeURIComponent(filter.barva);
		filtersQuery += '&staranje=' + encodeURIComponent(filter.staranje);
		filtersQuery += '&vega_dhsVegaSalesId=' + encodeURIComponent(filter.vega_dhsVegaSalesId);
		filtersQuery += '&vega_brand=' + encodeURIComponent(filter.vega_brand);
		filtersQuery += '&vega_status=' + encodeURIComponent(filter.vega_status);
		filtersQuery += '&predvideni_mada=' + encodeURIComponent(filter.predvideni_mada);
		if (filter.stanje) {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filter.stanje), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _item = _step2.value;

					filtersQuery += '&stanje[]=' + encodeURIComponent(_item);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
		if (filter.status) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filter.status), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _item2 = _step3.value;

					filtersQuery += '&status[]=' + encodeURIComponent(_item2);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		}
		if (filter.lokacije) {
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filter.lokacije), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var _item3 = _step4.value;

					filtersQuery += '&lokacije[]=' + encodeURIComponent(_item3);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
		}
		if (filter.prodaja) {
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filter.prodaja), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var _item4 = _step5.value;

					filtersQuery += '&prodaja[]=' + encodeURIComponent(_item4);
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}
		}
		if (filter.prodajalec) {
			filtersQuery += '&prodajalec=' + filter.prodajalec;
		}
		if (filter.kupec) {
			filtersQuery += '&kupec=' + filter.kupec;
		}
		if (filter.rmadc) {
			filtersQuery += '&rmadcstart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.rmadc.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&rmadcend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.rmadc.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.pmadc) {
			filtersQuery += '&pmadcstart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.pmadc.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&pmadcend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.pmadc.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.omada) {
			filtersQuery += '&omadastart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.omada.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&omadaend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.omada.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.pdp) {
			filtersQuery += '&pdpstart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.pdp.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&pdpend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.pdp.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.datum_prve_registracije) {
			filtersQuery += '&datum_prve_registracije_start=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_prve_registracije.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&datum_prve_registracije_end=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_prve_registracije.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.datum_kdaj_ga_moramo_prodati) {
			filtersQuery += '&datum_kdaj_ga_moramo_prodati_start=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_kdaj_ga_moramo_prodati.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&datum_kdaj_ga_moramo_prodati_end=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_kdaj_ga_moramo_prodati.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.datum_kdaj_ga_lahko_prodamo) {
			filtersQuery += '&datum_kdaj_ga_lahko_prodamo_start=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_kdaj_ga_lahko_prodamo.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + 'datum_kdaj_ga_lahko_prodamo_end=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_kdaj_ga_lahko_prodamo.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.obljubljenaDobava) {
			filtersQuery += '&odstart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.obljubljenaDobava.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&odend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.obljubljenaDobava.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		filtersQuery += '&arhiv=' + encodeURIComponent(filter.arhiv);
		filtersQuery += '&nissan=' + encodeURIComponent(filter.nissan);
		filtersQuery += '&manual=' + encodeURIComponent(filter.manual);
		filtersQuery += '&user_id=' + encodeURIComponent(user.dbid);
		filtersQuery += '&user_role=' + encodeURIComponent(user.role);
		return filtersQuery;
	},
	getVozilaFiltered: function getVozilaFiltered(ctx, filter, user) {
		var query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		query += '&search=' + encodeURIComponent(ctx.filter);
		query += this.addFiltersToQueryVozilaFiltered(filter, user);
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/items?' + query).then(function (response) {
			return response.data;
		});
	},
	getVozilaToConfirm: function getVozilaToConfirm(ctx, filter) {
		var query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		if (filter.ogrodje) {
			query += '&ogrodje=' + filter.ogrodje;
		}
		if (filter.libelle_modele) {
			query += '&libelle_modele=' + filter.libelle_modele;
		}
		if (filter.libelle_version) {
			query += '&libelle_version=' + filter.libelle_version;
		}
		if (filter.p_prodajalec_name) {
			query += '&p_prodajalec_name=' + filter.p_prodajalec_name;
		}
		if (filter.st_racuna) {
			query += '&st_racuna=' + filter.st_racuna;
		}
		if (filter.datum_racunovodja_potrdil) {
			query += '&datum_racunovodja_potrdil_start=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_racunovodja_potrdil.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&datum_racunovodja_potrdil_end=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum_racunovodja_potrdil.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_vozila_to_confirm?' + query).then(function (response) {
			return response.data;
		});
	},
	getRacuniZaIzstavit: function getRacuniZaIzstavit(ctx, user) {
		var query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&user_role=' + encodeURIComponent(user.role);
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_racuni_za_izstavit?' + query).then(function (response) {
			return response.data;
		});
	},
	searchVozila: function searchVozila(qs) {
		var args = {
			qs: qs
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/search', args).then(function (response) {
			return response.data;
		});
	},
	uvoziVozila: function uvoziVozila(zalogaRenault, prodajaRenault, zalogaDacia, prodajaDacia) {
		var args = {
			zalogaRenault: zalogaRenault,
			prodajaRenault: prodajaRenault,
			zalogaDacia: zalogaDacia,
			prodajaDacia: prodajaDacia
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/import', args).then(function (response) {
			return response.data;
		});
	},
	rezervirajVozilo: function rezervirajVozilo(itemId, prodajalec, kupec, trajanje) {
		var args = {
			itemId: itemId,
			prodajalec: prodajalec,
			kupec: kupec,
			trajanje: trajanje
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/reserve', args).then(function (response) {
			return response.data;
		});
	},
	prodajVozilo: function prodajVozilo(itemId, prodajaId, prodajalec, kupec, datumProdaje, datumPlaniraneIzdaje, urejenoFinanciranje, vlozeno, podpisano, financiranjeRci, external) {
		var args = {
			itemId: itemId,
			prodajaId: prodajaId,
			prodajalec: prodajalec,
			kupec: kupec,
			datumProdaje: datumProdaje,
			datumPlaniraneIzdaje: datumPlaniraneIzdaje,
			urejenoFinanciranje: urejenoFinanciranje,
			vlozeno: vlozeno,
			podpisano: podpisano,
			financiranje_rci: financiranjeRci,
			external: external
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/sell', args).then(function (response) {
			return response.data;
		});
	},
	stornirajProdajo: function stornirajProdajo(prodajaId) {
		var args = {
			prodajaId: prodajaId
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/cancel_sell', args).then(function (response) {
			return response.data;
		});
	},
	stornirajRezervacijo: function stornirajRezervacijo(rezervacijaId) {
		var args = {
			rezervacijaId: rezervacijaId
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/cancel_reservation', args).then(function (response) {
			return response.data;
		});
	},
	dobavivKoncesijo: function dobavivKoncesijo(itemId, prodajalec, lokacija, datumDobave) {
		var args = {
			itemId: itemId,
			prodajalec: prodajalec,
			lokacija: lokacija,
			datumDobave: datumDobave
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/dobavavkoncesijo', args).then(function (response) {
			return response.data;
		});
	},
	zadrziVozilo: function zadrziVozilo(itemId, lastnik) {
		var args = {
			itemId: itemId,
			lastnik: lastnik
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/zadrzivozilo', args).then(function (response) {
			return response.data;
		});
	},
	urediOpomboVozilo: function urediOpomboVozilo(itemId, opomba, akcijski) {
		var args = {
			itemId: itemId,
			opomba: opomba,
			akcijski: akcijski
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/urediopombovozila', args).then(function (response) {
			return response.data;
		});
	},
	getIzdaje: function getIzdaje(start, end) {
		var args = {
			start: start,
			end: end
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/getizdaje', args).then(function (response) {
			return response.data;
		});
	},
	dodajIzdajo: function dodajIzdajo(izdajaId, prodajalec, kupec, datumIzdaje, voziloInt, voziloExt, opomba) {
		var args = {
			izdajaId: izdajaId,
			prodajalec: prodajalec,
			kupec: kupec,
			datumIzdaje: datumIzdaje,
			voziloInt: voziloInt,
			voziloExt: voziloExt,
			opomba: opomba
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/dodajizdajo', args).then(function (response) {
			return response.data;
		});
	},
	odstraniIzdajo: function odstraniIzdajo(izdajaId) {
		var args = {
			izdajaId: izdajaId
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/odstraniizdajo', args).then(function (response) {
			return response.data;
		});
	},
	getKupci: function getKupci() {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_kupci').then(function (response) {
			return response.data;
		});
	},
	searchKupci: function searchKupci(qs) {
		var args = {
			qs: qs
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/search_kupci', args).then(function (response) {
			return response.data;
		});
	},
	searchKupecById: function searchKupecById(id) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/search_kupec_by_id', args, config).then(function (response) {
			return response.data;
		});
	},
	getKupciFiltered: function getKupciFiltered(ctx, filter) {
		var query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		query += '&search=' + ctx.filter;
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_kupci_filtered?' + query).then(function (response) {
			return response.data;
		});
	},
	addKupec: function addKupec(kupec) {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/add_kupec', kupec).then(function (response) {
			return response.data;
		});
	},
	removeKupec: function removeKupec(kupec) {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/remove_kupec', kupec).then(function (response) {
			return response.data;
		});
	},
	saveMapa: function saveMapa(itemId, podaljsanoJamstvoPicked, podaljsanoJamstvoLeta, podaljsanoJamstvoKm, podaljsanoJamstvoZnesek, podaljsanoJamstvoOpomba, zavarovanjePicked, zavarovanjeOpomba, myrPicked, myrLeta, myrKm, myrZnesek, myrOpomba, gapPicked, gapOpomba, bniPicked, bniOpomba, bonus1, bonus2, bonus3, bonus4, bonus5, bonus6, ostaliDogovori, nultiPicked, ciscenje, klicStranke, stRacuna, datumRacuna, prodajnaCena, skupniZnesek, rciLizing, rciKredit, starost, nakazila, nakazilaToDelete, povracila, povracilaToDelete, oprema, dodatneopremeToDelete, stopnjaDDV) {
		if (datumRacuna) {
			datumRacuna = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(datumRacuna, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
		}
		var _iteratorNormalCompletion6 = true;
		var _didIteratorError6 = false;
		var _iteratorError6 = undefined;

		try {
			for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(nakazila), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
				var nakazilo = _step6.value;

				if (nakazilo['datum']) {
					nakazilo['datum'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(nakazilo['datum'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
			}
		} catch (err) {
			_didIteratorError6 = true;
			_iteratorError6 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion6 && _iterator6.return) {
					_iterator6.return();
				}
			} finally {
				if (_didIteratorError6) {
					throw _iteratorError6;
				}
			}
		}

		var _iteratorNormalCompletion7 = true;
		var _didIteratorError7 = false;
		var _iteratorError7 = undefined;

		try {
			for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(povracila), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
				var povracilo = _step7.value;

				if (povracilo['datum']) {
					povracilo['datum'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(povracilo['datum'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
			}
		} catch (err) {
			_didIteratorError7 = true;
			_iteratorError7 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion7 && _iterator7.return) {
					_iterator7.return();
				}
			} finally {
				if (_didIteratorError7) {
					throw _iteratorError7;
				}
			}
		}

		var _iteratorNormalCompletion8 = true;
		var _didIteratorError8 = false;
		var _iteratorError8 = undefined;

		try {
			for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(oprema), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
				var dodatnaoprema = _step8.value;

				if (dodatnaoprema['datum_narocila']) {
					dodatnaoprema['datum_narocila'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(dodatnaoprema['datum_narocila'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
			}
		} catch (err) {
			_didIteratorError8 = true;
			_iteratorError8 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion8 && _iterator8.return) {
					_iterator8.return();
				}
			} finally {
				if (_didIteratorError8) {
					throw _iteratorError8;
				}
			}
		}

		var args = {
			item: itemId,
			podaljsano_jamstvo: podaljsanoJamstvoPicked,
			podaljsano_jamstvo_leta: podaljsanoJamstvoLeta,
			podaljsano_jamstvo_km: podaljsanoJamstvoKm,
			podaljsano_jamstvo_znesek: podaljsanoJamstvoZnesek,
			podaljsano_jamstvo_opomba: podaljsanoJamstvoOpomba,
			zavarovanje: zavarovanjePicked,
			zavarovanje_opomba: zavarovanjeOpomba,
			myr: myrPicked,
			myr_leta: myrLeta,
			myr_km: myrKm,
			myr_znesek: myrZnesek,
			myr_opomba: myrOpomba,
			gap: gapPicked,
			gap_opomba: gapOpomba,
			bni: bniPicked,
			bni_opomba: bniOpomba,
			bonus1: bonus1,
			bonus2: bonus2,
			bonus3: bonus3,
			bonus4: bonus4,
			bonus5: bonus5,
			bonus6: bonus6,
			ostali_dogovori: ostaliDogovori,
			nulti: nultiPicked,
			ciscenje: ciscenje,
			klic_stranke: klicStranke,
			st_racuna: stRacuna,
			datum_racuna: datumRacuna,
			prodajna_cena: prodajnaCena,
			skupni_znesek: skupniZnesek,
			rci_lizing: rciLizing,
			rci_kredit: rciKredit,
			starost: starost,
			nakazila: nakazila,
			nakazila_to_delete: nakazilaToDelete,
			povracila: povracila,
			povracila_to_delete: povracilaToDelete,
			dodatneopreme: oprema,
			dodatneopreme_to_delete: dodatneopremeToDelete,
			stopnja_ddv: stopnjaDDV
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/save_mapa', args).then(function (response) {
			return response.data;
		});
	},
	getMapa: function getMapa(itemId) {
		var args = {
			item: itemId
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_mapa', args).then(function (response) {
			if (!response.data) {
				return null;
			}
			if (!response.data['mapa'] || response.data['mapa'] === false) {
				return null;
			}
			if (response.data['mapa']['datum_racuna']) {
				response.data['mapa']['datum_racuna'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['mapa']['datum_racuna'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
			}
			if (response.data['mapa']['datum_prodajalec_potrdil']) {
				response.data['mapa']['datum_prodajalec_potrdil'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['mapa']['datum_prodajalec_potrdil'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
			}
			if (response.data['mapa']['datum_sekretar_potrdil']) {
				response.data['mapa']['datum_sekretar_potrdil'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['mapa']['datum_sekretar_potrdil'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
			}
			if (response.data['mapa']['datum_admin_potrdil']) {
				response.data['mapa']['datum_admin_potrdil'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['mapa']['datum_admin_potrdil'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
			}
			var _iteratorNormalCompletion9 = true;
			var _didIteratorError9 = false;
			var _iteratorError9 = undefined;

			try {
				for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response.data['mapa']['nakazila']), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
					var nakaziloFromDb = _step9.value;

					if (nakaziloFromDb['datum']) {
						nakaziloFromDb['datum'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(nakaziloFromDb['datum'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
					}
				}
			} catch (err) {
				_didIteratorError9 = true;
				_iteratorError9 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion9 && _iterator9.return) {
						_iterator9.return();
					}
				} finally {
					if (_didIteratorError9) {
						throw _iteratorError9;
					}
				}
			}

			var _iteratorNormalCompletion10 = true;
			var _didIteratorError10 = false;
			var _iteratorError10 = undefined;

			try {
				for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response.data['mapa']['povracila']), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
					var povraciloFromDb = _step10.value;

					if (povraciloFromDb['datum']) {
						povraciloFromDb['datum'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(povraciloFromDb['datum'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
					}
				}
			} catch (err) {
				_didIteratorError10 = true;
				_iteratorError10 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion10 && _iterator10.return) {
						_iterator10.return();
					}
				} finally {
					if (_didIteratorError10) {
						throw _iteratorError10;
					}
				}
			}

			var _iteratorNormalCompletion11 = true;
			var _didIteratorError11 = false;
			var _iteratorError11 = undefined;

			try {
				for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response.data['mapa']['dodatneopreme']), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
					var dodatnaOpremaFromDb = _step11.value;

					if (dodatnaOpremaFromDb['datum_narocila']) {
						dodatnaOpremaFromDb['datum_narocila'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(dodatnaOpremaFromDb['datum_narocila'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
					}
				}
			} catch (err) {
				_didIteratorError11 = true;
				_iteratorError11 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion11 && _iterator11.return) {
						_iterator11.return();
					}
				} finally {
					if (_didIteratorError11) {
						throw _iteratorError11;
					}
				}
			}

			return response.data;
		});
	},
	saveMapaUserPotrdil: function saveMapaUserPotrdil(itemId) {
		var args = {
			item: itemId
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/mapa_user_potrdil', args).then(function (response) {
			if (!response.data || response.data === false) {
				return null;
			}
			return response.data;
		});
	},
	mapaRemoveUserPotrdil: function mapaRemoveUserPotrdil(itemId, removeAkcija) {
		var args = {
			item: itemId,
			akcija: removeAkcija
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/mapa_remove_user_potrdil', args).then(function (response) {
			if (!response.data || response.data === false) {
				return null;
			}
			return response.data;
		});
	},
	getMFilesInfo: function getMFilesInfo(itemId) {
		var args = {
			itemId: itemId
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/mfiles_info', args).then(function (response) {
			return response.data;
		});
	},
	priliviUpload: function priliviUpload(tipPriliva, importText, importFile) {
		var args = new FormData();
		args.append('tip_priliva', tipPriliva);
		if (importText) {
			args.append('import_text', importText);
		}
		if (importFile) {
			args.append('import_file', importFile, importFile.name);
		}
		var settings = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/prilivi_upload', args, settings).then(function (response) {
			return response.data;
		});
	},
	priliviSave: function priliviSave(items) {
		var args = {
			items: items
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/prilivi_save', args).then(function (response) {
			return response.data;
		});
	},
	removePriliv: function removePriliv(id) {
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/remove_priliv', args).then(function (response) {
			return response.data;
		});
	},
	getPriliviFiltered: function getPriliviFiltered(ctx, filter, user) {
		var query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		query += '&search=' + encodeURIComponent(ctx.filter);
		if (filter.datum) {
			query += '&datumstart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&datumend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		query += '&ogrodje=' + encodeURIComponent(filter.ogrodje);
		query += '&placnik=' + encodeURIComponent(filter.placnik);
		query += '&naziv=' + encodeURIComponent(filter.naziv);
		query += '&referenca=' + encodeURIComponent(filter.referenca);
		if (filter.znesek) {
			if (filter.znesek.value) {
				query += '&znesek=' + encodeURIComponent(filter.znesek.value);
			} else if (filter.znesek.min && filter.znesek.max) {
				query += '&znesek[]=' + encodeURIComponent(filter.znesek.min);
				query += '&znesek[]=' + encodeURIComponent(filter.znesek.max);
			}
		}
		if (filter.vir) {
			var _iteratorNormalCompletion12 = true;
			var _didIteratorError12 = false;
			var _iteratorError12 = undefined;

			try {
				for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filter.vir), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
					var item = _step12.value;

					query += '&vir[]=' + encodeURIComponent(item);
				}
			} catch (err) {
				_didIteratorError12 = true;
				_iteratorError12 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion12 && _iterator12.return) {
						_iterator12.return();
					}
				} finally {
					if (_didIteratorError12) {
						throw _iteratorError12;
					}
				}
			}
		}
		query += '&user_id=' + encodeURIComponent(user.dbid);
		query += '&user_role=' + encodeURIComponent(user.role);
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_prilivi_filtered?' + query).then(function (response) {
			return response.data;
		});
	},
	addPriliv: function addPriliv(priliv) {
		if (priliv['datum']) {
			priliv['datum'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(priliv['datum'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
		}
		var args = {
			id: priliv['id'],
			id_vozila: priliv['id_vozila'],
			datum: priliv['datum'],
			naziv: priliv['naziv'],
			referenca: priliv['referenca'],
			znesek: priliv['znesek'],
			placnik: priliv['placnik']
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/add_priliv', args).then(function (response) {
			return response.data;
		});
	},
	povracilaUpload: function povracilaUpload(tipPovracila, importFile) {
		var args = new FormData();
		args.append('tip_povracila', tipPovracila);
		if (importFile) {
			args.append('import_file', importFile, importFile.name);
		}
		var settings = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/povracila_data_upload', args, settings).then(function (response) {
			return response.data;
		});
	},
	povracilaSave: function povracilaSave(items) {
		var args = {
			items: items
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/povracila_data_save', args).then(function (response) {
			return response.data;
		});
	},
	getPovracilaFiltered: function getPovracilaFiltered(ctx, filter, user) {
		var query = 'page=' + encodeURIComponent(ctx.currentPage);
		query += '&size=' + encodeURIComponent(ctx.perPage);
		query += '&sort=' + encodeURIComponent(ctx.sortBy);
		query += '&desc=' + encodeURIComponent(ctx.sortDesc);
		query += '&search=' + encodeURIComponent(ctx.filter);
		if (filter.datum) {
			query += '&datumstart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&datumend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(filter.datum.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (filter.chassis) {
			query += '&chassis=' + encodeURIComponent(filter.chassis);
		}
		if (filter.action_name) {
			query += '&action_name=' + encodeURIComponent(filter.action_name);
		}
		if (filter.sale_channel) {
			query += '&sale_channel=' + encodeURIComponent(filter.sale_channel);
		}
		if (filter.amount) {
			if (filter.amount.value) {
				query += '&amount=' + encodeURIComponent(filter.amount.value);
			} else if (filter.amount.min && filter.amount.max) {
				query += '&amount[]=' + encodeURIComponent(filter.amount.min);
				query += '&amount[]=' + encodeURIComponent(filter.amount.max);
			}
		}
		if (filter.statusPovracila) {
			var _iteratorNormalCompletion13 = true;
			var _didIteratorError13 = false;
			var _iteratorError13 = undefined;

			try {
				for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filter.statusPovracila), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
					var item = _step13.value;

					query += '&status[]=' + encodeURIComponent(item);
				}
			} catch (err) {
				_didIteratorError13 = true;
				_iteratorError13 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion13 && _iterator13.return) {
						_iterator13.return();
					}
				} finally {
					if (_didIteratorError13) {
						throw _iteratorError13;
					}
				}
			}
		}
		query += '&user_id=' + encodeURIComponent(user.dbid);
		query += '&user_role=' + encodeURIComponent(user.role);
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_povracila_filtered?' + query).then(function (response) {
			return response.data;
		});
	},
	removePovracilo: function removePovracilo(id) {
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/remove_povracilo', args).then(function (response) {
			return response.data;
		});
	},
	addPovracilo: function addPovracilo(povraciloData) {
		if (povraciloData['creditnotedate']) {
			povraciloData['creditnotedate'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(povraciloData['creditnotedate'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
		}
		var args = {
			id: povraciloData['id'],
			id_vozila: povraciloData['id_vozila'],
			creditnotedate: povraciloData['creditnotedate'],
			opomba: povraciloData['opomba'],
			status: povraciloData['status'],
			chassis: povraciloData['chassis'],
			policy: povraciloData['policy'],
			campaign: povraciloData['campaign'],
			action_name: povraciloData['action_name'],
			sale_channel: povraciloData['sale_channel'],
			month: povraciloData['month'],
			amount: povraciloData['amount'],
			numdoc: povraciloData['numdoc'],
			dealer_name: povraciloData['dealer_name'],
			discount: povraciloData['discount'],
			contribution: povraciloData['contribution'],
			v2_vozilo_opis: povraciloData['v2_vozilo_opis'],
			v2_gc: povraciloData['v2_gc'],
			v2_gc_odobreno: povraciloData['v2_gc_odobreno'],
			v2_marza_opcij: povraciloData['v2_marza_opcij'],
			v2_marza_opcij_odobreno: povraciloData['v2_marza_opcij_odobreno'],
			v2_dmv_dacia_zahtevano: povraciloData['v2_dmv_dacia_zahtevano'],
			v2_dmv_dacia_odobreno: povraciloData['v2_dmv_dacia_odobreno'],
			v2_ka1_naziv: povraciloData['v2_ka1_naziv'],
			v2_ka1_zahtevano: povraciloData['v2_ka1_zahtevano'],
			v2_ka1_odobreno: povraciloData['v2_ka1_odobreno'],
			v2_ka2_naziv: povraciloData['v2_ka2_naziv'],
			v2_ka2_zahtevano: povraciloData['v2_ka2_zahtevano'],
			v2_ka2_odobreno: povraciloData['v2_ka2_odobreno'],
			v2_ka3_naziv: povraciloData['v2_ka3_naziv'],
			v2_ka3_zahtevano: povraciloData['v2_ka3_zahtevano'],
			v2_ka3_odobreno: povraciloData['v2_ka3_odobreno'],
			v2_skupaj_zahtevano: povraciloData['v2_skupaj_zahtevano'],
			v2_komentar: povraciloData['v2_komentar'],
			v2_komentar_uvoznik: povraciloData['v2_komentar_uvoznik']
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/add_povracilo', args).then(function (response) {
			return response.data;
		});
	},
	relateVoziloPovracilo: function relateVoziloPovracilo(ogrodje, idPovracila) {
		var args = {
			ogrodje: ogrodje,
			idPovracila: idPovracila
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/relate_vozilo_povracilo', args).then(function (response) {
			return response.data;
		});
	},
	saveVozilo: function saveVozilo(data) {
		var itemData = {};
		itemData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(itemData, data);
		if (itemData['predvideni_mada']) {
			itemData['predvideni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['predvideni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['realni_mada']) {
			itemData['realni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['realni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_zps']) {
			itemData['datum_zps'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_zps'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_zds']) {
			itemData['datum_zds'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_zds'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['realni_madc']) {
			itemData['realni_madc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['realni_madc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['predvideni_madc']) {
			itemData['predvideni_madc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['predvideni_madc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_fakturiranja']) {
			itemData['datum_fakturiranja'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_fakturiranja'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_ddk']) {
			itemData['datum_ddk'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_ddk'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_kddk']) {
			itemData['datum_kddk'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_kddk'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_vnosa_nk']) {
			itemData['datum_vnosa_nk'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_vnosa_nk'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['dejanski_datum_dodelitve']) {
			itemData['dejanski_datum_dodelitve'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['dejanski_datum_dodelitve'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['dejanski_datum_stornacije']) {
			itemData['dejanski_datum_stornacije'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['dejanski_datum_stornacije'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_izhoda_iz_oc']) {
			itemData['datum_izhoda_iz_oc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_izhoda_iz_oc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['koncesija_datum']) {
			itemData['koncesija_datum'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['koncesija_datum'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['realni_ara']) {
			itemData['realni_ara'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['realni_ara'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_prve_registracije']) {
			itemData['datum_prve_registracije'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_prve_registracije'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_kdaj_ga_lahko_prodamo']) {
			itemData['datum_kdaj_ga_lahko_prodamo'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_kdaj_ga_lahko_prodamo'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}if (itemData['datum_kdaj_ga_moramo_prodati']) {
			itemData['datum_kdaj_ga_moramo_prodati'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(itemData['datum_kdaj_ga_moramo_prodati'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].vozilaImportDFormat);
		}
		if (itemData['konto'] !== '') {
			itemData['konto_destinacije'] = itemData['konto'];
		}
		var args = {
			id: itemData['id'],
			ogrodje: itemData['ogrodje'],
			vozilo: itemData['vozilo'],
			st_narocila_vozila: itemData['st_narocila_vozila'],
			st_narocila_kupca: itemData['st_narocila_kupca'],
			libelle_modele: itemData['libelle_modele'],
			libelle_version: itemData['libelle_version'],
			libelle_options: itemData['libelle_options'],
			libelle_teinte: itemData['libelle_teinte'],
			libelle_harmonie: itemData['libelle_harmonie'],
			libelle_sellerie: itemData['libelle_sellerie'],
			source_file: itemData['source_file'],
			st_nm: itemData['st_nm'],
			konto_lastnika: itemData['konto_lastnika'],
			drzava_fiche_gamme: itemData['drzava_fiche_gamme'],
			tip_narocila_vozila: itemData['tip_narocila_vozila'],
			vozilo_na_borzi: itemData['vozilo_na_borzi'],
			obljubljeni_mada: itemData['obljubljeni_mada'],
			predvideni_mada: itemData['predvideni_mada'],
			staranje: itemData['staranje'],
			realni_mada: itemData['realni_mada'],
			stanje_napredovanja: itemData['stanje_napredovanja'],
			opomba_vozilo: itemData['opomba_vozilo'],
			model: itemData['model'],
			verzija: itemData['verzija'],
			opcije: itemData['opcije'],
			barva: itemData['barva'],
			notranjost: itemData['notranjost'],
			oblazinjenje: itemData['oblazinjenje'],
			nivo_kvalitete: itemData['nivo_kvalitete'],
			sprememba: itemData['sprememba'],
			datum_zps: itemData['datum_zps'],
			datum_zds: itemData['datum_zds'],
			konto_naslovnika: itemData['konto_naslovnika'],
			koda_prodajalca: itemData['koda_prodajalca'],
			realni_madc: itemData['realni_madc'],
			predvideni_madc: itemData['predvideni_madc'],
			pristanisce_vkrcanja: itemData['pristanisce_vkrcanja'],
			ime_ladje: itemData['ime_ladje'],
			rezervirano_vozilo: itemData['rezervirano_vozilo'],
			maskirano_vozilo: itemData['maskirano_vozilo'],
			skrito_vozilo: itemData['skrito_vozilo'],
			viop: itemData['viop'],
			datum_fakturiranja: itemData['datum_fakturiranja'],
			datum_vnosa_nk: itemData['datum_vnosa_nk'],
			datum_ddk: itemData['datum_ddk'],
			datum_kddk: itemData['datum_kddk'],
			kupec: itemData['kupec'],
			konto_agenta_satelita: itemData['konto_agenta_satelita'],
			konto_destinacije: itemData['konto_destinacije'],
			koda_prod: itemData['koda_prod'],
			dejanski_datum_dodelitve: itemData['dejanski_datum_dodelitve'],
			dejanski_datum_stornacije: itemData['dejanski_datum_stornacije'],
			tip_kupca: itemData['tip_kupca'],
			prodajni_kanal: itemData['prodajni_kanal'],
			tip_nm: itemData['tip_nm'],
			ime: itemData['ime'],
			email: itemData['email'],
			telefon_privatni: itemData['telefon_privatni'],
			st_pogodbe_v_advensysu: itemData['st_pogodbe_v_advensysu'],
			stanje_narocila_kupca: itemData['stanje_narocila_kupca'],
			status_kvalitete: itemData['status_kvalitete'],
			realni_ara: itemData['realni_ara'],
			nef: itemData['nef'],
			ddo: itemData['ddo'],
			ddpp: itemData['ddpp'],
			blocage_financier: itemData['blocage_financier'],
			blokada_komerciale: itemData['blokada_komerciale'],
			blokada_cata: itemData['blokada_cata'],
			blokada_kvalitete: itemData['blokada_kvalitete'],
			pgeo_bcv: itemData['pgeo_bcv'],
			koncesija_lokacija: itemData['koncesija_lokacija'],
			koncesija_datum: itemData['koncesija_datum'],
			koncesija_prodajalec: itemData['koncesija_prodajalec'],
			zadrzano_lastnik: itemData['zadrzano_lastnik'],
			interna_opomba: itemData['interna_opomba'],
			akcijski: itemData['akcijski'],
			datum_izhoda_iz_oc: itemData['datum_izhoda_iz_oc'],
			opomba_narocilo_kupca: itemData['opomba_narocilo_kupca'],
			datum_prve_registracije: itemData['datum_prve_registracije'],
			datum_kdaj_ga_lahko_prodamo: itemData['datum_kdaj_ga_lahko_prodamo'],
			datum_kdaj_ga_moramo_prodati: itemData['datum_kdaj_ga_moramo_prodati'],
			st_kilometrov: itemData['st_kilometrov'],
			prodajna_cena: itemData['prodajna_cena']
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/save_vozilo', args).then(function (response) {
			return response.data;
		});
	},
	exportItemsData: function exportItemsData(data) {
		var args = {};
		var query = '';
		if (data.exportAll === true) {
			args = {
				exportAll: 1
			};
			query = '?' + this.addFiltersToQueryVozilaFiltered(data.filter, data.user);
		} else {
			args = {
				exportAll: 0,
				items: data.items
			};
		}
		var cfg = {
			responseType: 'blob'
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/export_itemsdata' + query, args, cfg).then(function (response) {
			return response;
		});
	},
	removeImportdata: function removeImportdata(id, sourceFile) {
		var args = {
			id: id,
			source_file: sourceFile
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/remove_importdata', args).then(function (response) {
			return response.data;
		});
	},
	archiveImportdata: function archiveImportdata(id) {
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/archive_importdata', args).then(function (response) {
			return response.data;
		});
	},
	uploadFilesForMapa: function uploadFilesForMapa(importFiles, modalData) {
		var args = new FormData();
		args.append('item', modalData);
		console.log(importFiles);
		if (importFiles) {
			var _iteratorNormalCompletion14 = true;
			var _didIteratorError14 = false;
			var _iteratorError14 = undefined;

			try {
				for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(importFiles), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
					var file = _step14.value;

					args.append('import_files[]', file, file.name);
				}
			} catch (err) {
				_didIteratorError14 = true;
				_iteratorError14 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion14 && _iterator14.return) {
						_iterator14.return();
					}
				} finally {
					if (_didIteratorError14) {
						throw _iteratorError14;
					}
				}
			}
		}
		var settings = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/upload_files_for_mapa', args, settings).then(function (response) {
			return response.data;
		});
	},
	getFilesOfMapa: function getFilesOfMapa(item) {
		var args = {
			item: item
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_files_of_mapa', args).then(function (response) {
			return response.data;
		});
	},
	removeFileOfMapa: function removeFileOfMapa(id) {
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/remove_file_of_mapa', args).then(function (response) {
			return response.data;
		});
	},
	downloadFileOfMapa: function downloadFileOfMapa(id) {
		var args = {
			id: id
		};
		var headers = { 'responseType': 'arraybuffer' };
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/download_file_of_mapa', args, headers).then(function (response) {
			return response;
		});
	},
	uvoziNissan: function uvoziNissan(zalogaNissan) {
		var args = {
			zalogaNissan: zalogaNissan
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/import_nissan', args).then(function (response) {
			return response.data;
		});
	},
	uvoziVega: function uvoziVega(vega) {
		var args = {
			vega: vega
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/import_vega', args).then(function (response) {
			return response.data;
		});
	},
	saveMapaZeljenaIzstavitevRacuna: function saveMapaZeljenaIzstavitevRacuna(itemId, zeljeniDatumCas) {
		var args = {
			item: itemId,
			zeljeni_datum: zeljeniDatumCas
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/mapa_zeljeni_racun', args).then(function (response) {
			if (!response.data || response.data === false) {
				return null;
			}
			return response.data;
		});
	},
	MapaIzstaviRacun: function MapaIzstaviRacun(mapaId) {
		var args = {
			mapa_id: mapaId
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/mapa_izstavitev_racuna', args).then(function (response) {
			return response.data;
		});
	},
	getImportdata: function getImportdata(id) {
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_importdata', args).then(function (response) {
			if (!response.data) {
				return null;
			}
			if (!response.data['importdata'] || response.data['importdata'] === false) {
				return null;
			}
			if (response.data['status'] === 'ok') {
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['realni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['predvideni_mada']) {
					response.data['importdata']['predvideni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['predvideni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['realni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_zps']) {
					response.data['importdata']['datum_zps'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_zps'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_zds']) {
					response.data['importdata']['datum_zds'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_zds'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['realni_madc']) {
					response.data['importdata']['realni_madc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['realni_madc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['predvideni_madc']) {
					response.data['importdata']['predvideni_madc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['predvideni_madc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_fakturiranja']) {
					response.data['importdata']['datum_fakturiranja'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_fakturiranja'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_izhoda_iz_oc']) {
					response.data['importdata']['datum_izhoda_iz_oc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_izhoda_iz_oc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				return response.data;
			} else {
				return null;
			}
		});
	},
	getImportdataDistinctByOgrodje: function getImportdataDistinctByOgrodje(ogrodje) {
		var args = {
			ogrodje: ogrodje
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/get_importdata_distinct_by_ogrodje', args).then(function (response) {
			if (!response.data) {
				return null;
			}
			if (!response.data['importdata'] || response.data['importdata'] === false) {
				return null;
			}
			if (response.data['status'] === 'ok') {
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['realni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['predvideni_mada']) {
					response.data['importdata']['predvideni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['predvideni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['realni_mada']) {
					response.data['importdata']['realni_mada'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['realni_mada'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_zps']) {
					response.data['importdata']['datum_zps'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_zps'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_zds']) {
					response.data['importdata']['datum_zds'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_zds'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['realni_madc']) {
					response.data['importdata']['realni_madc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['realni_madc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['predvideni_madc']) {
					response.data['importdata']['predvideni_madc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['predvideni_madc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_fakturiranja']) {
					response.data['importdata']['datum_fakturiranja'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_fakturiranja'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				if (response.data['importdata']['datum_izhoda_iz_oc']) {
					response.data['importdata']['datum_izhoda_iz_oc'] = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(response.data['importdata']['datum_izhoda_iz_oc'], __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
				}
				return response.data;
			} else {
				return null;
			}
		});
	},
	hotelHrambaEdit: function hotelHrambaEdit(hotelHramba) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			id: hotelHramba.id,
			fk_hotel_stranka: hotelHramba.fk_hotel_stranka,
			fk_hotel_lokacija: hotelHramba.fk_hotel_lokacija
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_hramba_edit', args, config).then(function (response) {
			return response.data;
		});
	},
	getHotelHrambeFiltered: function getHotelHrambeFiltered(ctx, inputFilter) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.id) {
			query += '&id=' + encodeURIComponent(inputFilter.id);
		}
		if (inputFilter.title) {
			query += '&title=' + encodeURIComponent(inputFilter.title);
		}
		if (inputFilter.email) {
			query += '&email=' + encodeURIComponent(inputFilter.email);
		}
		if (inputFilter.registration_number) {
			query += '&registration_number=' + encodeURIComponent(inputFilter.registration_number);
		}
		if (inputFilter.vehicle) {
			query += '&vehicle=' + encodeURIComponent(inputFilter.vehicle);
		}
		if (inputFilter.hotelLokacija) {
			query += '&hotelLokacija=' + encodeURIComponent(inputFilter.hotelLokacija);
		}
		if (inputFilter.external != null) {
			query += '&external=' + encodeURIComponent(inputFilter.external);
		}
		if (inputFilter.datumStoritve) {
			query += '&datumstart=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(inputFilter.datumStoritve.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&datumend=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(inputFilter.datumStoritve.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (inputFilter.dimensionsWidth) {
			query += '&dimensionsWidth=' + encodeURIComponent(inputFilter.dimensionsWidth);
		}
		if (inputFilter.dimensionsHeight) {
			query += '&dimensionsHeight=' + encodeURIComponent(inputFilter.dimensionsHeight);
		}
		if (inputFilter.dimensionsDiameter) {
			query += '&dimensionsDiameter=' + encodeURIComponent(inputFilter.dimensionsDiameter);
		}
		if (inputFilter.season) {
			var _iteratorNormalCompletion15 = true;
			var _didIteratorError15 = false;
			var _iteratorError15 = undefined;

			try {
				for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(inputFilter.season), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
					var item = _step15.value;

					query += '&season[]=' + encodeURIComponent(item);
				}
			} catch (err) {
				_didIteratorError15 = true;
				_iteratorError15 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion15 && _iterator15.return) {
						_iterator15.return();
					}
				} finally {
					if (_didIteratorError15) {
						throw _iteratorError15;
					}
				}
			}
		}
		if (inputFilter.statusHotelHramba != null) {
			query += '&statusHotelHramba=' + encodeURIComponent(inputFilter.statusHotelHramba);
		}
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_hrambe_list_filtered?' + query, config).then(function (response) {
			return response.data;
		});
	},
	hotelLokacijaEdit: function hotelLokacijaEdit(hotelHramba) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			id: hotelHramba.id,
			title: hotelHramba.title
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_lokacija_edit', args, config).then(function (response) {
			return response.data;
		});
	},
	getHotelLokacijeFiltered: function getHotelLokacijeFiltered(ctx, inputFilter) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.title) {
			query += '&title=' + encodeURIComponent(inputFilter.title);
		}
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_lokacije_list_filtered?' + query, config).then(function (response) {
			return response.data;
		});
	},
	searchHotelLokacije: function searchHotelLokacije(data) {
		var args = {
			qs: data.qs,
			freeOnly: data.freeOnly
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/search_hotel_lokacije', args).then(function (response) {
			return response.data;
		});
	},
	removeHotelLokacija: function removeHotelLokacija(id) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_lokacija_remove', args, config).then(function (response) {
			return response.data;
		});
	},
	hotelStoritevEdit: function hotelStoritevEdit(hotelStoritev, mode, initHotelKomentarji) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			mode: mode,
			id: hotelStoritev.id,
			fk_hotel_hramba: hotelStoritev.fk_hotel_hramba,
			fk_hotel_stranka: hotelStoritev.fk_hotel_stranka,
			num_tires: hotelStoritev.num_tires,
			dimensions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(hotelStoritev.dimensions),
			manufacturer: hotelStoritev.manufacturer,
			season: hotelStoritev.season,
			rims: hotelStoritev.rims,
			rims_cover: hotelStoritev.rims_cover,
			rims_screw: hotelStoritev.rims_screw,
			year: hotelStoritev.year,
			wear: hotelStoritev.wear,
			note_give: hotelStoritev.note_give,
			responsible_mechanic_give: hotelStoritev.responsible_mechanic_give,
			date_give: hotelStoritev.date_give != null ? Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(hotelStoritev.date_give, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat) : null,
			note_take: hotelStoritev.note_take,
			responsible_mechanic_take: hotelStoritev.responsible_mechanic_take,
			date_take: hotelStoritev.date_take != null ? Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(hotelStoritev.date_take, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat) : null,
			fk_hotel_storitev_take: hotelStoritev.fk_hotel_storitev_take,
			initHotelKomentarji: mode === 1 || mode === 3 ? initHotelKomentarji : null
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_storitev_edit', args, config).then(function (response) {
			return response.data;
		});
	},
	getHotelStoritveFiltered: function getHotelStoritveFiltered(ctx, inputFilter) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		query += '&with_archived=' + encodeURIComponent(inputFilter.with_archived);
		if (inputFilter.fk_hotel_hramba) {
			query += '&fk_hotel_hramba=' + encodeURIComponent(inputFilter.fk_hotel_hramba);
		}
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_storitve_list_filtered?' + query, config).then(function (response) {
			return response.data;
		});
	},
	hotelStoritevInitParams: function hotelStoritevInitParams(params) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			manufacturer: params.manufacturer
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_storitve_init_params', args, config).then(function (response) {
			return response.data;
		});
	},
	exportHotelStoritev: function exportHotelStoritev(id) {
		var args = {
			id: id
		};
		var cfg = {
			responseType: 'blob'
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_storitev_export_pdf', args, cfg).then(function (response) {
			return response;
		});
	},
	hotelKomentarEdit: function hotelKomentarEdit(hotelKomentar) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			id: hotelKomentar.id,
			linked_to: hotelKomentar.linked_to,
			content: hotelKomentar.content
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_komentar_edit', args, config).then(function (response) {
			return response.data;
		});
	},
	getHotelKomentarjiFiltered: function getHotelKomentarjiFiltered(ctx, inputFilter) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.linked_to) {
			query += '&linked_to=' + encodeURIComponent(inputFilter.linked_to);
		}
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_komentarji_list_filtered?' + query, config).then(function (response) {
			return response.data;
		});
	},
	searchHotelStranke: function searchHotelStranke(qs) {
		var args = {
			qs: qs
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_stranke_search', args).then(function (response) {
			return response.data;
		});
	},
	hotelStrankaEdit: function hotelStrankaEdit(hotelStranka) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			id: hotelStranka.id,
			first_name: hotelStranka.first_name,
			last_name: hotelStranka.last_name,
			title: hotelStranka.title,
			email: hotelStranka.email,
			phone_number: hotelStranka.phone_number,
			address: hotelStranka.address,
			city: hotelStranka.city,
			registration_number: hotelStranka.registration_number,
			vehicle: hotelStranka.vehicle,
			external: hotelStranka.external,
			is_company: hotelStranka.is_company
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_stranka_edit', args, config).then(function (response) {
			return response.data;
		});
	},
	hotelHrambaConfirm: function hotelHrambaConfirm(data) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var args = {
			items: data.items
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_hramba_confirm', args, config).then(function (response) {
			return response.data;
		});
	},
	hotelHrambaResetConfirmations: function hotelHrambaResetConfirmations() {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/hotel_hramba_reset_confirmations', config).then(function (response) {
			return response.data;
		});
	},
	cdpVehiclesStockListFiltered: function cdpVehiclesStockListFiltered(ctx, inputFilter) {
		var config = {
			timeout: __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].responseTimeout
		};
		var query = 'page=' + ctx.currentPage;
		query += '&size=' + ctx.perPage;
		query += '&sort=' + ctx.sortBy;
		query += '&desc=' + ctx.sortDesc;
		if (inputFilter.number) {
			query += '&number=' + encodeURIComponent(inputFilter.number);
		}
		if (inputFilter.vin) {
			query += '&vin=' + encodeURIComponent(inputFilter.vin);
		}
		if (inputFilter.registration_number) {
			query += '&registration_number=' + encodeURIComponent(inputFilter.registration_number);
		}
		if (inputFilter.model) {
			var _iteratorNormalCompletion16 = true;
			var _didIteratorError16 = false;
			var _iteratorError16 = undefined;

			try {
				for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(inputFilter.model), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
					var item = _step16.value;

					query += '&model[]=' + encodeURIComponent(item);
				}
			} catch (err) {
				_didIteratorError16 = true;
				_iteratorError16 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion16 && _iterator16.return) {
						_iterator16.return();
					}
				} finally {
					if (_didIteratorError16) {
						throw _iteratorError16;
					}
				}
			}
		}
		if (inputFilter.kind) {
			var _iteratorNormalCompletion17 = true;
			var _didIteratorError17 = false;
			var _iteratorError17 = undefined;

			try {
				for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(inputFilter.kind), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
					var _item5 = _step17.value;

					query += '&kind[]=' + encodeURIComponent(_item5);
				}
			} catch (err) {
				_didIteratorError17 = true;
				_iteratorError17 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion17 && _iterator17.return) {
						_iterator17.return();
					}
				} finally {
					if (_didIteratorError17) {
						throw _iteratorError17;
					}
				}
			}
		}
		if (inputFilter.location) {
			var _iteratorNormalCompletion18 = true;
			var _didIteratorError18 = false;
			var _iteratorError18 = undefined;

			try {
				for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(inputFilter.location), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
					var _item6 = _step18.value;

					query += '&location[]=' + encodeURIComponent(_item6);
				}
			} catch (err) {
				_didIteratorError18 = true;
				_iteratorError18 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion18 && _iterator18.return) {
						_iterator18.return();
					}
				} finally {
					if (_didIteratorError18) {
						throw _iteratorError18;
					}
				}
			}
		}
		if (inputFilter.payment_required_only) {
			query += '&payment_required_only=' + encodeURIComponent(inputFilter.payment_required_only);
		}
		if (inputFilter.due_date) {
			query += '&due_date_start=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(inputFilter.due_date.start, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat) + '&due_date_end=' + Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(inputFilter.due_date.end, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].inputDtFormat);
		}
		if (inputFilter.invoice_number) {
			query += '&invoice_number=' + encodeURIComponent(inputFilter.invoice_number);
		}
		if (inputFilter.paid) {
			query += '&paid=' + encodeURIComponent(inputFilter.paid);
		}
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/cdp_vehicles_stock_list_filtered?' + query, config).then(function (response) {
			return response.data;
		});
	},
	cdpVehiclesStockImport: function cdpVehiclesStockImport(newVehicles, usedVehicles, dmv) {
		var args = {
			newVehicles: newVehicles,
			usedVehicles: usedVehicles,
			dmv: dmv
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/cdp_vehicles_stock_import', args).then(function (response) {
			return response.data;
		});
	},
	cdpTraficImport: function cdpTraficImport(trafic) {
		var args = {
			trafic: trafic
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/cdp_vehicles_trafic_import', args).then(function (response) {
			return response.data;
		});
	},
	cdpVehicleStockSetPaid: function cdpVehicleStockSetPaid(id) {
		var args = {
			id: id
		};
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://zaloga.avtotehnika-celje.si/" + 'api/v1/cdp_vehicles_stock_set_paid', args).then(function (response) {
			return response;
		});
	},
	cdpVehicleStockGetLocations: function cdpVehicleStockGetLocations() {
		return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://zaloga.avtotehnika-celje.si/" + 'api/v1/cdp_vehicles_get_locations').then(function (response) {
			return response.data;
		});
	}
};
/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var settings = {
	stopnja_ddv: 22,
	dbDtFormat: 'YYYY-MM-DD HH:mm:ss',
	dbDFormat: 'YYYY-MM-DD',
	inputDtFormat: 'YYYY-MM-DD',
	viewDtFormat: 'DD. MM. YYYY',
	viewTimeFormat: 'HH:mm',
	hrsDtFormat: 'DD.MM.YYYY HH:mm',
	hrsDFormat: 'DD.MM.YYYY',
	vozilaImportDFormat: 'M/D/YYYY',
	isProdajalec: function isProdajalec(role) {
		return role === 0;
	},
	isSekretar: function isSekretar(role) {
		return role === 1;
	},
	isRacunovodja: function isRacunovodja(role) {
		return role === 3;
	},
	isModerator: function isModerator(role) {
		return role === 4;
	},
	isAdmin: function isAdmin(role) {
		return role === 5;
	},
	isSkrbnikGum: function isSkrbnikGum(role) {
		return role === 11;
	},
	isGledalecGum: function isGledalecGum(role) {
		return role === 12;
	},
	isPoprodaja: function isPoprodaja(role) {
		return role === 13;
	},
	highPermissionsRoles: [4, 5],
	vozilaRoles: [0, 1, 3],
	hotelGumRoles: [11, 12],
	poprodajaRoles: [13],
	errorMessages: {
		'serverSideValidationError': 'serverSideValidationError',
		'notSavedError': 'notSavedError',
		'PDOException': 'PDOException',
		'unknownRole': 'unknownRole',
		'invalidRole': 'invalidRole'
	},
	filterTimeoutLength: 1000,
	responseTimeout: 15000,
	tiresDimensions: {
		width_options: ['4', '7', '9', '12', '60', '80', '90', '100', '110', '120', '130', '135', '140', '145', '150', '155', '160', '165', '170', '175', '180', '190', '195', '205', '215', '225', '235', '245', '255', '255', '275', '285', '295', '315', '320', '500'],
		heigth_options: ['30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90', '100'],
		diameter_options: ['10', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21']
	},
	season_options: [{ text: 'Letne', value: 'L' }, { text: 'Zimske', value: 'Z' }, { text: 'Celoletne', value: 'ZL' }],
	rims_options: [{ text: 'Brez', value: 'BREZ' }, { text: 'ALU platišča', value: 'ALU' }, { text: 'FE platišča', value: 'FE' }],
	vehicle_models: [{ icon: 'logo_tz.png', value: 'tz', label: 'Tuja znamka' }, { icon: 'logo_renault.png', value: 'renault', label: 'Renault' }, { icon: 'logo_nissan.png', value: 'nissan', label: 'Nissan' }, { icon: 'logo_kia.png', value: 'kia', label: 'Kia' }, { icon: 'logo_toyota.png', value: 'toyota', label: 'Toyota' }, { icon: 'logo_dacia.png', value: 'dacia', label: 'Dacia' }, { icon: 'logo_mg.png', value: 'mg', label: 'MG' }],
	cdp_vehicle_stock_kind: [{ variant: 'success', value: 'Novo vozilo', label: 'N' }, { variant: 'warning', value: 'Testno vozilo', label: 'T' }, { variant: 'danger', value: 'Rabljeno vozilo', label: 'R' }],
	cdp_vehicle_stock_paid_options: [{ variant: 'success', value: 'paid_at_not_null', label: 'Plačano' }, { variant: 'primary', value: 'paid_at_null', label: 'Čaka na plačilo' }]
};
/* harmony default export */ __webpack_exports__["a"] = (settings);

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatumFilterDropdown_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48064d60_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatumFilterDropdown_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(975)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48064d60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatumFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48064d60_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatumFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48064d60_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatumFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickKupecInline_vue__ = __webpack_require__(522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccf1f24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickKupecInline_vue__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(902)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickKupecInline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccf1f24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickKupecInline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccf1f24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickKupecInline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messaging", function() { return messaging; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
	apiKey: 'AIzaSyDLr80baGCc9yi-LqPOB95arzlrtSv6_yw',
	authDomain: 'atc-bi.firebaseapp.com',
	databaseURL: 'https://atc-bi.firebaseio.com',
	projectId: 'atc-bi',
	storageBucket: 'atc-bi.appspot.com',
	messagingSenderId: '1062412169696'
};
__WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](config);

var db = __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]();
var auth = __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]();
var messaging = __WEBPACK_IMPORTED_MODULE_0_firebase__["messaging"]();



/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app'
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__(629);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';
var state = {
	user: null,
	loading: false,
	error: null,
	token: null
};
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_2_vuex_persist__["a" /* default */]({
	key: 'vuex',
	storage: window.localStorage,
	reducer: function reducer(state) {
		return {
			user: state.user,
			token: state.token
		};
	}
});
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: state,
	getters: {
		user: function user(state) {
			return state.user;
		},
		loading: function loading(state) {
			return state.loading;
		},
		error: function error(state) {
			return state.error;
		},
		token: function token(state) {
			return state.token;
		}
	},
	actions: {
		startLoading: function startLoading(_ref) {
			var commit = _ref.commit;

			commit('setLoading', true);
		},
		stopLoading: function stopLoading(_ref2) {
			var commit = _ref2.commit;

			commit('setLoading', false);
		},
		setUser: function setUser(_ref3, user) {
			var commit = _ref3.commit;

			commit('setUser', user);
		},
		clearUser: function clearUser(_ref4) {
			var commit = _ref4.commit;

			commit('setUser', null);
		},
		setError: function setError(_ref5, error) {
			var commit = _ref5.commit;

			commit('setError', error);
		},
		clearError: function clearError(_ref6) {
			var commit = _ref6.commit;

			commit('setError', null);
		},
		setToken: function setToken(_ref7, token) {
			var commit = _ref7.commit;

			commit('setToken', token);
		}
	},
	mutations: {
		setUser: function setUser(state, value) {
			state.user = value;
		},
		setLoading: function setLoading(state, value) {
			state.loading = value;
		},
		setError: function setError(state, value) {
			state.error = value;
		},
		setToken: function setToken(state, value) {
			state.token = value;
		}
	},
	plugins: [vuexLocalStorage.plugin],
	strict: debug
}));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_js__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Full',
	components: {
		AppHeader: __WEBPACK_IMPORTED_MODULE_0__components___["e" /* Header */],
		Sidebar: __WEBPACK_IMPORTED_MODULE_0__components___["f" /* Sidebar */],
		AppAside: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Aside */],
		AppFooter: __WEBPACK_IMPORTED_MODULE_0__components___["d" /* Footer */],
		Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components___["b" /* Breadcrumb */]
	},
	data: function data() {
		return {};
	},

	computed: {
		name: function name() {
			return this.$route.name;
		},
		list: function list() {
			return this.$route.matched;
		},
		nav: function nav() {
			var items = [];
			if (this.$store.getters.user !== null && (__WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].vozilaRoles.includes(this.$store.getters.user.role) || __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].highPermissionsRoles.includes(this.$store.getters.user.role))) {
				items.push({
					name: 'Domov',
					url: '/dashboard',
					icon: 'icon-speedometer'
				});
				items.push({
					name: 'Aktivnosti',
					url: '/aktivnosti',
					icon: 'icon-list'
				});
				items.push({
					name: 'Zaloga',
					url: '/tabla',
					icon: 'icon-layers'
				});
				items.push({
					name: 'Kupci',
					url: '/kupci',
					icon: 'icon-people'
				});
				items.push({
					name: 'Prilivi',
					url: '/prilivi',
					icon: 'icon-wallet'
				});
				items.push({
					name: 'Povračila',
					url: '/povracila',
					icon: 'icon-credit-card'
				});
			}
			if (this.$store.getters.user !== null && (__WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].vozilaRoles.includes(this.$store.getters.user.role) || __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].highPermissionsRoles.includes(this.$store.getters.user.role) || __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].poprodajaRoles.includes(this.$store.getters.user.role))) {
				items.push({
					name: 'Izdaja',
					url: '/izdaja',
					icon: 'icon-calendar'
				});
			}

			if (this.$store.getters.user !== null && (__WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].hotelGumRoles.includes(this.$store.getters.user.role) || __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].highPermissionsRoles.includes(this.$store.getters.user.role) || __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].poprodajaRoles.includes(this.$store.getters.user.role))) {
				items.push({
					name: 'Hotel gum',
					url: '/hotel',
					icon: 'icon-grid'
				});
			}

			if (this.$store.getters.user !== null && (this.$store.getters.user.role === 4 || this.$store.getters.user.role === 5)) {
				items.push({
					name: 'Nastavitve',
					url: '/nastavitve',
					icon: 'icon-settings',
					children: [{
						name: 'Uporabniki',
						url: '/nastavitve/uporabniki',
						icon: 'icon-user'
					}]
				});
			}
			return items;
		}
	}
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Callout_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'c-aside'
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		list: {
			type: Array,
			required: true,
			default: function _default() {
				return [];
			}
		}
	},
	methods: {
		isLast: function isLast(index) {
			return index === this.list.length - 1;
		},
		showName: function showName(item) {
			if (item.meta && item.meta.label) {
				item = item.meta && item.meta.label;
			}
			if (item.name) {
				item = item.name;
			}
			return item;
		}
	}
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		variant: {
			type: String
		}
	},
	computed: {
		classList: function classList() {
			return ['callout', this.calloutVariant];
		},
		calloutVariant: function calloutVariant() {
			return this.variant ? 'callout-' + this.variant : '';
		}
	}
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'c-footer'
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__ = __webpack_require__(643);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'c-header',
	components: {
		HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__["a" /* default */]
	},
	methods: {
		sidebarToggle: function sidebarToggle(e) {
			e.preventDefault();
			document.body.classList.toggle('sidebar-hidden');
		},
		sidebarMinimize: function sidebarMinimize(e) {
			e.preventDefault();
			document.body.classList.toggle('sidebar-minimized');
		},
		mobileSidebarToggle: function mobileSidebarToggle(e) {
			e.preventDefault();
			document.body.classList.toggle('sidebar-mobile-show');
		},
		asideToggle: function asideToggle(e) {
			e.preventDefault();
			document.body.classList.toggle('aside-menu-hidden');
		}
	}
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'header-dropdown',
	data: function data() {
		return {
			itemsCount: 42
		};
	},
	filters: {},
	methods: {
		logOut: function logOut(event) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
				_this.$store.dispatch('clearUser');
				_this.$router.replace('/auth/login');
			}).catch(function (error) {
				console.log('logout error: ');
				console.log(error);
			});
		}
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		}
	}
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__ = __webpack_require__(687);












/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar',
	props: {
		navItems: {
			type: Array,
			required: true,
			default: function _default() {
				return [];
			}
		}
	},
	components: {
		SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
		SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
		SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
		SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
		SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
		SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
		SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
		SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
		SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */],
		SidebarNavLabel: __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__["a" /* default */]
	},
	methods: {
		handleClick: function handleClick(e) {
			e.preventDefault();
			e.target.parentElement.classList.toggle('open');
		}
	}
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-footer'
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-form'
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-header'
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-minimizer',
	methods: {
		sidebarMinimize: function sidebarMinimize() {
			document.body.classList.toggle('sidebar-minimized');
		},
		brandMinimize: function brandMinimize() {
			document.body.classList.toggle('brand-minimized');
		}
	}
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-nav-divider',
	props: {
		classes: {
			type: String,
			default: ''
		}
	},
	computed: {
		classList: function classList() {
			return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
		},
		itemClasses: function itemClasses() {
			return this.classes ? this.classes.split(' ') : '';
		}
	}
});

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		name: {
			type: String,
			default: ''
		},
		url: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		}
	},
	methods: {
		handleClick: function handleClick(e) {
			e.preventDefault();
			e.target.parentElement.classList.toggle('open');
		}
	}
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d439d7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d439d7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d439d7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-nav-link',
	props: {
		name: {
			type: String,
			default: ''
		},
		url: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		},
		badge: {
			type: Object,
			default: function _default() {}
		},
		variant: {
			type: String,
			default: ''
		},
		classes: {
			type: String,
			default: ''
		}
	},
	computed: {
		classList: function classList() {
			return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
		},
		linkVariant: function linkVariant() {
			return this.variant ? 'nav-link-' + this.variant : '';
		},
		itemClasses: function itemClasses() {
			return this.classes ? this.classes.split(' ') : [];
		},
		isExternalLink: function isExternalLink() {
			if (this.url.substring(0, 4) === 'http') {
				return true;
			} else {
				return false;
			}
		}
	}
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		name: {
			type: String,
			default: ''
		},
		classes: {
			type: String,
			default: ''
		},
		wrapper: {
			type: Object,
			default: function _default() {}
		}
	},
	computed: {
		classList: function classList() {
			return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
		},
		itemClasses: function itemClasses() {
			return this.classes ? this.classes.split(' ') : '';
		}
	}
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1676bbac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1676bbac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1676bbac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-nav-item',
	props: {
		classes: {
			type: String,
			default: ''
		}
	},
	computed: {
		classList: function classList() {
			return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
		},
		itemClasses: function itemClasses() {
			return this.classes ? this.classes.split(' ') : '';
		}
	},
	methods: {
		hideMobile: function hideMobile() {
			if (document.body.classList.contains('sidebar-mobile-show')) {
				document.body.classList.toggle('sidebar-mobile-show');
			}
		}
	}
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__ = __webpack_require__(326);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar-nav-label',
	components: {
		SidebarNavItem: __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__["a" /* default */],
		SidebarNavLink: __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__["a" /* default */]
	},
	props: {
		name: {
			type: String,
			default: ''
		},
		url: {
			type: String,
			default: '#'
		},
		icon: {
			type: String,
			default: 'fa fa-circle'
		},
		classes: {
			type: String,
			default: ''
		},
		label: {
			type: Object,
			required: true,
			default: function _default() {}
		}
	},
	computed: {
		classList: function classList() {
			var classes = {
				navItem: ['hidden-cn'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getClasses(this.classes))).join(' '),
				navLink: 'nav-label',
				icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
			};
			return classes;
		}
	},
	methods: {
		getClasses: function getClasses(classes) {
			return classes ? classes.split(' ') : [];
		}
	}
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	model: {
		prop: 'checked',
		event: 'change'
	},
	props: {
		value: {
			default: true
		},
		uncheckedValue: {
			default: false
		},
		checked: {
			default: false
		},
		type: {
			type: String,
			default: 'default'
		},
		variant: {
			type: String,
			default: ''
		},
		pill: {
			type: Boolean,
			default: false
		},
		on: {
			type: String,
			default: null
		},
		off: {
			type: String,
			default: null
		},
		size: {
			type: String,
			default: null
		}
	},
	computed: {
		classList: function classList() {
			return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
		},
		switchType: function switchType() {
			return this.type ? 'switch-' + this.type : 'switch-default';
		},
		switchVariant: function switchVariant() {
			return this.variant ? 'switch-' + this.variant : 'switch-secondary';
		},
		switchPill: function switchPill() {
			return !this.pill ? null : 'switch-pill';
		},
		switchSize: function switchSize() {
			return this.size ? 'switch-' + this.size : '';
		},
		isChecked: function isChecked() {
			return this.checked === this.value;
		},
		isOn: function isOn() {
			return !this.on ? null : true;
		}
	},
	methods: {
		handleChange: function handleChange(_ref) {
			var checked = _ref.target.checked;

			this.$emit('change', checked ? this.value : this.uncheckedValue);
		}
	}
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_CardLine1ChartExample__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_CardLine2ChartExample__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_CardLine3ChartExample__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboard_CardBarChartExample__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dashboard_MainChartExample__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_SocialBoxChartExample__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard_CalloutChartExample__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components___ = __webpack_require__(308);











/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dashboard',
	components: {
		Callout: __WEBPACK_IMPORTED_MODULE_7__components___["c" /* Callout */],
		CardLine1ChartExample: __WEBPACK_IMPORTED_MODULE_0__dashboard_CardLine1ChartExample__["a" /* default */],
		CardLine2ChartExample: __WEBPACK_IMPORTED_MODULE_1__dashboard_CardLine2ChartExample__["a" /* default */],
		CardLine3ChartExample: __WEBPACK_IMPORTED_MODULE_2__dashboard_CardLine3ChartExample__["a" /* default */],
		CardBarChartExample: __WEBPACK_IMPORTED_MODULE_3__dashboard_CardBarChartExample__["a" /* default */],
		MainChartExample: __WEBPACK_IMPORTED_MODULE_4__dashboard_MainChartExample__["a" /* default */],
		SocialBoxChartExample: __WEBPACK_IMPORTED_MODULE_5__dashboard_SocialBoxChartExample__["a" /* default */],
		CalloutChartExample: __WEBPACK_IMPORTED_MODULE_6__dashboard_CalloutChartExample__["a" /* default */]
	},
	filters: {},
	data: function data() {
		return {
			selected: 'Month',
			tableItems: [{
				avatar: { url: 'static/img/avatars/1.jpg', status: 'success' },
				user: { name: 'Jana Novak', new: true, registered: 'Jan 1, 2015' },
				country: { name: 'USA', flag: 'us' },
				usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
				payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
				activity: 'pred 10 sek.'
			}, {
				avatar: { url: 'static/img/avatars/2.jpg', status: 'danger' },
				user: { name: 'Miran Košir', new: false, registered: 'Jan 1, 2015' },
				country: { name: 'Brazil', flag: 'br' },
				usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
				payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
				activity: 'pred 5 min.'
			}, {
				avatar: { url: 'static/img/avatars/3.jpg', status: 'warning' },
				user: { name: 'Janez Potočnik', new: true, registered: 'Jan 1, 2015' },
				country: { name: 'India', flag: 'in' },
				usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
				payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
				activity: 'pred 1 uro'
			}, {
				avatar: { url: 'static/img/avatars/4.jpg', status: '' },
				user: { name: 'Jan Hudomuk', new: true, registered: 'Jan 1, 2015' },
				country: { name: 'France', flag: 'fr' },
				usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
				payment: { name: 'PayPal', icon: 'fa fa-paypal' },
				activity: 'pred 2 dnevoma'
			}, {
				avatar: { url: 'static/img/avatars/5.jpg', status: 'success' },
				user: { name: 'Nina Glazer', new: true, registered: 'Jan 1, 2015' },
				country: { name: 'Spain', flag: 'es' },
				usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
				payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
				activity: 'Prejšnji teden'
			}, {
				avatar: { url: 'static/img/avatars/6.jpg', status: 'danger' },
				user: { name: 'Vanja Moškon', new: true, registered: 'Jan 1, 2015' },
				country: { name: 'Poland', flag: 'pl' },
				usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
				payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
				activity: 'Pred 3 dnevi'
			}],
			tableFields: {
				avatar: {
					label: '<i class="icon-people"></i>',
					class: 'text-center'
				},
				user: {
					label: 'Prodajalec'
				},
				country: {
					label: 'Enota',
					class: 'text-center'
				},
				usage: {
					label: 'Uspešnost'
				},
				payment: {
					label: 'Način plačila',
					class: 'text-center'
				},
				activity: {
					label: 'Aktiven'
				}
			}
		};
	},
	methods: {
		variant: function variant(value) {
			var $variant = void 0;
			if (value <= 25) {
				$variant = 'info';
			} else if (value > 25 && value <= 50) {
				$variant = 'success';
			} else if (value > 50 && value <= 75) {
				$variant = 'warning';
			} else if (value > 75 && value <= 100) {
				$variant = 'danger';
			}
			return $variant;
		},
		flag: function flag(value) {
			return 'flag-icon flag-icon-' + value;
		}
	},
	computed: {}
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(50);



var brandPrimary = '#20a8d8';
var datasets = [{
	label: 'My First dataset',
	backgroundColor: brandPrimary,
	borderColor: 'rgba(255,255,255,.55)',
	data: [65, 59, 84, 84, 51, 55, 40]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
	props: ['height'],
	mounted: function mounted() {
		this.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
			datasets: datasets
		}, {
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					gridLines: {
						color: 'transparent',
						zeroLineColor: 'transparent'
					},
					ticks: {
						fontSize: 2,
						fontColor: 'transparent'
					}
				}],
				yAxes: [{
					display: false,
					ticks: {
						display: false,
						min: Math.min.apply(Math, datasets[0].data) - 5,
						max: Math.max.apply(Math, datasets[0].data) + 5
					}
				}]
			},
			elements: {
				line: {
					borderWidth: 1
				},
				point: {
					radius: 4,
					hitRadius: 10,
					hoverRadius: 4
				}
			}
		});
	}
});

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(50);



var brandInfo = '#63c2de';
var datasets = [{
	label: 'My First dataset',
	backgroundColor: brandInfo,
	borderColor: 'rgba(255,255,255,.55)',
	data: [1, 18, 9, 17, 34, 22, 11]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
	props: ['height'],
	mounted: function mounted() {
		this.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
			datasets: datasets
		}, {
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					gridLines: {
						color: 'transparent',
						zeroLineColor: 'transparent'
					},
					ticks: {
						fontSize: 2,
						fontColor: 'transparent'
					}

				}],
				yAxes: [{
					display: false,
					ticks: {
						display: false,
						min: Math.min.apply(Math, datasets[0].data) - 5,
						max: Math.max.apply(Math, datasets[0].data) + 5
					}
				}]
			},
			elements: {
				line: {
					tension: 0.00001,
					borderWidth: 1
				},
				point: {
					radius: 4,
					hitRadius: 10,
					hoverRadius: 4
				}
			}
		});
	}
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(50);



var datasets = [{
	label: 'My First dataset',
	backgroundColor: 'rgba(255,255,255,.2)',
	borderColor: 'rgba(255,255,255,.55)',
	data: [78, 81, 80, 45, 34, 12, 40]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
	props: ['height'],
	mounted: function mounted() {
		this.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
			datasets: datasets
		}, {
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					display: false
				}],
				yAxes: [{
					display: false
				}]
			},
			elements: {
				line: {
					borderWidth: 2
				},
				point: {
					radius: 0,
					hitRadius: 10,
					hoverRadius: 4
				}
			}
		});
	}
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(50);



var datasets = [{
	label: 'My First dataset',
	backgroundColor: 'rgba(255,255,255,.3)',
	borderColor: 'transparent',
	data: [78, 81, 80, 45, 34, 12, 40, 75, 34, 89, 32, 68, 54, 72, 18, 98]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
	props: ['height'],
	mounted: function mounted() {
		this.renderChart({
			labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
			datasets: datasets
		}, {
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					display: false,
					categoryPercentage: 1,
					barPercentage: 0.5
				}],
				yAxes: [{
					display: false
				}]
			}
		});
	}
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(50);



var brandSuccess = '#4dbd74';
var brandInfo = '#63c2de';
var brandDanger = '#f86c6b';

function convertHex(hex, opacity) {
	hex = hex.replace('#', '');
	var r = parseInt(hex.substring(0, 2), 16);
	var g = parseInt(hex.substring(2, 4), 16);
	var b = parseInt(hex.substring(4, 6), 16);

	var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
	return result;
}

function random(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
	props: ['height'],
	mounted: function mounted() {
		var elements = 27;
		var data1 = [];
		var data2 = [];
		var data3 = [];

		for (var i = 0; i <= elements; i++) {
			data1.push(random(50, 200));
			data2.push(random(80, 100));
			data3.push(65);
		}
		this.renderChart({
			labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S'],
			datasets: [{
				label: 'My First dataset',
				backgroundColor: convertHex(brandInfo, 10),
				borderColor: brandInfo,
				pointHoverBackgroundColor: '#fff',
				borderWidth: 2,
				data: data1
			}, {
				label: 'My Second dataset',
				backgroundColor: 'transparent',
				borderColor: brandSuccess,
				pointHoverBackgroundColor: '#fff',
				borderWidth: 2,
				data: data2
			}, {
				label: 'My Third dataset',
				backgroundColor: 'transparent',
				borderColor: brandDanger,
				pointHoverBackgroundColor: '#fff',
				borderWidth: 1,
				borderDash: [8, 5],
				data: data3
			}]
		}, {
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					gridLines: {
						drawOnChartArea: false
					}
				}],
				yAxes: [{
					ticks: {
						beginAtZero: true,
						maxTicksLimit: 5,
						stepSize: Math.ceil(250 / 5),
						max: 250
					},
					gridLines: {
						display: true
					}
				}]
			},
			elements: {
				point: {
					radius: 0,
					hitRadius: 10,
					hoverRadius: 4,
					hoverBorderWidth: 3
				}
			}
		});
	}
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(50);



/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
	props: ['data', 'height'],
	mounted: function mounted() {
		this.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
			datasets: [{
				backgroundColor: 'rgba(255,255,255,.1)',
				borderColor: 'rgba(255,255,255,.55)',
				pointHoverBackgroundColor: '#fff',
				borderWidth: 2,
				data: this.data
			}]
		}, {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					display: false
				}],
				yAxes: [{
					display: false
				}]
			},
			elements: {
				point: {
					radius: 0,
					hitRadius: 10,
					hoverRadius: 4,
					hoverBorderWidth: 3
				}
			}
		});
	}
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(50);



/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
	props: ['data', 'height', 'width', 'variant'],
	mounted: function mounted() {
		this.renderChart({
			labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
			datasets: [{
				backgroundColor: 'transparent',
				borderColor: this.variant ? this.variant : '#c2cfd6',
				data: this.data
			}]
		}, {
			responsive: true,
			maintainAspectRatio: true,
			scales: {
				xAxes: [{
					display: false
				}],
				yAxes: [{
					display: false
				}]
			},
			elements: {
				line: {
					borderWidth: 2
				},
				point: {
					radius: 0,
					hitRadius: 10,
					hoverRadius: 4,
					hoverBorderWidth: 3
				}
			},
			legend: {
				display: false
			}
		});
	}
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PopulateDataModal__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PopulateVegaModal__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PopulateNissanModal__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RezervirajVoziloModal__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProdajVoziloModal__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DobavavKoncesijoModal__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ZadrzanoModal__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_StanjeFilterDropdown__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_StatusFilterDropdown__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_LokacijeFilterDropdown__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ProdajaFilterDropdown__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_OpombaVozilaModal__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MapaModal__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PodrobnostiVozilaModal__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PodrobnostiVozilaZalogaCard__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_PodrobnostiVozilaCard__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DatumFilterDropdown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_KontoDestinacijeFilterDropdown__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ImportCdpVehiclesStockModal__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ImportCdpTraficModal__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_DropdownFilters_DefaultDropdownFilter__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tools_images__ = __webpack_require__(989);

































var fb = __webpack_require__(170);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'tabla',
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay___default.a,
		'populate-data-modal': __WEBPACK_IMPORTED_MODULE_2__components_PopulateDataModal__["a" /* default */],
		'populate-vega-modal': __WEBPACK_IMPORTED_MODULE_3__components_PopulateVegaModal__["a" /* default */],
		'populate-nissan-modal': __WEBPACK_IMPORTED_MODULE_4__components_PopulateNissanModal__["a" /* default */],
		'rezerviraj-vozilo-modal': __WEBPACK_IMPORTED_MODULE_5__components_RezervirajVoziloModal__["a" /* default */],
		'prodaj-vozilo-modal': __WEBPACK_IMPORTED_MODULE_6__components_ProdajVoziloModal__["a" /* default */],
		'dobava-v-koncesijo-modal': __WEBPACK_IMPORTED_MODULE_7__components_DobavavKoncesijoModal__["a" /* default */],
		'zadrzano-modal': __WEBPACK_IMPORTED_MODULE_8__components_ZadrzanoModal__["a" /* default */],
		'stanje-filter-dropdown': __WEBPACK_IMPORTED_MODULE_9__components_StanjeFilterDropdown__["a" /* default */],
		'status-filter-dropdown': __WEBPACK_IMPORTED_MODULE_10__components_StatusFilterDropdown__["a" /* default */],
		'lokacije-filter-dropdown': __WEBPACK_IMPORTED_MODULE_11__components_LokacijeFilterDropdown__["a" /* default */],
		'prodaja-filter-dropdown': __WEBPACK_IMPORTED_MODULE_12__components_ProdajaFilterDropdown__["a" /* default */],
		'opomba-vozila-modal': __WEBPACK_IMPORTED_MODULE_13__components_OpombaVozilaModal__["a" /* default */],
		'datum-filter-dropdown': __WEBPACK_IMPORTED_MODULE_18__components_DatumFilterDropdown__["a" /* default */],
		'konto-filter-dropdown': __WEBPACK_IMPORTED_MODULE_19__components_KontoDestinacijeFilterDropdown__["a" /* default */],
		'mapa-modal': __WEBPACK_IMPORTED_MODULE_14__components_MapaModal__["a" /* default */],
		'podrobnosti-vozila-modal': __WEBPACK_IMPORTED_MODULE_15__components_PodrobnostiVozilaModal__["a" /* default */],
		'podrobnosti-vozila-zaloga-card': __WEBPACK_IMPORTED_MODULE_16__components_PodrobnostiVozilaZalogaCard__["a" /* default */],
		'podrobnosti-vozila-card': __WEBPACK_IMPORTED_MODULE_17__components_PodrobnostiVozilaCard__["a" /* default */],
		'import-cdp-vehicles-stock-modal': __WEBPACK_IMPORTED_MODULE_20__components_ImportCdpVehiclesStockModal__["a" /* default */],
		'import-cdp-trafic-modal': __WEBPACK_IMPORTED_MODULE_21__components_ImportCdpTraficModal__["a" /* default */],
		'default-dropdown-filter': __WEBPACK_IMPORTED_MODULE_22__components_DropdownFilters_DefaultDropdownFilter__["a" /* default */]
	},
	filters: {
		model_short_version: function model_short_version(value) {
			if (value) {
				if (value.length > 55) {
					return value.substring(0, 53) + '...';
				} else {
					return value;
				}
			} else {
				return '';
			}
		},
		koncesija_label: function koncesija_label(item) {
			if (item && item.koncesija_lokacija) {
				return 'V koncesiji (' + item.koncesija_lokacija + ')';
			}
			return 'V koncesiji';
		},
		akcija_dane: function akcija_dane(value) {
			if (value) {
				return 'Da';
			} else {
				return 'Ne';
			}
		}
	},
	methods: {
		onInputChange: function onInputChange(value) {
			var _this = this;

			if (this.filterImportdataTimeout !== null) {
				clearTimeout(this.filterImportdataTimeout);
			}
			this.filterImportdataTimeout = setTimeout(function () {
				_this.$refs.dataTable.refresh();
			}, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].filterTimeoutLength);
		},
		prodajalci_Changed: function prodajalci_Changed(prodajalec) {
			if (prodajalec) {
				this.inputFilter.prodajalec = prodajalec.id;
			} else {
				this.inputFilter.prodajalec = null;
			}
			this.$refs.dataTable.refresh();
		},
		kupci_Changed: function kupci_Changed(kupec) {
			if (kupec) {
				this.inputFilter.kupec = kupec.id;
			} else {
				this.inputFilter.kupec = null;
			}
			this.$refs.dataTable.refresh();
		},
		arhiv_Changed: function arhiv_Changed(arhiv) {
			this.$refs.dataTable.refresh();
		},
		nissan_Changed: function nissan_Changed(nissan) {
			this.$refs.dataTable.refresh();
		},
		getSoldInfo: function getSoldInfo(item) {
			if (!item || !item.has_sold) {
				return '';
			}
			var hs = 'Prodajalec: ' + item.p_prodajalec_name + ';';
			var kupecHr = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			if (kupecHr != null) {
				hs += ' Kupec: ' + kupecHr + ';';
			}
			var datumProdaje = Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["parse"])(item.p_datum_prodaje, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].dbDtFormat);
			hs += ' Datum prodaje: ' + Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["format"])(datumProdaje, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].hrsDtFormat);
			return hs;
		},
		isSold: function isSold(item) {
			if (!item || !item.has_sold) {
				return false;
			}
			return true;
		},
		getReservationInfo: function getReservationInfo(item) {
			if (!item || !item.has_reservation) {
				return '';
			}
			var hs = 'Prodajalec: ' + item.r_prodajalec_name + ';';
			var kupecHr = this.getKupecHR(item.r_kupec, item.r_is_company, item.r_kupec_name, item.r_company);
			if (kupecHr != null) {
				hs += ' Kupec: ' + kupecHr + ';';
			}
			var datumOd = Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["parse"])(item.r_reserved_from, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].dbDtFormat);
			var datumDo = Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["parse"])(item.r_reserved_to, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].dbDtFormat);
			hs += ' Od: ' + Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["format"])(datumOd, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].hrsDtFormat) + '; Do: ' + Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["format"])(datumDo, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].hrsDtFormat);
			return hs;
		},
		isReserved: function isReserved(item) {
			if (!item || !item.has_reservation) {
				return false;
			}
			return true;
		},
		isReservedDisabled: function isReservedDisabled(reserved, sold) {
			if (sold != null || reserved != null) {
				return true;
			}
			return false;
		},
		getKoncesijaInfo: function getKoncesijaInfo(item) {
			if (!item || !item.koncesija_datum) {
				return '';
			}
			var hs = 'Lokacija: ' + item.koncesija_lokacija + ';';
			if (item.koncesija_prodajalec != null) {
				hs += ' Prodajalec: ' + item.koncesija_prodajalec_name + ';';
			}
			var datumKoncesije = Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["parse"])(item.koncesija_datum, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].dbDtFormat);
			hs += ' Datum: ' + Object(__WEBPACK_IMPORTED_MODULE_24_date_fns__["format"])(datumKoncesije, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].hrsDtFormat);
			return hs;
		},
		isKoncesija: function isKoncesija(item) {
			if (!item || !item.koncesija_datum) {
				return false;
			}
			return true;
		},
		getKupecHR: function getKupecHR(id, isCompany, name, title) {
			if (id == null) {
				return null;
			}
			if (isCompany) {
				return title;
			}
			return name;
		},
		getTitle: function getTitle(value) {
			return value;
		},
		rowClicked: function rowClicked(row, index) {
			if (this.exportActive) {
				this.selectItem_change(row);
			} else {
				row._showDetails = !row._showDetails;
			}
		},

		sortingChanged: function sortingChanged(ctx) {
			console.log('sort');
			console.log(ctx);
		},
		onFiltered: function onFiltered(filteredItems) {
			console.log('filter');
			console.log(filteredItems);
		},
		rowClass: function rowClass(item, type) {
			if (!item) {
				return '';
			}
			if (this.isSold(item)) {
				return 'table-success';
			}
			if (this.isReserved(item)) {
				return 'table-primary';
			}
			if (item.akcijski === 1) {
				return 'table-warning';
			}
			if (item.konto_destinacije === 'TV' || item.konto_destinacije === 'RV0KM' || item.konto_destinacije === 'ND') {
				return 'table-info';
			}
			return '';
		},
		click_clearTableFilter: function click_clearTableFilter() {
			this.resetFilter();
			this.resetFilterForms();
			this.$refs.dataTable.refresh();
		},
		click_openPopulateDataModal: function click_openPopulateDataModal() {
			this.$refs.populateDataModal.showModal();
		},
		click_openPopulateVegaModal: function click_openPopulateVegaModal() {
			this.$refs.populateVegaModal.showModal();
		},
		click_openPopulateNissanModal: function click_openPopulateNissanModal() {
			this.$refs.populateNissanModal.showModal();
		},
		click_reserveItem: function click_reserveItem(value) {
			this.$refs.rezervirajVoziloModal.showModal(value);
		},
		click_sellItem: function click_sellItem(item) {
			var kupecHr = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			this.$refs.prodajVoziloModal.showModal(item.id, item.has_sold, item.p_prodajalec, item.p_kupec, item.p_datum_prodaje, item.p_datum_planirane_dobave, item.p_urejeno_financiranje, item.p_vlozeno, item.p_podpisano, item.p_financiranje_rci, item.p_external, kupecHr);
		},
		click_dobavavKoncesijo: function click_dobavavKoncesijo(item) {
			this.$refs.dobavavKoncesijoModal.showModal(item.id, item.koncesija_lokacija, item.koncesija_datum);
		},
		click_stornirajProdajo: function click_stornirajProdajo(prodajaId) {
			var _this2 = this;

			if (prodajaId) {
				__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].stornirajProdajo(prodajaId).then(function (response) {
					_this2.$refs.dataTable.refresh();
					_this2.updateTable = false;
					fb.db.ref('importdata').set({
						updated_on: new Date().getTime()
					});
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
				});
			}
		},
		click_stornirajRezervacijo: function click_stornirajRezervacijo(rezervacijaId) {
			var _this3 = this;

			if (rezervacijaId) {
				__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].stornirajRezervacijo(rezervacijaId).then(function (response) {
					_this3.$refs.dataTable.refresh();
					_this3.updateTable = false;
					fb.db.ref('importdata').set({
						updated_on: new Date().getTime()
					});
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
				});
			}
		},
		click_zadrzano: function click_zadrzano(value) {
			this.$refs.zadrzanoModal.showModal(value);
		},
		click_editOpomba: function click_editOpomba(row, button) {
			this.$refs.opombaVozilaModal.showModal(row.item.id, row.item.interna_opomba, row.item.akcijski);
		},
		click_showMapa: function click_showMapa(row, button) {
			var vozilo = row.item.libelle_modele + ' ' + row.item.libelle_version;
			var kupec = this.getKupecHR(row.item.p_kupec, row.item.p_is_company, row.item.p_kupec_name, row.item.p_company);
			this.$refs.mapaModal.showModal(row.item.id, row.item.ogrodje, vozilo, row.item.p_prodajalec, row.item.p_prodajalec_name, kupec, 0, row.item.p_datum_prodaje, row.item.p_datum_planirane_dobave, row.item.p_financiranje_rci, row.item.koncesija_datum, false);
		},
		on_dataUpdated: function on_dataUpdated() {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_reservationSuccess: function on_reservationSuccess() {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_sellSuccess: function on_sellSuccess() {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_prodajavkoncesijoSuccess: function on_prodajavkoncesijoSuccess() {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_zadrzanoSuccess: function on_zadrzanoSuccess() {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_opombaSuccess: function on_opombaSuccess() {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		dataProvider: function dataProvider(ctx) {
			var _this4 = this;

			this.isLoading = true;
			return __WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].getVozilaFiltered(ctx, this.inputFilter, this.user).then(function (data) {
				_this4.isLoading = false;
				_this4.items = data;
				_this4.totalRows = data.total;
				if (_this4.exportActive) {
					_this4.checkSelectedItems();
				}
				return _this4.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
					_this4.isLoading = false;
				}
				return [];
			});
		},
		click_showInfo: function click_showInfo(data, button) {
			this.$refs.podrobnostiVozilaModal.showModal(data.item);
		},
		on_stanjeFilterChange: function on_stanjeFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.stanje = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						this.inputFilter.stanje.push(item.value);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				this.inputFilter.stanje = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_statusFilterChange: function on_statusFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.status = [];
				var resetLokacije = true;
				var resetProdaja = true;
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var item = _step2.value;

						if (item.value === 'konces') {
							resetLokacije = false;
						} else if (item.value === 'prod') {
							resetProdaja = false;
						}
						this.inputFilter.status.push(item.value);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				if (resetLokacije) {
					this.inputFilter.lokacije = null;
					this.$refs.lokacijeDropdown.clear();
				}

				if (resetProdaja) {
					this.inputFilter.prodaja = null;
					this.$refs.prodajaDropdown.clear();
				}
			} else {
				this.inputFilter.status = null;
				this.inputFilter.lokacije = null;
				this.$refs.lokacijeDropdown.clear();
				this.inputFilter.prodaja = null;
				this.$refs.prodajaDropdown.clear();
			}
			this.$refs.dataTable.refresh();
		},
		on_kontoFilterChange: function on_kontoFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.konto_destinacije = [];
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var item = _step3.value;

						this.inputFilter.konto_destinacije.push(item.value);
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
			} else {
				this.inputFilter.konto_destinacije = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_lokacijeFilterChange: function on_lokacijeFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.lokacije = [];
				var _iteratorNormalCompletion4 = true;
				var _didIteratorError4 = false;
				var _iteratorError4 = undefined;

				try {
					for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
						var item = _step4.value;

						this.inputFilter.lokacije.push(item.value);
					}
				} catch (err) {
					_didIteratorError4 = true;
					_iteratorError4 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion4 && _iterator4.return) {
							_iterator4.return();
						}
					} finally {
						if (_didIteratorError4) {
							throw _iteratorError4;
						}
					}
				}
			} else {
				this.inputFilter.lokacije = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_prodajaFilterChange: function on_prodajaFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.prodaja = [];
				var _iteratorNormalCompletion5 = true;
				var _didIteratorError5 = false;
				var _iteratorError5 = undefined;

				try {
					for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
						var item = _step5.value;

						this.inputFilter.prodaja.push(item.value);
					}
				} catch (err) {
					_didIteratorError5 = true;
					_iteratorError5 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion5 && _iterator5.return) {
							_iterator5.return();
						}
					} finally {
						if (_didIteratorError5) {
							throw _iteratorError5;
						}
					}
				}
			} else {
				this.inputFilter.prodaja = null;
			}
			this.$refs.dataTable.refresh();
		},
		allowStorno: function allowStorno() {
			if (this.user.role === 4 || this.user.role === 5) {
				return true;
			} else {
				return false;
			}
		},
		resetFilter: function resetFilter() {
			this.prodajalec_selected = null;
			this.kupec_selected = null;
			this.inputFilter = {
				konto_destinacije: null,
				st_narocila_kupca: '',
				st_narocila_vozila: '',
				ogrodje: '',
				model: '',
				verzija: '',
				barva: '',
				staranje: '',
				stanje: null,
				status: null,
				lokacije: null,
				prodaja: null,
				prodajalec: null,
				kupec: null,
				rmadc: null,
				pmadc: null,
				omada: null,
				pdp: null,
				obljubljenaDobava: null,
				arhiv: false,
				nissan: false,
				vega_dhsVegaSalesId: '',
				vega_brand: '',
				vega_status: '',
				predvideni_mada: ''
			};
		},
		resetFilterForms: function resetFilterForms() {
			this.$refs.stanjeDropdown.clear();
			this.$refs.statusDropdown.clear();
			this.$refs.lokacijeDropdown.clear();
			this.$refs.prodajaDropdown.clear();
			this.$refs.rmadcDropdown.clear();
			this.$refs.pmadcDropdown.clear();
			this.$refs.omadaDropdown.clear();
			this.$refs.pdpDropdown.clear();
			this.$refs.obljubljenaDobavaDropdown.clear();
		},
		click_addNew: function click_addNew() {
			this.$refs.podrobnostiVozilaModal.showModal(null);
		},
		importdata_add: function importdata_add(data) {
			this.$refs.dataTable.refresh();
			var message = '';
			if (data.ogrodje !== '') {
				message = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ') uspešno dodano.';
			} else {
				message = 'Vozilo #' + data.id + ' uspešno dodano.';
			}
			this.$refs.toastr.s(message);
		},
		importdata_edit: function importdata_edit(data) {
			console.log('data', data);
			this.$refs.dataTable.refresh();
			var message = '';
			if (data.ogrodje !== '') {
				message = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ') uspešno urejeno.';
			} else {
				message = 'Vozilo #' + data.id + ' uspešno urejeno.';
			}
			this.$refs.toastr.s(message);
		},
		showDeleteButton: function showDeleteButton(data) {
			if (data.source_file === 'manual') {
				return true;
			}
			return false;
		},
		showArchiveButton: function showArchiveButton() {
			if (this.user.role === 1 || this.user.role === 5) {
				return true;
			} else {
				return false;
			}
		},
		click_archiveImportdata: function click_archiveImportdata(importdata) {
			var _this5 = this;

			this.$bvModal.msgBoxConfirm('Želite arhivirati vozilo ' + importdata.ogrodje + ' (#' + importdata.id + ')?', {
				title: 'Potrdite arhiviranje vozila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].archiveImportdata(importdata.id).then(function (response) {
						if (response.message === 'archived') {
							_this5.$refs.toastr.s('Vozilo ' + response.archived_importdata.ogrodje + ' (#' + response.archived_importdata.id + ') arhivirano.');
							_this5.$refs.dataTable.refresh();
						} else {
							_this5.$refs.toastr.e('Neveljaven odziv strežnika!');
							console.error('Neveljaven response message: ' + response.message);
						}
					}).catch(function (error) {
						if (error.response) {
							if (error.response.data.message === 'serverSideValidationError') {
								_this5.$refs.toastr.e('Napaka pri validaciji na strežniku!');
								console.error(error.response.data.message + ': ', error.response.data.errors);
							} else if (error.response.data.message === 'notFoundError') {
								_this5.$refs.toastr.e('Vozila #' + error.response.data.wrong_archived_id + ' ni mogoče najti!');
								console.error(error.response.data.message);
							} else if (error.response.data.message === 'notArchivedError') {
								_this5.$refs.toastr.e('Napaka pri arhiviranju vozila #' + error.response.data.wrong_archived_id + '!');
								console.error(error.response.data.message);
							} else if (error.response.data.message === 'PDOException') {
								_this5.$refs.toastr.e('Napaka pri podatkovni bazi!');
								console.error(error.response.data.message, 'details in .ex');
							} else {
								_this5.$refs.toastr.e('Neznana napaka na strežniku!');
								console.error(error.response.data.message);
							}
						} else if (error.request) {
							_this5.$refs.toastr.e('Napaka: strežnik se ni odzval!');
							console.log('The request was made but no response was received:', error.request);
						} else {
							_this5.$refs.toastr.e('Napaka pri pošiljanju zahteve na strežnik!');
							console.log('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		clicl_deleteImportdata: function clicl_deleteImportdata(importdata) {
			var _this6 = this;

			console.log('delete id', importdata.id);
			this.$bvModal.msgBoxConfirm('Želite izbrisati vozilo ' + importdata.ogrodje + ' (#' + importdata.id + ')?', {
				title: 'Potrdite brisanje vozila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].removeImportdata(importdata.id, importdata.source_file).then(function (response) {
						if (response.message === 'deleted') {
							_this6.$refs.toastr.s('Vozilo ' + response.deleted_importdata.ogrodje + ' (#' + response.deleted_importdata.id + ') izbrisano.');
							_this6.$refs.dataTable.refresh();
						} else {
							_this6.$refs.toastr.e('Neveljaven odziv strežnika!');
							console.error('Neveljaven response message: ' + response.message);
						}
					}).catch(function (error) {
						if (error.response) {
							if (error.response.data.message === 'serverSideValidationError') {
								_this6.$refs.toastr.e('Napaka pri validaciji na strežniku!');
								console.error(error.response.data.message + ': ', error.response.data.errors);
							} else if (error.response.data.message === 'wrongSourceFile') {
								_this6.$refs.toastr.e('Brisanje je dovoljeno samo za vozila vnesena ročno!');
								console.error(error.response.data.message, 'Delete allowed only for importdata where source_file === manual, currently send: ' + error.response.data.wrong_source_file);
							} else if (error.response.data.message === 'notFoundError') {
								_this6.$refs.toastr.e('Vozila #' + error.response.data.wrong_deleted_id + ' ni mogoče najti!');
								console.error(error.response.data.message);
							} else if (error.response.data.message === 'notDeletedError') {
								_this6.$refs.toastr.e('Napaka pri brisanju vozila #' + error.response.data.wrong_deleted_id + '!');
								console.error(error.response.data.message);
							} else if (error.response.data.message === 'PDOException') {
								_this6.$refs.toastr.e('Napaka pri podatkovni bazi!');
								console.error(error.response.data.message, 'details in .ex');
							} else {
								_this6.$refs.toastr.e('Neznana napaka na strežniku!');
								console.error(error.response.data.message);
							}
						} else if (error.request) {
							_this6.$refs.toastr.e('Napaka: strežnik se ni odzval!');
							console.log('The request was made but no response was received:', error.request);
						} else {
							_this6.$refs.toastr.e('Napaka pri pošiljanju zahteve na strežnik!');
							console.log('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		kupciSelect_load: __WEBPACK_IMPORTED_MODULE_28_lodash___default.a.debounce(function (loading, search, vm) {
			if (!vm.kupci_searchEmpty) {
				__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].searchKupci(search).then(function (kupci) {
					var _iteratorNormalCompletion6 = true;
					var _didIteratorError6 = false;
					var _iteratorError6 = undefined;

					try {
						for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(kupci), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
							var kupec = _step6.value;

							if (kupec.is_company) {
								kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
							} else {
								kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
							}
						}
					} catch (err) {
						_didIteratorError6 = true;
						_iteratorError6 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion6 && _iterator6.return) {
								_iterator6.return();
							}
						} finally {
							if (_didIteratorError6) {
								throw _iteratorError6;
							}
						}
					}

					loading(false);
					vm.kupci_searched = kupci;
				}).catch(function (error) {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
			} else {
				loading(false);
			}
		}, 500),
		kupciSelect_change: function kupciSelect_change(kupec) {
			if (kupec) {
				this.inputFilter.kupec = kupec.id;
			} else {
				this.inputFilter.kupec = null;
				this.kupci_searched = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.kupci_options));
			}
			this.$refs.dataTable.refresh();
		},
		kupciSelect_search: function kupciSelect_search(search, loading) {
			if (search && search !== '') {
				this.kupci_searchEmpty = false;
				loading(true);
				this.kupciSelect_load(loading, search, this);
			} else if (search === '' && this.inputFilter.kupec == null) {
				this.kupci_searched = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.kupci_options));
				this.kupci_searchEmpty = true;
			}
		},
		toggleExportActive: function toggleExportActive() {
			if (this.exportActive) {
				this.exportActive = false;
				var _iteratorNormalCompletion7 = true;
				var _didIteratorError7 = false;
				var _iteratorError7 = undefined;

				try {
					for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
						var selectedItem = _step7.value;

						selectedItem.selected = false;
					}
				} catch (err) {
					_didIteratorError7 = true;
					_iteratorError7 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion7 && _iterator7.return) {
							_iterator7.return();
						}
					} finally {
						if (_didIteratorError7) {
							throw _iteratorError7;
						}
					}
				}

				this.selectedItems = [];
				this.fields.shift();
				this.fields.push({ key: 'actions', label: '#', 'class': 'tbWidthActions' });
				this.exportAll = false;
			} else {
				this.exportActive = true;
				this.fields.unshift({ key: 'selected', label: '-', sortable: false });
				this.fields.pop();
			}
		},
		exportImportData: function exportImportData(ctx) {
			var _this7 = this;

			if (this.exportAll || this.selectedItems.length > 0) {
				this.isLoading = true;
				var data = {};
				if (this.exportAll) {
					data = {
						exportAll: this.exportAll,
						filter: this.inputFilter,
						user: this.user
					};
				} else {
					data = {
						exportAll: this.exportAll,
						items: this.selectedItems
					};
				}
				__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].exportItemsData(data).then(function (response) {
					_this7.isLoading = false;
					var fileLink = document.createElement('a');
					fileLink.href = URL.createObjectURL(response.data);
					fileLink.setAttribute('download', response.headers['content-disposition'].split('filename=')[1]);
					fileLink.click();
					URL.revokeObjectURL(fileLink.href);
					_this7.toggleExportActive();
					_this7.$refs.dataTable.refresh();
				}).catch(function (error) {
					_this7.isLoading = false;
					if (error.response) {
						_this7.$refs.toastr.e('Napaka pri izvozu vozil!');
						console.error(error);
					} else if (error.request) {
						_this7.$refs.toastr.e('Napaka pri izvozu vozil: strežnik se ni odzval!');
						console.error('The request was made but no response was received:', error.request);
					} else {
						_this7.$refs.toastr.e('Napaka pri pošiljanju zahteve za izvoz vozil-a na strežnik!');
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
			} else {
				this.$refs.toastr.e('Izbrati morate vsaj eno vozilo!');
			}
		},
		selectItem_change: function selectItem_change(item) {
			item.selected = !item.selected;
			if (item.selected) {
				this.selectedItems.push(item);
			} else {
				this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
			}
			this.$forceUpdate();
		},
		checkSelectedItems: function checkSelectedItems() {
			var _this8 = this;

			var _loop = function _loop(selectedItem) {
				console.log(_this8.items);
				var alreadyInSelectedItems = _this8.items.data.find(function (selItem) {
					return selItem.id === selectedItem.id;
				});
				if (alreadyInSelectedItems != null) {
					alreadyInSelectedItems.selected = true;
				}
			};

			var _iteratorNormalCompletion8 = true;
			var _didIteratorError8 = false;
			var _iteratorError8 = undefined;

			try {
				for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
					var selectedItem = _step8.value;

					_loop(selectedItem);
				}
			} catch (err) {
				_didIteratorError8 = true;
				_iteratorError8 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion8 && _iterator8.return) {
						_iterator8.return();
					}
				} finally {
					if (_didIteratorError8) {
						throw _iteratorError8;
					}
				}
			}
		},

		cdpVehiclesStockItems: function cdpVehiclesStockItems(ctx) {
			var _this9 = this;

			this.cdpVehiclesStockTableProps.isLoading = true;
			return __WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].cdpVehiclesStockListFiltered(ctx, this.cdpVehiclesStockTableProps.inputFilter).then(function (response) {
				_this9.cdpVehiclesStockTableProps.isLoading = false;
				_this9.cdpVehiclesStockTableProps.totalRows = response.items.total;
				_this9.cdpVehiclesStockTableProps.purchasePriceSum = response.amountsSum.purchasePriceSum;
				_this9.cdpVehiclesStockTableProps.dmvSum = response.amountsSum.dmvSum;
				_this9.cdpVehiclesStockTableProps.purchasePriceWithDmvSum = response.amountsSum.purchasePriceWithDmvSum;
				_this9.cdpVehiclesStockTableProps.amountDueSum = response.amountsSum.amountDueSum;
				if (_this9.locationOptions.length === 0) {
					__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].cdpVehicleStockGetLocations().then(function (items) {
						_this9.locationOptions = items;
					}).catch(function (error) {
						if (error) {
							console.log(error);
						}
					});
				}
				return response.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
					_this9.cdpVehiclesStockTableProps.isLoading = false;
				}
				return [];
			});
		},
		click_clearcdpVehiclesStockTableFilter: function click_clearcdpVehiclesStockTableFilter() {
			this.resetCdpVehiclesStockFilters();
			this.$refs.cdpVehiclesStockTable.refresh();
		},
		resetCdpVehiclesStockFilters: function resetCdpVehiclesStockFilters() {
			this.cdpVehiclesStockTableProps.inputFilter = {
				number: null,
				vin: null,
				registration_number: null,
				model: [],
				kind: [],
				location: [],
				due_date: null,
				invoice_number: null,
				paid: null
			};
			this.$refs.cdpVehiclesStockDueDateDropdown.clear();
			this.$refs.cdpVehicleStockModelDropdown.clear();
			this.$refs.cdpVehicleStockKindDropdown.clear();
			this.$refs.cdpVehicleStockLocationsDropdown.clear();
			this.$refs.cdpVehicleStockPaidDropdown.clear();
		},
		onCdpVehiclesStockFilterChange: function onCdpVehiclesStockFilterChange(value) {
			var _this10 = this;

			if (this.cdpVehiclesStockTableProps.filterTimeout !== null) {
				clearTimeout(this.cdpVehiclesStockTableProps.filterTimeout);
			}
			this.cdpVehiclesStockTableProps.filterTimeout = setTimeout(function () {
				_this10.$refs.cdpVehiclesStockTable.refresh();
			}, __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].filterTimeoutLength);
		},
		click_openImportCdpVehiclesStockModal: function click_openImportCdpVehiclesStockModal() {
			this.$refs.importCdpVehiclesStockModal.showModal();
		},
		click_openImportCdpTraficModal: function click_openImportCdpTraficModal() {
			this.$refs.importCdpTraficModal.showModal();
		},
		on_cdpDataUpdated: function on_cdpDataUpdated() {
			this.$refs.cdpVehiclesStockTable.refresh();
		},
		cdpVehicleStockPaidTitle: function cdpVehicleStockPaidTitle(item) {
			if (item.paid_at) {
				return 'Plačilo potrdil ' + (item.paid_by_user_title ? item.paid_by_user_title : '/') + '\n dne ' + this.$options.filters.hr_date(item.paid_at) + ' ob ' + this.$options.filters.hr_time(item.paid_at);
			}
			return 'Potrdi plačilo';
		},
		click_cdpVehicleStockPay: function click_cdpVehicleStockPay(item) {
			var _this11 = this;

			this.cdpVehiclesStockTableProps.isLoading = true;
			__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].cdpVehicleStockSetPaid(item.id).then(function (response) {
				_this11.cdpVehiclesStockTableProps.isLoading = false;
				_this11.$refs.toastr.s('Plačilo za vozilo ' + item.number + ' uspešno potrjeno!');
				_this11.$refs.cdpVehiclesStockTable.refresh();
			}).catch(function (error) {
				_this11.$refs.toastr.e('Napaka pri potrjevanju plačila!');
				_this11.cdpVehiclesStockTableProps.isLoading = false;
				if (error) {
					console.log(error);
				}
			});
		},
		on_cdpVehicleStockModelFilterChange: function on_cdpVehicleStockModelFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.cdpVehiclesStockTableProps.inputFilter.model = [];
				var _iteratorNormalCompletion9 = true;
				var _didIteratorError9 = false;
				var _iteratorError9 = undefined;

				try {
					for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
						var item = _step9.value;

						this.cdpVehiclesStockTableProps.inputFilter.model.push(item.value);
					}
				} catch (err) {
					_didIteratorError9 = true;
					_iteratorError9 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion9 && _iterator9.return) {
							_iterator9.return();
						}
					} finally {
						if (_didIteratorError9) {
							throw _iteratorError9;
						}
					}
				}
			} else {
				this.cdpVehiclesStockTableProps.inputFilter.model = null;
			}
			this.$refs.cdpVehiclesStockTable.refresh();
		},
		on_cdpVehicleStockKindFilterChange: function on_cdpVehicleStockKindFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.cdpVehiclesStockTableProps.inputFilter.kind = [];
				var _iteratorNormalCompletion10 = true;
				var _didIteratorError10 = false;
				var _iteratorError10 = undefined;

				try {
					for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
						var item = _step10.value;

						this.cdpVehiclesStockTableProps.inputFilter.kind.push(item.value);
					}
				} catch (err) {
					_didIteratorError10 = true;
					_iteratorError10 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion10 && _iterator10.return) {
							_iterator10.return();
						}
					} finally {
						if (_didIteratorError10) {
							throw _iteratorError10;
						}
					}
				}
			} else {
				this.cdpVehiclesStockTableProps.inputFilter.kind = null;
			}
			this.$refs.cdpVehiclesStockTable.refresh();
		},
		on_cdpVehicleStockLocationFilterChange: function on_cdpVehicleStockLocationFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.cdpVehiclesStockTableProps.inputFilter.location = [];
				var _iteratorNormalCompletion11 = true;
				var _didIteratorError11 = false;
				var _iteratorError11 = undefined;

				try {
					for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(selectedItems), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
						var item = _step11.value;

						this.cdpVehiclesStockTableProps.inputFilter.location.push(item.value);
					}
				} catch (err) {
					_didIteratorError11 = true;
					_iteratorError11 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion11 && _iterator11.return) {
							_iterator11.return();
						}
					} finally {
						if (_didIteratorError11) {
							throw _iteratorError11;
						}
					}
				}
			} else {
				this.cdpVehiclesStockTableProps.inputFilter.location = [];
			}
			this.$refs.cdpVehiclesStockTable.refresh();
		},
		on_cdpVehicleStockPaidFilterChange: function on_cdpVehicleStockPaidFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.cdpVehiclesStockTableProps.inputFilter.paid = selectedItems[0].value;
			} else {
				this.cdpVehiclesStockTableProps.inputFilter.paid = null;
			}
			this.$refs.cdpVehiclesStockTable.refresh();
		}
	},
	props: {},
	data: function data() {
		return {
			imagesTool: __WEBPACK_IMPORTED_MODULE_29__tools_images__["a" /* default */],
			settings: __WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */],
			kupci_searchEmpty: false,
			isLoading: false,
			fields: [{ key: 'konto_destinacije', label: 'Konto', sortable: true, 'class': 'tbWidthXSmall' }, { key: 'vega_dhsVegaSalesId', label: 'Vega id', headerTitle: 'Vega id', sortable: true, 'class': 'tbWidthXMedium' }, { key: 'st_narocila_kupca', label: 'ŠtN. kupca', headerTitle: 'Številka naročila kupca', sortable: true, 'class': 'tbWidthXMedium' }, { key: 'st_narocila_vozila', label: 'ŠtN. vozila', headerTitle: 'Številka naročila vozila', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'ogrodje', label: 'VIN', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'vega_brand', label: 'Znamka', sortable: true, 'class': 'tbWidthXMedium' }, { key: 'libelle_modele', label: 'Model', sortable: true }, { key: 'libelle_version', label: 'Verzija', 'class': 'tbWidthXXMedium' }, { key: 'libelle_options', label: 'Opcije', 'class': 'text-center tbWidthMedium' }, { key: 'predvideni_mada', label: 'PDP', headerTitle: 'Date dispo probable: Predviden datum prihoda', sortable: true }, { key: 'vega_status', label: 'Vega status', 'class': 'text-center' }, { key: 'staranje', label: 'Staranje', 'class': 'text-center tbWidthXXSmall', sortable: true }, { key: 'status', label: 'Status' }, { key: 'actions', label: '#', 'class': 'tbWidthActions' }],
			prodajalec_selected: null,
			prodajalci_options: [],
			kupec_selected: null,
			kupci_options: [],
			kupci_searched: [],
			currentPage: 1,
			perPage: 50,
			totalRows: 0,
			naviLimit: 7,
			updateTable: false,
			items: [],
			filter: null,
			inputFilter: {
				konto_destinacije: null,
				st_narocila_kupca: '',
				st_narocila_vozila: '',
				ogrodje: '',
				model: '',
				verzija: '',
				barva: '',
				staranje: '',
				stanje: null,
				status: null,
				lokacije: null,
				prodaja: null,
				prodajalec: null,
				kupec: null,
				rmadc: null,
				pmadc: null,
				omada: null,
				pdp: null,
				obljubljenaDobava: null,
				arhiv: false,
				nissan: false,
				vega_dhsVegaSalesId: '',
				vega_brand: '',
				vega_status: '',
				predvideni_mada: ''
			},
			filterImportdataTimeout: null,
			exportActive: false,
			selectedItems: [],
			exportAll: false,
			cdpVehiclesStockTableProps: {
				isLoading: false,
				fields: [{ key: 'number', label: 'Številka', headerTitle: '-', sortable: true, 'class': 'tbWidthXMedium' }, { key: 'vin', label: 'Šasija', headerTitle: '-', sortable: true, 'class': 'tbWidthXMedium' }, { key: 'registration_number', label: 'Reg.', headerTitle: '-', sortable: true, 'class': 'tbWidthXMedium' }, { key: 'model', label: 'Znamka', headerTitle: '-', sortable: true, 'tdClass': 'text-center align-middle', 'class': 'tbWidthXMedium' }, { key: 'kind', label: 'Tip', headerTitle: '-', sortable: true, 'tdClass': 'text-center align-middle', 'class': 'tbWidthXXSmall' }, { key: 'location_title', label: 'Lokacija', headerTitle: '-', sortable: true, 'class': 'tbWidthXMedium' }, { key: 'delivery_date', label: 'Dobava', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'standing_days', label: 'Stojnina', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'purchase_price', label: 'Nabavna', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'dmv', label: 'DMV', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'purchase_price_with_dmv', label: 'Nab. z DMV', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'amount_due', label: 'Obveznost', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'due_date', label: 'Bonif.', headerTitle: '-', sortable: true, 'class': 'text-nowrap' }, { key: 'invoice_number', label: 'Št. računa', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'stock_status', label: 'Status', headerTitle: '-', sortable: true, 'class': 'tbWidthXXMedium' }, { key: 'actions', label: '#', 'class': 'tbCdpVehiclesStockWidthActions', 'tdClass': 'text-center align-middle' }],
				currentPage: 1,
				perPage: 50,
				totalRows: 0,
				naviLimit: 7,
				inputFilter: {
					number: null,
					vin: null,
					registration_number: null,
					model: [],
					kind: [],
					location: [],
					due_date: null,
					invoice_number: null,
					paid: null
				},
				filterTimeout: null,
				purchasePriceSum: null,
				dmvSum: null,
				purchasePriceWithDmvSum: null,
				amountDueSum: null
			},
			selectedTabIndex: 0,
			cdpVehicleStockModelOptions: [],
			cdpVehicleStockKindOptions: [],
			locationOptions: [],
			cdpVehicleStockPaidOptions: [],
			stickyHeader: false
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		userCanConfirmCdpVehicleStockPay: function userCanConfirmCdpVehicleStockPay() {
			if (__WEBPACK_IMPORTED_MODULE_25__settings_js__["a" /* default */].isRacunovodja(this.user.role)) {
				return true;
			}
			return false;
		},
		isProdajaDropdownVisible: function isProdajaDropdownVisible() {
			if (this.inputFilter.status) {
				for (var i = 0, len = this.inputFilter.status.length; i < len; i++) {
					if (this.inputFilter.status[i] === 'prod') {
						return true;
					}
				}
			}
			return false;
		},
		isLokacijeDropdownVisible: function isLokacijeDropdownVisible() {
			if (this.inputFilter.status) {
				for (var i = 0, len = this.inputFilter.status.length; i < len; i++) {
					if (this.inputFilter.status[i] === 'konces') {
						return true;
					}
				}
			}
			return false;
		}
	},
	created: function created() {
		var _this12 = this;

		var $main = this;
		fb.db.ref('importdata').on('value', function (snapshot) {
			if ($main.updateTable) {
				$main.$refs.dataTable.refresh();
				$main.$refs.toastr.s('Podatki posodobljeni');
			}
			$main.updateTable = true;
		});

		__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].getProdajalci().then(function (prodajalci) {
			for (var i = 0; i < prodajalci.length; i++) {
				prodajalci[i].full_name = prodajalci[i].first_name + ' ' + prodajalci[i].last_name;
			}
			prodajalci.push({
				id: -1,
				email: '',
				full_name: 'Nedodeljeno',
				first_name: 'Nedodeljeno',
				last_name: '',
				role: 0,
				fb_uid: '',
				match_pattern: '',
				created_at: '1900-01-01 00:00:01',
				updated_at: '1900-01-01 00:00:01',
				deleted_at: null
			});
			_this12.prodajalci_options = prodajalci;
		}).catch(function (error) {
			if (error) {
				console.log(error);
			}
		});

		__WEBPACK_IMPORTED_MODULE_23__service__["a" /* default */].searchKupci('#initialize').then(function (kupci) {
			var _iteratorNormalCompletion12 = true;
			var _didIteratorError12 = false;
			var _iteratorError12 = undefined;

			try {
				for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(kupci), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
					var kupec = _step12.value;

					if (kupec.is_company) {
						kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
					} else {
						kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
					}
				}
			} catch (err) {
				_didIteratorError12 = true;
				_iteratorError12 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion12 && _iterator12.return) {
						_iterator12.return();
					}
				} finally {
					if (_didIteratorError12) {
						throw _iteratorError12;
					}
				}
			}

			_this12.kupci_options = kupci;
			_this12.kupci_searched = kupci;
		}).catch(function (error) {
			if (error) {
				console.log(error);
			}
		});
		this.cdpVehicleStockModelOptions = structuredClone(this.settings.vehicle_models);
		this.cdpVehicleStockKindOptions = structuredClone(this.settings.cdp_vehicle_stock_kind);
		this.cdpVehicleStockPaidOptions = structuredClone(this.settings.cdp_vehicle_stock_paid_options);
	}
});

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







var usDefaultValues = {
	url: "https://zaloga.avtotehnika-celje.si/" + 'api/v1/upload',
	thumbnailWidth: 150,
	maxFilesize: 50,
	uploadMultiple: false,
	maxFiles: 1,
	addRemoveLinks: false,
	paramName: 'import_data',

	dictRemoveFile: 'Odstrani datoteko',
	dictFileTooBig: 'Datoteka je prevelika',
	init: function init(event) {
		console.log('DZ init');
	},
	uploadprogress: function uploadprogress(file, progress, bytesSent, event) {
		console.log('DZ uploadprogress');
		console.log(progress);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		vueDropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
	},
	methods: {
		showModal: function showModal() {
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			this.$refs.modal.hide();
			this.showStep1 = true;
			this.showStep2 = false;
			this.showStep3 = false;
			this.zalogaUploadedRenault = null;
			this.prodajaUploadedRenault = null;
			this.zalogaUploadedDacia = null;
			this.prodajaUploadedDacia = null;
			this.uploadResultMessage = '';
			this.$refs.dzZalogaRenault.removeAllFiles();
			this.$refs.dzProdajaRenault.removeAllFiles();
			this.$refs.dzZalogaDacia.removeAllFiles();
			this.$refs.dzProdajaDacia.removeAllFiles();
		},
		moveToProcessing: function moveToProcessing() {
			var _this = this;

			if (this.zalogaUploadedRenault && this.prodajaUploadedRenault && this.zalogaUploadedDacia && this.prodajaUploadedDacia) {
				this.showStep1 = false;
				this.showStep2 = true;
				this.showStep3 = false;
				__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].uvoziVozila(this.zalogaUploadedRenault, this.prodajaUploadedRenault, this.zalogaUploadedDacia, this.prodajaUploadedDacia).then(function (response) {
					_this.uploadResultMessage = 'Zaloga uspešno posodobljena. Najdenih je bilo <b>' + (response.data.renault.zaloga.total + response.data.dacia.zaloga.total) + '</b>, od tega <b>' + (response.data.renault.zaloga.new + response.data.dacia.zaloga.new) + '</b> novih.';
					_this.uploadResultMessage += '<br /><br />';
					_this.uploadResultMessage += 'Prodaja uspešno posodobljena. Najdenih je bilo <b>' + (response.data.renault.prodaja.total + response.data.dacia.prodaja.total) + '</b>, od tega <b>' + (response.data.renault.prodaja.new + response.data.dacia.prodaja.new) + '</b> novih.';
					_this.showStep1 = false;
					_this.showStep2 = false;
					_this.showStep3 = true;
					_this.$emit('data-updated');
				}).catch(function (error) {
					if (error) {
						console.log(error);
						_this.uploadResultMessage = 'Napaka pri uvozu podatkov!';
						_this.showStep1 = false;
						_this.showStep2 = false;
						_this.showStep3 = true;
					}
				});
			}
		},
		dzTemplate: function dzTemplate() {
			return '<div class="dz-preview dz-file-preview">\n\t\t\t\t<div class="dz-image">\n\t\t\t\t\t<div data-dz-thumbnail-bg></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-details">\n\t\t\t\t\t<div class="dz-filename"><span data-dz-name></span></div><br />(<div class="dz-size"><span data-dz-size></span></div>)\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n\t\t\t\t<div class="dz-error-message"><span data-dz-errormessage></span></div>\n\t\t\t\t<div class="dz-success-mark"><i class="fa fa-check"></i></div>\n\t\t\t\t<div class="dz-error-mark"><i class="fa fa-close"></i></div>\n\t\t\t</div>';
		}
	},
	data: function data() {
		var _this2 = this;

		return {
			showStep1: true,
			showStep2: false,
			showStep3: false,
			animate: true,
			zalogaUploadedRenault: null,
			prodajaUploadedRenault: null,
			zalogaUploadedDacia: null,
			prodajaUploadedDacia: null,
			uploadResultMessage: '',
			usZalogaRenault: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko z zalogo<br /><b>Renault</b>',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', 'zaloga');
					formData.append('import_make', 'renault');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.zalogaUploadedRenault = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.zalogaUploadedRenault = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			usProdajaRenault: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko s prodajo<br /><b>Renault</b>',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', 'prodaja');
					formData.append('import_make', 'renault');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.prodajaUploadedRenault = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.prodajaUploadedRenault = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			usZalogaDacia: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko z zalogo<br /><b>Dacia</b>',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', 'zaloga');
					formData.append('import_make', 'dacia');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.zalogaUploadedDacia = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.zalogaUploadedDacia = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			usProdajaDacia: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko s prodajo<br /><b>Dacia</b>',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', 'prodaja');
					formData.append('import_make', 'dacia');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.prodajaUploadedDacia = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.prodajaUploadedDacia = response.data.file;
					_this2.moveToProcessing();
				}
			})
		};
	},
	created: function created() {
		var _this3 = this;

		var user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
		user.getIdToken().then(function (idToken) {
			var headers = {
				'Authorization': 'Bearer ' + idToken
			};
			_this3.usZalogaRenault.headers = headers;
			_this3.usProdajaRenault.headers = headers;
			_this3.usZalogaDacia.headers = headers;
			_this3.usProdajaDacia.headers = headers;
		});
	}
});

/***/ }),
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







var usDefaultValues = {
	url: "https://zaloga.avtotehnika-celje.si/" + 'api/v1/upload_vega',
	thumbnailWidth: 150,
	maxFilesize: 50,
	uploadMultiple: false,
	maxFiles: 1,
	addRemoveLinks: false,
	paramName: 'import_data',

	dictRemoveFile: 'Odstrani datoteko',
	dictFileTooBig: 'Datoteka je prevelika',
	init: function init(event) {
		console.log('DZ init');
	},
	uploadprogress: function uploadprogress(file, progress, bytesSent, event) {
		console.log('DZ uploadprogress');
		console.log(progress);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		vueDropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
	},
	methods: {
		showModal: function showModal() {
			this.showError();
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			this.$refs.modal.hide();
			this.showStep1 = true;
			this.showStep2 = false;
			this.showStep3 = false;
			this.uploadedVega = null;
			this.uploadResultMessage = '';
			this.$refs.dzVega.removeAllFiles();
		},
		moveToProcessing: function moveToProcessing() {
			var _this = this;

			if (this.uploadedVega) {
				this.showStep1 = false;
				this.showStep2 = true;
				this.showStep3 = false;
				__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].uvoziVega(this.uploadedVega).then(function (response) {
					_this.uploadResultMessage = 'Zaloga uspešno posodobljena. Najdenih je bilo <b>' + response.data.vega.totalZaloga + '</b>, od tega <b>' + response.data.vega.newZaloga + '</b> novih.';
					_this.uploadResultMessage += '<br /><br />';
					_this.uploadResultMessage += 'Prodaja uspešno posodobljena. Najdenih je bilo <b>' + response.data.vega.totalProdaja + '</b>, od tega <b>' + response.data.vega.newProdaja + '</b> novih.';
					if (response.data.vega.numNonAdded > 0) {
						_this.uploadResultMessage += '<br /><br />Št. neuspešno dodanih: <b>' + response.data.vega.numNonAdded + '</b>!';
					}
					if (response.data.vega.numchangedColumnsItems > 0) {
						_this.uploadResultMessage += '<br /><br />Št. zapisov s spremenjenim številom stolpcev: <b>' + response.data.vega.numchangedColumnsItems + '</b>!';
					}
					_this.showStep1 = false;
					_this.showStep2 = false;
					_this.showStep3 = true;
					_this.$emit('data-updated');
				}).catch(function (error) {
					if (error) {
						console.log(error);
						_this.uploadResultMessage = 'Napaka pri uvozu podatkov!';
						_this.showStep1 = false;
						_this.showStep2 = false;
						_this.showStep3 = true;
					}
				});
			}
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		dzTemplate: function dzTemplate() {
			return '<div class="dz-preview dz-file-preview">\n\t\t\t\t<div class="dz-image">\n\t\t\t\t\t<div data-dz-thumbnail-bg></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-details">\n\t\t\t\t\t<div class="dz-filename"><span data-dz-name></span></div><br />(<div class="dz-size"><span data-dz-size></span></div>)\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n\t\t\t\t<div class="dz-error-message"><span data-dz-errormessage></span></div>\n\t\t\t\t<div class="dz-success-mark"><i class="fa fa-check"></i></div>\n\t\t\t\t<div class="dz-error-mark"><i class="fa fa-close"></i></div>\n\t\t\t</div>';
		}
	},
	data: function data() {
		var _this2 = this;

		return {
			showStep1: true,
			showStep2: false,
			showStep3: false,
			animate: true,
			uploadedVega: null,
			uploadResultMessage: '',
			usVega: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko <br /><b>Vega</b>',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', 'vega');
					formData.append('import_make', 'vega');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					_this2.showError('Napaka pri nalaganju datoteke na strežnik!');
					_this2.$refs.dzVega.removeAllFiles();
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.uploadedVega = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					_this2.showError();
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.uploadedVega = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR'
		};
	},
	created: function created() {
		var _this3 = this;

		var user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
		user.getIdToken().then(function (idToken) {
			var headers = {
				'Authorization': 'Bearer ' + idToken
			};
			_this3.usVega.headers = headers;
		});
	}
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







var usDefaultValues = {
	url: "https://zaloga.avtotehnika-celje.si/" + 'api/v1/upload_nissan',
	thumbnailWidth: 150,
	maxFilesize: 50,
	uploadMultiple: false,
	maxFiles: 1,
	addRemoveLinks: false,
	paramName: 'import_data',

	dictRemoveFile: 'Odstrani datoteko',
	dictFileTooBig: 'Datoteka je prevelika',
	init: function init(event) {
		console.log('DZ init');
	},
	uploadprogress: function uploadprogress(file, progress, bytesSent, event) {
		console.log('DZ uploadprogress');
		console.log(progress);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		vueDropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
	},
	methods: {
		showModal: function showModal() {
			this.showError();
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			this.$refs.modal.hide();
			this.showStep1 = true;
			this.showStep2 = false;
			this.showStep3 = false;
			this.zalogaUploadedNissan = null;
			this.uploadResultMessage = '';
			this.$refs.dzZalogaNissan.removeAllFiles();
		},
		moveToProcessing: function moveToProcessing() {
			var _this = this;

			if (this.zalogaUploadedNissan) {
				this.showStep1 = false;
				this.showStep2 = true;
				this.showStep3 = false;
				__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].uvoziNissan(this.zalogaUploadedNissan).then(function (response) {
					_this.uploadResultMessage = 'Zaloga uspešno posodobljena. Najdenih je bilo <b>' + response.data.nissan.total + '</b>, od tega <b>' + response.data.nissan.new + '</b> novih.';
					_this.uploadResultMessage += '<br /><br />';
					_this.showStep1 = false;
					_this.showStep2 = false;
					_this.showStep3 = true;
					_this.$emit('data-updated');
				}).catch(function (error) {
					if (error) {
						console.log(error);
						_this.uploadResultMessage = 'Napaka pri uvozu podatkov!';
						_this.showStep1 = false;
						_this.showStep2 = false;
						_this.showStep3 = true;
					}
				});
			}
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		dzTemplate: function dzTemplate() {
			return '<div class="dz-preview dz-file-preview">\n\t\t\t\t<div class="dz-image">\n\t\t\t\t\t<div data-dz-thumbnail-bg></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-details">\n\t\t\t\t\t<div class="dz-filename"><span data-dz-name></span></div><br />(<div class="dz-size"><span data-dz-size></span></div>)\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n\t\t\t\t<div class="dz-error-message"><span data-dz-errormessage></span></div>\n\t\t\t\t<div class="dz-success-mark"><i class="fa fa-check"></i></div>\n\t\t\t\t<div class="dz-error-mark"><i class="fa fa-close"></i></div>\n\t\t\t</div>';
		}
	},
	data: function data() {
		var _this2 = this;

		return {
			showStep1: true,
			showStep2: false,
			showStep3: false,
			animate: true,
			zalogaUploadedNissan: null,
			uploadResultMessage: '',
			usZalogaNissan: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko z zalogo<br /><b>Nissan</b>',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', 'nissan');
					formData.append('import_make', 'nissan');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					_this2.showError('Napaka pri nalaganju datoteke na strežnik!');
					_this2.$refs.dzZalogaNissan.removeAllFiles();
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.zalogaUploadedNissan = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					_this2.showError();
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.zalogaUploadedNissan = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR'
		};
	},
	created: function created() {
		var _this3 = this;

		var user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
		user.getIdToken().then(function (idToken) {
			var headers = {
				'Authorization': 'Bearer ' + idToken
			};
			_this3.usZalogaNissan.headers = headers;
		});
	}
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PickKupecInline__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'pick-kupec-inline': __WEBPACK_IMPORTED_MODULE_1__components_PickKupecInline__["a" /* default */]
	},
	props: {
		prodajalci: Array,
		kupci: Array
	},
	methods: {
		showModal: function showModal(id) {
			this.item_id = id;

			this.prodajalci_selected = null;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.vsiProdajalci), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.user.email === item.email) {
						this.prodajalci_selected = item;
						break;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.user.role === 5) {
				this.prodajalci_disabled = false;
				this.trajanja_disabled = false;
				this.trajanje_value = 1;
			}
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			if (!this.item_id) {
				this.showError('Vozilo ni izbrano');
				return;
			}
			if (!this.prodajalci_selected) {
				this.showError('Prodajalec ni izbran');
				return;
			}
			if (!this.kupec_selected) {
				this.showError('Kupec ni izbran');
				return;
			}

			this.showError(null);
			this.in_progress = true;
			__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].rezervirajVozilo(this.item_id, this.prodajalci_selected, this.kupec_selected, this.trajanje_value).then(function (response) {
				_this.$refs.modal.hide();
				_this.clearModalData();
				_this.$emit('reservation-success');
			}).catch(function (error) {
				_this.in_progress = false;
				_this.processAddError(error);
			});
		},
		processAddError: function processAddError(error) {
			if (!error) {
				this.showError('Napaka pri prezervaciji (G)');
				return;
			}
			console.log(error);
			if (!error.response || !error.response.status || error.response.status !== 400) {
				this.showError('Rezervacija ni uspela (S)');
				return;
			}
			if (!error.response.data || !error.response.data.code || !error.response.data.message) {
				this.showError('Rezervacija ni uspela (U)');
				return;
			}
			this.showError(error.response.data.message + ' (#' + error.response.data.code + ')');
		},
		clearModalData: function clearModalData() {
			this.kupec_selected = null;
			this.trajanje_value = 1;
			this.action_message_type = null;
			this.action_message = null;
			this.in_progress = false;
		},
		loadProdajalci: function loadProdajalci() {
			var _this2 = this;

			this.prodajalci_options = [];
			__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].getProdajalci().then(function (prodajalci) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(prodajalci), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var item = _step2.value;

						item.full_name = item.first_name + ' ' + item.last_name;
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				_this2.prodajalci_options = prodajalci;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		showError: function showError(message) {
			this.action_message_type = this.ACTION_TYPE_ERROR;
			this.action_message = message;
		}
	},
	data: function data() {
		return {
			item_id: null,
			prodajalci_disabled: true,
			prodajalci_selected: null,
			prodajalci_options: null,
			kupec_selected: null,
			trajanja_disabled: true,
			trajanje_value: 1,
			action_message_type: null,
			action_message: null,
			in_progress: false,
			ACTION_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		vsiProdajalci: function vsiProdajalci() {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		}
	},
	created: function created() {}
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
	},
	props: {
		value: Object,
		title: String,
		kupci: Array,
		userCanEdit: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		value: function value() {
			if (this.value == null) {
				this.izbran_kupec = null;
			} else {
				this.kupciSelect_change(this.value);
			}
		}
	},
	methods: {
		selectOld: function selectOld(id) {
			this.izbran_kupec = null;
			if (id) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.vsiKupci), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						if (id === item.id) {
							this.izbran_kupec = item;
							break;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
			this.$emit('input', this.izbran_kupec);
		},
		select: function select(id) {
			var _this = this;

			this.izbran_kupec = null;
			if (id) {
				this.kupciLoading = true;
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchKupecById(id).then(function (response) {
					_this.kupciLoading = false;
					if (response.message === 'success') {
						console.log('response.kupec', response.kupec);
						var kupec = response.kupec;
						if (kupec.is_company) {
							kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
						} else {
							kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
						}
						_this.izbran_kupec = kupec;
					} else {
						console.error('Neveljaven odziv strežnika');
					}
					_this.$emit('input', _this.izbran_kupec);
				}).catch(function (error) {
					_this.kupciLoading = false;
					_this.$emit('input', _this.izbran_kupec);
					_this.clearNovKupec();
					if (error.response) {
						console.error(error);
					} else if (error.request) {
						console.error('The request was made but no response was received:', error.request);
					} else {
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
			}
		},
		novKupec_Submit: function novKupec_Submit(evt) {
			var _this2 = this;

			evt.preventDefault();
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].addKupec(this.obrazec).then(function (kupec) {
				if (kupec.is_company) {
					kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
				} else {
					kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
				}
				_this2.vsiKupci.push(kupec);

				_this2.izbran_kupec = kupec;
				_this2.$emit('input', _this2.izbran_kupec);
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		novKupec_Reset: function novKupec_Reset(evt) {
			evt.preventDefault();
			this.clearNovKupec();
		},

		clearNovKupec: function clearNovKupec() {
			var _this3 = this;

			this.obrazec.id = 0;
			this.obrazec.is_company = false;
			this.obrazec.title = '';
			this.obrazec.contact_name = '';
			this.obrazec.first_name = '';
			this.obrazec.last_name = '';
			this.obrazec.email = '';
			this.obrazec.phone_number = '';
			this.prikazi_obrazec = false;
			this.$nextTick(function () {
				_this3.prikazi_obrazec = true;
			});
		},
		loadKupci: function loadKupci() {
			var _this4 = this;

			this.kupci_options = [];
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchKupci('#initialize').then(function (kupci) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(kupci), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var kupec = _step2.value;

						if (kupec.is_company) {
							kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
						} else {
							kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				_this4.kupci_options = kupci;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		kupciSelect_load: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm) {
			if (!vm.kupci_searchEmpty) {
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchKupci(search).then(function (kupci) {
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(kupci), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var kupec = _step3.value;

							if (kupec.is_company) {
								kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
							} else {
								kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
							}
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}

					loading(false);
					vm.kupci_searched = kupci;
				}).catch(function (error) {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
			} else {
				loading(false);
			}
		}, 500),
		kupciSelect_change: function kupciSelect_change(kupec) {
			if (kupec) {
				this.izbran_kupec = kupec;
				this.obrazec.id = kupec.id;
				this.obrazec.is_company = kupec.is_company;
				this.obrazec.title = kupec.title;
				this.obrazec.contact_name = kupec.contact_name;
				this.obrazec.first_name = kupec.first_name;
				this.obrazec.last_name = kupec.last_name;
				this.obrazec.email = kupec.email;
				this.obrazec.phone_number = kupec.phone_number;
			} else {
				this.izbran_kupec = null;
				this.kupci_searched = null;
				this.clearNovKupec();
			}
			this.$emit('input', this.izbran_kupec);
		},

		kupciSelect_search: function kupciSelect_search(search, loading) {
			if (search && search !== '') {
				this.kupci_searchEmpty = false;
				loading(true);
				this.kupciSelect_load(loading, search, this);
			} else if (search === '' && this.izbran_kupec == null) {
				this.kupci_searched = null;
				this.kupci_searchEmpty = true;
			}
		}
	},
	data: function data() {
		return {
			kupci_searchEmpty: false,
			izbran_kupec: null,
			kupci_options: null,
			kupci_searched: null,
			obrazec: {
				id: 0,
				is_company: false,
				title: '',
				contact_name: '',
				first_name: '',
				last_name: '',
				email: '',
				phone_number: ''
			},
			prikazi_obrazec: true,
			kupciLoading: false
		};
	},
	computed: {
		vsiKupci: function vsiKupci() {
			if (this.kupci_searched != null) {
				return this.kupci_searched;
			}if (this.kupci) {
				return this.kupci;
			} else {
				if (this.kupci_options == null) {
					this.loadKupci();
				}
				return this.kupci_options;
			}
		}
	},
	created: function created() {}
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PickKupecInline__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns__);







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'pick-kupec-inline': __WEBPACK_IMPORTED_MODULE_1__components_PickKupecInline__["a" /* default */]
	},
	props: {
		prodajalci: Array,
		kupci: Array
	},
	methods: {
		showModal: function showModal(id, prodajaId, prodajalec, kupec, datumProdaje, datumPlaniraneDobave, urejenoFinanciranje, vlozeno, podpisano, financiranjeRci, external, externalKupecHr) {
			var _this = this;

			this.item_id = id;
			this.prodaja_id = null;
			if (prodajaId) {
				this.prodaja_id = prodajaId;
			}
			this.clearModalData();

			this.prodajalci_selected = null;
			if (prodajalec) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.vsiProdajalci), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						if (prodajalec === item.id) {
							this.prodajalci_selected = item;
							break;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.vsiProdajalci), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var _item = _step2.value;

						if (this.user.email === _item.email) {
							this.prodajalci_selected = _item;
							break;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			}

			if (kupec) {
				this.$nextTick(function () {
					_this.$refs.pickKupec.select(kupec);
				});
			} else {
				this.$nextTick(function () {
					_this.$refs.pickKupec.select(null);
				});
			}

			if (datumProdaje) {
				var dp = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(datumProdaje, __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].dbDtFormat);
				this.datum_prodaje = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(dp, __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].inputDtFormat);
			}

			if (datumPlaniraneDobave) {
				var dpi = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(datumPlaniraneDobave, __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].dbDtFormat);
				this.datum_planirane_izdaje = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(dpi, __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].inputDtFormat);
			}

			if (urejenoFinanciranje != null) {
				this.urejeno_financiranje = urejenoFinanciranje === 1;
			}
			if (vlozeno != null) {
				this.vlozeno = vlozeno === 1;
			}
			if (podpisano != null) {
				this.podpisano = podpisano === 1;
			}
			if (financiranjeRci != null) {
				this.financiranje_rci = financiranjeRci === 1;
			}
			this.external = external;
			this.externalKupecHr = externalKupecHr;

			this.prodajalci_disabled = true;
			if (this.user.role === 5 && !this.external) {
				this.prodajalci_disabled = false;
			}
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this2 = this;

			evt.preventDefault();
			if (!this.item_id) {
				this.showError('Vozilo ni izbrano');
				return;
			}
			if (!this.prodajalci_selected) {
				this.showError('Prodajalec ni izbran');
				return;
			}
			if (!this.external && !this.kupec_selected) {
				this.showError('Kupec ni izbran');
				return;
			}
			if (!this.datum_prodaje) {
				this.showError('Datum prodaje ni izbran');
				return;
			}
			if (!this.datum_planirane_izdaje) {
				this.showError('Kupec planirane izdaje ni izbran');
				return;
			}
			if (this.urejeno_financiranje == null) {
				this.showError('Stanje urejenega financiranja ni izbrano');
				return;
			}
			if (this.vlozeno == null) {
				this.showError('Stanje vloženosti ni izbrano');
				return;
			}
			if (this.podpisano == null) {
				this.showError('Stanje podpisa ni izbrano');
				return;
			}
			if (this.financiranje_rci == null) {
				this.showError('Stanje RCI financiranja ni izbrano');
				return;
			}

			this.showError(null);
			this.in_progress = true;
			__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].prodajVozilo(this.item_id, this.prodaja_id, this.prodajalci_selected, this.kupec_selected, this.datum_prodaje, this.datum_planirane_izdaje, this.urejeno_financiranje, this.vlozeno, this.podpisano, this.financiranje_rci, this.external).then(function (response) {
				_this2.$refs.modal.hide();
				_this2.clearModalData();
				_this2.$emit('sell-success');
			}).catch(function (error) {
				_this2.in_progress = false;
				_this2.processAddError(error);
				if (error) {
					console.log(error);
				}
			});
		},
		processAddError: function processAddError(error) {
			if (!error) {
				this.showError('Napaka pri prodaji (G)');
				return;
			}
			console.log(error);
			if (!error.response || !error.response.status || error.response.status !== 400) {
				this.showError('Prodaja ni uspela (S)');
				return;
			}
			if (!error.response.data || !error.response.data.code || !error.response.data.message) {
				this.showError('Prodaja ni uspela (U)');
				return;
			}
			this.showError(error.response.data.message + ' (#' + error.response.data.code + ')');
		},
		clearModalData: function clearModalData() {
			this.kupec_selected = null;
			this.datum_prodaje = '';
			this.datum_planirane_izdaje = '';
			this.urejeno_financiranje = null;
			this.vlozeno = null;
			this.podpisano = null;
			this.financiranje_rci = null;
			this.external = false;
			this.externalKupecHr = '';
			this.action_message_type = null;
			this.action_message = null;
			this.in_progress = false;
		},
		loadProdajalci: function loadProdajalci() {
			var _this3 = this;

			this.prodajalci_options = [];
			__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].getProdajalci().then(function (prodajalci) {
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(prodajalci), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var item = _step3.value;

						item.full_name = item.first_name + ' ' + item.last_name;
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}

				_this3.prodajalci_options = prodajalci;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		showError: function showError(message) {
			this.action_message_type = this.ACTION_TYPE_ERROR;
			this.action_message = message;
		}
	},
	data: function data() {
		return {
			item_id: null,
			prodaja_id: null,
			prodajalci_disabled: true,
			prodajalci_selected: null,
			prodajalci_options: null,
			kupec_selected: null,
			datum_prodaje: '',
			datum_planirane_izdaje: '',
			urejeno_financiranje: null,
			vlozeno: null,
			podpisano: null,
			financiranje_rci: null,
			external: false,
			externalKupecHr: '',
			action_message_type: null,
			action_message: null,
			in_progress: false,
			ACTION_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		vsiProdajalci: function vsiProdajalci() {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		}
	},
	created: function created() {}
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns__);






/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		showModal: function showModal(id, lokacija, datumDobave) {
			this.item_id = id;
			this.lokacija_selected = null;
			if (lokacija) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.lokacija_options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						if (lokacija === item.value) {
							this.lokacija_selected = item;
							break;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
			this.datum_dobave = '';
			if (datumDobave) {
				var dp = Object(__WEBPACK_IMPORTED_MODULE_3_date_fns__["parse"])(datumDobave, __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].dbDtFormat);
				this.datum_dobave = Object(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(dp, __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].inputDtFormat);
			}
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			if (this.item_id != null && this.lokacija_selected != null && this.datum_dobave !== '') {
				__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].dobavivKoncesijo(this.item_id, this.user, this.lokacija_selected, this.datum_dobave).then(function (response) {
					_this.$refs.modal.hide();
					_this.$emit('prodajavkoncesijo-success');
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
				});
			}
		}
	},
	data: function data() {
		return {
			item_id: null,
			datum_dobave: '',
			lokacija_selected: null,
			lokacija_options: [{
				label: 'CC (city center)',
				value: 'CC'
			}, {
				label: 'ŠO (šotor)',
				value: 'ŠO'
			}, {
				label: 'DV (dvorišče)',
				value: 'DV'
			}, {
				label: 'OG (ograja)',
				value: 'OG'
			}, {
				label: 'Ostalo',
				value: 'Ostalo'
			}]
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		}
	},
	created: function created() {}
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		showModal: function showModal(id) {
			this.item_id = id;
			this.lastnik_selected = null;
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			if (this.item_id != null && this.lastnik_selected != null) {
				__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].zadrziVozilo(this.item_id, this.lastnik_selected.value).then(function (response) {
					_this.$refs.modal.hide();
					_this.$emit('zadrzano-success');
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
				});
			}
		}
	},
	data: function data() {
		return {
			item_id: null,
			lastnik_selected: null,
			lastnik_options: [{
				label: 'ATC',
				value: 'ATC'
			}, {
				label: 'Strašek',
				value: 'STRAŠEK'
			}, {
				label: 'AHPA',
				value: 'AHPA'
			}]
		};
	},
	created: function created() {}
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'stanjefilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: 'ARA',
				value: 'ARA',
				active: false
			}, {
				label: 'ARA/>90',
				value: 'ARA/>90',
				active: false
			}, {
				label: 'EXPE',
				value: 'EXPE',
				active: false
			}, {
				label: 'M+1',
				value: 'M+1',
				active: false
			}, {
				label: 'M+2',
				value: 'M+2',
				active: false
			}, {
				label: 'MADC',
				value: 'MADC',
				active: false
			}, {
				label: 'OC',
				value: 'OC',
				active: false
			}, {
				label: 'pred AF',
				value: 'pred AF',
				active: false
			}, {
				label: 'TOVAR',
				value: 'TOVAR',
				active: false
			}, {
				label: 'TRPP',
				value: 'TRPP',
				active: false
			}, {
				label: 'ZPRT',
				value: 'ZPRT',
				active: false
			}, {
				label: 'PROIZVODNJA',
				value: 'PROIZVODNJA',
				active: false
			}, {
				label: 'AVTOTEHNIKA CELJE',
				value: 'AVTOTEHNIKA CELJE',
				active: false
			}, {
				label: 'ATK/PRESK/CE.',
				value: 'ATK/PRESK/CE.',
				active: false
			}, {
				label: 'TRANSPORT IZ AMSTERD',
				value: 'TRANSPORT IZ AMSTERD',
				active: false
			}]
		};
	}
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'stanjefilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: 'Prodano',
				value: 'prod',
				active: false
			}, {
				label: 'Rezervirano',
				value: 'rez',
				active: false
			}, {
				label: 'V koncesiji',
				value: 'konces',
				active: false
			}, {
				label: 'Ni v koncesiji',
				value: 'nokonces',
				active: false
			}, {
				label: 'Prosto',
				value: 'prosto',
				active: false
			}]
		};
	}
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lokacijefilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vse lokacije',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: 'CC (city center)',
				value: 'CC',
				active: false
			}, {
				label: 'ŠO (šotor)',
				value: 'ŠO',
				active: false
			}, {
				label: 'DV (dvorišče)',
				value: 'DV',
				active: false
			}, {
				label: 'OG (ograja)',
				value: 'OG',
				active: false
			}, {
				label: 'Ostalo',
				value: 'Ostalo',
				active: false
			}]
		};
	}
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'prodajafilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vsa prodaja',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: 'Urejeno financiranje',
				value: 'financiranjeu',
				active: false
			}, {
				label: 'Vloženo',
				value: 'vlozeno',
				active: false
			}, {
				label: 'Podpisano',
				value: 'podpisano',
				active: false
			}, {
				label: 'Financiranje RCI',
				value: 'financiranjerci',
				active: false
			}]
		};
	}
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		showModal: function showModal(id, opomba, akcijski) {
			this.item_id = id;
			this.opomba = opomba;
			this.akcijski = akcijski;
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			if (this.item_id != null && this.opomba != null) {
				__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].urediOpomboVozilo(this.item_id, this.opomba, this.akcijski).then(function (response) {
					_this.$refs.modal.hide();
					_this.$emit('opomba-success');
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
				});
			}
		}
	},
	data: function data() {
		return {
			item_id: null,
			opomba: '',
			akcijski: 0
		};
	},
	created: function created() {}
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapaModal_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a07474_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapaModal_vue__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(929)
  __webpack_require__(930)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23a07474"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a07474_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a07474_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PlacilaModal__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ladda__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modals_EditPrilivModal__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modals_NaloziDatotekoModal__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modals_ZeljenaIzstavitevRacunaModal__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Modals_DodajanjeStKupoprodajnePogodbeModal__ = __webpack_require__(946);














var znasekRegex = /[+-]{0,1}[0-9.,]{1,10}/;

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a,
		'placila-modal': __WEBPACK_IMPORTED_MODULE_3__components_PlacilaModal__["a" /* default */],
		'edit-priliv-modal': __WEBPACK_IMPORTED_MODULE_8__components_Modals_EditPrilivModal__["a" /* default */],
		'nalozi-datoteko-modal': __WEBPACK_IMPORTED_MODULE_9__components_Modals_NaloziDatotekoModal__["a" /* default */],
		'zeljena-izstavitev-racuna-modal': __WEBPACK_IMPORTED_MODULE_10__components_Modals_ZeljenaIzstavitevRacunaModal__["a" /* default */],
		'dodajanje-st-kupoprodjane-pogodbe-modal': __WEBPACK_IMPORTED_MODULE_11__components_Modals_DodajanjeStKupoprodajnePogodbeModal__["a" /* default */]
	},
	methods: {
		showModal: function showModal(id, ogrodje, vozilo, prodajalecId, prodajalecName, kupec, starost, datumProdaje, datumPlaniraneDobave, financiranjeRci, koncesijaDatum, autoLoadPlacila) {
			this.isLoading = true;
			this.item_id = id;
			this.ogrodje = ogrodje;
			this.vozilo = vozilo;
			this.prodajalec_id = prodajalecId;
			this.prodajalec_name = prodajalecName;
			this.kupec = kupec;
			this.starost = starost;
			if (datumProdaje) {
				this.datum_nakupa = datumProdaje;
			}
			if (datumPlaniraneDobave) {
				this.datum_planirane_dobave = datumPlaniraneDobave;
			}
			this.financiranje_rci = financiranjeRci;
			if (koncesijaDatum) {
				this.koncesija_datum = koncesijaDatum;
			}
			this.autoLoadPlacila = autoLoadPlacila;
			if (!this.autoLoadPlacila) {
				this.$refs.modal.show();
			}
			this.getMapa(id);
		},
		getMapa: function getMapa(itemId) {
			var _this = this;

			this.isLoading = true;
			this.initChangeNakazila = false;
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getMapa(itemId).then(function (response) {
				if (response) {
					_this.podaljsano_jamstvo_picked = response['mapa']['podaljsano_jamstvo'];
					_this.podaljsano_jamstvo_leta = response['mapa']['podaljsano_jamstvo_leta'];
					_this.podaljsano_jamstvo_km = response['mapa']['podaljsano_jamstvo_km'];
					_this.podaljsano_jamstvo_znesek = Number(response['mapa']['podaljsano_jamstvo_znesek']) || null;
					_this.podaljsano_jamstvo_opomba = response['mapa']['podaljsano_jamstvo_opomba'];
					_this.zavarovanje_picked = response['mapa']['zavarovanje'];
					_this.zavarovanje_opomba = response['mapa']['zavarovanje_opomba'];
					_this.myr_picked = response['mapa']['myr'];
					_this.myr_leta = response['mapa']['myr_leta'];
					_this.myr_km = response['mapa']['myr_km'];
					_this.myr_znesek = Number(response['mapa']['myr_znesek']) || null;
					_this.myr_opomba = response['mapa']['myr_opomba'];
					_this.gap_picked = response['mapa']['gap'];
					_this.gap_opomba = response['mapa']['gap_opomba'];
					_this.bni_picked = response['mapa']['bni'];
					_this.bni_opomba = response['mapa']['bni_opomba'];
					_this.bonus1 = Number(response['mapa']['bonus1']) || null;
					_this.bonus2 = Number(response['mapa']['bonus2']) || null;
					_this.bonus3 = Number(response['mapa']['bonus3']) || null;
					_this.bonus4 = Number(response['mapa']['bonus4']) || null;
					_this.bonus5 = Number(response['mapa']['bonus5']) || null;
					_this.bonus6 = Number(response['mapa']['bonus6']) || null;
					_this.ostali_dogovori = response['mapa']['ostali_dogovori'];
					_this.nulti_picked = response['mapa']['nulti'];
					_this.ciscenje_picked = response['mapa']['ciscenje'];
					_this.klic_stranke = response['mapa']['klic_stranke'];
					_this.st_racuna = response['mapa']['st_racuna'];
					_this.datum_racuna = response['mapa']['datum_racuna'];
					_this.prodajna_cena = Number(response['mapa']['prodajna_cena']) || null;
					_this.skupni_znesek = Number(response['mapa']['skupni_znesek']) || null;
					_this.rci_lizing = response['mapa']['rci_lizing'];
					_this.rci_kredit = response['mapa']['rci_kredit'];
					_this.nakazila = [];
					var nakazilaFromDb = response['mapa']['nakazila'];
					if (nakazilaFromDb !== undefined) {
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;

						try {
							for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(nakazilaFromDb), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var nakaziloFromDb = _step.value;

								_this.nakazila.push({
									id: nakaziloFromDb['id'],
									tip: nakaziloFromDb['tip'],
									datum: nakaziloFromDb['datum'],
									znesek: Number(nakaziloFromDb['znesek']),
									opomba: nakaziloFromDb['opomba'],
									st_kupoprodajne_pogodbe: nakaziloFromDb['st_kupoprodajne_pogodbe'],
									ujemajocPrilivId: null,
									ujemajocPrilivZnesek: null
								});
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}
					}
					_this.povracila = [];
					var povracilaFromDb = response['mapa']['povracila'];
					if (povracilaFromDb !== undefined) {
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(povracilaFromDb), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var povraciloFromDb = _step2.value;

								_this.povracila.push({
									id: povraciloFromDb['id'],
									tip: povraciloFromDb['tip'],
									datum: povraciloFromDb['datum'],
									znesek: Number(povraciloFromDb['znesek'])
								});
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
					_this.oprema = [];
					var dodatneopremeFromDb = response['mapa']['dodatneopreme'];
					if (dodatneopremeFromDb !== undefined) {
						var _iteratorNormalCompletion3 = true;
						var _didIteratorError3 = false;
						var _iteratorError3 = undefined;

						try {
							for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dodatneopremeFromDb), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
								var dodatnaopremaFromDb = _step3.value;

								_this.oprema.push({
									id: dodatnaopremaFromDb['id'],
									tip: dodatnaopremaFromDb['tip'],
									znesek: Number(dodatnaopremaFromDb['znesek']),
									opomba: dodatnaopremaFromDb['opomba'],
									datum_narocila: dodatnaopremaFromDb['datum_narocila']
								});
							}
						} catch (err) {
							_didIteratorError3 = true;
							_iteratorError3 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion3 && _iterator3.return) {
									_iterator3.return();
								}
							} finally {
								if (_didIteratorError3) {
									throw _iteratorError3;
								}
							}
						}
					}
					_this.datum_prodajalec_potrdil = response['mapa']['datum_prodajalec_potrdil'];
					_this.datum_sekretar_potrdil = response['mapa']['datum_sekretar_potrdil'];
					_this.datum_moderator_potrdil = response['mapa']['datum_moderator_potrdil'];
					_this.datum_racunovodja_potrdil = response['mapa']['datum_racunovodja_potrdil'];
					_this.prilivi = [];
					_this.priliviBrezUjemanj = [];
					var priliviFromDb = response['mapa']['prilivi'];
					if (priliviFromDb !== undefined) {
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(priliviFromDb), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var prilivFromDb = _step4.value;

								_this.prilivi.push({
									id: prilivFromDb['id'],
									naziv: prilivFromDb['naziv'],
									placnik: prilivFromDb['placnik'],
									referenca: prilivFromDb['referenca'],
									vir: prilivFromDb['vir'],
									datum: prilivFromDb['datum'],
									znesek: Number(prilivFromDb['znesek'])
								});
								_this.priliviBrezUjemanj.push({
									id: prilivFromDb['id'],
									naziv: prilivFromDb['naziv'],
									placnik: prilivFromDb['placnik'],
									referenca: prilivFromDb['referenca'],
									vir: prilivFromDb['vir'],
									datum: prilivFromDb['datum'],
									znesek: Number(prilivFromDb['znesek'])
								});
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}
					}
					_this.povracilaData = [];
					_this.povracilaDataBrezUjemanja = [];
					var povracilaDataFromDb = response['mapa']['povracilaData'];
					if (povracilaDataFromDb !== undefined) {
						var _iteratorNormalCompletion5 = true;
						var _didIteratorError5 = false;
						var _iteratorError5 = undefined;

						try {
							for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(povracilaDataFromDb), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
								var povraciloDataFromDb = _step5.value;

								_this.povracilaData.push({
									id: povraciloDataFromDb['id'],
									action_name: povraciloDataFromDb['action_name'],
									chassis: povraciloDataFromDb['chassis'],
									sale_channel: povraciloDataFromDb['sale_channel'],
									creditnotedate: povraciloDataFromDb['creditnotedate'],
									amount: Number(povraciloDataFromDb['amount'])
								});
								_this.povracilaDataBrezUjemanja.push({
									id: povraciloDataFromDb['id'],
									action_name: povraciloDataFromDb['action_name'],
									chassis: povraciloDataFromDb['chassis'],
									sale_channel: povraciloDataFromDb['sale_channel'],
									creditnotedate: povraciloDataFromDb['creditnotedate'],
									amount: Number(povraciloDataFromDb['amount'])
								});
							}
						} catch (err) {
							_didIteratorError5 = true;
							_iteratorError5 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion5 && _iterator5.return) {
									_iterator5.return();
								}
							} finally {
								if (_didIteratorError5) {
									throw _iteratorError5;
								}
							}
						}
					}
					_this.datoteke = _this.addFilesTypes(response['mapa']['datoteke']);
					_this.mapaExist = true;
					_this.formChanged = false;
					if (response['mapa']['zeljena_izstavitev_racuna'] != null) {
						_this.zeljenaIzstavitevRacuna = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(response['mapa']['zeljena_izstavitev_racuna'], __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].dbDtFormat);
					} else {
						_this.zeljenaIzstavitevRacuna = null;
					}
					_this.datum_izstavitve_racuna = response['mapa']['datum_izstavitve_racuna'];
					_this.stopnja_ddv = response['mapa']['stopnja_ddv'];
					_this.najdiUjemanjaNakazil();
					_this.najdiUjemanjaPovracil();
				} else {
					_this.mapaExist = false;
					_this.stopnja_ddv = __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].stopnja_ddv;
				}
				_this.nakazila_to_delete = [];
				_this.povracila_to_delete = [];
				_this.dodatneopreme_to_delete = [];
				_this.isLoading = false;
				if (_this.autoLoadPlacila) {
					_this.showPlacilaModal();
				}
				setTimeout(function () {
					_this.initChangeNakazila = true;
				}, 1000);
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				_this.isLoading = false;
				_this.$refs.modal.hide();
			});
		},
		addFilesTypes: function addFilesTypes(datoteke) {
			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;

			try {
				for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(datoteke), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var datoteka = _step6.value;

					var extension = datoteka.ime_datoteke.substring(datoteka.ime_datoteke.length - 4, datoteka.ime_datoteke.length).toLowerCase();
					if (extension === '.pdf') {
						datoteka.file_type = 'fa-file-pdf-o';
					} else if (extension === '.jpg' || extension === 'jpeg' || extension === '.bmp' || extension === '.png') {
						datoteka.file_type = 'fa-file-image-o';
					} else if (extension === '.xls' || extension === 'xlsx' || extension === '.csv' || extension === '.slk') {
						datoteka.file_type = 'fa-file-excel-o';
					} else if (extension === '.doc' || extension === 'docx') {
						datoteka.file_type = 'fa-file-excel-o';
					} else if (extension === '.txt') {
						datoteka.file_type = 'fa-file-text-o';
					} else if (extension === '.ppt' || extension === 'pptx') {
						datoteka.file_type = 'fa-file-powerpoint-o';
					} else {
						datoteka.file_type = 'fa-file-o';
					}
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}

			return datoteke;
		},
		click_updateData: function click_updateData(evt) {
			var _this2 = this;

			if (this.item_id) {
				var loader = __WEBPACK_IMPORTED_MODULE_7_ladda__["a" /* create */](this.$refs.aUpdate);
				loader.start();
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getMFilesInfo(this.item_id).then(function (response) {
					loader.stop();
					if (!response.item) {
						return;
					}
					if (response.item.id !== _this2.item_id) {
						return;
					}
					_this2.st_racuna = response.item.st_racuna;
					_this2.datum_racuna = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(response.item.datum_racuna, __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].dbDtFormat);
					_this2.skupni_znesek = Number(response.item.skupni_znesek);
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
					loader.stop();
				});
			}
		},
		click_toggleLock: function click_toggleLock(evt) {
			this.moderatorUnlock = !this.moderatorUnlock;
		},
		onOkModal: function onOkModal(evt) {
			var _this3 = this;

			evt.preventDefault();
			if (this.ogrodje != null && this.item_id != null) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].saveMapa(this.item_id, this.podaljsano_jamstvo_picked, this.podaljsano_jamstvo_leta, this.podaljsano_jamstvo_km, this.podaljsano_jamstvo_znesek, this.podaljsano_jamstvo_opomba, this.zavarovanje_picked, this.zavarovanje_opomba, this.myr_picked, this.myr_leta, this.myr_km, this.myr_znesek, this.myr_opomba, this.gap_picked, this.gap_opomba, this.bni_picked, this.bni_opomba, this.bonus1, this.bonus2, this.bonus3, this.bonus4, this.bonus5, this.bonus6, this.ostali_dogovori, this.nulti_picked, this.ciscenje_picked, this.klic_stranke, this.st_racuna, this.datum_racuna, this.prodajna_cena, this.skupni_znesek, this.rci_lizing, this.rci_kredit, this.starost, this.nakazila, this.nakazila_to_delete, this.povracila, this.povracila_to_delete, this.oprema, this.dodatneopreme_to_delete, this.stopnja_ddv).then(function (response) {
					_this3.$refs.toastr.s('Mapa vozila z ogordjem ' + _this3.ogrodje + ' uspešno shranjena!');
					_this3.moderatorUnlock = false;
					_this3.getMapa(_this3.item_id);
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
					_this3.showError('Napaka pri shranjevanju mape');
					_this3.isLoading = false;
				});
			}
		},
		onCancelModal: function onCancelModal(evt) {
			var _this4 = this;

			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this4.clearModalData();
			}, 500);
		},
		click_showPlacila: function click_showPlacila(button) {
			this.showPlacilaModal();
		},
		click_showModalZeljenaIzstavitevRacuna: function click_showModalZeljenaIzstavitevRacuna(button) {
			this.$refs.zeljenaIzstavitevRacunaModal.showModal(this.item_id, this.zeljenaIzstavitevRacuna);
		},
		showPlacilaModal: function showPlacilaModal() {
			this.$refs.placilaModal.showModal(this.item_id, this.prodajalec_name, this.kupec, this.ogrodje, this.vozilo, this.st_racuna, this.datum_racuna, this.skupni_znesek, this.prodajna_cena, this.nakazila, this.sumPovracila(), this.starost, this.datum_prodajalec_potrdil, this.datum_sekretar_potrdil, this.datum_moderator_potrdil, this.datum_racunovodja_potrdil, this.podaljsano_jamstvo_znesek, this.myr_znesek);
		},
		click_removeProdajalecPotrdil: function click_removeProdajalecPotrdil() {
			this.removeUserPotrdil(1);
		},
		click_removeSekretarPotrdil: function click_removeSekretarPotrdil() {
			this.removeUserPotrdil(2);
		},
		click_removeModeratorPotrdil: function click_removeModeratorPotrdil() {
			this.removeUserPotrdil(3);
		},
		click_removeRacunovodjaPotrdil: function click_removeRacunovodjaPotrdil() {
			this.removeUserPotrdil(4);
		},
		removeUserPotrdil: function removeUserPotrdil(removeAkcija) {
			var _this5 = this;

			this.isLoading = true;
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].mapaRemoveUserPotrdil(this.item_id, removeAkcija).then(function (response) {
				if (response['message'] === 'success') {
					if (response['mapa']) {
						var mapa = response['mapa'];
						_this5.datum_prodajalec_potrdil = mapa['datum_prodajalec_potrdil'] ? Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(mapa['datum_prodajalec_potrdil'], __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].dbDtFormat) : null;
						_this5.datum_sekretar_potrdil = mapa['datum_sekretar_potrdil'] ? Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(mapa['datum_sekretar_potrdil'], __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].dbDtFormat) : null;
						_this5.datum_moderator_potrdil = mapa['datum_moderator_potrdil'] ? Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(mapa['datum_moderator_potrdil'], __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].dbDtFormat) : null;
						_this5.datum_racunovodja_potrdil = mapa['datum_racunovodja_potrdil'] ? Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(mapa['datum_racunovodja_potrdil'], __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].dbDtFormat) : null;
						if (_this5.datum_prodajalec_potrdil === null) {
							_this5.zeljenaIzstavitevRacuna = null;
						}
						_this5.isLoading = false;
					} else {
						_this5.showError('Napaka (strežnik ni vrnil mape)!');
						console.error('response[mapa] == null!');
						_this5.isLoading = false;
					}
				} else {
					_this5.showError('Neveljaven odziv strežnika!');
					console.error('Neveljaven response message: ' + response['message']);
					_this5.isLoading = false;
				}
			}).catch(function (error) {
				_this5.isLoading = false;
				if (error.response) {
					if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].errorMessages.serverSideValidationError) {
						_this5.showError('Napaka pri validaciji na strežniku!');
						console.error(error.response.data.message + ': ', error.response.data.errors);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].errorMessages.notSavedError) {
						_this5.showError('Napaka pri shranjevanju!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === 'invalidAction') {
						_this5.showError('Neznana akcija brisanja!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].errorMessages.invalidRole) {
						_this5.showError('Uporabnik nima pravice odstranjevanja potrditev!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].errorMessages.PDOException) {
						_this5.showError('Napaka na strežniku!');
						console.error(error.response.data.message, 'details in .ex');
					} else {
						_this5.showError('Neznana napaka na strežniku!');
						console.error(error.response.data.message);
					}
				} else if (error.request) {
					console.log('The request was made but no response was received:', error.request);
				} else {
					console.log('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},

		click_addNakazilo: function click_addNakazilo(evt) {
			if (!this.novo_nakazilo.tip) {
				this.showError('Tip nakazila ni izbran');
				return;
			}
			var res = znasekRegex.test(this.novo_nakazilo.znesek);
			if (this.novo_nakazilo.znesek === '' || !res) {
				this.showError('Znesek nakazila ni pravilen');
				return;
			}
			this.showError(null);

			this.nakazila.push({
				id: 0 - this.nakazila.length,
				tip: this.novo_nakazilo.tip.value,
				datum: this.novo_nakazilo.datum,
				znesek: this.novo_nakazilo.znesek,
				opomba: this.novo_nakazilo.opomba,
				st_kupoprodajne_pogodbe: null,
				ujemajocPrilivId: null,
				ujemajocPrilivZnesek: null
			});
			this.novo_nakazilo.id = 0;
			this.novo_nakazilo.tip = '';
			this.novo_nakazilo.datum = null;
			this.novo_nakazilo.znesek = null;
			this.novo_nakazilo.opomba = '';
			this.novo_nakazilo.st_kupoprodajne_pogodbe = null;
			this.novo_nakazilo.ujemajocPrilivId = null;
			this.novo_nakazilo.ujemajocPrilivZnesek = null;
			this.nakazilaChange();
		},
		click_removeNakazilo: function click_removeNakazilo(nakazilo, evt) {
			this.nakazila_to_delete.push(nakazilo.id);
			this.nakazila = this.nakazila.filter(function (value, index, arr) {
				return value.id !== nakazilo.id;
			});
			this.nakazilaChange();
		},
		tipNakazila_createOption: function tipNakazila_createOption(value) {
			var n = {
				label: value,
				value: value
			};
			return n;
		},
		click_addPovracilo: function click_addPovracilo(evt) {
			if (!this.novo_povracilo.tip) {
				this.showError('Tip povračila ni izbran');
				return;
			}
			var res = znasekRegex.test(this.novo_povracilo.znesek);
			if (this.novo_povracilo.znesek === '' || !res) {
				this.showError('Znesek povračila ni pravilen');
				return;
			}
			this.showError(null);

			this.povracila.push({
				id: 0 - this.povracila.length,
				tip: this.novo_povracilo.tip.value,
				datum: this.novo_povracilo.datum,
				znesek: this.novo_povracilo.znesek,
				ujemajocePovraciloDataId: null,
				ujemajocePovraciloDataZnesek: null
			});
			this.novo_povracilo.id = 0;
			this.novo_povracilo.tip = '';
			this.novo_povracilo.datum = null;
			this.novo_povracilo.znesek = null;
		},
		click_removePovracilo: function click_removePovracilo(povracilo, evt) {
			this.povracila_to_delete.push(povracilo.id);
			this.povracila = this.povracila.filter(function (value, index, arr) {
				return value.id !== povracilo.id;
			});
		},
		tipPovracila_createOption: function tipPovracila_createOption(value) {
			var n = {
				label: value,
				value: value
			};
			return n;
		},
		click_addOprema: function click_addOprema(evt) {
			if (!this.nova_oprema.tip) {
				this.showError('Tip opreme ni izbran');
				return;
			}
			var res = znasekRegex.test(this.nova_oprema.znesek);
			if (this.nova_oprema.znesek === '' || !res) {
				this.showError('Znesek opreme ni pravilen');
				return;
			}
			this.showError(null);

			this.oprema.push({
				id: 0 - this.oprema.length,
				tip: this.nova_oprema.tip.value,
				znesek: this.nova_oprema.znesek,
				datum_narocila: this.nova_oprema.datum_narocila,
				opomba: this.nova_oprema.opomba
			});
			this.nova_oprema.id = 0;
			this.nova_oprema.tip = '';
			this.nova_oprema.znesek = null;
			this.nova_oprema.datum_narocila = null;
			this.nova_oprema.opomba = '';
		},
		click_removeOprema: function click_removeOprema(oprema, evt) {
			this.dodatneopreme_to_delete.push(oprema.id);
			this.oprema = this.oprema.filter(function (value, index, arr) {
				return value.id !== oprema.id;
			});
		},
		tipOpreme_createOption: function tipOpreme_createOption(value) {
			var n = {
				label: value,
				value: value
			};
			return n;
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		sumNakazila: function sumNakazila() {
			var sum = 0;
			var _iteratorNormalCompletion7 = true;
			var _didIteratorError7 = false;
			var _iteratorError7 = undefined;

			try {
				for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.nakazila), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
					var nakazilo = _step7.value;

					sum += nakazilo.znesek;
				}
			} catch (err) {
				_didIteratorError7 = true;
				_iteratorError7 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion7 && _iterator7.return) {
						_iterator7.return();
					}
				} finally {
					if (_didIteratorError7) {
						throw _iteratorError7;
					}
				}
			}

			return sum;
		},
		sumPovracila: function sumPovracila() {
			var sum = 0;
			var _iteratorNormalCompletion8 = true;
			var _didIteratorError8 = false;
			var _iteratorError8 = undefined;

			try {
				for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.povracila), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
					var povracilo = _step8.value;

					sum += povracilo.znesek;
				}
			} catch (err) {
				_didIteratorError8 = true;
				_iteratorError8 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion8 && _iterator8.return) {
						_iterator8.return();
					}
				} finally {
					if (_didIteratorError8) {
						throw _iteratorError8;
					}
				}
			}

			return sum;
		},
		on_userPotrdilSuccess: function on_userPotrdilSuccess(datum, userId, userRole, akcija) {
			this.$emit('userpotrdil-success', datum, userId, userRole, akcija);
			if (akcija === 1) {
				this.datum_prodajalec_potrdil = datum;
			} else if (akcija === 2) {
				this.datum_sekretar_potrdil = datum;
			} else if (akcija === 3) {
				this.datum_moderator_potrdil = datum;
			} else if (akcija === 4) {
				this.datum_racunovodja_potrdil = datum;
			}
			if (this.autoLoadPlacila) {
				this.$refs.modal.hide();
				this.clearModalData();
			}
		},
		on_success_zeljenaIzstavitevRacuna: function on_success_zeljenaIzstavitevRacuna(datum) {
			if (typeof datum === 'string' && datum != null) {
				this.zeljenaIzstavitevRacuna = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(datum, __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].dbDtFormat);
			} else {
				this.zeljenaIzstavitevRacuna = null;
			}
		},
		on_userPotrdilCanceled: function on_userPotrdilCanceled() {
			if (this.autoLoadPlacila) {
				this.$refs.modal.hide();
				this.clearModalData();
			}
		},
		clearModalData: function clearModalData() {
			this.item_id = null;
			this.ogrodje = '';
			this.vozilo = '';
			this.prodajalec_id = 0;
			this.prodajalec_name = '';
			this.kupec = '';
			this.starost = 0;
			this.datum_nakupa = '';
			this.datum_planirane_dobave = '';
			this.financiranje_rci = '';
			this.koncesija_datum = '';
			this.podaljsano_jamstvo_picked = null;
			this.podaljsano_jamstvo_leta = null;
			this.podaljsano_jamstvo_km = null;
			this.podaljsano_jamstvo_znesek = null;
			this.podaljsano_jamstvo_opomba = null;
			this.zavarovanje_picked = null;
			this.zavarovanje_opomba = null;
			this.myr_picked = null;
			this.myr_leta = null;
			this.myr_km = null;
			this.myr_znesek = null;
			this.myr_opomba = null;
			this.gap_picked = null;
			this.gap_opomba = null;
			this.bni_picked = null;
			this.bni_opomba = null;
			this.bonus1 = null;
			this.bonus2 = null;
			this.bonus3 = null;
			this.bonus4 = null;
			this.bonus5 = null;
			this.bonus6 = null;
			this.ostali_dogovori = null;
			this.nulti_picked = null;
			this.ciscenje_picked = null;
			this.klic_stranke = null;
			this.st_racuna = null;
			this.datum_racuna = null;
			this.prodajna_cena = null;
			this.skupni_znesek = null;
			this.rci_lizing = null;
			this.rci_kredit = null;
			this.nakazila = [];
			this.nakazila_to_delete = [];
			this.novo_nakazilo = {
				id: 0,
				tip: '',
				znesek: null,
				datum: null,
				opomba: '',
				st_kupoprodajne_pogodbe: null,
				ujemajocPrilivId: null,
				ujemajocPrilivZnesek: null
			};
			this.povracila = [];
			this.povracila_to_delete = [];
			this.novo_povracilo = {
				id: 0,
				tip: '',
				znesek: null,
				datum: null,
				ujemajocePovraciloDataId: null,
				ujemajocePovraciloDataZnesek: null
			};
			this.oprema = [];
			this.dodatneopreme_to_delete = [];
			this.nova_oprema = {
				id: 0,
				tip: '',
				znesek: null,
				datum_narocila: null,
				opomba: ''
			};
			this.message = {
				type: null,
				text: null
			};
			this.datum_prodajalec_potrdil = null;
			this.datum_sekretar_potrdil = null;
			this.datum_moderator_potrdil = null;
			this.datum_racunovodja_potrdil = null;
			this.mapaExist = false;
			this.formChanged = false;
			this.initChangeNakazila = false;
			this.prilivi = [];
			this.prilivHover = {
				id: null,
				datum: null,
				placnik: null,
				znesek: null,
				vir: null
			};
			this.priliviBrezUjemanj = [];
			this.povracilaData = [];
			this.datoteke = [];
			this.povraciloDataHover = {
				id: null,
				creditnotedate: null,
				amount: null,
				action_name: null,
				sale_channel: null
			};
			this.povracilaDataBrezUjemanja = [];
			this.nakazilaPrilivPar = {
				nakazilo: null,
				priliv: null
			};
			this.nakazilaPriliviPari = [];
			this.zeljenaIzstavitevRacuna = null;
			this.datum_izstavitve_racuna = null;
			this.gumbPlaciloTitle = '';
			this.gumbZeljeniRacunTitle = '';
			this.moderatorUnlock = false;
		},
		najdiUjemanjaNakazil: function najdiUjemanjaNakazil() {
			var _this6 = this;

			var nakazilaTmp = [];
			var priliviTmp = [];

			var _loop = function _loop(nakazilo) {
				if (nakazilo.tip === 'Rabljeno vozilo') {
					nakazilaTmp.push(nakazilo);
					nakazilo.ujemajocPrilivId = 0 - _this6.nakazila.length;
					nakazilo.ujemajocPrilivZnesek = nakazilo.znesek;
					_this6.nakazila = _this6.nakazila.filter(function (value, index, arr) {
						return value.id !== nakazilo.id;
					});
				} else {
					var _loop2 = function _loop2(_priliv) {
						if (nakazilo.znesek === Number(_priliv.znesek)) {
							nakazilaTmp.push(nakazilo);
							_this6.nakazila = _this6.nakazila.filter(function (value, index, arr) {
								return value.id !== nakazilo.id;
							});
							_this6.priliviBrezUjemanj = _this6.priliviBrezUjemanj.filter(function (value, index, arr) {
								return value.id !== _priliv.id;
							});
							nakazilo.ujemajocPrilivId = _priliv.id;
							nakazilo.ujemajocPrilivZnesek = Number(_priliv.znesek);
							return 'break';
						}
					};

					var _iteratorNormalCompletion12 = true;
					var _didIteratorError12 = false;
					var _iteratorError12 = undefined;

					try {
						for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this6.priliviBrezUjemanj), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
							var _priliv = _step12.value;

							var _ret2 = _loop2(_priliv);

							if (_ret2 === 'break') break;
						}
					} catch (err) {
						_didIteratorError12 = true;
						_iteratorError12 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion12 && _iterator12.return) {
								_iterator12.return();
							}
						} finally {
							if (_didIteratorError12) {
								throw _iteratorError12;
							}
						}
					}
				}
			};

			var _iteratorNormalCompletion9 = true;
			var _didIteratorError9 = false;
			var _iteratorError9 = undefined;

			try {
				for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.nakazila), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
					var nakazilo = _step9.value;

					_loop(nakazilo);
				}
			} catch (err) {
				_didIteratorError9 = true;
				_iteratorError9 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion9 && _iterator9.return) {
						_iterator9.return();
					}
				} finally {
					if (_didIteratorError9) {
						throw _iteratorError9;
					}
				}
			}

			var _iteratorNormalCompletion10 = true;
			var _didIteratorError10 = false;
			var _iteratorError10 = undefined;

			try {
				for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.nakazila), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
					var nakazilo = _step10.value;

					nakazilaTmp.push(nakazilo);
				}
			} catch (err) {
				_didIteratorError10 = true;
				_iteratorError10 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion10 && _iterator10.return) {
						_iterator10.return();
					}
				} finally {
					if (_didIteratorError10) {
						throw _iteratorError10;
					}
				}
			}

			var _iteratorNormalCompletion11 = true;
			var _didIteratorError11 = false;
			var _iteratorError11 = undefined;

			try {
				for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.priliviBrezUjemanj), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
					var priliv = _step11.value;

					priliv.znesek = Number(priliv.znesek);
					priliviTmp.push(priliv);
				}
			} catch (err) {
				_didIteratorError11 = true;
				_iteratorError11 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion11 && _iterator11.return) {
						_iterator11.return();
					}
				} finally {
					if (_didIteratorError11) {
						throw _iteratorError11;
					}
				}
			}

			this.nakazila = nakazilaTmp;
			this.priliviBrezUjemanj = priliviTmp;
		},
		clickPrilivZnesek: function clickPrilivZnesek(idPriliva, evt) {
			var izbranPriliv = this.prilivi.find(function (priliv) {
				return priliv.id === idPriliva;
			});
			this.$refs.editPrilivModal.showModal(izbranPriliv, true);
		},
		getPrilivInfo: function getPrilivInfo(idPriliva) {
			var izbranPriliv = this.prilivi.find(function (priliv) {
				return priliv.id === idPriliva;
			});
			this.prilivHover.id = izbranPriliv.id;
			this.prilivHover.datum = izbranPriliv.datum;
			this.prilivHover.placnik = izbranPriliv.placnik;
			this.prilivHover.znesek = izbranPriliv.znesek;
			this.prilivHover.vir = izbranPriliv.vir;
		},
		resetPrilivInfo: function resetPrilivInfo() {
			this.prilivHover.id = null;
			this.prilivHover.datum = null;
			this.prilivHover.placnik = null;
			this.prilivHover.znesek = null;
			this.prilivHover.vir = null;
		},

		najdiUjemanjaPovracil: function najdiUjemanjaPovracil() {
			var _this7 = this;

			var povracilaTmp = [];
			var povracilaDataTmp = [];

			var _loop3 = function _loop3(povracilo) {
				var _loop4 = function _loop4(_povraciloData) {
					if (povracilo.znesek === Number(_this7.dodajDavek(_povraciloData.amount).toFixed(2))) {
						povracilaTmp.push(povracilo);
						_this7.povracila = _this7.povracila.filter(function (value, index, arr) {
							return value.id !== povracilo.id;
						});
						_this7.povracilaDataBrezUjemanja = _this7.povracilaDataBrezUjemanja.filter(function (value, index, arr) {
							return value.id !== _povraciloData.id;
						});
						povracilo.ujemajocePovraciloDataId = _povraciloData.id;
						povracilo.ujemajocePovraciloDataZnesek = Number(_this7.dodajDavek(_povraciloData.amount));
						return 'break';
					}
				};

				var _iteratorNormalCompletion16 = true;
				var _didIteratorError16 = false;
				var _iteratorError16 = undefined;

				try {
					for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this7.povracilaDataBrezUjemanja), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
						var _povraciloData = _step16.value;

						var _ret4 = _loop4(_povraciloData);

						if (_ret4 === 'break') break;
					}
				} catch (err) {
					_didIteratorError16 = true;
					_iteratorError16 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion16 && _iterator16.return) {
							_iterator16.return();
						}
					} finally {
						if (_didIteratorError16) {
							throw _iteratorError16;
						}
					}
				}
			};

			var _iteratorNormalCompletion13 = true;
			var _didIteratorError13 = false;
			var _iteratorError13 = undefined;

			try {
				for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.povracila), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
					var povracilo = _step13.value;

					_loop3(povracilo);
				}
			} catch (err) {
				_didIteratorError13 = true;
				_iteratorError13 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion13 && _iterator13.return) {
						_iterator13.return();
					}
				} finally {
					if (_didIteratorError13) {
						throw _iteratorError13;
					}
				}
			}

			var _iteratorNormalCompletion14 = true;
			var _didIteratorError14 = false;
			var _iteratorError14 = undefined;

			try {
				for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.povracila), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
					var povracilo = _step14.value;

					povracilaTmp.push(povracilo);
				}
			} catch (err) {
				_didIteratorError14 = true;
				_iteratorError14 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion14 && _iterator14.return) {
						_iterator14.return();
					}
				} finally {
					if (_didIteratorError14) {
						throw _iteratorError14;
					}
				}
			}

			var _iteratorNormalCompletion15 = true;
			var _didIteratorError15 = false;
			var _iteratorError15 = undefined;

			try {
				for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.povracilaDataBrezUjemanja), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
					var povraciloData = _step15.value;

					povraciloData.amount = Number(this.dodajDavek(povraciloData.amount));
					povracilaDataTmp.push(povraciloData);
				}
			} catch (err) {
				_didIteratorError15 = true;
				_iteratorError15 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion15 && _iterator15.return) {
						_iterator15.return();
					}
				} finally {
					if (_didIteratorError15) {
						throw _iteratorError15;
					}
				}
			}

			this.povracila = povracilaTmp;
			this.povracilaDataBrezUjemanja = povracilaDataTmp;
		},
		getPovraciloDataInfo: function getPovraciloDataInfo(idPovracilaData) {
			var izbranoPovracilo = this.povracilaData.find(function (povraciloData) {
				return povraciloData.id === idPovracilaData;
			});
			this.povraciloDataHover.id = izbranoPovracilo.id;
			this.povraciloDataHover.creditnotedate = izbranoPovracilo.creditnotedate;
			this.povraciloDataHover.amount = izbranoPovracilo.amount;
			this.povraciloDataHover.action_name = izbranoPovracilo.action_name;
			this.povraciloDataHover.sale_channel = izbranoPovracilo.sale_channel;
		},
		resetPovraciloDataInfo: function resetPovraciloDataInfo() {
			this.povraciloDataHover.id = null;
			this.povraciloDataHover.creditnotedata = null;
			this.povraciloDataHover.amount = null;
			this.povraciloDataHover.action_name = null;
			this.povraciloDataHover.sale_channel = null;
		},
		naloziDatoteko_click: function naloziDatoteko_click() {
			this.$refs.naloziDatotekoModal.showModal('mapa', this.item_id);
		},

		onNaloziDatoteko_success: function onNaloziDatoteko_success(result) {
			result = this.addFilesTypes(result);
			var _iteratorNormalCompletion17 = true;
			var _didIteratorError17 = false;
			var _iteratorError17 = undefined;

			try {
				for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
					var datoteka = _step17.value;

					this.datoteke.push(datoteka);
				}
			} catch (err) {
				_didIteratorError17 = true;
				_iteratorError17 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion17 && _iterator17.return) {
						_iterator17.return();
					}
				} finally {
					if (_didIteratorError17) {
						throw _iteratorError17;
					}
				}
			}
		},
		removeDatoteka_click: function removeDatoteka_click(item) {
			var _this8 = this;

			this.$bvModal.msgBoxConfirm('Želite izbrisati datoteko ' + item.ime_datoteke + '?', {
				title: 'Potrdite brisanje datoteke',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].removeFileOfMapa(item.id).then(function (response) {
						_this8.datoteke = _this8.datoteke.filter(function (value, index, arr) {
							return value.id !== item.id;
						});
						_this8.showError(null);
						_this8.$refs.datotekeTable.refresh();
					}).catch(function (error) {
						_this8.showError('Napaka odstranjevanju datoteke!');
						if (error) {
							console.log(error);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		downloadDatoteka_click: function downloadDatoteka_click(item) {
			var _this9 = this;

			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].downloadFileOfMapa(item.id).then(function (response) {
				console.log(response);
				var blob = new Blob([response.data], { type: response.headers['content-type'] });
				var link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = item.ime_datoteke;
				link.click();
				_this9.showError(null);
			}).catch(function (error) {
				_this9.showError('Napaka pri prenosu datoteke!');
				if (error) {
					console.log(error);
				}
			});
		},
		dodajDavek: function dodajDavek(znesek) {
			return +znesek + +znesek * (this.stopnja_ddv / 100);
		},
		click_setKupoprodajnaPogodba: function click_setKupoprodajnaPogodba(nakazilo, evt) {
			var tmpNakazilo = {
				id: nakazilo.id,
				st_kupoprodajne_pogodbe: nakazilo.st_kupoprodajne_pogodbe
			};
			this.$refs.dodajanjeStKupoprodajnePogodbeModal.showModal(tmpNakazilo);
		},
		on_success_stKupoprodajnePogodbe: function on_success_stKupoprodajnePogodbe(nakaziloId, stKupoprodajnePogodbe) {
			var nakazilo = this.nakazila.find(function (nakazilo) {
				return nakazilo.id === nakaziloId;
			});
			nakazilo.st_kupoprodajne_pogodbe = stKupoprodajnePogodbe;
		},
		getKupoprodajnaPogodbaTitle: function getKupoprodajnaPogodbaTitle(nakazilo) {
			if (nakazilo.id < 1) {
				return 'Najprej je potrebno shraniti mapo';
			} else {
				return nakazilo.st_kupoprodajne_pogodbe;
			}
		},
		getRabljenoVoziloInfo: function getRabljenoVoziloInfo(nakazilo) {
			return 'Št. kupoprodajne pogodbe: ' + nakazilo.st_kupoprodajne_pogodbe;
		},

		nakazilaChange: function nakazilaChange() {
			if (this.initChangeNakazila) {
				this.formChanged = true;
			}
		}
	},
	data: function data() {
		return {
			isLoading: false,
			fullPage: true,
			item_id: null,
			autoLoadPlacila: false,
			ogrodje: '',
			vozilo: '',
			prodajalec_id: 0,
			prodajalec_name: '',
			kupec: '',
			starost: 0,
			datum_nakupa: '',
			datum_planirane_dobave: '',
			financiranje_rci: '',
			koncesija_datum: '',
			podaljsano_jamstvo_picked: null,
			podaljsano_jamstvo_leta: null,
			podaljsano_jamstvo_km: null,
			podaljsano_jamstvo_znesek: null,
			podaljsano_jamstvo_opomba: null,
			zavarovanje_picked: null,
			zavarovanje_opomba: null,
			myr_picked: null,
			myr_leta: null,
			myr_km: null,
			myr_znesek: null,
			myr_opomba: null,
			gap_picked: null,
			gap_opomba: null,
			bni_picked: null,
			bni_opomba: null,
			bonus1: null,
			bonus2: null,
			bonus3: null,
			bonus4: null,
			bonus5: null,
			bonus6: null,
			ostali_dogovori: null,
			nulti_picked: null,
			ciscenje_picked: null,
			klic_stranke: null,
			st_racuna: null,
			datum_racuna: null,
			prodajna_cena: null,
			skupni_znesek: null,
			rci_lizing: null,
			rci_kredit: null,
			nakazila: [],
			nakazila_to_delete: [],
			novo_nakazilo: {
				id: 0,
				tip: '',
				znesek: null,
				datum: null,
				opomba: '',
				st_kupoprodajne_pogodbe: ''
			},
			tipi_nakazil: [{
				label: 'Placilo stranke',
				value: 'Placilo stranke'
			}, {
				label: 'Ara',
				value: 'Ara'
			}, {
				label: 'Blagajna',
				value: 'Blagajna'
			}, {
				label: 'Nakazilo',
				value: 'Nakazilo'
			}, {
				label: 'Banka',
				value: 'Banka'
			}, {
				label: 'Rabljeno vozilo',
				value: 'Rabljeno vozilo'
			}, {
				label: 'RCI Lizing',
				value: 'RCI Lizing'
			}, {
				label: 'RCI Kredit',
				value: 'RCI Lizing'
			}],
			povracila: [],
			povracila_to_delete: [],
			novo_povracilo: {
				id: 0,
				tip: '',
				znesek: null,
				datum: null
			},
			tipi_povracil: [{
				label: 'End of life',
				value: 'End of life'
			}, {
				label: 'Zimske gume',
				value: 'Zimske gume'
			}, {
				label: 'Lista šasij',
				value: 'Lista šasij'
			}, {
				label: 'Redna akcija',
				value: 'Redna akcija'
			}, {
				label: 'Dodatno odobren popust',
				value: 'Dodatno odobren popust'
			}, {
				label: 'Staro za novo',
				value: 'Staro za novo'
			}, {
				label: 'Cash plan RCI',
				value: 'Cash plan RCI'
			}],
			oprema: [],
			dodatneopreme_to_delete: [],
			nova_oprema: {
				id: 0,
				tip: '',
				znesek: null,
				datum_narocila: null,
				opomba: ''
			},
			tipi_opreme: [{
				label: 'Strešni nosilci',
				value: 'Strešni nosilci'
			}, {
				label: 'Gume',
				value: 'Gume'
			}, {
				label: 'Parkirni senzorji',
				value: 'Parkirni senzorji'
			}, {
				label: 'Predelava',
				value: 'Predelava'
			}, {
				label: 'Obvezna oprema',
				value: 'Obvezna oprema'
			}],
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR',
			datum_prodajalec_potrdil: null,
			datum_sekretar_potrdil: null,
			datum_moderator_potrdil: null,
			datum_racunovodja_potrdil: null,
			mapaExist: false,
			formChanged: false,
			initChangeNakazila: false,
			prilivi: [],
			prilivHover: {
				id: null,
				datum: null,
				placnik: null,
				znesek: null,
				vir: null
			},
			povraciloDataHover: {
				id: null,
				creditnotedate: null,
				amount: null,
				action_name: null,
				sale_channel: null
			},
			priliviBrezUjemanj: [],
			povracilaData: [],
			povracilaDataBrezUjemanja: [],
			datoteke: [],
			datotekeTable_fields: [{ key: 'file_type', label: '', class: 'tdIcons' }, { key: 'ime_datoteke', label: 'Ime', sortable: false }, { key: 'actions', label: '', sortable: false, class: 'tdActions' }],
			zeljenaIzstavitevRacuna: null,
			datum_izstavitve_racuna: null,
			stopnja_ddv: null,
			gumbPlaciloTitle: '',
			gumbZeljeniRacunTitle: '',
			moderatorUnlock: false
		};
	},
	watch: {
		prodajna_cena: function prodajna_cena(val, Oldval) {
			if (!(val && !Oldval) && this.item_id) {
				this.formChanged = true;
			}
		}
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		isRoleProdajalec: function isRoleProdajalec() {
			return __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].isProdajalec(this.user.role);
		},
		isRoleSekretar: function isRoleSekretar() {
			return __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].isSekretar(this.user.role);
		},
		isRoleRacunovodja: function isRoleRacunovodja() {
			return __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].isRacunovodja(this.user.role);
		},
		isRoleModerator: function isRoleModerator() {
			return __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].isModerator(this.user.role);
		},
		isRoleAdmin: function isRoleAdmin() {
			return __WEBPACK_IMPORTED_MODULE_6__settings_js__["a" /* default */].isAdmin(this.user.role);
		},
		placiloDisabled: function placiloDisabled() {
			if (!this.mapaExist) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (mapa še ni shranjena)';
				return true;
			}if (this.formChanged) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Prodajna cena ali nakazila so se spremenila, najprej shranite mapo)';
				return true;
			}if (!this.prodajna_cena) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Prodajna cena ni vnešena)';
				return true;
			}if (this.prodajna_cena <= 0) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Prodajna cena mora biti večja od 0€)';
				return true;
			}if (Math.abs(this.razlika) > 100) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Razlika med nakazili in prodajno ceno je večja od 100€)';
				return true;
			}
			this.gumbPlaciloTitle = 'Plačilo omogočeno';
			return false;
		},
		zeljenaIzstavitevRacunaShow: function zeljenaIzstavitevRacunaShow() {
			if (this.isProdajalecPotrdil) {
				return true;
			}
			return false;
		},
		zeljenaIzstavitevRacunaDisabled: function zeljenaIzstavitevRacunaDisabled() {
			if (this.datum_izstavitve_racuna) {
				this.gumbZeljeniRacunTitle = 'Račun je že bil izstavljen.';
				return true;
			}
			this.gumbZeljeniRacunTitle = '';
			return false;
		},
		modalDisabled: function modalDisabled() {
			return false;
		},
		tabFinanceDisabled: function tabFinanceDisabled() {
			if (this.showLockIcon && this.moderatorUnlock) {
				return false;
			}
			if (this.isRoleProdajalec) {
				if (this.isProdajalecPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleSekretar) {
				if (this.isSekretarPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleModerator) {
				if (this.isModeratorPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleRacunovodja) {
				if (this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleAdmin) {
				if (this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			}
			return false;
		},
		showLockIcon: function showLockIcon() {
			if (this.isRoleModerator) {
				if (this.isProdajalecPotrdil && this.isSekretarPotrdil && this.isModeratorPotrdil && this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			}
			return false;
		},
		isProdajalecPotrdil: function isProdajalecPotrdil() {
			if (this.datum_prodajalec_potrdil && this.datum_prodajalec_potrdil !== '' && this.datum_prodajalec_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isSekretarPotrdil: function isSekretarPotrdil() {
			if (this.datum_sekretar_potrdil && this.datum_sekretar_potrdil !== '' && this.datum_sekretar_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isModeratorPotrdil: function isModeratorPotrdil() {
			if (this.datum_moderator_potrdil && this.datum_moderator_potrdil !== '' && this.datum_moderator_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isRacunovodjaPotrdil: function isRacunovodjaPotrdil() {
			if (this.datum_racunovodja_potrdil && this.datum_racunovodja_potrdil !== '' && this.datum_racunovodja_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		razlika: function razlika() {
			var pCena = this.prodajna_cena;
			var nak = this.sumNakazila();
			return nak - pCena;
		},
		priliviSkupaj: function priliviSkupaj() {
			var skupaj = 0;
			var _iteratorNormalCompletion18 = true;
			var _didIteratorError18 = false;
			var _iteratorError18 = undefined;

			try {
				for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.prilivi), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
					var priliv = _step18.value;

					skupaj = +skupaj + +priliv.znesek;
				}
			} catch (err) {
				_didIteratorError18 = true;
				_iteratorError18 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion18 && _iterator18.return) {
						_iterator18.return();
					}
				} finally {
					if (_didIteratorError18) {
						throw _iteratorError18;
					}
				}
			}

			return this.moneyFormatter.format(skupaj);
		},
		povracilaDataSkupaj: function povracilaDataSkupaj() {
			var skupaj = 0.0;
			var _iteratorNormalCompletion19 = true;
			var _didIteratorError19 = false;
			var _iteratorError19 = undefined;

			try {
				for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.povracilaData), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
					var povraciloData = _step19.value;

					skupaj = +skupaj + +povraciloData.amount;
				}
			} catch (err) {
				_didIteratorError19 = true;
				_iteratorError19 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion19 && _iterator19.return) {
						_iterator19.return();
					}
				} finally {
					if (_didIteratorError19) {
						throw _iteratorError19;
					}
				}
			}

			return this.moneyFormatter.format(this.dodajDavek(skupaj));
		},
		razlikaFormatted: function razlikaFormatted() {
			return this.moneyFormatter.format(this.razlika);
		},
		razlikaClass: function razlikaClass() {
			return {
				positive: this.razlika > 0,
				negative: this.razlika < 0,
				input_total: true
			};
		},
		sestevekPovracila: function sestevekPovracila() {
			return this.sumPovracila();
		},
		sestevekPovracilaFormatted: function sestevekPovracilaFormatted() {
			return this.moneyFormatter.format(this.sestevekPovracila);
		},
		sestevekPovracilaClass: function sestevekPovracilaClass() {
			return {
				positive: this.sestevekPovracila > 0,
				negative: this.sestevekPovracila < 0,
				input_total: true
			};
		}
	},
	created: function created() {}
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ladda__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_js__ = __webpack_require__(12);







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
	},
	methods: {
		showModal: function showModal(id, prodajalec, kupec, ogrodje, vozilo, stRacuna, datumRacuna, skupniZnesek, prodajnaCena, nakazila, povracilaSkupaj, starost, datumProdajalecPotrdil, datumSekretarPotrdil, datumModeratorPotrdil, datumRacunovodjaPotrdil, podaljsanoJamstvoZnesek, myrZnesek) {
			this.showError(null);
			this.isLoading = false;
			this.item_id = id;
			this.prodajalec = prodajalec;
			this.kupec = kupec;
			this.ogrodje = ogrodje;
			this.vozilo = vozilo;
			this.st_racuna = stRacuna;
			this.datum_racuna = datumRacuna;
			this.znesek_racuna = skupniZnesek;
			this.prodajna_cena = prodajnaCena;
			this.nakazila = nakazila;
			this.povracila_skupaj = povracilaSkupaj;
			this.starost = starost;
			this.datumProdajalecPotrdil = datumProdajalecPotrdil;
			this.datumSekretarPotrdil = datumSekretarPotrdil;
			this.datumModeratorPotrdil = datumModeratorPotrdil;
			this.datumRacunovodjaPotrdil = datumRacunovodjaPotrdil;
			this.podaljsanoJamstvoZnesek = podaljsanoJamstvoZnesek;
			this.myrZnesek = myrZnesek;
			this.$refs.modal.show();
		},
		click_okModal: function click_okModal(evt) {
			var _this = this;

			evt.preventDefault();
			this.showError(null);
			this.isLoading = true;
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].saveMapaUserPotrdil(this.item_id).then(function (response) {
				_this.isLoading = false;
				if (response['message'] === 'success') {
					_this.action_confirmed = true;
					_this.$refs.modal.hide();
					_this.$emit('userpotrdil-success', response['datum'] ? Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["parse"])(response['datum']['date'], __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].dbDtFormat) : null, response['user_id'], response['user_role'], response['akcija']);
				} else if (response['message'] === 'roleAlreadyConfirmed') {
					_this.showError('Trenutna vloga je že potrdila!');
				} else if (response['message'] === 'moderatorNotYetConfirmed') {
					_this.showError('Najprej mora potrditi moderator!');
				} else if (response['message'] === 'allConfirmed') {
					_this.showError('Vse vloge so že potrdile!');
				} else {
					_this.showError('Neveljaven odziv strežnika!');
					console.error('Neveljaven response message: ' + response['message']);
				}
			}).catch(function (error) {
				_this.isLoading = false;
				if (error.response) {
					if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].errorMessages.serverSideValidationError) {
						_this.showError('Napaka pri validaciji na strežniku!');
						console.error(error.response.data.message + ': ', error.response.data.errors);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].errorMessages.notSavedError) {
						_this.showError('Napaka pri shranjevanju!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].errorMessages.unknownRole) {
						_this.showError('Neznana vloga uporabnika!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].errorMessages.PDOException) {
						_this.showError('Napaka na strežniku!');
						console.error(error.response.data.message, 'details in .ex');
					} else {
						_this.showError('Neznana napaka na strežniku!');
						console.error(error.response.data.message);
					}
				} else if (error.request) {
					console.log('The request was made but no response was received:', error.request);
				} else {
					console.log('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		click_cancelModal: function click_cancelModal(evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
		},
		onHiddenModal: function onHiddenModal(evt) {
			if (!this.action_confirmed) {
				this.$emit('userpotrdil-canceled');
			}
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		click_updateData: function click_updateData(evt) {
			var _this2 = this;

			if (this.item_id) {
				var loader = __WEBPACK_IMPORTED_MODULE_3_ladda__["a" /* create */](this.$refs.aUpdate);
				loader.start();
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getMFilesInfo(this.item_id).then(function (response) {
					loader.stop();
					if (!response.item) {
						return;
					}
					if (response.item.id !== _this2.item_id) {
						return;
					}
					_this2.st_racuna = response.item.st_racuna;
					_this2.datum_racuna = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["parse"])(response.item.datum_racuna, __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].dbDtFormat);
					_this2.znesek_racuna = Number(response.item.skupni_znesek);
				}).catch(function (error) {
					if (error) {
						console.log(error);
					}
					loader.stop();
				});
			}
		}
	},
	data: function data() {
		return {
			isLoading: false,
			item_id: null,
			prodajalec: '',
			kupec: '',
			ogrodje: '',
			vozilo: '',
			st_racuna: '',
			datum_racuna: '',
			znesek_racuna: 0,
			prodajna_cena: 0,
			nakazila: [],
			povracila_skupaj: 0,
			starost: 0,
			datumProdajalecPotrdil: null,
			datumSekretarPotrdil: null,
			datumModeratorPotrdil: null,
			datumRacunovodjaPotrdil: null,
			podaljsanoJamstvoZnesek: null,
			myrZnesek: null,
			gumbPotrdiTitle: '',
			message: {
				type: null,
				text: null
			},
			action_confirmed: false,
			ACTION_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		isRoleProdajalec: function isRoleProdajalec() {
			return __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].isProdajalec(this.user.role);
		},
		isRoleSekretar: function isRoleSekretar() {
			return __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].isSekretar(this.user.role);
		},
		isRoleRacunovodja: function isRoleRacunovodja() {
			return __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].isRacunovodja(this.user.role);
		},
		isRoleModerator: function isRoleModerator() {
			return __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].isModerator(this.user.role);
		},
		isRoleAdmin: function isRoleAdmin() {
			return __WEBPACK_IMPORTED_MODULE_4__settings_js__["a" /* default */].isAdmin(this.user.role);
		},
		razlika: function razlika() {
			return this.prodajna_cena + this.povracila_skupaj - this.znesek_racuna - this.podaljsanoJamstvoZnesek - this.myrZnesek;
		},
		razlikaFormatted: function razlikaFormatted() {
			return this.moneyFormatter.format(this.razlika);
		},
		razlikaClass: function razlikaClass() {
			return {
				positive: this.razlika > 0,
				negative: this.razlika < 0,
				input_total: true
			};
		},
		isProdajalecPotrdil: function isProdajalecPotrdil() {
			if (this.datumProdajalecPotrdil && this.datumProdajalecPotrdil !== '' && this.datumProdajalecPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isSekretarPotrdil: function isSekretarPotrdil() {
			if (this.datumSekretarPotrdil && this.datumSekretarPotrdil !== '' && this.datumSekretarPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isModeratorPotrdil: function isModeratorPotrdil() {
			if (this.datumModeratorPotrdil && this.datumModeratorPotrdil !== '' && this.datumModeratorPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isRacunovodjaPotrdil: function isRacunovodjaPotrdil() {
			if (this.datumRacunovodjaPotrdil && this.datumRacunovodjaPotrdil !== '' && this.datumRacunovodjaPotrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		potrdiDisabled: function potrdiDisabled() {
			if (this.isRoleProdajalec) {
				if (!this.isProdajalecPotrdil && !this.isSekretarPotrdil && !this.isRacunovodjaPotrdil && !this.isModeratorPotrdil) {
					this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Prodajalec je že potrdil)';
					return true;
				}
			} else if (this.isRoleSekretar) {
				if (!this.isSekretarPotrdil && !this.isModeratorPotrdil && !this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Sekretar je že potrdil)';
					return true;
				}
			} else if (this.isRoleRacunovodja) {
				if (!this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else if (!this.isSekretarPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					} else {
						if (!this.isModeratorPotrdil) {
							this.gumbPotrdiTitle = 'Onemogočeno (Moderator še ni potrdil)';
							return true;
						}
						this.gumbPotrdiTitle = 'Potrdi kot računovodja';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Računovodja je že potrdil)';
					return true;
				}
			} else if (this.isRoleModerator) {
				if (!this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else if (!this.isSekretarPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					} else if (!this.isModeratorPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot moderator';
					} else {
						this.gumbPotrdiTitle = 'Potrdi kot računovodja';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Že potrjeno s strani računovodje)';
					return true;
				}
			} else if (this.isRoleAdmin) {
				if (!this.isRacunovodjaPotrdil) {
					if (!this.isProdajalecPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot prodajalec';
					} else if (!this.isSekretarPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot sekretar';
					} else if (!this.isModeratorPotrdil) {
						this.gumbPotrdiTitle = 'Potrdi kot moderator';
					} else {
						this.gumbPotrdiTitle = 'Potrdi kot računovodja';
					}
					return false;
				} else {
					this.gumbPotrdiTitle = 'Onemogočeno (Že potrjeno s strani računovodje)';
					return true;
				}
			}
			this.gumbPotrdiTitle = 'Onemogočeno (Neznana vloga uporabnika)';
			return true;
		},
		showUpdateFromMFilesButton: function showUpdateFromMFilesButton() {
			if (this.isRoleSekretar || this.isRoleModerator || this.isRoleAdmin) {
				return true;
			}
			return false;
		}
	},
	created: function created() {}
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPrilivModal_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203c753b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPrilivModal_vue__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(935)
  __webpack_require__(936)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-203c753b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPrilivModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203c753b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPrilivModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203c753b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPrilivModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_js__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		showModal: function showModal(priliv, readOnly) {
			this.clearForm();
			this.readOnly = readOnly;
			if (!priliv) {
				this.addNew = true;
				this.clearForm();
				this.$refs.modal.show();
			} else {
				this.modalPriliv.id = priliv.id;
				this.modalPriliv.id_vozila = priliv.id_vozila;
				if (priliv.datum) {
					this.modalPriliv.datum = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(priliv.datum, __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].dbDtFormat);
				}
				this.modalPriliv.naziv = priliv.naziv;
				this.modalPriliv.referenca = priliv.referenca;
				this.modalPriliv.znesek = Number(priliv.znesek);
				this.modalPriliv.placnik = priliv.placnik;
				this.modalPriliv.ogrodje = priliv.ogrodje;
				this.$refs.modal.show();
			}
		},
		modal_okClick: function modal_okClick(evt) {
			var _this = this;

			evt.preventDefault();
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].addPriliv(this.modalPriliv).then(function (response) {
				if (_this.addNew) {
					_this.$emit('priliv_add');
				} else {
					_this.$emit('priliv_edit');
				}
				_this.$refs.modal.hide();
				_this.clearForm();
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		modal_cancelClick: function modal_cancelClick(evt) {
			var _this2 = this;

			evt.preventDefault();
			this.clearForm();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this2.clearForm();
			}, 300);
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function clearForm() {
			this.addNew = false;
			this.modalPriliv.id = 0;
			this.modalPriliv.datum = null;
			this.modalPriliv.id_vozila = null;
			this.modalPriliv.naziv = '';
			this.modalPriliv.referenca = '';
			this.modalPriliv.znesek = 0;
			this.modalPriliv.placnik = '';
			this.modalPriliv.ogrodje = null;
			this.readOnly = false;
		},
		vozilaSelect_load: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm) {
			loading(true);
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].searchVozila(search).then(function (vozila) {
				loading(false);
				vm.ogrodja_options = vozila;
			}).catch(function (error) {
				loading(false);
				if (error) {
					console.log(error);
				}
			});
		}, 500),
		voziloSelect_change: function voziloSelect_change(value) {
			this.modalPriliv.id_vozila = value.id;
		},
		vozilaSelect_search: function vozilaSelect_search(search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		}
	},
	watch: {},
	data: function data() {
		return {
			modalTitle: '',
			modalCancelTitle: 'Prekliči',
			modalErrorMsg: null,
			modalIsBusy: false,
			addNew: false,
			modalPriliv: {
				id: 0,
				datum: null,
				naziv: '',
				referenca: '',
				znesek: 0,
				placnik: '',
				ogrodje: null
			},
			ogrodja_options: [],
			readOnly: false
		};
	},
	computed: {
		modalTitle_text: function modalTitle_text() {
			if (this.readOnly) {
				return 'Podrobnosti priliva';
			} else if (this.modalPriliv.id === 0) {
				return 'Dodajanje priliva';
			}
			return 'Urejanje priliva';
		},
		ok_text: function ok_text() {
			if (this.readOnly) {
				return 'OK';
			} else if (this.modalPriliv.id === 0) {
				return 'Dodaj';
			}
			return 'Shrani';
		},
		message_class: function message_class() {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created: function created() {}
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ladda__ = __webpack_require__(46);



var IMG_PH_TEXT = 'Izberi ali povleci datoteko ...';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'nalozi-datoteko',
	components: {},
	methods: {
		showModal: function showModal(showFrom, data, multiple) {
			this.clearForm();
			this.showFrom = showFrom;
			this.modalData = data;
			this.$refs.modal.show();
		},
		modal_okClick: function modal_okClick(evt) {
			var _this = this;

			evt.preventDefault();
			var loader = __WEBPACK_IMPORTED_MODULE_1_ladda__["a" /* create */](this.$refs.aOk);
			loader.start();
			if (this.showFrom === 'mapa') {
				__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].uploadFilesForMapa(this.import_files, this.modalData).then(function (result) {
					loader.stop();
					_this.$emit('success', result);
					_this.$refs.modal.hide();
					_this.clearForm();
				}).catch(function (error) {
					loader.stop();
					_this.showError('Napaka!');
					if (error) {
						console.log(error);
					}
				});
			} else {
				this.showError('Neznani upload');
			}
		},
		modal_cancelClick: function modal_cancelClick(evt) {
			var _this2 = this;

			evt.preventDefault();
			this.clearForm();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this2.clearForm();
			}, 300);
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function clearForm() {
			this.modalTitle = '';
			this.modalCancelTitle = '';
			this.modalIsBusy = false;
			this.showFrom = null;
			this.modalData = null;
			this.multipleFiles = null;
			this.import_files = null;
			this.message.type = null;
			this.message.text = null;
		}
	},
	watch: {},
	data: function data() {
		return {
			modalTitle: '',
			modalCancelTitle: 'Prekliči',
			modalErrorMsg: null,
			modalIsBusy: false,
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			showFrom: null,
			modalData: null,
			multipleFiles: false,
			import_files: null
		};
	},
	computed: {
		modalTitle_text: function modalTitle_text() {
			if (this.showFrom === 'mapa') {
				return 'Nalaganje datoteke';
			}
			return 'Neznano nalaganje';
		},
		ok_text: function ok_text() {
			return 'Naloži';
		},
		upload_placeholder: function upload_placeholder() {
			return IMG_PH_TEXT;
		}
	},
	created: function created() {}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);








/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a
	},
	methods: {
		showModal: function showModal(itemId, zeljenaIzstavitevRacuna) {
			this.itemId = itemId;
			if (zeljenaIzstavitevRacuna != null) {
				var zir = new Date(zeljenaIzstavitevRacuna);
				this.uraZeljeneIzstavitveRacuna = {
					HH: __WEBPACK_IMPORTED_MODULE_3_numeral___default()(Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["getHours"])(zir)).format('00'),
					mm: __WEBPACK_IMPORTED_MODULE_3_numeral___default()(Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["getMinutes"])(zir)).format('00')
				};
				this.datumZeljeneIzstavitveRacuna = zir;
			}
			this.$refs.modal.show();
		},
		modal_okClick: function modal_okClick(evt) {
			var _this = this;

			evt.preventDefault();
			this.showError(null);
			this.isLoading = true;
			var datumCasZeljeneIzstavitveRacuna = null;
			if (this.datumZeljeneIzstavitveRacuna) {
				datumCasZeljeneIzstavitveRacuna = this.parseDatumInCas(this.datumZeljeneIzstavitveRacuna, this.uraZeljeneIzstavitveRacuna);
			}
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].saveMapaZeljenaIzstavitevRacuna(this.itemId, datumCasZeljeneIzstavitveRacuna).then(function (response) {
				if (response['message'] === 'success') {
					_this.isLoading = false;
					_this.$emit('success', response['zeljena_izstavitev_racuna']);
					_this.$refs.modal.hide();
					setTimeout(function () {
						_this.clearForm();
					}, 300);
				} else {
					_this.isLoading = false;
					_this.showError('Neveljaven odziv strežnika!');
					console.error('Neveljaven response message: ' + response['message']);
				}
			}).catch(function (error) {
				_this.isLoading = false;
				if (error.response) {
					if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.serverSideValidationError) {
						_this.showError('Napaka pri validaciji na strežniku!');
						console.error(error.response.data.message + ': ', error.response.data.errors);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.notSavedError) {
						_this.showError('Napaka pri shranjevanju!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.PDOException) {
						_this.showError('Napaka na strežniku!');
						console.error(error.response.data.message, 'details in .ex');
					} else {
						_this.showError('Neznana napaka na strežniku!');
						console.error(error.response.data.message);
					}
				} else if (error.request) {
					console.log('The request was made but no response was received:', error.request);
				} else {
					console.log('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		modal_cancelClick: function modal_cancelClick(evt) {
			var _this2 = this;

			this.$refs.modal.hide();
			setTimeout(function () {
				_this2.clearForm();
			}, 300);
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function clearForm() {
			this.item_id = null;
			this.datumZeljeneIzstavitveRacuna = null;
			this.uraZeljeneIzstavitveRacuna.HH = '09';
			this.uraZeljeneIzstavitveRacuna.mm = '00';
			this.message.type = null;
			this.message.text = null;
		},
		click_removeDatumZeljeneIzstavitve: function click_removeDatumZeljeneIzstavitve() {
			this.datumZeljeneIzstavitveRacuna = null;
			this.uraZeljeneIzstavitveRacuna.HH = '09';
			this.uraZeljeneIzstavitveRacuna.mm = '00';
			this.message.type = null;
			this.message.text = null;
		},
		parseDatumInCas: function parseDatumInCas(datum, cas) {
			return Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["setHours"])(Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["setMinutes"])(datum, cas.mm), cas.HH), __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].dbDtFormat);
		}
	},
	watch: {},
	data: function data() {
		return {
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			isLoading: false,
			itemId: null,
			datumZeljeneIzstavitveRacuna: null,
			uraZeljeneIzstavitveRacuna: {
				HH: '09',
				mm: '00'
			}
		};
	},
	computed: {
		modalTitle: function modalTitle() {
			return 'Željena izstavitev računa';
		},
		modalCancelTitle: function modalCancelTitle() {
			return 'Prekliči';
		},
		modalOkTitle: function modalOkTitle() {
			return 'Shrani';
		},
		message_class: function message_class() {
			return 'error_message';
		}
	},
	created: function created() {}
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a
	},
	methods: {
		showModal: function showModal(data) {
			this.nakaziloId = data.id;
			this.stKupoprodajnePogodbe = data.st_kupoprodajne_pogodbe;
			this.$refs.modal.show();
		},
		click_okModal: function click_okModal(evt) {
			evt.preventDefault();
			this.$emit('success', this.nakaziloId, this.stKupoprodajnePogodbe);
			this.$refs.modal.hide();
		},
		click_cancelModal: function click_cancelModal(evt) {
			var _this = this;

			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this.clearModal();
			}, 300);
		},
		clearModal: function clearModal() {
			this.message.type = null;
			this.message.text = null;
			this.isLoading = false;
			this.nakaziloId = null;
			this.stKupoprodajnePogodbe = null;
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: function data() {
		return {
			isLoading: false,
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR',
			nakaziloId: null,
			stKupoprodajnePogodbe: null
		};
	},
	computed: {},
	created: function created() {}
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PodrobnostiVozilaModal_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b447f82_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaModal_vue__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(950)
  __webpack_require__(951)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b447f82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PodrobnostiVozilaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b447f82_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b447f82_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ladda__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__settings_js__ = __webpack_require__(12);















/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a
	},
	methods: {
		showModal: function showModal(data) {
			this.createOptions();
			if (data != null) {
				if (data.source_file === 'manual') {
					this.nacin = this.NACIN_UREJANJA;
					this.itemData1 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.itemData1, data);
					if (data.ogrodje !== '') {
						this.title = 'Urejanje vozila ' + data.ogrodje + ' (#' + data.id + ')';
					} else {
						this.title = 'Urejanje vozila #' + data.id;
					}
					if (this.itemData1.konto_destinacije === 'TV' || this.itemData1.konto_destinacije === 'RV0KM' || this.itemData1.konto_destinacije === 'ND') {
						this.itemData1.konto = this.itemData1.konto_destinacije;
					}
					this.itemData1.datum_prve_registracije = this.parseDbDate(this.itemData1.datum_prve_registracije, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_kdaj_ga_lahko_prodamo = this.parseDbDate(this.itemData1.datum_kdaj_ga_lahko_prodamo, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_kdaj_ga_moramo_prodati = this.parseDbDate(this.itemData1.datum_kdaj_ga_moramo_prodati, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.predvideni_mada = this.parseDbDate(this.itemData1.predvideni_mada, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.realni_mada = this.parseDbDate(this.itemData1.realni_mada, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_zps = this.parseDbDate(this.itemData1.datum_zps, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_zds = this.parseDbDate(this.itemData1.datum_zds, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.realni_madc = this.parseDbDate(this.itemData1.realni_madc, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.predvideni_madc = this.parseDbDate(this.itemData1.predvideni_madc, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_fakturiranja = this.parseDbDate(this.itemData1.datum_fakturiranja, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_vnosa_nk = this.parseDbDate(this.itemData1.datum_vnosa_nk, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_ddk = this.parseDbDate(this.itemData1.datum_ddk, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_kddk = this.parseDbDate(this.itemData1.datum_kddk, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.dejanski_datum_dodelitve = this.parseDbDate(this.itemData1.dejanski_datum_dodelitve, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.dejanski_datum_stornacije = this.parseDbDate(this.itemData1.dejanski_datum_stornacije, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.realni_ara = this.parseDbDate(this.itemData1.realni_ara, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.koncesija_datum = this.parseDbDate(this.itemData1.koncesija_datum, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
					this.itemData1.datum_izhoda_iz_oc = this.parseDbDate(this.itemData1.datum_izhoda_iz_oc, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
				} else {
					this.nacin = this.NACIN_PODROBNOSTI;
					this.itemData = data;
					if (data.ogrodje !== '') {
						this.title = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ')';
					} else {
						this.title = 'Vozilo #' + data.id;
					}
					this.itemData.content = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data, null, 2);
				}
			} else {
				this.nacin = this.NACIN_DODAJANJA;
				this.title = 'Dodajanje vozila';
				this.itemData1.source_file = 'manual';
			}
			this.$refs.modal.show();
		},
		parseDbDate: function parseDbDate(value) {
			if (value) {
				return Object(__WEBPACK_IMPORTED_MODULE_11_date_fns__["parse"])(value, __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].dbDtFormat);
			}
			return '';
		},
		clearModal: function clearModal() {
			this.itemData1.id = null;
			this.itemData1.ogrodje = '';
			this.itemData1.vozilo = '';
			this.itemData1.st_narocila_vozila = '';
			this.itemData1.st_narocila_kupca = '';
			this.itemData1.libelle_modele = '';
			this.itemData1.libelle_version = '';
			this.itemData1.libelle_options = '';
			this.itemData1.libelle_teinte = '';
			this.itemData1.libelle_harmonie = '';
			this.itemData1.libelle_sellerie = '';
			this.itemData1.source_file = 'manual';
			this.itemData1.st_nm = '';
			this.itemData1.konto_lastnika = '';
			this.itemData1.drzava_fiche_gamme = '';
			this.itemData1.tip_narocila_vozila = '';
			this.itemData1.vozilo_na_borzi = '';
			this.itemData1.obljubljeni_mada = '';
			this.itemData1.predvideni_mada = '';
			this.itemData1.staranje = '';
			this.itemData1.realni_mada = '';
			this.itemData1.stanje_napredovanja = '';
			this.itemData1.opomba_vozilo = '';
			this.itemData1.model = '';
			this.itemData1.verzija = '';
			this.itemData1.opcije = '';
			this.itemData1.barva = '';
			this.itemData1.notranjost = '';
			this.itemData1.oblazinjenje = '';
			this.itemData1.nivo_kvalitete = '';
			this.itemData1.sprememba = '';
			this.itemData1.datum_zps = '';
			this.itemData1.datum_zds = '';
			this.itemData1.konto_naslovnika = '';
			this.itemData1.koda_prodajalca = '';
			this.itemData1.realni_madc = '';
			this.itemData1.predvideni_madc = '';
			this.itemData1.pristanisce_vkrcanja = '';
			this.itemData1.ime_ladje = '';
			this.itemData1.rezervirano_vozilo = '';
			this.itemData1.maskirano_vozilo = '';
			this.itemData1.skrito_vozilo = '';
			this.itemData1.viop = '';
			this.itemData1.datum_fakturiranja = '';
			this.itemData1.datum_vnosa_nk = '';
			this.itemData1.datum_ddk = '';
			this.itemData1.datum_kddk = '';
			this.itemData1.kupec = '';
			this.itemData1.konto_agenta_satelita = '';
			this.itemData1.konto_destinacije = '';
			this.itemData1.koda_prod = '';
			this.itemData1.dejanski_datum_dodelitve = '';
			this.itemData1.dejanski_datum_stornacije = '';
			this.itemData1.tip_kupca = '';
			this.itemData1.prodajni_kanal = '';
			this.itemData1.tip_nm = '';
			this.itemData1.ime = '';
			this.itemData1.email = '';
			this.itemData1.telefon_privatni = '';
			this.itemData1.st_pogodbe_v_advensysu = '';
			this.itemData1.stanje_narocila_kupca = '';
			this.itemData1.status_kvalitete = '';
			this.itemData1.realni_ara = '';
			this.itemData1.nef = '';
			this.itemData1.ddo = '';
			this.itemData1.ddpp = '';
			this.itemData1.blocage_financier = '';
			this.itemData1.blokada_komerciale = '';
			this.itemData1.blokada_cata = '';
			this.itemData1.blokada_kvalitete = '';
			this.itemData1.pgeo_bcv = '';
			this.itemData1.koncesija_lokacija = '';
			this.itemData1.koncesija_datum = '';
			this.itemData1.koncesija_prodajalec = '';
			this.itemData1.zadrzano_lastnik = '';
			this.itemData1.interna_opomba = '';
			this.itemData1.akcijski = '';
			this.itemData1.datum_izhoda_iz_oc = '';
			this.itemData1.opomba_narocilo_kupca = '';
			this.itemData1.konto = '';
			this.itemData1.datum_prve_registracije = '';
			this.itemData1.datum_kdaj_ga_lahko_prodamo = '';
			this.itemData1.datum_kdaj_ga_moramo_prodati = '';
			this.itemData1.st_kilometrov = '';
			this.itemData1.prodajna_cena = null;
			this.prodajalci_selected = null;
			this.prodajalci_options = null;
			this.vozilo_arhivirano = true;
		},
		resetModal: function resetModal() {
			this.clearModal();
			this.itemData = {};
			this.title = '';
			this.itemData.content = '';
			this.message = {
				type: null,
				text: null
			};
			this.ogrodja_options = [];
			this.nacin = this.NACIN_NEZNAN;
		},
		modal_okClick: function modal_okClick(evt) {
			var _this = this;

			evt.preventDefault();
			if (this.nacin === this.NACIN_PODROBNOSTI) {
				this.$refs.modal.hide();
			} else if (this.nacin === this.NACIN_UREJANJA || this.nacin === this.NACIN_DODAJANJA) {
				if (this.validateForm) {
					if (this.prodajalci_selected != null) {
						this.itemData1.koncesija_prodajalec = this.prodajalci_selected.id;
					}
					if (this.itemData1.obljubljeni_mada == null) {
						this.itemData1.obljubljeni_mada = '';
					}
					this.showError(null);
					var loader = __WEBPACK_IMPORTED_MODULE_6_ladda__["a" /* create */](this.$refs.aOk);
					loader.start();
					__WEBPACK_IMPORTED_MODULE_5__service__["a" /* default */].saveVozilo(this.itemData1).then(function (response) {
						loader.stop();
						if (response['message'] === 'edited') {
							_this.$emit('importdata_edit', response['importdata']);
							_this.$refs.modal.hide();
						} else if (response['message'] === 'added') {
							_this.$emit('importdata_add', response['importdata']);
							_this.$refs.modal.hide();
						} else {
							_this.showError('Neveljaven odziv strežnika!');
							console.error('Neveljaven response message: ' + response['message']);
						}
					}).catch(function (error) {
						loader.stop();
						if (error.response) {
							if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].errorMessages.serverSideValidationError) {
								_this.showError('Napaka pri validaciji na strežniku!');
								console.error(error.response.data.message + ': ', error.response.data.errors);
							} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].errorMessages.notSavedError) {
								_this.showError('Napaka pri shranjevanju!');
								console.error(error.response.data.message);
							} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_12__settings_js__["a" /* default */].errorMessages.PDOException) {
								_this.showError('Napaka na strežniku!');
								console.error(error.response.data.message);
							} else {
								_this.showError('Neznana napaka na strežniku!');
								console.error(error.response.data.message);
							}
						} else if (error.request) {
							console.log('The request was made but no response was received:', error.request);
						} else {
							console.log('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				} else {
					this.showError('Označena polja so nepravino izpolnjena!');
				}
			} else {
				this.showError('Neznan način uporabe modala!');
			}
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		modal_cancelClick: function modal_cancelClick(evt) {
			var _this2 = this;

			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this2.resetModal();
			}, 300);
		},
		loadProdajalci: function loadProdajalci() {
			var _this3 = this;

			this.prodajalci_options = [];
			__WEBPACK_IMPORTED_MODULE_5__service__["a" /* default */].getProdajalci().then(function (prodajalci) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(prodajalci), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						item.full_name = item.first_name + ' ' + item.last_name;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this3.prodajalci_options = prodajalci;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		createOptions: function createOptions() {
			var wOptions = [];
			var week = __WEBPACK_IMPORTED_MODULE_7_moment___default()().week();
			var year = __WEBPACK_IMPORTED_MODULE_7_moment___default()().year();
			var weeksInYear = this.weeksInYear(year);
			var numOptions = 52;
			var numWeeksInPreviusYear = this.weeksInYear(year - 1);
			for (var i = 0; i <= numOptions; i++) {
				var tmpWeek = week - numOptions / 2 + i;
				if (tmpWeek > weeksInYear) {
					tmpWeek = tmpWeek - numOptions - 1;
					var nextYear = year + 1;
					wOptions.push(tmpWeek + '/' + nextYear);
				} else if (tmpWeek <= 0) {
					tmpWeek = numWeeksInPreviusYear - Math.abs(tmpWeek);
					var previusYear = year - 1;
					wOptions.push(tmpWeek + '/' + previusYear);
				} else {
					wOptions.push(tmpWeek + '/' + year);
				}
			}
			this.weeks_options = wOptions;
			this.current_week = __WEBPACK_IMPORTED_MODULE_7_moment___default()().week();
		},
		weeksInYear: function weeksInYear(year) {
			return Math.max(__WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date(year, 11, 31)).isoWeek(), __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date(year, 11, 31 - 7)).isoWeek());
		},
		vozilaSelect_load: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function (loading, search, vm) {
			loading(true);
			__WEBPACK_IMPORTED_MODULE_5__service__["a" /* default */].searchVozila(search).then(function (vozila) {
				vozila = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(vozila.map(function (item) {
					return item.ogrodje;
				}))));
				vm.ogrodja_options = vozila;
				loading(false);
			}).catch(function (error) {
				loading(false);
				if (error) {
					console.log(error);
				}
			});
		}, 500),
		voziloSelect_change: function voziloSelect_change(ogrodje) {
			var _this4 = this;

			this.clearModal();
			if (ogrodje == null) {
				this.ogrodja_options = [];
				this.showError();
				return '';
			} else if (this.ogrodja_options.find(function (element) {
				return element === ogrodje;
			})) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_5__service__["a" /* default */].getImportdataDistinctByOgrodje(ogrodje).then(function (response) {
					if (response.status === 'ok') {
						_this4.itemData1.ogrodje = ogrodje;
						_this4.predizpolniModal(response.importdata);
					} else {
						_this4.showError('Napaka pri pridobivanju podatkov (importdata ne obstaja)');
					}
					_this4.isLoading = false;
				}).catch(function (error) {
					_this4.isLoading = false;
					_this4.showError('Napaka pri pridobivanju podatkov');
					if (error) {
						console.log(error);
					}
				});
			} else {
				this.itemData1.ogrodje = ogrodje;
			}
		},
		vozilaSelect_search: function vozilaSelect_search(search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		predizpolniModal: function predizpolniModal(importdata) {
			this.itemData1.vozilo = importdata.vozilo;
			if (importdata.archived_on == null) {
				this.showError('Vozilo še ni bilo arhivirano in ga ni mogoče dodati');
				this.vozilo_arhivirano = false;
			} else {
				this.vozilo_arhivirano = true;
				this.itemData1.st_narocila_vozila = importdata.st_narocila_vozila;
				this.itemData1.konto_lastnika = importdata.konto_lastnika;
				this.itemData1.tip_narocila_vozila = importdata.tip_narocila_vozila;
				this.itemData1.vozilo_na_borzi = importdata.vozilo_na_borzi;
				this.itemData1.obljubljeni_mada = importdata.obljubljeni_mada;
				this.itemData1.predvideni_mada = importdata.predvideni_mada;
				this.itemData1.predvideni_mada_ts = importdata.predvideni_mada_ts;
				this.itemData1.staranje = importdata.staranje;
				this.itemData1.realni_mada = importdata.realni_mada;
				this.itemData1.realni_mada_ts = importdata.realni_mada_ts;
				this.itemData1.libelle_modele = importdata.libelle_modele;
				this.itemData1.libelle_version = importdata.libelle_version;
				this.itemData1.libelle_options = importdata.libelle_options;
				this.itemData1.libelle_teinte = importdata.libelle_teinte;
				this.itemData1.libelle_harmonie = importdata.libelle_harmonie;
				this.itemData1.libelle_sellerie = importdata.libelle_sellerie;
				this.itemData1.drzava_fiche_gamme = importdata.drzava_fiche_gamme;
				this.itemData1.model = importdata.model;
				this.itemData1.verzija = importdata.verzija;
				this.itemData1.opcije = importdata.opcije;
				this.itemData1.barva = importdata.barva;
				this.itemData1.notranjost = importdata.notranjost;
				this.itemData1.oblazinjenje = importdata.oblazinjenje;
				this.itemData1.nivo_kvalitete = importdata.nivo_kvalitete;
				this.itemData1.sprememba = importdata.sprememba;
				this.itemData1.datum_zps = importdata.datum_zps;
				this.itemData1.datum_zds = importdata.datum_zds;
				this.itemData1.stanje_napredovanja = importdata.stanje_napredovanja;
				this.itemData1.konto_destinacije = importdata.konto_destinacije;
				this.itemData1.koda_prodajalca = importdata.koda_prodajalca;
				this.itemData1.realni_madc = importdata.realni_madc;
				this.itemData1.realni_madc_ts = importdata.realni_madc_ts;
				this.itemData1.predvideni_madc = importdata.predvideni_madc;
				this.itemData1.predvideni_madc_ts = importdata.predvideni_madc_ts;
				this.itemData1.pristanisce_vkrcanja = importdata.pristanisce_vkrcanja;
				this.itemData1.ime_ladje = importdata.ime_ladje;
				this.itemData1.rezervirano_vozilo = importdata.rezervirano_vozilo;
				this.itemData1.maskirano_vozilo = importdata.maskirano_vozilo;
				this.itemData1.skrito_vozilo = importdata.skrito_vozilo;
				this.itemData1.opomba_vozilo = importdata.opomba_vozilo;
				this.itemData1.datum_fakturiranja = importdata.datum_fakturiranja;
				this.itemData1.datum_izhoda_iz_oc = importdata.datum_izhoda_iz_oc;
				this.itemData1.source_file = 'manual';
			}
		}
	},
	data: function data() {
		return {
			NACIN_NEZNAN: 0,
			NACIN_DODAJANJA: 1,
			NACIN_UREJANJA: 2,
			NACIN_PODROBNOSTI: 3,
			nacin: this.NACIN_NEZNAN,
			title: '',
			itemData: {
				content: ''
			},
			itemData1: {
				id: null,
				ogrodje: '',
				vozilo: '',
				st_narocila_vozila: '',
				st_narocila_kupca: '',
				libelle_modele: '',
				libelle_version: '',
				libelle_options: '',
				libelle_teinte: '',
				libelle_harmonie: '',
				libelle_sellerie: '',
				source_file: '',
				st_nm: '',
				konto_lastnika: '',
				drzava_fiche_gamme: '',
				tip_narocila_vozila: '',
				vozilo_na_borzi: '',
				obljubljeni_mada: '',
				predvideni_mada: '',
				staranje: '',
				realni_mada: '',
				stanje_napredovanja: '',
				opomba_vozilo: '',
				model: '',
				verzija: '',
				opcije: '',
				barva: '',
				notranjost: '',
				oblazinjenje: '',
				nivo_kvalitete: '',
				sprememba: '',
				datum_zps: '',
				datum_zds: '',
				konto_naslovnika: '',
				koda_prodajalca: '',
				realni_madc: '',
				predvideni_madc: '',
				pristanisce_vkrcanja: '',
				ime_ladje: '',
				rezervirano_vozilo: '',
				maskirano_vozilo: '',
				skrito_vozilo: '',
				viop: '',
				datum_fakturiranja: '',
				datum_vnosa_nk: '',
				datum_ddk: '',
				datum_kddk: '',
				kupec: '',
				konto_agenta_satelita: '',
				konto_destinacije: '',
				koda_prod: '',
				dejanski_datum_dodelitve: '',
				dejanski_datum_stornacije: '',
				tip_kupca: '',
				prodajni_kanal: '',
				tip_nm: '',
				ime: '',
				email: '',
				telefon_privatni: '',
				st_pogodbe_v_advensysu: '',
				stanje_narocila_kupca: '',
				status_kvalitete: '',
				realni_ara: '',
				nef: '',
				ddo: '',
				ddpp: '',
				blocage_financier: '',
				blokada_komerciale: '',
				blokada_cata: '',
				blokada_kvalitete: '',
				pgeo_bcv: '',
				koncesija_lokacija: '',
				koncesija_datum: '',
				koncesija_prodajalec: '',
				zadrzano_lastnik: '',
				interna_opomba: '',
				akcijski: '',
				opomba_narocilo_kupca: '',
				datum_izhoda_iz_oc: '',
				konto: '',
				datum_prve_registracije: '',
				datum_kdaj_ga_lahko_prodamo: '',
				datum_kdaj_ga_moramo_prodati: '',
				st_kilometrov: '',
				prodajna_cena: null
			},
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			prodajalci_selected: null,
			prodajalci_options: null,
			weeks_options: null,
			current_week: null,
			ogrodja_options: [],
			isLoading: false,
			vozilo_arhivirano: true
		};
	},
	computed: {
		ok_text: function ok_text() {
			if (this.nacin === this.NACIN_DODAJANJA) {
				return 'Dodaj';
			}
			if (this.nacin === this.NACIN_UREJANJA) {
				return 'Shrani';
			}
			if (this.nacin === this.NACIN_PODROBNOSTI) {
				return 'Zapri';
			}
		},
		state_ogrodje: function state_ogrodje() {
			if (this.itemData1.ogrodje.length > 0 && this.itemData1.ogrodje.length <= 20 && this.vozilo_arhivirano) {
				this.showError();
				return true;
			}
			return false;
		},
		invalidFeedback_ogrodje: function invalidFeedback_ogrodje() {
			if (this.itemData1.hasOwnProperty('ogrodje')) {
				if (this.itemData1.ogrodje.length > 20) {
					return 'Ogrodje lahko vsebuje največ 20 znakov';
				}if (this.itemData1.ogrodje.length < 1) {
					return 'Ogrodje je obvezno';
				} else {
					return '';
				}
			}
			return 'Ogrodje je obvezno';
		},
		state_tip_narocila_vozila: function state_tip_narocila_vozila() {
			if (this.itemData1.tip_narocila_vozila.length <= 5) {
				this.showError();
				return true;
			}
			return false;
		},
		invalidFeedback_tip_narocila_vozila: function invalidFeedback_tip_narocila_vozila() {
			if (this.itemData1.tip_narocila_vozila.length > 5) {
				return 'Največ 5 znakov';
			} else {
				return '';
			}
		},
		vsiProdajalci: function vsiProdajalci() {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		},

		validateForm: function validateForm() {
			if (this.state_ogrodje) {
				return true;
			}
			return false;
		}
	},
	created: function created() {}
});

/***/ }),
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['item'],
	filters: {
		akcija_dane: function akcija_dane(value) {
			if (value) {
				return 'Da';
			} else {
				return 'Ne';
			}
		}
	},
	computed: {
		showAditionalParams: function showAditionalParams() {
			if (this.item.konto_destinacije === 'TV' || this.item.konto_destinacije === 'RV0KM' || this.item.konto_destinacije === 'ND') {
				return true;
			}
			return false;
		}
	}
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['item'],
	computed: {
		showAditionalParams: function showAditionalParams() {
			if (this.item.konto_destinacije === 'TV' || this.item.konto_destinacije === 'RV0KM' || this.item.konto_destinacije === 'ND') {
				return true;
			}
			return false;
		}
	}
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		default_label: {
			type: String,
			required: false
		},
		value: {
			type: Object,
			required: false
		},
		compact: {
			type: Boolean,
			required: false,
			default: true
		},
		noFutureValues: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	methods: {
		click_1dan: function click_1dan(evt) {
			this.custom_set = true;
			this.title = 'Danes';
			var start = new Date();
			this.izbranDatum = { start: start, end: start };
		},
		click_prev7dni: function click_prev7dni(evt) {
			this.custom_set = true;
			this.title = '-7 dni';
			var end = new Date();
			var start = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["subDays"])(end, 7);
			this.izbranDatum = { start: start, end: end };
		},
		click_prev30dni: function click_prev30dni(evt) {
			this.custom_set = true;
			this.title = '-30 dni';
			var end = new Date();
			var start = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["subDays"])(end, 30);
			this.izbranDatum = { start: start, end: end };
		},
		click_next7dni: function click_next7dni(evt) {
			this.custom_set = true;
			this.title = '+7 dni';
			var start = new Date();
			var end = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["addDays"])(start, 7);
			this.izbranDatum = { start: start, end: end };
		},
		click_next30dni: function click_next30dni(evt) {
			this.custom_set = true;
			this.title = '+30 dni';
			var start = new Date();
			var end = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["addDays"])(start, 30);
			this.izbranDatum = { start: start, end: end };
		},
		click_taMesec: function click_taMesec(evt) {
			this.custom_set = true;
			this.title = 'Ta mesec';
			var start = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["startOfMonth"])(new Date());
			var end = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["endOfMonth"])(start);
			this.izbranDatum = { start: start, end: end };
		},
		click_prev3mesece: function click_prev3mesece(evt) {
			this.custom_set = true;
			this.title = '-3 mesece';
			var end = new Date();
			var start = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["subDays"])(end, 90);
			this.izbranDatum = { start: start, end: end };
		},
		click_prev6mesecev: function click_prev6mesecev(evt) {
			this.custom_set = true;
			this.title = '-6 mesecev';
			var end = new Date();
			var start = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["subDays"])(end, 180);
			this.izbranDatum = { start: start, end: end };
		},
		click_pocisti: function click_pocisti() {
			this.clear();
			this.$refs.dropdown.hide();
		},
		selected: function selected(env) {
			if (!this.izbranDatum || !this.izbranDatum.start || !this.izbranDatum.end) {
				this.$emit('input', this.izbranDatum);
				return;
			}
			if (!this.custom_set) {
				if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isEqual"])(this.izbranDatum.start, this.izbranDatum.end)) {
					this.is_smalltext_class = false;
					this.title = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.izbranDatum.start, 'DD.MM.YYYY');
				} else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isSameMonth"])(this.izbranDatum.start, this.izbranDatum.end)) {
					this.is_smalltext_class = true;
					this.title = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.izbranDatum.start, 'DD') + '.-' + Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.izbranDatum.end, 'DD.MM') + '.';
				} else {
					this.is_smalltext_class = true;
					this.title = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.izbranDatum.start, 'DD.MM') + '.-' + Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.izbranDatum.end, 'DD.MM') + '.';
				}
			} else {
				this.is_smalltext_class = false;
			}
			this.custom_set = false;
			this.$emit('input', this.izbranDatum);
			this.$refs.dropdown.hide();
		},
		clear: function clear() {
			this.is_smalltext_class = false;
			this.custom_set = false;
			this.title = null;
			this.izbranDatum = null;
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.title) {
				return this.title;
			} else if (this.default_label) {
				return this.default_label;
			} else {
				return this.default_label_empty;
			}
		},
		showCompact: function showCompact() {
			if (this.compact != null) {
				return this.compact;
			} else {
				return true;
			}
		}
	},
	data: function data() {
		return {
			is_smalltext_class: false,
			custom_set: false,
			title: null,
			izbranDatum: null,
			default_label_empty: 'Vse'
		};
	},
	created: function created() {}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'kontofilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.getItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		},
		getItems: function getItems() {
			if (this.user.role === 4 || this.user.role === 5) {
				return this.items;
			} else {
				return this.items.filter(function (item) {
					return !item.admin_only;
				});
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: '00004P',
				value: '00004P',
				admin_only: false,
				active: false
			}, {
				label: '900033',
				value: '900033',
				admin_only: false,
				active: false
			}, {
				label: '900089',
				value: '900089',
				admin_only: false,
				active: false
			}, {
				label: '906276',
				value: '906276',
				admin_only: false,
				active: false
			}, {
				label: 'CENNM',
				value: 'CENNM',
				admin_only: false,
				active: false
			}, {
				label: 'RV0KM',
				value: 'RV0KM',
				admin_only: true,
				active: false
			}, {
				label: 'RV0KMD',
				value: 'RV0KMD',
				admin_only: false,
				active: false
			}, {
				label: 'RV2KM2',
				value: 'RV2KM2',
				admin_only: true,
				active: false
			}, {
				label: 'RV2KMD',
				value: 'RV2KMD',
				admin_only: false,
				active: false
			}, {
				label: 'TV',
				value: 'TV',
				admin_only: false,
				active: false
			}, {
				label: 'ND',
				value: 'ND',
				admin_only: false,
				active: false
			}, {
				label: '000001',
				value: '000001',
				admin_only: false,
				active: false
			}, {
				label: '000005',
				value: '000005',
				admin_only: false,
				active: false
			}, {
				label: '110032',
				value: '110032',
				admin_only: false,
				active: false
			}, {
				label: '110042',
				value: '110042',
				admin_only: false,
				active: false
			}, {
				label: '906089',
				value: '906089',
				admin_only: false,
				active: false
			}, {
				label: 'Brez',
				value: '#',
				admin_only: false,
				active: false
			}]
		};
	}
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







var usDefaultValues = {
	url: "https://zaloga.avtotehnika-celje.si/" + 'api/v1/cdp_vehicles_stock_upload',
	thumbnailWidth: 150,
	maxFilesize: 50,
	uploadMultiple: false,
	maxFiles: 1,
	addRemoveLinks: false,
	paramName: 'cdp_import',

	dictRemoveFile: 'Odstrani datoteko',
	dictFileTooBig: 'Datoteka je prevelika',
	init: function init(event) {
		console.log('DZ init');
	},
	uploadprogress: function uploadprogress(file, progress, bytesSent, event) {
		console.log('DZ uploadprogress');
		console.log(progress);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		vueDropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
	},
	methods: {
		showModal: function showModal() {
			this.$refs.modal.show();
			if (!this.timestamp) this.timestamp = Math.floor(Date.now() / 1000);
		},
		onOkModal: function onOkModal(evt) {
			this.$refs.modal.hide();
			this.showStep1 = true;
			this.showStep2 = false;
			this.showStep3 = false;
			this.newVehiclesUploaded = null;
			this.usedVehiclesUploaded = null;
			this.dmvUploaded = null;
			this.$refs.dzNewVehicles.removeAllFiles();
			this.$refs.dzUsedVehicles.removeAllFiles();
			this.$refs.dzdmv.removeAllFiles();
			this.timestamp = null;
		},
		moveToProcessing: function moveToProcessing() {
			var _this = this;

			if (this.newVehiclesUploaded && this.usedVehiclesUploaded && this.dmvUploaded) {
				this.showStep1 = false;
				this.showStep2 = true;
				this.showStep3 = false;
				this.uploadResultMessage = '';
				__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].cdpVehiclesStockImport(this.newVehiclesUploaded, this.usedVehiclesUploaded, this.dmvUploaded).then(function (response) {
					_this.uploadResultMessage = 'Nova vozila uspešno posodobljena. Najdenih je bilo <b>' + response.data.newVehicles.total + '</b>, od tega <b>' + response.data.newVehicles.new + '</b> novih.';
					_this.uploadResultMessage += '<br /><br />';
					_this.uploadResultMessage += 'Rabljena vozila uspešno posodobljena. Najdenih je bilo <b>' + response.data.usedVehicles.total + '</b>, od tega <b>' + response.data.usedVehicles.new + '</b> novih.';
					_this.uploadResultMessage += '<br /><br />';
					_this.uploadResultMessage += 'DMV uspešno posodobljen. Najdenih je bilo <b>' + response.data.dmv.numFound + '</b>, od skupno <b>' + response.data.dmv.total + '</b> vnosov v pregednici.';
					_this.showStep1 = false;
					_this.showStep2 = false;
					_this.showStep3 = true;
					_this.$emit('data-updated');
				}).catch(function (error) {
					if (error) {
						console.log(error);
						_this.uploadResultMessage = 'Napaka pri uvozu podatkov!';
						_this.showStep1 = false;
						_this.showStep2 = false;
						_this.showStep3 = true;
					}
				});
			}
		},
		dzTemplate: function dzTemplate() {
			return '<div class="dz-preview dz-file-preview">\n\t\t\t\t<div class="dz-image">\n\t\t\t\t\t<div data-dz-thumbnail-bg></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-details">\n\t\t\t\t\t<div class="dz-filename"><span data-dz-name></span></div><br />(<div class="dz-size"><span data-dz-size></span></div>)\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n\t\t\t\t<div class="dz-error-message"><span data-dz-errormessage></span></div>\n\t\t\t\t<div class="dz-success-mark"><i class="fa fa-check"></i></div>\n\t\t\t\t<div class="dz-error-mark"><i class="fa fa-close"></i></div>\n\t\t\t</div>';
		}
	},
	data: function data() {
		var _this2 = this;

		return {
			showStep1: true,
			showStep2: false,
			showStep3: false,
			animate: true,
			newVehiclesUploaded: null,
			usedVehiclesUploaded: null,
			dmvUploaded: null,
			uploadResultMessage: '',
			usNewVehicles: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko z <b>novimi</b> vozili<br />',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', _this2.timestamp + 'newVehicles');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.newVehiclesUploaded = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.newVehiclesUploaded = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			usUsedVehicles: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko s <b>rabljenimi</b> vozili<br />',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', _this2.timestamp + 'usedVehicles');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.usedVehiclesUploaded = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.usedVehiclesUploaded = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			usDmv: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko z <b>DMV</b><br />',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
					formData.append('import_type', _this2.timestamp + 'dmv');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.dmvUploaded = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.dmvUploaded = response.data.file;
					_this2.moveToProcessing();
				}
			}),
			timestamp: null
		};
	},
	created: function created() {
		var _this3 = this;

		var user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
		user.getIdToken().then(function (idToken) {
			var headers = {
				'Authorization': 'Bearer ' + idToken
			};
			_this3.usNewVehicles.headers = headers;
			_this3.usUsedVehicles.headers = headers;
			_this3.usDmv.headers = headers;
		});
	}
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);







var usDefaultValues = {
	url: "https://zaloga.avtotehnika-celje.si/" + 'api/v1/cdp_vehicles_trafic_upload',
	thumbnailWidth: 150,
	maxFilesize: 50,
	uploadMultiple: true,
	maxFiles: 10,
	parallelUploads: 10,
	addRemoveLinks: false,
	paramName: 'trafic_import',

	dictRemoveFile: 'Odstrani datoteko',
	dictFileTooBig: 'Datoteka je prevelika',
	init: function init() {
		console.log('DZ init');
		var limitExceeded = false;
		this.on("addedfiles", function (files) {
			if (this.files.length > this.options.maxFiles) {
				if (!limitExceeded) {
					limitExceeded = true;
					this.removeAllFiles(true);
					alert('Izberete lahko najve\u010D ' + this.options.maxFiles + ' datotek. Izberite ponovno.');
				}
			}
		});

		this.on("reset", function () {
			limitExceeded = false;
		});
	},
	uploadprogress: function uploadprogress(file, progress, bytesSent, event) {
		console.log('DZ uploadprogress');
		console.log(progress);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		vueDropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
	},
	methods: {
		showModal: function showModal() {
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			this.$refs.modal.hide();
			this.showStep1 = true;
			this.showStep2 = false;
			this.showStep3 = false;
			this.cdpTraficUploaded = null;
			this.$refs.dzCdpTrafic.removeAllFiles();
		},
		moveToProcessing: function moveToProcessing() {
			var _this = this;

			if (this.cdpTraficUploaded) {
				this.showStep1 = false;
				this.showStep2 = true;
				this.showStep3 = false;
				this.uploadResultMessage = '';
				__WEBPACK_IMPORTED_MODULE_2__service__["a" /* default */].cdpTraficImport(this.cdpTraficUploaded).then(function (response) {
					_this.uploadResultMessage += 'Trafic posodobljen. Najdenih je bilo <b>' + response.data.found + '</b>, od skupno <b>' + response.data.total + '</b> vnosov v pregednici.';
					_this.showStep1 = false;
					_this.showStep2 = false;
					_this.showStep3 = true;
					_this.$emit('data-updated');
				}).catch(function (error) {
					if (error) {
						console.log(error);
						_this.uploadResultMessage = 'Napaka pri uvozu podatkov!';
						_this.showStep1 = false;
						_this.showStep2 = false;
						_this.showStep3 = true;
					}
				});
			}
		},
		dzTemplate: function dzTemplate() {
			return '<div class="dz-preview dz-file-preview">\n\t\t\t\t<div class="dz-image">\n\t\t\t\t\t<div data-dz-thumbnail-bg></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-details">\n\t\t\t\t\t<div class="dz-filename"><span data-dz-name></span></div><br />(<div class="dz-size"><span data-dz-size></span></div>)\n\t\t\t\t</div>\n\t\t\t\t<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n\t\t\t\t<div class="dz-error-message"><span data-dz-errormessage></span></div>\n\t\t\t\t<div class="dz-success-mark"><i class="fa fa-check"></i></div>\n\t\t\t\t<div class="dz-error-mark"><i class="fa fa-close"></i></div>\n\t\t\t</div>';
		}
	},
	data: function data() {
		var _this2 = this;

		return {
			showStep1: true,
			showStep2: false,
			showStep3: false,
			animate: true,
			cdpTraficUploaded: null,
			usedVehiclesUploaded: null,
			dmvUploaded: null,
			uploadResultMessage: '',
			usCdpTrafic: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, usDefaultValues, {
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteke <b>Trafic</b><br />',
				sending: function sending(file, xhr, formData) {
					console.log('DZ send');
				},
				error: function error(file, message, xhr) {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					_this2.cdpTraficUploaded = null;
				},
				success: function success(file, response) {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						var elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					_this2.cdpTraficUploaded = response.data.files;
					if (!_this2.showStep2) _this2.moveToProcessing();
				}
			})
		};
	},
	created: function created() {
		var _this3 = this;

		var user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
		user.getIdToken().then(function (idToken) {
			var headers = {
				'Authorization': 'Bearer ' + idToken
			};
			_this3.usCdpTrafic.headers = headers;
		});
	}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'default-dropdown-filter',
	props: {
		defaultLabel: {
			type: String,
			required: false,
			default: 'Vse'
		},
		defaultHeader: {
			type: String,
			required: false,
			default: null
		},
		value: {
			required: false
		},
		items: {
			type: Array,
			required: true
		},
		multiselect: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			selectedItems: [],
			allSelected: true
		};
	}
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fullcalendar_vue__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_daygrid__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_daygrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fullcalendar_daygrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_bootstrap__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fullcalendar_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timegrid__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timegrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fullcalendar_timegrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullcalendar_interaction__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullcalendar_interaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fullcalendar_interaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fullcalendar_core_locales_sl__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fullcalendar_core_locales_sl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fullcalendar_core_locales_sl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IzdajaModal__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings_js__ = __webpack_require__(12);













var fb = __webpack_require__(170);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'izdaja',
	components: {
		FullCalendar: __WEBPACK_IMPORTED_MODULE_1__fullcalendar_vue__["a" /* default */],
		'izdaja-modal': __WEBPACK_IMPORTED_MODULE_8__components_IzdajaModal__["a" /* default */]
	},
	methods: {
		handleDateClick: function handleDateClick(args) {
			console.log('Date click', args);
		},
		handleSelect: function handleSelect(selectInfo) {
			console.log('Select', selectInfo);
			if (this.userCanEdit) {
				this.$refs.izdajModal.showModal(1, selectInfo.start);
			}
		},
		handleSelectAllow: function handleSelectAllow(selectInfo) {
			console.log('Select allow', selectInfo);
			if (!this.userCanEdit) {
				return false;
			}
			var nowDate = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["setHours"])(Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["setMinutes"])(Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["setSeconds"])(new Date(), 0), 0), 0);
			var selectedDate = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["setHours"])(Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["setMinutes"])(Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["setSeconds"])(selectInfo.start, 0), 0), 0);
			var dayDiff = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["differenceInHours"])(selectedDate, nowDate);
			if (dayDiff < 23) {
				return false;
			}
			var diff = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["differenceInMinutes"])(selectInfo.end, selectInfo.start);
			if (diff <= 30) {
				return true;
			}
			if (diff === 1440) {
				return true;
			}
			return false;
		},
		handleDatesRender: function handleDatesRender(info) {
			console.log('Dates render', info);
		},
		handleValidRange: function handleValidRange(nowDate) {
			return {
				start: Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["subYears"])(nowDate, 1),
				end: Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["addDays"])(nowDate, 31)
			};
		},
		handleEventClick: function handleEventClick(eventClickInfo) {
			eventClickInfo.jsEvent.preventDefault();
			var izdaja = eventClickInfo.event.extendedProps.izdaja;
			this.$refs.izdajModal.showModal(2, izdaja.datum_izdaje, izdaja.id, izdaja.prodajalec, izdaja.kupec, izdaja.voziloExt, izdaja.voziloInt, izdaja.v_ogrodje, izdaja.v_libelle_modele, izdaja.v_libelle_version, izdaja.opomba);
		},
		handleEventRender: function handleEventRender(info) {
			console.log('Render:', info);
			if (info.view.type === 'timeGridWeek') {
				console.log('Set week sizes');
			}
		},
		handleEvents: function handleEvents(fetchInfo, successCallback, failureCallback) {
			var _this = this;

			var start = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(fetchInfo.start, __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].dbDtFormat);
			var end = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["format"])(fetchInfo.end, __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].dbDtFormat);
			this.calendarIsLoading = true;
			var vue = this;
			__WEBPACK_IMPORTED_MODULE_9__service__["a" /* default */].getIzdaje(start, end).then(function (events) {
				_this.calendarIsLoading = false;
				successCallback(events.map(function (event) {
					var start = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["parse"])(event.datum_izdaje, __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].dbDtFormat);
					var end = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns__["addMinutes"])(start, 30);
					var vozilo = event.voziloInt ? event.v_libelle_modele + ' ' + event.v_libelle_version + ' (' + event.v_ogrodje + ')' : event.voziloExt;
					var kupec = vue.getKupecHR(event.kupec, event.k_is_company, event.k_first_name + ' ' + event.k_last_name, event.k_title);
					var title = 'Prodajalec: ' + event.p_first_name + ' ' + event.p_last_name + '\nVozilo: ' + vozilo + '\nKupec: ' + kupec;
					var c = {
						id: event.id,
						title: title,
						start: start,
						end: end,
						allDay: false,
						izdaja: event
					};
					return c;
				}));
			}).catch(function (error) {
				if (error) {
					_this.calendarIsLoading = false;
					console.log(error);
					failureCallback(error);
				}
			});
		},
		click_openAddIzdaja: function click_openAddIzdaja() {
			this.$refs.izdajModal.showModal(0, null);
		},
		getKupecHR: function getKupecHR(id, isCompany, name, title) {
			if (id == null) {
				return null;
			}
			if (isCompany) {
				return title;
			}
			return name;
		},
		on_izdajeSuccess: function on_izdajeSuccess(izdaja) {
			this.$refs.calendar.getApi().refetchEvents();
			this.calendarUpdate = false;
			fb.db.ref('novaIzdaja').set({
				updated_on: new Date().getTime()
			});
		},
		on_izdajeRemoved: function on_izdajeRemoved(izdaja) {
			this.$refs.calendar.getApi().refetchEvents();
			this.calendarUpdate = false;
			fb.db.ref('novaIzdaja').set({
				updated_on: new Date().getTime()
			});
		},
		loadKupci: function loadKupci() {
			var _this2 = this;

			this.kupci_options = [];
			__WEBPACK_IMPORTED_MODULE_9__service__["a" /* default */].searchKupci('#initialize').then(function (kupci) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(kupci), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						if (item.is_company) {
							item.full_name = item.title + ' (' + item.contact_name + ')';
						} else {
							item.full_name = item.first_name + ' ' + item.last_name;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this2.kupci_options = kupci;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		}
	},
	data: function data() {
		return {
			calendarIsLoading: false,
			calendarUpdate: false,
			calendarPlugins: [__WEBPACK_IMPORTED_MODULE_2__fullcalendar_daygrid___default.a, __WEBPACK_IMPORTED_MODULE_3__fullcalendar_bootstrap___default.a, __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timegrid___default.a, __WEBPACK_IMPORTED_MODULE_5__fullcalendar_interaction___default.a],
			calendarHeader: {
				left: 'prev,next today',
				center: 'title',
				right: 'timeGridDay,timeGridWeek,dayGridMonth'
			},
			calendarButtonText: {
				today: 'Danes'
			},
			calendarAllDaySlot: false,
			calendarSlotLabelFormat: {
				hour: '2-digit',
				minute: '2-digit',
				omitZeroMinute: false,
				meridiem: false
			},
			calendarLocale: __WEBPACK_IMPORTED_MODULE_6__fullcalendar_core_locales_sl___default.a,
			kupci_options: null
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		vsiKupci: function vsiKupci() {
			if (this.kupci_options == null) {
				this.loadKupci();
			}
			return this.kupci_options;
		},
		userCanEdit: function userCanEdit() {
			if (__WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].isProdajalec(this.user.role) || __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].isSekretar(this.user.role) || __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].isModerator(this.user.role) || __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].isRacunovodja(this.user.role) || __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].isAdmin(this.user.role) || __WEBPACK_IMPORTED_MODULE_10__settings_js__["a" /* default */].isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created: function created() {
		var $main = this;
		fb.db.ref('novaIzdaja').on('value', function (snapshot) {
			if ($main.calendarUpdate) {
				$main.$refs.calendar.getApi().refetchEvents();
				$main.$refs.toastr.s('Podatki posodobljeni');
			}
			$main.calendarUpdate = true;
		});
	}
});

/***/ }),
/* 553 */,
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PickKupecInline__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);









/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'pick-kupec-inline': __WEBPACK_IMPORTED_MODULE_1__components_PickKupecInline__["a" /* default */]
	},
	props: {
		prodajalci: Array,
		kupci: Array
	},
	methods: {
		showModal: function showModal(type, izbranDatum, izdajaId, prodajalec, kupec, voziloExt, voziloInt, ogrodje, libelleModele, libelleVersion, opomba) {
			var _this = this;

			this.izdaja_id = null;
			if (izdajaId) {
				this.izdaja_id = izdajaId;
			}
			this.clearModalData();
			if (type === 0) {} else if (type === 1) {
				this.datum_izdaje = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["setHours"])(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["setMinutes"])(izbranDatum, 0), 0);
				this.cas_izdaje = {
					HH: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["getHours"])(izbranDatum)).format('00'),
					mm: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["getMinutes"])(izbranDatum)).format('00')
				};
			} else if (type === 2) {
				this.datum_izdaje = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["setHours"])(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["setMinutes"])(izbranDatum, 0), 0);
				this.cas_izdaje = {
					HH: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["getHours"])(izbranDatum)).format('00'),
					mm: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["getMinutes"])(izbranDatum)).format('00')
				};
				this.ok_title = this.ACTION_TITLE_EDIT;
			}

			this.prodajalci_selected = null;
			if (prodajalec) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.vsiProdajalci), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						if (prodajalec === item.id) {
							this.prodajalci_selected = item;
							break;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.vsiProdajalci), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var _item = _step2.value;

						if (this.user.email === _item.email) {
							this.prodajalci_selected = _item;
							break;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			}

			if (kupec) {
				this.$nextTick(function () {
					_this.$refs.pickKupec.select(kupec);
				});
			} else {
				this.$nextTick(function () {
					_this.$refs.pickKupec.select(null);
				});
			}

			if (voziloInt) {
				var vozilo = this.voziloDefValue();
				vozilo.id = voziloInt;
				vozilo.ogrodje = ogrodje;
				vozilo.libelle_modele = libelleModele;
				vozilo.libelle_version = libelleVersion;
				this.vozilo_selected = vozilo;
			} else if (voziloExt) {
				var _vozilo = this.voziloDefValue();
				_vozilo.ogrodje = voziloExt;
				this.vozilo_selected = _vozilo;
			}

			if (opomba) {
				this.opomba = opomba;
			}

			if (this.user.role === 5) {
				this.prodajalci_disabled = false;
			}
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this2 = this;

			evt.preventDefault();
			if (!this.prodajalci_selected) {
				this.showError('Prodajalec ni izbran');
				return;
			}
			if (!this.vozilo_selected) {
				this.showError('Vozilo ni izbrano');
				return;
			}
			if (!this.kupec_selected) {
				this.showError('Kupec ni izbran');
				return;
			}
			if (!this.datum_izdaje) {
				this.showError('Datum izdaje ni izbran');
				return;
			}
			if (!this.cas_izdaje) {
				this.showError('Čas izdaje ni izbran');
				return;
			}

			var datumIzdaje = this.parseDatumInCas(this.datum_izdaje, this.cas_izdaje);
			var voziloInt = null;
			var voziloExt = null;
			if (this.vozilo_selected.id > 0) {
				voziloInt = this.vozilo_selected.id;
			} else {
				voziloExt = this.vozilo_selected.ogrodje;
			}
			this.showError(null);
			this.in_progress = true;
			__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].dodajIzdajo(this.izdaja_id, this.prodajalci_selected, this.kupec_selected, datumIzdaje, voziloInt, voziloExt, this.opomba).then(function (response) {
				_this2.$refs.modal.hide();
				_this2.clearModalData();
				_this2.$emit('izdaja-success', response.izdaja);
			}).catch(function (error) {
				_this2.in_progress = false;
				_this2.processAddError(error);
			});
		},
		click_odstrani: function click_odstrani(evt) {
			var _this3 = this;

			if (!this.izdaja_id) {
				this.showError('Odstranitev ni mogoča');
				return;
			}

			this.showError(null);
			this.in_progress = true;
			__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].odstraniIzdajo(this.izdaja_id).then(function (response) {
				_this3.$refs.modal.hide();
				_this3.clearModalData();
				_this3.$emit('izdaja-removed', response.izdaja);
			}).catch(function (error) {
				_this3.in_progress = false;
				_this3.processRemoveError(error);
			});
		},
		parseDatumInCas: function parseDatumInCas(datum, cas) {
			return Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["setHours"])(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["setMinutes"])(datum, cas.mm), cas.HH), __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
		},
		clearModalData: function clearModalData() {
			this.vozilo_selected = null;
			this.kupec_selected = null;
			this.datum_izdaje = null;
			this.cas_izdaje = null;
			this.opomba = null;
			this.action_message_type = null;
			this.action_message = null;
			this.in_progress = false;
			this.ok_title = this.ACTION_TITLE_ADD;
		},
		loadProdajalci: function loadProdajalci() {
			var _this4 = this;

			this.prodajalci_options = [];
			__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].getProdajalci().then(function (prodajalci) {
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(prodajalci), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var item = _step3.value;

						item.full_name = item.first_name + ' ' + item.last_name;
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}

				_this4.prodajalci_options = prodajalci;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		voziloSelect_change: function voziloSelect_change(value) {
			if (value) {
				if (value.p_kupec) {
					this.$refs.pickKupec.select(value.p_kupec);
				} else {
					this.$refs.pickKupec.select(null);
				}
			} else {
				this.$refs.pickKupec.select(null);
			}
		},
		vozilaSelect_createOption: function vozilaSelect_createOption(value) {
			var vozilo = this.voziloDefValue();
			vozilo.ogrodje = value;
			return vozilo;
		},
		vozilaSelect_search: function vozilaSelect_search(search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		voziloDefValue: function voziloDefValue() {
			return {
				id: -1,
				ogrodje: '',
				libelle_modele: 'Nov model',
				libelle_version: 'Nova verzija'
			};
		},
		vozilaSelect_load: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function (loading, search, vm) {
			loading(true);
			__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].searchVozila(search).then(function (vozila) {
				loading(false);
				vm.vozila_options = vozila;
			}).catch(function (error) {
				loading(false);
				if (error) {
					console.log(error);
				}
			});
		}, 500),
		processAddError: function processAddError(error) {
			if (!error) {
				this.showError('Napaka pri izdaji (G)');
				return;
			}
			console.log(error);
			if (!error.response || !error.response.status || error.response.status !== 400) {
				this.showError('Izdaja ni uspela (S)');
				return;
			}
			if (!error.response.data || !error.response.data.code || !error.response.data.message) {
				this.showError('Izdaja ni uspela (U)');
				return;
			}
			this.showError(error.response.data.message + ' (#' + error.response.data.code + ')');
		},
		processRemoveError: function processRemoveError(error) {
			if (!error) {
				this.showError('Napaka pri odstranjevanju (G)');
				return;
			}
			console.log(error);
			this.showError('Napaka pri odstranjevanju (R)');
		},
		showError: function showError(message) {
			this.action_message_type = this.ACTION_TYPE_ERROR;
			this.action_message = message;
		},
		getCasIzdajeText: function getCasIzdajeText() {
			var resultText = '';
			if (this.cas_izdaje != null) {
				if (this.cas_izdaje.HH != null) {
					resultText += this.cas_izdaje.HH + ' : ';
				} else {
					resultText += '-- : ';
				}
				if (this.cas_izdaje.mm != null) {
					resultText += this.cas_izdaje.mm;
				} else {
					resultText += '--';
				}
				return resultText;
			} else {
				return '';
			}
		}
	},
	data: function data() {
		return {
			vozilo_selected: null,
			vozila_options: [],
			izdaja_id: null,
			prodajalci_disabled: true,
			prodajalci_selected: null,
			prodajalci_options: null,
			kupec_selected: null,
			action_message_type: null,
			action_message: null,
			datum_izdaje: null,
			cas_izdaje: null,
			opomba: '',
			ok_title: '',
			in_progress: false,
			ACTION_TITLE_ADD: 'Dodaj',
			ACTION_TITLE_EDIT: 'Spremeni',
			ACTION_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		vsiProdajalci: function vsiProdajalci() {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		},
		dateRange: function dateRange() {
			var nowDate = new Date();
			return {
				min: Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["addDays"])(nowDate, 1),
				max: Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["addDays"])(nowDate, 31)
			};
		},
		userCanEdit: function userCanEdit() {
			if (__WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isProdajalec(this.user.role) || __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isSekretar(this.user.role) || __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isModerator(this.user.role) || __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isRacunovodja(this.user.role) || __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isAdmin(this.user.role) || __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created: function created() {}
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditKupecModal__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'kupci',
	components: {
		'edit-kupec-modal': __WEBPACK_IMPORTED_MODULE_0__components_EditKupecModal__["a" /* default */]
	},
	filters: {
		type_format: function type_format(isCompany) {
			if (isCompany) {
				return 'P';
			} else {
				return 'F';
			}
		},
		title_format: function title_format(item) {
			if (item.is_company) {
				return item.title + ' (' + item.contact_name + ')';
			} else {
				return item.first_name + ' ' + item.last_name;
			}
		}
	},
	methods: {
		rowClicked: function rowClicked(item, index) {
			this.selectedKupec = item;
			this.$refs.editModal.openModal();
		},

		click_openAddKupec: function click_openAddKupec() {
			this.selectedKupec = null;
			this.$refs.editModal.openModal();
		},
		click_openEditKupec: function click_openEditKupec(data, button) {
			this.selectedKupec = data.item;
			this.$refs.editModal.openModal();
		},
		click_removeKupec: function click_removeKupec(data, button) {
			var _this = this;

			var naziv = '';
			if (data.item.is_company) {
				naziv = data.item.title + ' ' + data.item.contact_name;
			} else {
				naziv = data.item.first_name + ' ' + data.item.first_name;
			}
			this.$bvModal.msgBoxConfirm('Želite izbrisati kupca ' + naziv + '?', {
				title: 'Potrdite brisanje kupca',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].removeKupec(data.item).then(function (kupec) {
						_this.$refs.dataTable.refresh();
						_this.$refs.toastr.s('Kupec ' + data.item.first_name + ' ' + data.item.last_name + ' odstranjen');
					}).catch(function (error) {
						if (error) {
							console.log(error);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		edit_add: function edit_add(item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Kupec ' + item.first_name + ' ' + item.last_name + ' dodan');
		},
		edit_update: function edit_update(item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Kupec ' + item.first_name + ' ' + item.last_name + ' posodobljen');
		},
		dataProvider: function dataProvider(ctx) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getKupciFiltered(ctx, this.filter).then(function (data) {
				_this2.items = data;
				_this2.totalRows = data.total;
				return _this2.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				return [];
			});
		},
		allowDelete: function allowDelete() {
			if (this.user.role === 4 || this.user.role === 5) {
				return true;
			} else {
				return false;
			}
		}
	},
	data: function data() {
		return {
			fields: [{ key: 'is_company', label: 'Tip', sortable: true, class: 'seznamKupcevTip' }, { key: 'title', label: 'Naziv', sortable: true }, { key: 'email', label: 'Email', sortable: true }, { key: 'phone_number', label: 'Telefon', sortable: true, class: 'seznamKupcevTelefon' }, { key: 'actions', label: '#', class: 'seznamKupcevActions' }],
			selectedKupec: null,
			currentPage: 1,
			perPage: 50,
			totalRows: 0,
			items: [],
			filter: null
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		}
	}
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editkupecmodal',
	methods: {
		openModal: function openModal() {
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			this.$refs.form.classList.add('was-validated');
			if (!this.$refs.form.checkValidity()) {
				this.modalErrorMsg = { message: 'Označena polja so nepravilno izpolnjena' };
				return;
			}
			this.modalIsBusy = true;
			this.modalErrorMsg = null;
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].addKupec(this.modalItem).then(function (kupec) {
				_this.modalIsBusy = false;
				_this.$emit('input', _this.modalItem);
				if (_this.modalIsNew) {
					_this.$emit('kupec_add', _this.modalItem);
				} else {
					_this.$emit('kupec_edit', _this.modalItem);
				}
				_this.$refs.modal.hide();
			}).catch(function (error) {
				if (error) {
					console.log(error);
					_this.modalErrorMsg = { message: 'Napaka na strežniku' };
					_this.modalIsBusy = false;
				}
			});
		},
		clear_error_msg: function clear_error_msg(event) {
			this.modalErrorMsg = null;
		}
	},
	props: ['value'],
	watch: {
		value: function value() {
			var _this2 = this;

			if (this.value == null) {
				this.$nextTick(function () {
					_this2.$refs.form.classList.remove('was-validated');
				});
				this.modalErrorMsg = null;
				this.modalIsNew = true;
				this.modalTitle = 'Dodaj kupca';
				this.modalOkTitle = 'Dodaj';
				this.modalItem.id = 0;
				this.modalItem.is_company = 'false';
				this.modalItem.title = '';
				this.modalItem.contact_name = '';
				this.modalItem.first_name = '';
				this.modalItem.last_name = '';
				this.modalItem.email = '';
				this.modalItem.phone_number = '';
				this.modalItem.address = '';
			} else {
				this.$nextTick(function () {
					_this2.$refs.form.classList.remove('was-validated');
				});
				this.modalErrorMsg = null;
				this.modalIsNew = false;
				this.modalTitle = 'Uredi kupca (' + this.value.first_name + ' ' + this.value.last_name + ')';
				this.modalOkTitle = 'Shrani';
				this.modalItem.id = this.value.id;
				if (this.value.is_company) {
					this.modalItem.is_company = 'true';
				} else {
					this.modalItem.is_company = 'false';
				}
				this.modalItem.title = this.value.title;
				this.modalItem.contact_name = this.value.contact_name;
				this.modalItem.first_name = this.value.first_name;
				this.modalItem.last_name = this.value.last_name;
				this.modalItem.email = this.value.email;
				this.modalItem.phone_number = this.value.phone_number;
				this.modalItem.address = this.value.address;
			}
		}
	},
	data: function data() {
		return {
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Dodaj kupca',
			modalOkTitle: 'Dodaj',
			modalCancelTitle: 'Prekliči',
			modalIsNew: true,
			modalItem: {
				id: 0,
				is_company: 'false',
				title: '',
				contact_name: '',
				first_name: '',
				last_name: '',
				email: '',
				phone_number: '',
				address: ''
			}
		};
	}
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DatumFilterDropdown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DropdownFilters_VirPrilivaDropdown__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DropdownFilters_ZnesekDropdown__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modals_UvoziPrilivModal__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modals_EditPrilivModal__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings_js__ = __webpack_require__(12);










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'prilivi',
	components: {
		'datum-filter-dropdown': __WEBPACK_IMPORTED_MODULE_2__components_DatumFilterDropdown__["a" /* default */],
		'vir-filter-dropdown': __WEBPACK_IMPORTED_MODULE_3__components_DropdownFilters_VirPrilivaDropdown__["a" /* default */],
		'znesek-filter-dropdown': __WEBPACK_IMPORTED_MODULE_4__components_DropdownFilters_ZnesekDropdown__["a" /* default */],
		'uvozi-priliv-modal': __WEBPACK_IMPORTED_MODULE_5__components_Modals_UvoziPrilivModal__["a" /* default */],
		'edit-priliv-modal': __WEBPACK_IMPORTED_MODULE_6__components_Modals_EditPrilivModal__["a" /* default */]
	},
	filters: {},
	methods: {
		click_openUvoziPrilive: function click_openUvoziPrilive($event) {
			this.showError(null);
			this.$refs.uvoziModal.showModal();
		},
		click_editPriliv: function click_editPriliv(priliv) {
			this.showError(null);
			this.$refs.editPrilivModal.showModal(priliv, false);
		},
		click_removePriliv: function click_removePriliv(priliv) {
			var _this = this;

			this.$bvModal.msgBoxConfirm('Želite izbrisati priliv #' + priliv.id + '?', {
				title: 'Potrdite brisanje priliva',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].removePriliv(priliv.id).then(function (response) {
						_this.table.items = _this.table.items.filter(function (value, index, arr) {
							return value.id !== priliv.id;
						});
						_this.showError(null);
						_this.$refs.dataTable.refresh();
					}).catch(function (error) {
						_this.showError('Napaka odstranjevanju priliva!');
						if (error) {
							console.log(error);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		table_rowClick: function table_rowClick(item, index) {
			this.showError(null);
		},
		table_dataProvider: function table_dataProvider(ctx) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getPriliviFiltered(ctx, this.inputFilter, this.user).then(function (data) {
				_this2.items = data;
				_this2.table.totalRows = data.total;
				return _this2.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				_this2.totalRows = 0;
				return [];
			});
		},
		table_filterChange: function table_filterChange(value) {
			var _this3 = this;

			if (this.filterPriliviTimeout !== null) {
				clearTimeout(this.filterPriliviTimeout);
			}
			this.filterPriliviTimeout = setTimeout(function () {
				_this3.$refs.dataTable.refresh();
			}, __WEBPACK_IMPORTED_MODULE_7__settings_js__["a" /* default */].filterTimeoutLength);
		},
		table_virFilterChange: function table_virFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.vir = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selectedItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						this.inputFilter.vir.push(item.value);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				this.inputFilter.vir = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_priliviPotrjeniSuccess: function on_priliviPotrjeniSuccess() {
			this.$refs.dataTable.refresh();
		},
		edit_add: function edit_add() {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Priliv dodan');
		},
		edit_update: function edit_update() {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Priliv posodobljen');
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: function data() {
		return {
			table: {
				items: [],
				fields: [{ key: 'datum', label: 'Datum', sortable: true, class: 'seznamPrilivovDatum' }, { key: 'ogrodje', label: 'Ogrodje', sortable: true, class: 'seznamPrilivovOgrodje' }, { key: 'placnik', label: 'Stranka', sortable: true }, { key: 'naziv', label: 'Naziv', sortable: true }, { key: 'referenca', label: 'Referenca', sortable: true }, { key: 'znesek', label: 'Znesek', sortable: true, class: 'seznamPrilivovZnesek' }, { key: 'vir', label: 'Vir', sortable: true, class: 'seznamPrilivovVir' }, { key: 'actions', label: '#', class: 'seznamPrilivovActions' }],
				currentPage: 1,
				perPage: 50,
				totalRows: 0,
				sortDesc: true,
				sortBy: 'created_at',
				filter: null
			},
			inputFilter: {
				datum: null,
				ogrodje: '',
				placnik: '',
				naziv: '',
				referenca: '',
				znesek: null,
				vir: null
			},
			filterPriliviTimeout: null,
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		message_class: function message_class() {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created: function created() {}
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'virprilivfilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: 'LON',
				value: 'lon',
				active: false
			}, {
				label: 'Vasco',
				value: 'vasco',
				active: false
			}, {
				label: 'SKB',
				value: 'skb',
				active: false
			}, {
				label: 'TRAFIC',
				value: 'trafic',
				active: false
			}, {
				label: 'Izvoz',
				value: 'izvoz',
				active: false
			}, {
				label: 'Ročno',
				value: 'rocno',
				active: false
			}]
		};
	}
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZnesekDropdown_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b744e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZnesekDropdown_vue__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1017)
  __webpack_require__(1018)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18b744e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZnesekDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b744e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZnesekDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b744e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZnesekDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'znesekfilter-dropdown',
	props: {
		value: {
			type: Object,
			required: false
		}
	},
	methods: {
		click_potrdi: function click_potrdi(evt) {
			if (this.mode === '') {
				this.$emit('input', null);
				this.$refs.dropdown.hide();
				return;
			}
			if (this.mode === 'single') {
				if (!this.znesek) {
					return;
				}
				this.izbranZnesek = { value: this.znesek };
				this.label = this.znesek + ' €';
			} else if (this.mode === 'range') {
				if (!this.znesek_od || !this.znesek_do) {
					return;
				}
				this.izbranZnesek = { min: this.znesek_od, max: this.znesek_do };
				this.label = this.znesek_od + ' - ' + this.znesek_do + ' €';
			}
			this.$emit('input', this.izbranZnesek);
			this.$refs.dropdown.hide();
		},
		click_pocisti: function click_pocisti(evt) {
			this.clearForm();
			this.$emit('input', null);
			this.$refs.dropdown.hide();
		},
		clear: function clear() {
			this.clearForm();
		},
		clearForm: function clearForm() {
			this.izbranZnesek = null;
			this.label = null;
			this.mode = '';
			this.znesek = null;
			this.znesek_od = null;
			this.znesek_do = null;
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.label) {
				return this.label;
			} else {
				return this.defaultItemLabel;
			}
		}
	},
	data: function data() {
		return {
			izbranZnesek: null,
			label: null,
			mode: '',
			znesek: null,
			znesek_od: null,
			znesek_do: null,
			defaultItemLabel: 'Vse'
		};
	}
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ladda__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var LON_PH_TEXT = 'Izberi ali povleci LON Excel datoteko za uvoz ...';
var SKB_PH_TEXT = 'Izberi ali povleci SKB Xml datoteko za uvoz ...';
var VASCO_PH_TEXT = 'Izberi ali povleci Vasco Excel datoteko za uvoz ...';
var TRAFIC_PH_TEXT = 'Izberi ali povleci Trafic Excel datoteko za uvoz ...';

/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		showModal: function showModal() {
			this.$refs.modal.show();
		},
		modal_okClick: function modal_okClick(evt) {
			var _this = this;

			evt.preventDefault();
			this.showError(null);
			var loader = __WEBPACK_IMPORTED_MODULE_2_ladda__["a" /* create */](this.$refs.aOk);
			loader.start();
			if (this.show_step_two) {
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].priliviSave(this.import_table.items).then(function (response) {
					loader.stop();
					if (response.processed) {
						_this.clearForm();
						_this.$refs.modal.hide();
						_this.$emit('priliviPotrjeni-success');
					} else {
						_this.showError('Prilivov ni mogoče shraniti!');
					}
				}).catch(function (error) {
					loader.stop();
					_this.showError('Napaka pri shranjevanju prilivov!');
					if (error) {
						console.log(error);
					}
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].priliviUpload(this.tip_priliva, this.import_text, this.import_file).then(function (response) {
					loader.stop();
					if (response.items && response.items.length > 0) {
						_this.import_table.items = response.items;
						_this.show_step_two = true;
					} else {
						_this.showError('Prilivov ni mogoče uvoziti!');
					}
				}).catch(function (error) {
					loader.stop();
					_this.showError('Napaka pri uvozu prilivov!');
					if (error) {
						console.log(error);
					}
				});
			}
		},
		modal_cancelClick: function modal_cancelClick(evt) {
			var _this2 = this;

			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this2.clearForm();
			}, 300);
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function clearForm() {
			this.show_step_two = false;
			this.tip_priliva = 'lon';
			this.import_file = null;
			this.import_text = '';
			this.message = {
				type: null,
				text: null
			};
		},
		vozilaSelect_load: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (loading, search, vm) {
			loading(true);
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchVozila(search).then(function (vozila) {
				loading(false);
				vm.ogrodja_options = vozila;
			}).catch(function (error) {
				loading(false);
				if (error) {
					console.log(error);
				}
			});
		}, 500),
		voziloSelect_change: function voziloSelect_change(value, index) {
			this.import_table.items[index].id_vozila = value.id;
		},
		vozilaSelect_search: function vozilaSelect_search(search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		toggleSelectAll: function toggleSelectAll() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.import_table.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var priliv = _step.value;

					priliv.selected = !this.selectAll;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	},
	watch: {
		tip_priliva: function tip_priliva() {
			this.import_file = null;
			this.import_text = '';
			this.showError(null);
		}
	},
	data: function data() {
		return {
			show_step_two: false,
			tip_priliva: 'lon',
			import_file: null,
			import_text: '',
			import_table: {
				items: [],
				fields: [{ key: 'selected', sortable: false, class: 'tdPrilivSelect' }, { key: 'datum', label: 'Datum', sortable: false, class: 'tdPrilivDatum' }, { key: 'iskalniNiz', label: 'Naziv', sortable: false }, { key: 'ogrodje', label: 'Ogrodje', sortable: false, class: 'tdPrilivOgrodje' }, { key: 'znesek', label: 'Znesek', sortable: false, class: 'tdPrilivZnesek' }]
			},
			ogrodja_options: [],
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			selectAll: true
		};
	},
	computed: {
		upload_placeholder: function upload_placeholder() {
			if (this.tip_priliva === 'lon') {
				return LON_PH_TEXT;
			} else if (this.tip_priliva === 'vasco') {
				return VASCO_PH_TEXT;
			} else if (this.tip_priliva === 'trafic') {
				return TRAFIC_PH_TEXT;
			}
			return SKB_PH_TEXT;
		},
		upload_accept: function upload_accept() {
			if (this.tip_priliva === 'lon') {
				return '.csv, .xls';
			} else if (this.tip_priliva === 'vasco') {
				return '.xls, .xlsx';
			} else if (this.tip_priliva === 'trafic') {
				return '.csv';
			}
			return '.xml';
		},
		ok_text: function ok_text() {
			if (this.show_step_two) {
				return 'Potrdi';
			}
			return 'Naprej';
		},
		modal_size: function modal_size() {
			if (this.show_step_two) {
				return 'lg';
			}
			return 'lg';
		},
		modal_body_class: function modal_body_class() {
			if (this.show_step_two) {
				return 'no_padding';
			}
			return '';
		},
		message_class: function message_class() {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created: function created() {}
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EditUserPasswordModal__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EditUserPictureModal__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings_js__ = __webpack_require__(12);









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Profile',
	components: {
		'edit-user-password-modal': __WEBPACK_IMPORTED_MODULE_1__components_EditUserPasswordModal__["a" /* default */],
		'edit-user-picture-modal': __WEBPACK_IMPORTED_MODULE_2__components_EditUserPictureModal__["a" /* default */]
	},
	filters: {},
	methods: {
		click_remove: function click_remove(data, button) {
			console.log(data);
		},
		click_edit: function click_edit(data, button) {
			console.log(data);
		},
		click_showInfo: function click_showInfo(data, button) {
			console.log(data);
		},
		click_openEditUserPassword: function click_openEditUserPassword(button) {
			this.$refs.EditUserPasswordModal.showModal(this.user);
		},
		click_openEditUserPicture: function click_openEditUserPicture(button) {
			this.$refs.EditUserPictureModal.showModal(this.user);
		},
		click_removeUserPicture: function click_removeUserPicture(button) {
			var _this = this;

			this.uploadValue = 100;
			var usr = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;

			usr.updateProfile({
				photoURL: null
			}).then(function () {
				var newUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.user);
				newUser.photoURL = null;
				_this.$store.dispatch('setUser', newUser);
				_this.$refs.toastr.s('Slika odstranjena');
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				this.modalErrorMsg = 'Napaka pri odstranjevanju slike uporabnika.';
			});
		},
		edit_password: function edit_password() {
			this.$refs.toastr.s('Geslo posodobljeno');
			console.log('Password update successful');
		},
		edit_picture: function edit_picture() {
			this.$refs.toastr.s('Slika posodobljena');
			console.log('Picture update successful');
		},
		timestampIzpis: function timestampIzpis(timestamp) {
			var result = '';
			if (timestamp) {
				var datum = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(timestamp.substring(0, 10), __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].viewDtFormat);
				var ura = timestamp.substring(11, 19);
				result = 'Dne ' + datum + ' ob ' + ura;
			}
			return result;
		}
	},
	data: function data() {
		return {
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			items: [],
			filter: null
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		}
	},
	created: function created() {}
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editUserPsswordModal',
	methods: {
		showModal: function showModal(user) {
			console.log('Show modal ' + user.email + '-' + user.id);
			this.modalUser.id = user.id;
			this.modalUser.email = user.email;
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			this.modalErrorMsg = null;
			this.$refs.form.classList.add('was-validated');
			if (!this.$refs.form.checkValidity()) {
				this.modalErrorMsg = 'Označena polja so nepravilno izpolnjena';
				return;
			} else {
				if (this.modalUser.newPassword === '' || this.modalUser.newPassword !== this.modalUser.newPassword2) {
					this.modalErrorMsg = 'Gesli se ne ujemata';
					return;
				}
			}
			var context = this;
			__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.modalUser.email, this.modalUser.oldPassword).then(function (fbUser) {
				fbUser.updatePassword(_this.modalUser.newPassword).then(function () {
					context.modalIsBusy = false;
					context.$emit('edit_password');
					context.clearModal();
					context.$refs.modal.hide();
				}).catch(function (error) {
					console.log('Error: ' + error);
					context.modalIsBusy = false;
					context.modalErrorMsg = 'Napaka pri spreminjanju gesla.';
				});
			}).catch(function (error) {
				console.log('Error: ' + error);
				_this.modalIsBusy = false;
				_this.modalErrorMsg = 'Napačno prejšnje geslo.';
			});
		},
		onCancelModal: function onCancelModal(evt) {
			this.clearModal();
			this.$refs.modal.hide();
		},
		clearModal: function clearModal() {
			this.modalErrorMsg = null;
			this.modalIsBusy = false;
			this.modalUser.id = 0;
			this.modalUser.email = '';
			this.modalUser.oldPassword = '';
			this.modalUser.newPassword = '';
			this.modalUser.newPassword2 = '';
		},
		clear_error_msg: function clear_error_msg(event) {
			this.modalErrorMsg = null;
		}
	},
	data: function data() {
		return {
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Sprememba gesla',
			modalOkTitle: 'Spremeni',
			modalCancelTitle: 'Prekliči',
			modalUser: {
				id: 0,
				email: '',
				oldPassword: '',
				newPassword: '',
				newPassword2: ''
			}
		};
	}
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);




var IMG_PH_TEXT = 'Izberi ali povleci sliko ...';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editUserPictureModal',
	methods: {
		showModal: function showModal(user) {
			this.modalUser.id = user.id;
			this.modalUser.email = user.email;
			this.modalUser.photoURL = user.photoURL;
			this.modalUser.display_name = user.display_name;
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			this.modalErrorMsg = null;
			this.modalIsBusy = true;
			var storageRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage().ref('' + ('profiles/' + this.modalUser.email + '/' + Date.now() + '_' + this.imageData.name)).put(this.imageData);
			storageRef.on('state_changed', function (snapshot) {
				_this.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
			}, function (error) {
				if (error) {
					console.log(error.message);
				}
				_this.modalErrorMsg = 'Napaka pri nalaganju slike.';
			}, function () {
				_this.uploadValue = 100;
				storageRef.snapshot.ref.getDownloadURL().then(function (url) {
					_this.uploadValue = 100;
					var usr = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;

					usr.updateProfile({
						photoURL: url
					}).then(function () {
						var newUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.user);
						newUser.photoURL = url;
						_this.$store.dispatch('setUser', newUser);
						_this.$emit('edit_picture');

						_this.clearModal();
						_this.modalIsBusy = false;
						_this.$refs.modal.hide();
					}).catch(function (error) {
						if (error) {
							console.log(error);
						}
						this.modalErrorMsg = 'Napaka pri spreminjanju slike uporabnika.';
					});
				});
			});
		},
		onCancelModal: function onCancelModal(evt) {
			this.clearModal();
			this.$refs.modal.hide();
		},
		previewImage: function previewImage(event) {
			var _this2 = this;

			var input;
			if (event instanceof DragEvent) {
				this.imageData = event.dataTransfer.files[0];
				input = event.dataTransfer;
			} else {
				this.imageData = event.target.files[0];
				input = event.target;
			}
			if (input.files && input.files[0]) {
				var reader = new FileReader();
				reader.onload = function (e) {
					_this2.imageDataPreview = e.target.result;
				};
				reader.readAsDataURL(input.files[0]);
			}
		},
		clear_error_msg: function clear_error_msg(event) {
			this.modalErrorMsg = null;
		},
		clearModal: function clearModal() {
			this.imageData = null;
			this.imageDataPreview = null;
			this.uploadValue = 0;
			this.modalErrorMsg = null;
			this.modalIsBusy = false;
			this.modalUser.id = 0;
			this.modalUser.email = '';
			this.modalUser.phoroUrl = '';
			this.modalUser.display_name = '';
		}
	},
	data: function data() {
		return {
			imageData: null,
			imageDataPreview: null,
			uploadValue: 0,
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Sprememba profilne slike',
			modalOkTitle: 'Shrani',
			modalCancelTitle: 'Prekliči',
			modalUser: {
				id: 0,
				email: '',
				phoroUrl: '',
				display_name: ''
			}
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		upload_accept: function upload_accept() {
			return '.jpg';
		},
		upload_placeholder: function upload_placeholder() {
			return IMG_PH_TEXT;
		}
	}
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditUserModal__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_js__ = __webpack_require__(12);







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'uporabniki',
	components: {
		'edit-user-modal': __WEBPACK_IMPORTED_MODULE_0__components_EditUserModal__["a" /* default */]
	},
	filters: {
		role_hr: function role_hr(value) {
			if (value != null) {
				if (value === 5) {
					return 'Administrator';
				} else if (value === 4) {
					return 'Moderator';
				} else if (value === 3) {
					return 'Računovodja';
				} else if (value === 1) {
					return 'Komercialni sekretar';
				} else if (value === 0) {
					return 'Prodajalec';
				} else if (value === 11) {
					return 'Skrbnik gum';
				} else if (value === 12) {
					return 'Servis';
				} else if (value === 13) {
					return 'Poprodaja';
				} else {
					return 'Neznana vloga';
				}
			} else {
				return 'Neznana vloga';
			}
		}
	},
	methods: {
		rowClicked: function rowClicked(item, index) {
			this.$refs.editModal.showModal(item);
		},
		click_openAddUser: function click_openAddUser() {
			this.$refs.editModal.showModal(null);
		},
		click_openEditUser: function click_openEditUser(data, button) {
			this.$refs.editModal.showModal(data.item);
		},
		click_removeUser: function click_removeUser(data, button) {
			var _this = this;

			this.$bvModal.msgBoxConfirm('Želite izbrisati uporabnika ' + data.item.email + '?', {
				title: 'Potrdite brisanje uporabnika',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].removeUser(data.item).then(function (response) {
						if (response['message'] === 'deleted') {
							_this.$refs.dataTable.refresh();
							_this.$refs.toastr.s('Uporabnik ' + response['user']['email'] + ' odstranjen');
						} else {
							_this.$refs.toastr.e('Neveljaven odziv strežnika!');
							console.error('Neveljaven response message: ' + response.data['message']);
						}
					}).catch(function (error) {
						if (error.response) {
							if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].errorMessages.serverSideValidationError) {
								_this.$refs.toastr.e('Napaka pri validaciji na strežniku!');
								console.error(error.response.data.message + ': ', error.response.data.errors);
							} else if (error.response.data.message === 'userNotExists') {
								_this.$refs.toastr.e('Uporabnik ne obstaja!');
								console.error(error.response.data.message);
							} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].errorMessages.invalidRole) {
								_this.$refs.toastr.e('Uporabnik nima pravice odstranjevanja uporabnikov!');
								console.error(error.response.data.message);
							} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].errorMessages.PDOException) {
								_this.$refs.toastr.e('Napaka na strežniku!');
								console.error(error.response.data.message, 'details in .ex');
							} else {
								_this.$refs.toastr.e('Neznana napaka na strežniku!');
								console.error(error.response.data.message);
							}
						} else if (error.request) {
							console.log('The request was made but no response was received:', error.request);
						} else {
							console.log('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		edit_add: function edit_add(item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Uporabnik ' + item.first_name + ' ' + item.last_name + ' dodan');
		},
		edit_update: function edit_update(item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Uporabnik ' + item.first_name + ' ' + item.last_name + ' posodobljen');
		},
		dataProvider: function dataProvider(ctx) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getUsers(ctx, this.inputFilter).then(function (data) {
				_this2.items = data;
				_this2.totalRows = data.total;
				return _this2.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				return [];
			});
		},
		timestampIzpis: function timestampIzpis(timestam) {
			var result = '';
			if (timestam) {
				var datum = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(timestam.substring(0, 10), __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].viewDtFormat);
				var ura = timestam.substring(11, 19);
				result = 'Dne ' + datum + ' ob ' + ura;
			}
			return result;
		}
	},
	data: function data() {
		return {
			fields: [{ key: 'first_name', label: 'Ime', sortable: true }, { key: 'last_name', label: 'Priimek', sortable: true }, { key: 'email', label: 'Email', sortable: true }, { key: 'role', label: 'Vloga' }, { key: 'last_access_at', label: 'Zadnji dostop' }, { key: 'last_access_ip', label: 'Ip zadnjega dostopa' }, { key: 'actions', label: '#' }],
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			items: [],
			filter: null
		};
	}
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editusermodal',
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
	},
	methods: {
		showModal: function showModal(value) {
			if (value == null) {
				this.modalErrorMsg = null;
				this.modalIsNew = true;
				this.modalTitle = 'Dodaj uporabnika';
				this.modalOkTitle = 'Dodaj';
				this.modalUser.id = 0;
				this.modalUser.first_name = '';
				this.modalUser.last_name = '';
				this.modalUser.email = '';
				this.modalUser.password = '';
				this.modalUser.password2 = '';
				this.modalUser.match_pattern = '';
				this.modalUser.role = 0;
			} else {
				this.modalErrorMsg = null;
				this.modalIsNew = false;
				this.modalTitle = 'Uredi uporabnika (' + value.first_name + ' ' + value.last_name + ')';
				this.modalOkTitle = 'Shrani';
				this.modalUser.id = value.id;
				this.modalUser.first_name = value.first_name;
				this.modalUser.last_name = value.last_name;
				this.modalUser.email = value.email;
				this.modalUser.password = '';
				this.modalUser.password2 = '';
				this.modalUser.match_pattern = value.match_pattern;
				this.modalUser.role = value.role;
				this.modalUser.last_access_ip_readonly = value.last_access_ip;
				this.modalUser.last_access_at_readonly = value.last_access_at;
				this.modalUser.created_at_readonly = value.created_at;
			}
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal(evt) {
			var _this = this;

			evt.preventDefault();
			if (!this.validateForm) {
				this.modalErrorMsg = 'Označena polja so nepravilno izpolnjena';
				return;
			}
			this.modalIsBusy = true;
			this.modalErrorMsg = null;
			this.isLoading = true;
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].addUser(this.modalUser).then(function (response) {
				_this.modalIsBusy = false;
				_this.isLoading = false;
				if (response['message'] === 'updated' && !_this.modalIsNew) {
					_this.$emit('user_edit', response['user']);
					_this.$refs.modal.hide();
				} else if (response['message'] === 'added' && _this.modalIsNew) {
					_this.$emit('user_add', response['user']);
					_this.$refs.modal.hide();
				} else {
					_this.modalErrorMsg = 'Neveljaven odziv strežnika';
					console.error('Neveljaven response message: ' + response.data['message']);
				}
			}).catch(function (error) {
				_this.modalIsBusy = false;
				_this.isLoading = false;
				if (error.response) {
					if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.serverSideValidationError) {
						_this.modalErrorMsg = 'Napaka pri validaciji na strežniku!';
						console.error(error.response.data.message + ': ', error.response.data.errors);
					} else if (error.response.data.message === 'emailInUse') {
						_this.modalErrorMsg = 'Email že obstaja!';
						console.error(error.response.data.message);
					} else if (error.response.data.message === 'userNotExists') {
						_this.modalErrorMsg = 'Uporabnik ne obstaja!';
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.invalidRole) {
						_this.showError('Uporabnik nima pravice odstranjevanja uporabnikov!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.PDOException) {
						_this.modalErrorMsg = 'Napaka na strežniku!';
						console.error(error.response.data.message, 'details in .ex');
					} else {
						_this.modalErrorMsg = 'Neznana napaka na strežniku!';
						console.error(error.response.data.message);
					}
				} else if (error.request) {
					console.log('The request was made but no response was received:', error.request);
				} else {
					console.log('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		clear_error_msg: function clear_error_msg(event) {
			this.modalErrorMsg = null;
		},
		timestampIzpis: function timestampIzpis(prefix, timestamp) {
			var result = '';
			if (timestamp) {
				var datum = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(timestamp.substring(0, 10), __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].viewDtFormat);
				var ura = timestamp.substring(11, 19);
				result = prefix + ' dne <b>' + datum + '</b> ob ' + ura;
			}
			return result;
		}
	},
	computed: {
		state_password: function state_password() {
			if (this.modalIsNew) {
				if (this.modalUser.password.length >= 6) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			} else {
				if (this.modalUser.password.length === 0 || this.modalUser.password.length >= 6) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			}
		},
		invalidFeedback_password: function invalidFeedback_password() {
			if (this.modalIsNew) {
				if (this.modalUser.password.length < 6) {
					return 'Geslo mora vsebovati vsaj 6 znakov';
				} else {
					return '';
				}
			} else {
				if (this.modalUser.password.length === 0) {
					return '';
				}
				if (this.modalUser.password.length > 0 && this.modalUser.password.length < 6) {
					return 'Za spremembo gesla mora geslo mora vsebovati vsaj 6 znakov';
				}
			}
		},
		state_password2: function state_password2() {
			if (this.modalIsNew) {
				if (this.modalUser.password === this.modalUser.password2) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			} else {
				if ((this.modalUser.password.length === 0 || this.modalUser.password.length >= 6) && this.modalUser.password === this.modalUser.password2) {
					this.modalErrorMsg = null;
					return true;
				}
				return false;
			}
		},
		invalidFeedback_password2: function invalidFeedback_password2() {
			if (this.modalIsNew) {
				if (this.modalUser.password.length === 0 && this.modalUser.password2.length < 6) {
					return 'Geslo mora vsebovati vsaj 6 znakov';
				}
				if (this.modalUser.password !== this.modalUser.password2) {
					return 'Gesli se ne ujemata';
				}
				return '';
			} else {
				if (this.modalUser.password.length === 0 && this.modalUser.password2.length < 6) {
					return 'Geslo mora vsebovati vsaj 6 znakov';
				}
				if ((this.modalUser.password.length > 0 || this.modalUser.password2.length > 0) && this.modalUser.password !== this.modalUser.password2) {
					return 'Gesli se ne ujemata';
				}
				return '';
			}
		},
		state_firstName: function state_firstName() {
			if (this.modalUser.first_name.length > 0) {
				this.modalErrorMsg = null;
				return true;
			}
			return false;
		},
		invalidFeedback_firstName: function invalidFeedback_firstName() {
			if (this.modalUser.first_name.length === 0) {
				return 'Ime je obvezno';
			}
			return '';
		},
		state_lastName: function state_lastName() {
			if (this.modalUser.last_name.length > 0) {
				this.modalErrorMsg = null;
				return true;
			}
			return false;
		},
		invalidFeedback_lastName: function invalidFeedback_lastName() {
			if (this.modalUser.last_name.length === 0) {
				return 'Priimek je obvezen';
			}
			return '';
		},
		state_email: function state_email() {
			var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (this.modalUser.email.length > 0 && emailRegex.test(this.modalUser.email)) {
				this.modalErrorMsg = null;
				return true;
			}
			return false;
		},
		invalidFeedback_email: function invalidFeedback_email() {
			if (this.modalUser.email.length === 0) {
				return 'Email je obvezen';
			}
			var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(this.modalUser.email)) {
				return 'Email je nepravilne oblike';
			}
			return '';
		},

		validateForm: function validateForm() {
			if (this.state_password && this.state_password2 && this.state_firstName && this.state_lastName && this.state_email) {
				return true;
			}
			return false;
		}
	},
	data: function data() {
		return {
			isLoading: false,
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Dodaj uporabnika',
			modalOkTitle: 'Dodaj',
			modalCancelTitle: 'Prekliči',
			modalIsNew: true,
			modalUser: {
				id: 0,
				first_name: '',
				last_name: '',
				email: '',
				password: '',
				password2: '',
				match_pattern: '',
				role: 0
			},
			role_options: [{ text: 'Prodajalec', value: 0 }, { text: 'Komercialni sekretar', value: 1 }, { text: 'Računovodja', value: 3 }, { text: 'Moderator', value: 4 }, { text: 'Administrator', value: 5 }, { text: 'Skrbnik gum', value: 11 }, { text: 'Servis', value: 12 }, { text: 'Poprodaja', value: 13 }]
		};
	}
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Login',
	data: function data() {
		return {
			email: '',
			password: ''
		};
	},

	computed: {
		error: function error() {
			return this.$store.getters.error;
		},
		loading: function loading() {
			return this.$store.getters.loading;
		}
	},
	methods: {
		onSubmit: function onSubmit(event) {
			var _this = this;

			this.$store.dispatch('startLoading');
			this.$store.dispatch('clearError');
			__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (fbUser) {
				var loginUser = {
					id: fbUser.uid,
					display_name: fbUser.displayName,
					email: fbUser.email,
					phoneNumber: fbUser.phoneNumber,
					photoURL: fbUser.photoURL,
					creationTime: fbUser.metadata.creationTime,
					lastSignInTime: fbUser.metadata.lastSignInTime
				};
				fbUser.getIdToken().then(function (idToken) {
					_this.$store.dispatch('setToken', idToken);
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;

					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getUser(loginUser).then(function (response) {
						loginUser.dbid = response.data.id;
						loginUser.first_name = response.data.first_name;
						loginUser.last_name = response.data.last_name;
						loginUser.role = response.data.role;

						_this.$store.dispatch('setUser', loginUser);
						_this.$router.replace('/');
					}).catch(function (error) {
						if (error) {
							_this.$store.dispatch('setError', error);
							_this.$store.dispatch('stopLoading');
						}
					});
				}).catch(function (error) {
					if (error) {
						this.$store.dispatch('setError', error);
						this.$store.dispatch('stopLoading');
					}
				});
			}).catch(function (error) {
				if (error) {
					_this.$store.dispatch('setError', error);
					_this.$store.dispatch('stopLoading');
				}
			});
		},
		onDismissed: function onDismissed(event) {
			this.$store.dispatch('clearError');
		}
	}
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DatumFilterDropdown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DropdownFilters_ZnesekDropdown__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modals_UvoziPovracilaModal__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modals_EditPovraciloModal__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DropdownFilters_StatusPovracilaFilterDropdown__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings_js__ = __webpack_require__(12);










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'povracila',
	components: {
		'datum-filter-dropdown': __WEBPACK_IMPORTED_MODULE_2__components_DatumFilterDropdown__["a" /* default */],
		'znesek-filter-dropdown': __WEBPACK_IMPORTED_MODULE_3__components_DropdownFilters_ZnesekDropdown__["a" /* default */],
		'uvozi-povracila-modal': __WEBPACK_IMPORTED_MODULE_4__components_Modals_UvoziPovracilaModal__["a" /* default */],
		'edit-povracilo-modal': __WEBPACK_IMPORTED_MODULE_5__components_Modals_EditPovraciloModal__["a" /* default */],
		'status-povracila-filter-dropdown': __WEBPACK_IMPORTED_MODULE_6__components_DropdownFilters_StatusPovracilaFilterDropdown__["a" /* default */]
	},
	filters: {},
	methods: {
		click_openUvoziPovracila: function click_openUvoziPovracila($event) {
			this.showError(null);
			this.$refs.uvoziPovracilaModal.showModal();
		},
		click_editPovracilo: function click_editPovracilo(povraciloData) {
			this.showError(null);
			this.$refs.editPovraciloModal.showModal(povraciloData);
		},
		click_removePovracilo: function click_removePovracilo(povraciloData) {
			var _this = this;

			this.$bvModal.msgBoxConfirm('Želite izbrisati povračilo #' + povraciloData.id + '?', {
				title: 'Potrdite brisanje poravčila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].removePovracilo(povraciloData.id).then(function (response) {
						_this.table.items = _this.table.items.filter(function (value, index, arr) {
							return value.id !== povraciloData.id;
						});
						_this.showError(null);
						_this.$refs.dataTable.refresh();
					}).catch(function (error) {
						_this.showError('Napaka odstranjevanju povračila!');
						if (error) {
							console.log(error);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		table_rowClick: function table_rowClick(item, index) {
			this.showError(null);
		},
		table_dataProvider: function table_dataProvider(ctx) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getPovracilaFiltered(ctx, this.inputFilter, this.user).then(function (data) {
				_this2.items = data.items;
				_this2.table.filterSum = data.sumItems;
				_this2.table.totalRows = data.items.total;
				return _this2.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				_this2.totalRows = 0;
				return [];
			});
		},
		table_filterChange: function table_filterChange(value) {
			var _this3 = this;

			if (this.filterPovracilaTimeout !== null) {
				clearTimeout(this.filterPovracilaTimeout);
			}
			this.filterPovracilaTimeout = setTimeout(function () {
				_this3.$refs.dataTable.refresh();
			}, __WEBPACK_IMPORTED_MODULE_7__settings_js__["a" /* default */].filterTimeoutLength);
		},
		on_statusPovracilaFilterChange: function on_statusPovracilaFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.statusPovracila = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selectedItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						this.inputFilter.statusPovracila.push(item.value);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				this.inputFilter.statusPovracila = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_povracilaPotrjenaSuccess: function on_povracilaPotrjenaSuccess() {
			this.$refs.dataTable.refresh();
		},
		edit_add: function edit_add() {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Povračilo dodano');
		},
		edit_update: function edit_update() {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Povračilo posodobljeno');
		},
		edit_vozilo_find: function edit_vozilo_find() {
			this.$refs.dataTable.refresh();
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: function data() {
		return {
			table: {
				items: [],
				fields: [{ key: 'creditnotedate', label: 'Datum izdobave', sortable: true, class: 'seznamPovracilDatum' }, { key: 'chassis', label: 'Šasija', sortable: true, class: 'seznamPovracilOgrodje' }, { key: 'amount', label: 'Skupaj odobreno', sortable: true, class: 'seznamPovracilZnesek' }, { key: 'status', label: 'Status', sortable: false, class: 'seznamPovracilStatus' }, { key: 'sale_channel', label: 'Prodajni kanal', sortable: true, class: '' }, { key: 'actions', label: '#', class: 'seznamPovracilActions' }],
				currentPage: 1,
				perPage: 50,
				totalRows: 0,
				sortDesc: true,
				sortBy: 'created_at',
				filter: null,
				filterSum: null
			},
			inputFilter: {
				datum: null,
				chassis: '',
				amount: null,
				status: null,
				action_name: '',
				sale_channel: ''
			},
			filterPovracilaTimeout: null,
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		message_class: function message_class() {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created: function created() {}
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ladda__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var EXCEL_PH_TEXT = 'Izberi ali povleci Excel datoteko za uvoz ...';
var EXCEL_V2_PH_TEXT = 'Izberi ali povleci Excel Xlsx datoteko za uvoz ...';

/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		showModal: function showModal() {
			this.$refs.modal.show();
		},
		modal_okClick: function modal_okClick(evt) {
			var _this = this;

			evt.preventDefault();
			this.showError(null);
			var loader = __WEBPACK_IMPORTED_MODULE_2_ladda__["a" /* create */](this.$refs.aOk);
			loader.start();
			if (this.show_step_two) {
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].povracilaSave(this.import_table.items).then(function (response) {
					loader.stop();
					if (response.processed) {
						_this.clearForm();
						_this.$refs.modal.hide();
						_this.$emit('povracilaPotrjena-success');
					} else {
						_this.showError('Povračil ni mogoče shraniti!');
					}
				}).catch(function (error) {
					loader.stop();
					_this.showError('Napaka pri shranjevanju povračil!');
					if (error) {
						console.log(error);
					}
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].povracilaUpload(this.tip_povracila, this.import_file).then(function (response) {
					loader.stop();
					if (response.items && response.items.length > 0) {
						_this.import_table.items = response.items;
						_this.show_step_two = true;
					} else {
						_this.showError('Povračil ni mogoče uvoziti!');
					}
				}).catch(function (error) {
					loader.stop();
					_this.showError('Napaka pri uvozu povračil!');
					if (error) {
						console.log(error);
					}
				});
			}
		},
		modal_cancelClick: function modal_cancelClick(evt) {
			var _this2 = this;

			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this2.clearForm();
			}, 300);
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function clearForm() {
			this.show_step_two = false;
			this.tip_povracila = 'excel_v2';
			this.import_file = null;
			this.message = {
				type: null,
				text: null
			};
		},
		vozilaSelect_load: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (loading, search, vm) {
			loading(true);
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchVozila(search).then(function (vozila) {
				loading(false);
				vm.ogrodja_options = vozila;
			}).catch(function (error) {
				loading(false);
				if (error) {
					console.log(error);
				}
			});
		}, 500),
		voziloSelect_change: function voziloSelect_change(value, index) {
			this.import_table.items[index].id_vozila = value.id;
			this.import_table.items[index].chassis = value.ogrodje;
		},
		vozilaSelect_search: function vozilaSelect_search(search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		toggleSelectAll: function toggleSelectAll() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.import_table.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var priliv = _step.value;

					priliv.selected = !this.selectAll;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	},
	watch: {
		tip_povracila: function tip_povracila() {
			this.import_file = null;
			this.showError(null);
		}
	},
	data: function data() {
		return {
			show_step_two: false,
			tip_povracila: 'excel_v2',
			import_file: null,
			import_table: {
				items: [],
				fields: [{ key: 'selected', sortable: false, class: 'tdPovraciloSelect' }, { key: 'creditnotedate', label: 'Datum izdobave', sortable: false, class: 'tdPovraciloDatum' }, { key: 'chassis', label: 'Šasija', sortable: false, class: 'tdPovraciloOgrodje' }, { key: 'amount', label: 'Skupaj odobreno', sortable: false, class: 'tdPovraciloZnesek' }]
			},
			ogrodja_options: [],
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			selectAll: true
		};
	},
	computed: {
		upload_placeholder: function upload_placeholder() {
			return EXCEL_PH_TEXT;
		},
		upload_placeholder_v2: function upload_placeholder_v2() {
			return EXCEL_V2_PH_TEXT;
		},
		upload_accept: function upload_accept() {
			return '.xls';
		},
		upload_accept_v2: function upload_accept_v2() {
			return '.xlsx';
		},
		ok_text: function ok_text() {
			if (this.show_step_two) {
				return 'Potrdi';
			}
			return 'Naprej';
		},
		modal_size: function modal_size() {
			if (this.show_step_two) {
				return 'lg';
			}
			return 'lg';
		},
		modal_body_class: function modal_body_class() {
			if (this.show_step_two) {
				return 'no_padding';
			}
			return '';
		},
		message_class: function message_class() {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created: function created() {}
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ladda__ = __webpack_require__(46);







/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		showModal: function showModal(povraciloData) {
			this.clearForm();
			this.status_options = this.generateStatusOptions();
			if (!povraciloData) {
				this.addNew = true;
				this.$refs.modal.show();
			} else {
				this.modalPovraciloData.id = povraciloData.id;
				this.modalPovraciloData.id_vozila = povraciloData.id_vozila;
				if (povraciloData.creditnotedate) {
					this.modalPovraciloData.creditnotedate = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["parse"])(povraciloData.creditnotedate, __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].dbDtFormat);
				}
				this.modalPovraciloData.opomba = povraciloData.opomba;
				this.modalPovraciloData.status = povraciloData.status;
				this.selectedStatus.label = this.getStatusLabel(povraciloData.status);
				this.selectedStatus.value = povraciloData.status;
				this.selectedStatus.classStatus = this.getStatusClass(povraciloData.status);
				this.modalPovraciloData.chassis = povraciloData.chassis;
				this.modalPovraciloData.policy = povraciloData.policy;
				this.modalPovraciloData.campaign = povraciloData.campaign;
				this.modalPovraciloData.action_name = povraciloData.action_name;
				this.modalPovraciloData.sale_channel = povraciloData.sale_channel;
				this.modalPovraciloData.month = povraciloData.month;
				this.modalPovraciloData.amount = Number(povraciloData.amount);
				this.modalPovraciloData.numdoc = povraciloData.numdoc;
				this.modalPovraciloData.dealer_name = povraciloData.dealer_name;
				this.modalPovraciloData.discount = povraciloData.discount;
				this.modalPovraciloData.contribution = povraciloData.contribution;
				this.modalPovraciloData.v2_vozilo_opis = povraciloData.v2_vozilo_opis;
				this.modalPovraciloData.v2_gc = Number(povraciloData.v2_gc);
				this.modalPovraciloData.v2_gc_odobreno = Number(povraciloData.v2_gc_odobreno);
				this.modalPovraciloData.v2_marza_opcij = Number(povraciloData.v2_marza_opcij);
				this.modalPovraciloData.v2_marza_opcij_odobreno = Number(povraciloData.v2_marza_opcij_odobreno);
				this.modalPovraciloData.v2_dmv_dacia_zahtevano = Number(povraciloData.v2_dmv_dacia_zahtevano);
				this.modalPovraciloData.v2_dmv_dacia_odobreno = Number(povraciloData.v2_dmv_dacia_odobreno);
				this.modalPovraciloData.v2_ka1_naziv = povraciloData.v2_ka1_naziv;
				this.modalPovraciloData.v2_ka1_zahtevano = Number(povraciloData.v2_ka1_zahtevano);
				this.modalPovraciloData.v2_ka1_odobreno = Number(povraciloData.v2_ka1_odobreno);
				this.modalPovraciloData.v2_ka2_naziv = povraciloData.v2_ka2_naziv;
				this.modalPovraciloData.v2_ka2_zahtevano = Number(povraciloData.v2_ka2_zahtevano);
				this.modalPovraciloData.v2_ka2_odobreno = Number(povraciloData.v2_ka2_odobreno);
				this.modalPovraciloData.v2_ka3_naziv = povraciloData.v2_ka3_naziv;
				this.modalPovraciloData.v2_ka3_zahtevano = Number(povraciloData.v2_ka3_zahtevano);
				this.modalPovraciloData.v2_ka3_odobreno = Number(povraciloData.v2_ka3_odobreno);
				this.modalPovraciloData.v2_skupaj_zahtevano = Number(povraciloData.v2_skupaj_zahtevano);
				this.modalPovraciloData.v2_komentar = povraciloData.v2_komentar;
				this.modalPovraciloData.v2_komentar_uvoznik = povraciloData.v2_komentar_uvoznik;
				this.$refs.modal.show();
			}
		},
		generateStatusOptions: function generateStatusOptions() {
			var options = [];
			options.push({ label: 'Bi naj dobili', value: 0, classStatus: 'classStatus0' });
			options.push({ label: 'Smo zahtevali', value: 1, classStatus: 'classStatus1' });
			options.push({ label: 'Smo dobili', value: 2, classStatus: 'classStatus2' });
			options.push({ label: 'Modra', value: 3, classStatus: 'classStatus3' });
			return options;
		},
		getStatusLabel: function getStatusLabel(status) {
			if (status === 0) {
				return 'Bi naj dobili';
			} else if (status === 1) {
				return 'Smo zahtevali';
			} else if (status === 2) {
				return 'Smo dobili';
			} else if (status === 3) {
				return 'Modra';
			}
		},
		getStatusValue: function getStatusValue(status) {
			if (status === 'Bi naj dobili') {
				return 0;
			} else if (status === 'Smo zahtevali') {
				return 1;
			} else if (status === 'Smo dobili') {
				return 2;
			} else if (status === 'Modra') {
				return 3;
			}
		},
		getStatusClass: function getStatusClass(status) {
			if (status === 0) {
				return 'classStatus0';
			} else if (status === 1) {
				return 'classStatus1';
			} else if (status === 2) {
				return 'classStatus2';
			} else if (status === 3) {
				return 'classStatus3';
			}
		},
		modal_okClick: function modal_okClick(evt) {
			var _this = this;

			evt.preventDefault();
			this.modalPovraciloData.status = this.selectedStatus.value;
			if ((this.modalPovraciloData.id_vozila === null || this.modalPovraciloData.id_vozila === 'null' || this.modalPovraciloData.id_vozila === '') && this.addNew) {
				this.showError('Poje Chassis je obvezno!');
			} else {
				__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].addPovracilo(this.modalPovraciloData).then(function (response) {
					if (_this.addNew) {
						_this.$emit('povracilo_add');
					} else {
						_this.$emit('povracilo_edit');
					}
					_this.$refs.modal.hide();
				}).catch(function (error) {
					_this.showError('Napaka!');
					if (error) {
						console.log(error);
					}
				});
			}
		},
		modal_cancelClick: function modal_cancelClick(evt) {
			var _this2 = this;

			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(function () {
				_this2.clearForm();
			}, 300);
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function clearForm() {
			this.addNew = false;
			this.modalPovraciloData.id = 0;
			this.modalPovraciloData.id_vozila = null;
			this.modalPovraciloData.creditnotedate = null;
			this.modalPovraciloData.opomba = null;
			this.modalPovraciloData.status = null;
			this.modalPovraciloData.chassis = null;
			this.modalPovraciloData.policy = null;
			this.modalPovraciloData.campaign = null;
			this.modalPovraciloData.action_name = null;
			this.modalPovraciloData.sale_channel = null;
			this.modalPovraciloData.month = null;
			this.modalPovraciloData.amount = 0;
			this.modalPovraciloData.numdoc = null;
			this.modalPovraciloData.dealer_name = null;
			this.modalPovraciloData.discount = null;
			this.modalPovraciloData.contribution = null;
			this.modalPovraciloData.v2_vozilo_opis = null;
			this.modalPovraciloData.v2_gc = 0;
			this.modalPovraciloData.v2_gc_odobreno = 0;
			this.modalPovraciloData.v2_marza_opcij = 0;
			this.modalPovraciloData.v2_marza_opcij_odobreno = 0;
			this.modalPovraciloData.v2_dmv_dacia_zahtevano = 0;
			this.modalPovraciloData.v2_dmv_dacia_odobreno = 0;
			this.modalPovraciloData.v2_ka1_naziv = null;
			this.modalPovraciloData.v2_ka1_zahtevano = 0;
			this.modalPovraciloData.v2_ka1_odobreno = 0;
			this.modalPovraciloData.v2_ka2_naziv = null;
			this.modalPovraciloData.v2_ka2_zahtevano = 0;
			this.modalPovraciloData.v2_ka2_odobreno = 0;
			this.modalPovraciloData.v2_ka3_naziv = null;
			this.modalPovraciloData.v2_ka3_zahtevano = 0;
			this.modalPovraciloData.v2_ka3_odobreno = 0;
			this.modalPovraciloData.v2_skupaj_zahtevano = 0;
			this.modalPovraciloData.v2_komentar = null;
			this.modalPovraciloData.v2_komentar_uvoznik = null;
			this.selectedStatus.label = null;
			this.selectedStatus.value = null;
			this.selectedStatus.classStatus = null;
			this.ogrodja_options = [];
			this.message.type = null;
			this.message.text = null;
		},
		vozilaSelect_load: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm) {
			loading(true);
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].searchVozila(search).then(function (vozila) {
				loading(false);
				vm.ogrodja_options = vozila;
			}).catch(function (error) {
				loading(false);
				if (error) {
					console.log(error);
				}
			});
		}, 500),
		voziloSelect_change: function voziloSelect_change(value) {
			if (value != null) {
				this.modalPovraciloData.id_vozila = value.id;
				this.modalPovraciloData.chassis = value.ogrodje;
			} else {
				this.modalPovraciloData.id_vozila = null;
				this.modalPovraciloData.chassis = null;
			}
		},
		vozilaSelect_search: function vozilaSelect_search(search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		click_updateData: function click_updateData(ogrodje, evt) {
			var _this3 = this;

			this.showError();
			var loader = __WEBPACK_IMPORTED_MODULE_4_ladda__["a" /* create */](this.$refs.aUpdate);
			loader.start();
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].relateVoziloPovracilo(ogrodje, this.modalPovraciloData.id).then(function (response) {
				loader.stop();
				if (response.status === 'ok') {
					_this3.showError();
					_this3.$emit('povracilo_id_vozila_find');
					_this3.modalPovraciloData.id_vozila = response.idVozila;
					_this3.$forceUpdate();
				} else {
					_this3.showError('Vozila ni v bazi!');
				}
			}).catch(function (error) {
				_this3.showError('Napaka!');
				if (error) {
					console.log(error);
				}
				loader.stop();
			});
		},
		toggleAdditionalDataCollapse: function toggleAdditionalDataCollapse() {
			this.showOldData = !this.showOldData;
		}
	},
	watch: {},
	data: function data() {
		return {
			modalTitle: '',
			modalCancelTitle: 'Prekliči',
			modalErrorMsg: null,
			modalIsBusy: false,
			addNew: false,
			modalPovraciloData: {
				id: 0,
				creditnotedate: null,
				opomba: '',
				status: 0,
				znesek: 0,
				chassis: null,
				policy: null,
				campaign: null,
				action_name: null,
				sale_channel: null,
				month: null,
				amount: 0,
				numdoc: null,
				dealer_name: null,
				discount: 0,
				contribution: null,
				v2_vozilo_opis: null,
				v2_gc: 0,
				v2_gc_odobreno: 0,
				v2_marza_opcij: 0,
				v2_marza_opcij_odobreno: 0,
				v2_dmv_dacia_zahtevano: 0,
				v2_dmv_dacia_odobreno: 0,
				v2_ka1_naziv: null,
				v2_ka1_zahtevano: 0,
				v2_ka1_odobreno: 0,
				v2_ka2_naziv: null,
				v2_ka2_zahtevano: 0,
				v2_ka2_odobreno: 0,
				v2_ka3_naziv: null,
				v2_ka3_zahtevano: 0,
				v2_ka3_odobreno: 0,
				v2_skupaj_zahtevano: 0,
				v2_komentar: null,
				v2_komentar_uvoznik: null
			},
			selectedStatus: {
				label: null,
				value: null,
				classStatus: null
			},
			status_options: [],
			ogrodja_options: [],
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			showOldData: false
		};
	},
	computed: {
		modalTitle_text: function modalTitle_text() {
			if (this.modalPovraciloData.id === 0) {
				return 'Dodajanje povračila';
			}
			return 'Urejanje povračila';
		},
		ok_text: function ok_text() {
			if (this.modalPovraciloData.id === 0) {
				return 'Dodaj';
			}
			return 'Shrani';
		},
		message_class: function message_class() {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created: function created() {}
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'statusPovracilaFilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: 'Bi naj dobili',
				value: '0',
				active: false
			}, {
				label: 'Smo zahtevali',
				value: '1',
				active: false
			}, {
				label: 'Smo dobili',
				value: '2',
				active: false
			}, {
				label: 'Modra',
				value: '3',
				active: false
			}]
		};
	}
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MapaModal__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PodrobnostiVozilaModal__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DatumFilterDropdown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modals_IzstavitevRacunaModal__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns__);










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'aktivnosti',
	components: {
		'mapa-modal': __WEBPACK_IMPORTED_MODULE_0__components_MapaModal__["a" /* default */],
		'podrobnosti-vozila-modal': __WEBPACK_IMPORTED_MODULE_1__components_PodrobnostiVozilaModal__["a" /* default */],
		'datum-filter-dropdown': __WEBPACK_IMPORTED_MODULE_2__components_DatumFilterDropdown__["a" /* default */],
		'izstavitev-racuna-modal': __WEBPACK_IMPORTED_MODULE_3__components_Modals_IzstavitevRacunaModal__["a" /* default */]
	},
	filters: {},
	data: function data() {
		return {
			potrditvePlacilTable_props: {
				items: [],
				fields: [{ key: 'ogrodje', label: 'VIN', sortable: true }, { key: 'libelle_modele', label: 'Model', sortable: true }, { key: 'libelle_version', label: 'Verzija', sortable: true }, { key: 'p_prodajalec_name', label: 'Prodajalec' }, { key: 'st_racuna', label: 'Št. računa RNS', sortable: true }, { key: 'skupni_znesek', label: 'Skupni znesek', sortable: true }, { key: 'prodajalec_potrditev', label: 'Potrditev prodajalca', sortable: true }, { key: 'sekretar_potrditev', label: 'Potrditev sekretarja', sortable: true }, { key: 'moderator_potrditev', label: 'Potrditev moderatorja', sortable: true }, { key: 'racunovodja_potrditev', label: 'Potrditev računovodje', sortable: true }],
				totalRows: 0,
				currentPage: 1,
				perPage: 10,
				naviLimit: 3,
				inputFilter: {
					ogrodje: null,
					libelle_modele: null,
					libelle_version: null,
					p_prodajalec_name: null,
					st_racuna: null,
					skupni_znesek: null,
					datum_racunovodja_potrdil: null
				},
				textFilterTimeout: null
			},
			zeljeneIzstavitveRacunovTable: {
				items: [],
				fields: [{ key: 'ogrodje', label: 'VIN' }, { key: 'pu_title', label: 'Prodajalec' }, { key: 'pk_title', label: 'Kupec' }, { key: 'm_zeljena_izstavitev_racuna', label: 'Datum željene izstavitve' }, { key: 'm_datum_izstavitve_racuna', label: 'Datum izstavitve' }],
				totalRows: 0,
				filter: null,
				currentPage: 1,
				perPage: 10,
				naviLimit: 3
			},
			customKontoTable: {
				items: [],
				fields: [{ key: 'konto_destinacije', label: 'Konto', sortable: true, class: 'dashboardCustomKontoTdKonto' }, { key: 'ogrodje', label: 'VIN', sortable: true, class: 'dashboardCustomKontoTdOgrodje' }, { key: 'libelle_modele', label: 'Model' }, { key: 'libelle_version', label: 'Verzija' }, { key: 'libelle_options', label: 'Opcije' }, { key: 'datum_prve_registracije', label: 'Datum prve registracije', sortable: true, class: 'dashboardCustomKontoTdDatum' }, { key: 'datum_kdaj_ga_moramo_prodati', label: 'Kdaj ga moramo prodati', sortable: true, class: 'dashboardCustomKontoTdDatum' }, { key: 'datum_kdaj_ga_lahko_prodamo', label: 'Kdaj ga lahko prodamo', sortable: true, class: 'dashboardCustomKontoTdDatum' }, { key: 'prodajna_cena', label: 'Prodajna cena', sortable: true }, { key: 'st_kilometrov', label: 'Št. kilometrov', sortable: true }, { key: 'status', label: 'Status' }],
				totalRows: 0,
				filter: '',
				inputFilter: {
					konto_destinacije: ['TV', 'ND', 'RV0KM'],
					st_narocila_kupca: '',
					st_narocila_vozila: '',
					ogrodje: '',
					model: '',
					verzija: '',
					barva: '',
					staranje: '',
					stanje: null,
					status: null,
					lokacije: null,
					prodaja: null,
					prodajalec: null,
					kupec: null,
					rmadc: null,
					pmadc: null,
					omada: null,
					pdp: null,
					obljubljenaDobava: null,
					arhiv: false,
					nissan: false,
					manual: true,
					datum_prve_registracije: null,
					datum_kdaj_ga_moramo_prodati: null,
					datum_kdaj_ga_lahko_prodamo: null
				},
				currentPage: 1,
				perPage: 10,
				naviLimit: 7
			},
			cdpVehiclesStockPaymentTable: {
				isLoading: false,
				fields: [{ key: 'number', label: 'Številka', headerTitle: '-', sortable: true, 'class': '' }, { key: 'vin', label: 'Šasija', headerTitle: '-', sortable: true, 'class': '' }, { key: 'registration_number', label: 'Reg.', headerTitle: '-', sortable: true, 'class': '' }, { key: 'purchase_price', label: 'Nabavna', headerTitle: '-', sortable: true, 'class': '' }, { key: 'dmv', label: 'DMV', headerTitle: '-', sortable: true, 'class': '' }, { key: 'purchase_price_with_dmv', label: 'Nab. z DMV', headerTitle: '-', sortable: true, 'class': '' }, { key: 'amount_due', label: 'Obveznost', headerTitle: '-', sortable: true, 'class': '' }, { key: 'due_date', label: 'Valuta', headerTitle: '-', sortable: true, 'class': '' }, { key: 'invoice_number', label: 'Št. računa', headerTitle: '-', sortable: true, 'class': '' }, { key: 'actions', label: '#', 'class': 'tbCdpVehiclesStockPaymentWidthActions', 'tdClass': 'text-center align-middle' }],
				totalRows: 0,
				inputFilter: {
					payment_required_only: 1
				},
				currentPage: 1,
				perPage: 10,
				naviLimit: 7
			}
		};
	},
	methods: {
		potrditvePlacilTable_dataProvider: function potrditvePlacilTable_dataProvider(ctx) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_4__service__["a" /* default */].getVozilaToConfirm(ctx, this.potrditvePlacilTable_props.inputFilter).then(function (data) {
				_this.potrditvePlacilTable_props.totalRows = data.total;
				return data.items;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				_this.potrditvePlacilTable_props.totalRows = 0;
				return [];
			});
		},
		zeljeneIzstavitveRacunovTable_dataProvider: function zeljeneIzstavitveRacunovTable_dataProvider(ctx) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_4__service__["a" /* default */].getRacuniZaIzstavit(ctx, this.user).then(function (result) {
				_this2.zeljeneIzstavitveRacunovTable.totalRows = result.total;
				return result.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				_this2.zeljeneIzstavitveRacunovTable.totalRows = 0;
				return [];
			});
		},
		customKontoTable_dataProvider: function customKontoTable_dataProvider(ctx) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_4__service__["a" /* default */].getVozilaFiltered(ctx, this.customKontoTable.inputFilter, this.user).then(function (data) {
				_this3.customKontoTable.items = data;
				_this3.customKontoTable.totalRows = data.total;
				return _this3.customKontoTable.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				_this3.customKontoTable.totalRows = 0;
				return [];
			});
		},
		cdpVehiclesStockPaymentTable_dataProvider: function cdpVehiclesStockPaymentTable_dataProvider(ctx) {
			var _this4 = this;

			this.cdpVehiclesStockPaymentTable.isLoading = true;
			return __WEBPACK_IMPORTED_MODULE_4__service__["a" /* default */].cdpVehiclesStockListFiltered(ctx, this.cdpVehiclesStockPaymentTable.inputFilter).then(function (response) {
				_this4.cdpVehiclesStockPaymentTable.isLoading = false;
				_this4.cdpVehiclesStockPaymentTable.totalRows = response.items.total;
				return response.items.data;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
				_this4.cdpVehiclesStockPaymentTable.isLoading = false;
				_this4.cdpVehiclesStockPaymentTable.totalRows = 0;
				return [];
			});
		},
		potrditvePlacilTable_rowClick: function potrditvePlacilTable_rowClick(item, index) {
			var vozilo = item.libelle_modele + ' ' + item.libelle_version;
			var kupec = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			this.$refs.mapaModal.showModal(item.id, item.ogrodje, vozilo, item.p_prodajalec, item.p_prodajalec_name, kupec, 0, item.p_datum_prodaje, item.p_datum_planirane_dobave, item.p_financiranje_rci, item.koncesija_datum, true);
		},
		zeljeneIzstavitveRacunovTable_rowClick: function zeljeneIzstavitveRacunovTable_rowClick(item, index) {
			var data = {
				'mapa_id': item.m_id,
				'ogrodje': item.ogrodje,
				'datum_izstavitve_racuna': item.m_datum_izstavitve_racuna
			};
			this.$refs.izstavitevRacunaModal.showModal(data);
		},
		izstavitevRacuna_success: function izstavitevRacuna_success() {
			this.$refs.zeljeneIzstavitveRacunovTable.refresh();
		},
		customKontoTable_rowClick: function customKontoTable_rowClick(item, index) {
			this.$refs.podrobnostiVozilaModal.showModal(item);
		},
		getKupecHR: function getKupecHR(id, isCompany, name, title) {
			if (id == null) {
				return null;
			}
			if (isCompany) {
				return title;
			}
			return name;
		},

		on_userPotrdilSuccess: function on_userPotrdilSuccess(datum, userId, userRole, akcija) {
			this.$refs.potrditvePlacilTable.refresh();
		},
		importdata_edit: function importdata_edit(data) {
			this.$refs.customKontoTable.refresh();
			var message = '';
			if (data.ogrodje !== '') {
				message = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ') uspešno urejeno.';
			} else {
				message = 'Vozilo #' + data.id + ' uspešno urejeno.';
			}
			this.$refs.toastr.s(message);
		},
		onCustomKontoTableFilterChange: function onCustomKontoTableFilterChange(value) {
			this.$refs.customKontoTable.refresh();
		},
		onPotrditvePlacilTableFilterChange: function onPotrditvePlacilTableFilterChange(value) {
			this.$refs.potrditvePlacilTable.refresh();
		},
		onPotrditvePlacilTableTextFilterChange: function onPotrditvePlacilTableTextFilterChange(value) {
			var _this5 = this;

			if (this.potrditvePlacilTable_props.textFilterTimeout !== null) {
				clearTimeout(this.potrditvePlacilTable_props.textFilterTimeout);
			}
			this.potrditvePlacilTable_props.textFilterTimeout = setTimeout(function () {
				_this5.$refs.potrditvePlacilTable.refresh();
			}, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].filterTimeoutLength);
		},
		getSoldInfo: function getSoldInfo(item) {
			if (!item || !item.has_sold) {
				return '';
			}
			var hs = 'Prodajalec: ' + item.p_prodajalec_name + ';';
			var kupecHr = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			if (kupecHr != null) {
				hs += ' Kupec: ' + kupecHr + ';';
			}
			var datumProdaje = Object(__WEBPACK_IMPORTED_MODULE_6_date_fns__["parse"])(item.p_datum_prodaje, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].dbDtFormat);
			hs += ' Datum prodaje: ' + Object(__WEBPACK_IMPORTED_MODULE_6_date_fns__["format"])(datumProdaje, __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].hrsDtFormat);
			return hs;
		},
		isSold: function isSold(item) {
			if (!item || !item.has_sold) {
				return false;
			}
			return true;
		},
		getTitle: function getTitle(value) {
			return value;
		},

		cdpVehicleStockPaidTitle: function cdpVehicleStockPaidTitle(item) {
			if (item.paid_at) {
				return 'Plačilo potrdil ' + (item.paid_by_user_title ? item.paid_by_user_title : '/') + '\n dne ' + this.$options.filters.hr_date(item.paid_at) + ' ob ' + this.$options.filters.hr_time(item.paid_at);
			}
			return 'Potrdi plačilo';
		},
		click_cdpVehicleStockPay: function click_cdpVehicleStockPay(item) {
			var _this6 = this;

			this.cdpVehiclesStockPaymentTable.isLoading = true;
			__WEBPACK_IMPORTED_MODULE_4__service__["a" /* default */].cdpVehicleStockSetPaid(item.id).then(function (response) {
				_this6.cdpVehiclesStockPaymentTable.isLoading = false;
				_this6.$refs.toastr.s('Plačilo za vozilo ' + item.number + ' uspešno potrjeno!');
				_this6.$refs.cdpVehiclesStockPaymentTable.refresh();
			}).catch(function (error) {
				_this6.$refs.toastr.e('Napaka pri potrjevanju plačila!');
				_this6.cdpVehiclesStockPaymentTable.isLoading = false;
				if (error) {
					console.log(error);
				}
			});
		}
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		isRoleProdajalec: function isRoleProdajalec() {
			return __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isProdajalec(this.user.role);
		},
		isRoleSekretar: function isRoleSekretar() {
			return __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isSekretar(this.user.role);
		},
		isRoleAdmin: function isRoleAdmin() {
			return __WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isAdmin(this.user.role);
		},
		userCanConfirmCdpVehicleStockPay: function userCanConfirmCdpVehicleStockPay() {
			if (__WEBPACK_IMPORTED_MODULE_5__settings_js__["a" /* default */].isRacunovodja(this.user.role)) {
				return true;
			}
			return false;
		}
	}
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_js__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a
	},
	methods: {
		showModal: function showModal(data) {
			console.log('data', data);
			this.mapa_id = data.mapa_id;
			this.ogrodje = data.ogrodje;
			this.datum_izstavitve_racuna = data.datum_izstavitve_racuna;
			this.$refs.modal.show();
		},
		click_okModal: function click_okModal(evt) {
			var _this = this;

			evt.preventDefault();
			this.isLoading = true;
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].MapaIzstaviRacun(this.mapa_id).then(function (response) {
				if (response['message'] === 'success') {
					_this.isLoading = false;
					_this.$refs.modal.hide();
					_this.$emit('izstavitevRacuna_success');
				} else {
					_this.isLoading = false;
					_this.showError('Neveljaven odziv strežnika!');
					console.error('Neveljaven response message: ' + response['message']);
				}
			}).catch(function (error) {
				_this.isLoading = false;
				if (error.response) {
					if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.serverSideValidationError) {
						_this.showError('Napaka pri validaciji na strežniku!');
						console.error(error.response.data.message + ': ', error.response.data.errors);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.notSavedError) {
						_this.showError('Napaka pri shranjevanju izstavitve računa!');
						console.error(error.response.data.message);
					} else if (error.response.data.message === __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].errorMessages.PDOException) {
						_this.showError('Napaka na strežniku!');
						console.error(error.response.data.message);
					} else {
						_this.showError('Neznana napaka na strežniku!');
						console.error(error.response.data.message);
					}
				} else if (error.request) {
					console.log('The request was made but no response was received:', error.request);
				} else {
					console.log('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
			console.log('ok click');
		},
		click_cancelModal: function click_cancelModal(evt) {
			var _this2 = this;

			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(function () {
				console.log('clear');
				_this2.clearModal();
			}, 300);
		},
		clearModal: function clearModal() {
			this.message.type = null;
			this.message.text = null;
			this.isLoading = false;
			this.mapa_id = null;
			this.ogrodje = null;
			this.datum_izstavitve_racuna = null;
		},
		showError: function showError(message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: function data() {
		return {
			isLoading: false,
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR',
			mapa_id: null,
			ogrodje: '',
			datum_izstavitve_racuna: null
		};
	},
	computed: {
		buttonIzdajDisabled: function buttonIzdajDisabled() {
			if (this.datum_izstavitve_racuna) {
				return true;
			}
			return false;
		}
	},
	created: function created() {}
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HotelGum_Modals_EditHotelHrambaModal__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HotelGum_Modals_HotelLokacijeModal__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HotelGum_Modals_EditHotelStoritevModal__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DropdownFilters_ExternalFilterDropdown__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DropdownFilters_SeasonFilterDropdown__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DatumFilterDropdown__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DropdownFilters_StatusHotelHrambaFilterDropdown__ = __webpack_require__(1088);
















/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'hotelGum',
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a,
		'edit-hotel-hramba-modal': __WEBPACK_IMPORTED_MODULE_5__components_HotelGum_Modals_EditHotelHrambaModal__["a" /* default */],
		'hotel-lokacije-modal': __WEBPACK_IMPORTED_MODULE_6__components_HotelGum_Modals_HotelLokacijeModal__["a" /* default */],
		'edit-hotel-storitev-modal': __WEBPACK_IMPORTED_MODULE_7__components_HotelGum_Modals_EditHotelStoritevModal__["a" /* default */],
		'external-filter-dropdown': __WEBPACK_IMPORTED_MODULE_8__components_DropdownFilters_ExternalFilterDropdown__["a" /* default */],
		'season-filter-dropdown': __WEBPACK_IMPORTED_MODULE_9__components_DropdownFilters_SeasonFilterDropdown__["a" /* default */],
		'datum-filter-dropdown': __WEBPACK_IMPORTED_MODULE_10__components_DatumFilterDropdown__["a" /* default */],
		'status-hotel-hramba-dropdown': __WEBPACK_IMPORTED_MODULE_11__components_DropdownFilters_StatusHotelHrambaFilterDropdown__["a" /* default */]
	},
	filters: {},
	methods: {
		hotelHrambeTableFilter_change: function hotelHrambeTableFilter_change(value) {
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTableTextFilter_change: function hotelHrambeTableTextFilter_change(value) {
			var _this = this;

			if (this.hotelHrambeTable_props.textFilterTimeout !== null) {
				clearTimeout(this.hotelHrambeTable_props.textFilterTimeout);
			}
			this.hotelHrambeTable_props.textFilterTimeout = setTimeout(function () {
				_this.$refs.hotelHrambeTable.refresh();
			}, __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].filterTimeoutLength);
		},
		hotelHrambeTableRefresh_click: function hotelHrambeTableRefresh_click() {
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTableToggleFilter_click: function hotelHrambeTableToggleFilter_click() {
			this.hotelHrambeTable_props.inputFilter.id = null;
			this.hotelHrambeTable_props.inputFilter.title = null;
			this.hotelHrambeTable_props.inputFilter.email = null;
			this.hotelHrambeTable_props.inputFilter.registration_number = null;
			this.hotelHrambeTable_props.inputFilter.vehicle = null;
			this.hotelHrambeTable_props.inputFilter.hotelLokacija = null;
			this.hotelHrambeTable_props.inputFilter.external = null;
			this.hotelHrambeTable_props.inputFilter.datumStoritve = null;
			this.hotelHrambeTable_props.inputFilter.dimensionsWidth = null;
			this.hotelHrambeTable_props.inputFilter.dimensionsHeight = null;
			this.hotelHrambeTable_props.inputFilter.dimensionsDiameter = null;
			this.$refs.externalFilterDropdown.click_Vse();
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTable_items: function hotelHrambeTable_items(ctx) {
			var _this2 = this;

			this.hotelHrambeTable_props.isLoading = true;
			return __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getHotelHrambeFiltered(ctx, this.hotelHrambeTable_props.inputFilter).then(function (responseData) {
				_this2.hotelHrambeTable_props.isLoading = false;
				if (responseData.message === 'success') {
					_this2.hotelHrambeTable_props.empty_text = 'Ni vnosov';
					_this2.hotelHrambeTable_props.total = responseData.items.total;

					var _loop = function _loop(hotelHramba) {
						var alreadySelectedItem = responseData.items.data.find(function (item) {
							return item.id === hotelHramba.id;
						});
						if (alreadySelectedItem != null) {
							alreadySelectedItem.selected = true;
						}
					};

					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.selectedItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var hotelHramba = _step.value;

							_loop(hotelHramba);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					return responseData.items.data;
				} else {
					_this2.$refs.toastr.e('Neveljaven odziv strežnika.');
					_this2.hotelHrambeTable_props.empty_text = 'Napaka pri pridobivanju hramb';
					_this2.hotelHrambeTable_props.total = 0;
					console.error('Neveljaven odziv strežnika: ', responseData.message);
					return [];
				}
			}).catch(function (error) {
				_this2.hotelHrambeTable_props.isLoading = false;
				if (error.response) {
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							_this2.$refs.toastr.e('Neznana napaka na strežniku!');
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							_this2.$refs.toastr.e('Napaka pri podatkovni bazi!');
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							_this2.$refs.toastr.e('Uporabnik nima dostopa do Hotela gum!');
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							_this2.$refs.toastr.e('Napaka pri validaciji na strežniku!');
							console.error(error.response.data.message);
						} else {
							_this2.$refs.toastr.e('Neznana napaka na strežniku (status: ' + error.response.status + ')!');
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						_this2.$refs.toastr.e('Neznana napaka na strežniku (status: ' + error.response.status + ')!');
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					_this2.$refs.toastr.e('Napaka: strežnik se ni odzval!');
					console.error('The request was made but no response was received:', error.request);
				} else {
					_this2.$refs.toastr.e('Napaka pri pošiljanju zahteve na strežnik!');
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
				_this2.hotelHrambeTable_props.empty_text = 'Napaka pri pridobivanju hramb';
				_this2.hotelHrambeTable_props.total = 0;
				return [];
			});
		},
		hotelHrambeTable_rowClicked: function hotelHrambeTable_rowClicked(item, index) {
			if (this.confirmationActive) {
				this.selectItem_change(item);
			} else {
				if (item.fk_hotel_stranka && item.fk_hotel_lokacija) {
					this.$refs.editHotelHrambaModal.showModal(3, item);
				} else {
					this.$refs.editHotelHrambaModal.showModal(2, item);
				}
			}
		},
		addHotelHotelHramba_click: function addHotelHotelHramba_click() {
			this.$refs.editHotelHrambaModal.showModal(1, null);
		},
		hotelHrambaEdit_click: function hotelHrambaEdit_click(item) {
			this.$refs.editHotelHrambaModal.showModal(2, item);
		},
		hotelHrambaManageStorive_click: function hotelHrambaManageStorive_click(item) {
			this.$refs.editHotelHrambaModal.showModal(3, item);
		},
		emit_edit_hotel_hramba: function emit_edit_hotel_hramba(hramba, mode, actionCommited) {
			if (mode === 1) {
				this.$refs.toastr.s('Hramba št. ' + hramba.id + ' uspešno dodana.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 2) {
				this.$refs.toastr.s('Hramba št. ' + hramba.id + ' uspešno urejena.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 3) {
				if (actionCommited) {
					this.$refs.hotelHrambeTable.refresh();
				}
			} else {
				console.error('Neznana akcija emit_edit_hotel_hramba', hramba, mode);
			}
		},
		emit_hotelStranke_changed: function emit_hotelStranke_changed() {
			this.$refs.hotelHrambeTable.refresh();
			this.initializeHotelStranke();
		},
		emit_hotelStoritev_changed: function emit_hotelStoritev_changed() {
			this.$refs.hotelHrambeTable.refresh();
		},
		hotelHrambeTableLokacije_click: function hotelHrambeTableLokacije_click() {
			this.$refs.hotelLokacijeModal.showModal(1);
		},
		hotelHrambaStatus: function hotelHrambaStatus(item) {
			if (item.fk_hotel_lokacija && item.fk_hotel_stranka) {
				return {
					label: 'Zasedena',
					variant: 'warning',
					class: '',
					title: 'Hramba ima stranko in lokacijo'
				};
			} else if (item.fk_hotel_lokacija && !item.fk_hotel_stranka) {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Hramba ima samo lokacijo'
				};
			} else if (!item.fk_hotel_lokacija && item.fk_hotel_stranka) {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Hramba ima samo stranko'
				};
			} else {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Hramba nima lokacije in stranke'
				};
			}
		},
		hotelHrambaAddGive_click: function hotelHrambaAddGive_click(item) {
			var modalInput = {
				mode: 1,
				hotelStoritev: null,
				hotelHramba: item
			};
			this.$refs.editHotelStoritevModal.showModal(modalInput);
		},
		hotelHrambaAddTake_click: function hotelHrambaAddTake_click(item) {
			var activeHotelStoritev = {
				id: item.hotel_storitev_id,
				fk_hotel_hramba: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_stranka: item.hotel_storitev_fk_hotel_stranka,
				num_tires: item.hotel_storitev_num_tires,
				dimensions: item.hotel_storitev_dimensions,
				manufacturer: item.hotel_storitev_manufacturer,
				season: item.hotel_storitev_season,
				rims: item.hotel_storitev_rims,
				rims_cover: item.hotel_storitev_rims_cover,
				rims_screw: item.hotel_storitev_rims_screw,
				wear: item.hotel_storitev_year,
				note_give: item.hotel_storitev_note_give,
				responsible_mechanic_give: item.hotel_storitev_responsible_mechanic_give,
				date_give: item.hotel_storitev_date_give,
				note_take: item.hotel_storitev_note_take,
				responsible_mechanic_take: item.hotel_storitev_date_take,
				date_take: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_storitev_take: item.hotel_storitev_fk_hotel_storitev_take,
				fk_hotel_storitev_give: item.hotel_storitev_fk_hotel_storitev_give
			};
			var modalInput = {
				mode: 2,
				hotelStoritev: activeHotelStoritev,
				hotelHramba: item
			};
			this.$refs.editHotelStoritevModal.showModal(modalInput);
		},
		hotelHrambaAddSwitch_click: function hotelHrambaAddSwitch_click(item) {
			var activeHotelStoritev = {
				id: item.hotel_storitev_id,
				fk_hotel_hramba: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_stranka: item.hotel_storitev_fk_hotel_stranka,
				num_tires: item.hotel_storitev_num_tires,
				dimensions: item.hotel_storitev_dimensions,
				manufacturer: item.hotel_storitev_manufacturer,
				season: item.hotel_storitev_season,
				rims: item.hotel_storitev_rims,
				rims_cover: item.hotel_storitev_rims_cover,
				rims_screw: item.hotel_storitev_rims_screw,
				wear: item.hotel_storitev_year,
				note_give: item.hotel_storitev_note_give,
				responsible_mechanic_give: item.hotel_storitev_responsible_mechanic_give,
				date_give: item.hotel_storitev_date_give,
				note_take: item.hotel_storitev_note_take,
				responsible_mechanic_take: item.hotel_storitev_date_take,
				date_take: item.hotel_storitev_fk_hotel_hramba,
				fk_hotel_storitev_take: item.hotel_storitev_fk_hotel_storitev_take,
				fk_hotel_storitev_give: item.hotel_storitev_fk_hotel_storitev_give,
				hotel_komentarji: item.hotel_storitev_komentarji
			};
			var modalInput = {
				mode: 3,
				hotelStoritev: activeHotelStoritev,
				hotelHramba: item
			};
			this.$refs.editHotelStoritevModal.showModal(modalInput);
		},
		emit_edit_hotel_storitev: function emit_edit_hotel_storitev(storitev, mode) {
			if (mode === 1) {
				this.$refs.toastr.s('Gume  #' + storitev.id + ' uspešno oddane.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 2) {
				this.$refs.toastr.s('Gume  #' + storitev.id + ' uspešno prevzete.');
				this.$refs.hotelHrambeTable.refresh();
			} else if (mode === 3) {
				this.$refs.toastr.s('Zamenjava dodana.');
				this.$refs.hotelHrambeTable.refresh();
			} else {
				this.$refs.toastr.s('Neznana akcija.');
				console.error('Neznana akcija emit_edit_hotel_storitev', storitev, mode);
			}
		},
		getSeasonLabel: function getSeasonLabel(season) {
			var selectedOption = __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].season_options.find(function (element) {
				return element.value === season;
			});
			if (selectedOption) {
				return selectedOption.text;
			}
			return '';
		},
		getDemensionsLabel: function getDemensionsLabel(dimensions) {
			dimensions = JSON.parse(dimensions);
			return dimensions.width + '/' + dimensions.heigth + 'R' + dimensions.diameter;
		},
		on_seasonFilterChange: function on_seasonFilterChange(selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.hotelHrambeTable_props.inputFilter.season = [];
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selectedItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var item = _step2.value;

						this.hotelHrambeTable_props.inputFilter.season.push(item.value);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			} else {
				this.hotelHrambeTable_props.inputFilter.season = null;
			}
			this.$refs.hotelHrambeTable.refresh();
		},
		rowClass: function rowClass(item) {
			if (!item) {
				return '';
			}
			var result = '';
			if (this.confirmationActive) {
				if (item.date_confirmed == null) {
					result += 'table-danger';
				} else {
					result += 'table-success';
				}
			} else {
				if (this.currentDate >= this.dangerDateZimske && this.currentDate <= this.lineDateZimske && item.hotel_storitev_season === 'Z') {
					result += 'table-danger';
				} else if (this.currentDate >= this.dangerDateLetne && this.currentDate <= this.lineDateLetne && item.hotel_storitev_season === 'L') {
					result += 'table-danger';
				} else if (this.currentDate >= this.warningDateZimske && this.currentDate <= this.lineDateZimske && item.hotel_storitev_season === 'Z') {
					result += 'table-warning';
				} else if (this.currentDate >= this.warningDateLetne && this.currentDate <= this.lineDateLetne && item.hotel_storitev_season === 'L') {
					result += 'table-warning';
				}
			}
			return result;
		},
		setHover: function setHover(item) {
			if (!item) {
				return true;
			}
			if (item.date_confirmed != null) {
				return false;
			}
			return true;
		},
		setCheckingDates: function setCheckingDates() {
			this.currentDate = new Date();

			this.lineDateZimske = new Date();
			this.lineDateZimske.setMonth(2);
			this.lineDateZimske.setDate(15);
			this.warningDateZimske = new Date();
			this.warningDateZimske.setMonth(1);
			this.warningDateZimske.setDate(15);
			this.dangerDateZimske = new Date();
			this.dangerDateZimske.setMonth(2);
			this.dangerDateZimske.setDate(1);
			this.lineDateLetne = new Date();
			this.lineDateLetne.setMonth(10);
			this.lineDateLetne.setDate(15);
			this.warningDateLetne = new Date();
			this.warningDateLetne.setMonth(9);
			this.warningDateLetne.setDate(15);
			this.dangerDateLetne = new Date();
			this.dangerDateLetne.setMonth(10);
			this.dangerDateLetne.setDate(1);
		},
		initializeHotelStranke: function initializeHotelStranke() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchHotelStranke('#initialize').then(function (hotelStranke) {
				_this3.hotelStranke_options = hotelStranke;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		toggleConfirmationActive: function toggleConfirmationActive() {
			if (this.confirmationActive) {
				this.confirmationActive = false;
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var selectedItem = _step3.value;

						selectedItem.selected = false;
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}

				this.selectedItems = [];
				this.hotelHrambeTable_props.fields.shift();
				this.hotelHrambeTable_props.fields.pop();
				this.hotelHrambeTable_props.fields.push({ key: 'actions', label: '#', 'class': 'tdHotelHrambeActions' });
			} else {
				this.confirmationActive = true;
				this.hotelHrambeTable_props.fields.unshift({ key: 'selected', label: '-', sortable: false });
				this.hotelHrambeTable_props.fields.pop();
				this.hotelHrambeTable_props.fields.push({ key: 'user_confirmed', label: 'Potrdil', 'class': '' });
			}
		},
		confirmHotelHrambe: function confirmHotelHrambe() {
			var _this4 = this;

			if (this.selectedItems.length > 0) {
				this.isLoading = true;
				var data = {
					items: this.selectedItems
				};
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].hotelHrambaConfirm(data).then(function (response) {
					_this4.isLoading = false;
					if (response.message === 'success') {
						_this4.toggleConfirmationActive();
						if (response.num_confirmation_success > 0) {
							_this4.$refs.toastr.s('Število potrjenih hramb: ' + response.num_confirmation_success);
						}
						if (response.items_not_found.length > 0) {
							var notFoundString = 'Številke hramb, ki niso bile najdene na strežniku: ';
							var _iteratorNormalCompletion4 = true;
							var _didIteratorError4 = false;
							var _iteratorError4 = undefined;

							try {
								for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.items_not_found), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
									var item = _step4.value;

									notFoundString += '#' + item.id + ', ';
								}
							} catch (err) {
								_didIteratorError4 = true;
								_iteratorError4 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion4 && _iterator4.return) {
										_iterator4.return();
									}
								} finally {
									if (_didIteratorError4) {
										throw _iteratorError4;
									}
								}
							}

							notFoundString = notFoundString.substring(-2);
							_this4.$refs.toastr.e(notFoundString);
						}
						if (response.items_not_saved.length > 0) {
							var notSavedString = 'Številke hramb, ki niso bile uspešno potrjene: ';
							var _iteratorNormalCompletion5 = true;
							var _didIteratorError5 = false;
							var _iteratorError5 = undefined;

							try {
								for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.items_not_saved), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
									var _item = _step5.value;

									notSavedString += '#' + _item.id + ', ';
								}
							} catch (err) {
								_didIteratorError5 = true;
								_iteratorError5 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion5 && _iterator5.return) {
										_iterator5.return();
									}
								} finally {
									if (_didIteratorError5) {
										throw _iteratorError5;
									}
								}
							}

							notSavedString = notSavedString.substring(-2);
							_this4.$refs.toastr.e(notSavedString);
						}
						_this4.$refs.hotelHrambeTable.refresh();
					} else {
						_this4.$refs.toastr.e('Neveljaven odziv strežnika');
						_this4.$refs.hotelHrambeTable.refresh();
					}
				}).catch(function (error) {
					_this4.isLoading = false;
					if (error.response) {
						_this4.$refs.toastr.e('Napaka pri potrditvi hramb!');
						console.error(error);
					} else if (error.request) {
						_this4.$refs.toastr.e('Napaka pri potrditvi hramb: strežnik se ni odzval!');
						console.error('The request was made but no response was received:', error.request);
					} else {
						_this4.$refs.toastr.e('Napaka pri pošiljanju zahteve za potrditve hramb na strežnik!');
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
			} else {
				this.$refs.toastr.e('Izbrati morate vsaj eno hrambo!');
			}
		},
		selectItem_change: function selectItem_change(item) {
			console.log(item);
			if (item.date_confirmed == null) {
				item.selected = !item.selected;
				if (item.selected) {
					this.selectedItems.push(item);
				} else {
					this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
				}
				this.$forceUpdate();
			}
		},
		resetConfirmations: function resetConfirmations() {
			var _this5 = this;

			this.$bvModal.msgBoxConfirm('Ste prepričani, da želite ponastaviti VSE potrditve?', {
				title: 'Potrdite ponastavitev VSEH potrditev',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					_this5.isLoading = true;
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].hotelHrambaResetConfirmations().then(function (response) {
						_this5.isLoading = false;
						if (response.message === 'success') {
							_this5.$refs.toastr.s('Potrditve uspešno ponastavljene');
							_this5.toggleConfirmationActive();
							_this5.toggleConfirmationActive();
							_this5.$refs.hotelHrambeTable.refresh();
						} else {
							_this5.$refs.toastr.e('Neveljaven odziv strežnika');
							_this5.$refs.hotelHrambeTable.refresh();
						}
					}).catch(function (error) {
						_this5.isLoading = false;
						if (error.response) {
							_this5.$refs.toastr.e('Napaka pri potrditvi hramb!');
							console.error(error);
						} else if (error.request) {
							_this5.$refs.toastr.e('Napaka pri potrditvi hramb: strežnik se ni odzval!');
							console.error('The request was made but no response was received:', error.request);
						} else {
							_this5.$refs.toastr.e('Napaka pri pošiljanju zahteve za potrditve hramb na strežnik!');
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	data: function data() {
		return {
			settings: __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */],
			hotelHrambeTable_props: {
				fields: [{ key: 'id', label: 'Št. hrambe', sortable: true, class: 'tdHotelHrambeId' }, { key: 'hotel_stranka_title', label: 'Naziv', sortable: true, class: '' }, { key: 'hotel_stranka_registration_number', label: 'Registracijska števila', sortable: true, class: '' }, { key: 'hotel_stranka_vehicle', label: 'Vozilo', sortable: true, class: '' }, { key: 'hotel_lokacija_title', label: 'Lokacija', sortable: false, class: '' }, { key: 'hotel_stranka_external', label: 'External', sortable: true, class: 'tdHotelStoritveExternal' }, { key: 'hotel_storitev_season', label: 'Sezona', sortable: false, class: '' }, { key: 'hotel_storitev_date_give', label: 'Datum', sortable: false, class: 'tdHotelStoritevDatum' }, { key: 'hotel_storitev_dimensions', label: 'Dimenzije', sortable: false, class: 'tdHotelStoritevDimensions' }, { key: 'status', label: 'Status', class: 'tdHotelHrambeStatus' }, { key: 'actions', label: '#', sortable: false, class: 'tdHotelHrambeActions' }],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 1000,
				total: 0,
				isLoading: false,
				inputFilter: {
					id: null,
					title: null,
					email: null,
					registration_number: null,
					vehicle: null,
					external: null,
					season: null,
					hotelLokacija: null,
					datumStoritve: null,
					dimensionsWidth: null,
					dimensionsHeight: null,
					dimensionsDiameter: null,
					statusHotelHramba: null
				},
				textFilterTimeout: null,
				options_numRowsOnPage: [{ value: 50, text: '50' }, { value: 100, text: '100' }, { value: 200, text: '200' }, { value: 1000, text: '1000' }]
			},
			hotelStoritevDistincManufacturers: [],
			hotelStranke_options: [],
			currentDate: null,
			lineDateZimske: null,
			warningDateZimske: null,
			dangerDateZimske: null,
			lineDateLetne: null,
			warningDateLetne: null,
			dangerDateLetne: null,
			confirmationActive: false,
			selectedItems: []
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		userCanEdit: function userCanEdit() {
			if (__WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].isModerator(this.user.role) || __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].isAdmin(this.user.role) || __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created: function created() {
		var _this6 = this;

		__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].hotelStoritevInitParams({ 'manufacturer': true }).then(function (responseData) {
			if (responseData.message === 'success') {
				_this6.hotelStoritevDistincManufacturers = responseData.distinctManufacturers;
			} else {
				console.error('Neveljaven odziv strežnika: ', responseData.message);
			}
		}).catch(function (error) {
			if (error.response) {
				if (error.response.status === 400) {
					if (error.response.data.internalCode === 600) {
						console.error(error.response.data.message);
					} else if (error.response.data.internalCode === 601) {
						console.error(error.response.data.message);
					} else if (error.response.data.internalCode === 602) {
						console.error(error.response.data.message);
					} else if (error.response.data.internalCode === 603) {
						console.error(error.response.data.message);
					} else {
						console.error(error.response.data.internalCode, error.response.data.message);
					}
				} else {
					console.error(error.response.status, error.response.data.message);
				}
			} else if (error.request) {
				console.error('The request was made but no response was received:', error.request);
			} else {
				console.error('Something happened in setting up the request that triggered an Error:', error.message);
			}
		});
		this.initializeHotelStranke();
		this.setCheckingDates();
	}
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ladda__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HotelGum_Modals_EditHotelStoritevModal__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HotelGum_Modals_EditHotelStrankaModal__ = __webpack_require__(1073);













/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'edit-hotel-hramba-modal',
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a,
		'edit-hotel-storitev-modal': __WEBPACK_IMPORTED_MODULE_7__components_HotelGum_Modals_EditHotelStoritevModal__["a" /* default */],
		'edit-hotel-stranka-modal': __WEBPACK_IMPORTED_MODULE_8__components_HotelGum_Modals_EditHotelStrankaModal__["a" /* default */]
	},
	props: {
		hotelStoritevDistincManufacturers: {
			type: Array,
			required: false
		},
		hotelStranke: Array
	},
	methods: {
		showModal: function showModal(mode, hotelHramba) {
			this.mode = mode;
			this.initModal(hotelHramba);
		},
		initModal: function initModal(hotelHramba) {
			if (this.mode === this.mode_ADDING1) {
				this.title = 'Dodajanje nove hrambe';
				this.okButton.label = 'Dodaj';
			} else if (this.mode === this.mode_EDITING2) {
				this.title = 'Urejanje hrambe št. ' + hotelHramba.id;
				this.hotelHramba = this.initHotelHramba(hotelHramba);
				this.okButton.label = 'Shrani';
			} else if (this.mode === this.mode_MANAGESTORITVE3) {
				this.title = 'Hramba št. ' + hotelHramba.id;
				this.storitveOfHrambaTable_props.inputFilter.fk_hotel_hramba = hotelHramba.id;
				this.hotelHramba = this.initHotelHramba(hotelHramba);
				this.okButton.label = 'Zapri';
			} else {
				this.title = 'Neznan način';
				this.mode = this.mode_UNKNOWN0;
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initHotelHramba: function initHotelHramba(hotelHramba) {
			this.hotel_stranka_selected = {
				id: hotelHramba.fk_hotel_stranka,
				first_name: hotelHramba.hotel_stranka_first_name,
				last_name: hotelHramba.hotel_stranka_last_name,
				title: hotelHramba.hotel_stranka_title,
				email: hotelHramba.hotel_stranka_email,
				phone_number: hotelHramba.hotel_stranka_phone_number,
				registration_number: hotelHramba.hotel_stranka_registration_number,
				vehicle: hotelHramba.hotel_stranka_vehicle,
				external: hotelHramba.hotel_stranka_external,
				is_company: hotelHramba.hotel_stranka_is_company
			};
			this.selectedLocation = hotelHramba.hotel_lokacija_title;
			return {
				id: hotelHramba.id,
				fk_hotel_stranka: hotelHramba.fk_hotel_stranka,
				fk_hotel_lokacija: hotelHramba.fk_hotel_lokacija
			};
		},
		onOkModal: function onOkModal() {
			var _this = this;

			if (this.formDisabled) {
				this.$emit('emit_success', this.hotelHramba, this.mode, this.manageMode_actionCommited);
				this.$refs.modal.hide();
			} else {
				this.startProgress();
				this.showAlert();
				if (this.hotelHramba.fk_hotel_lokacija === -1) {
					var hotelLokacija = {
						id: -1,
						title: this.selectedLocation
					};
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].hotelLokacijaEdit(hotelLokacija).then(function (responseData) {
						if (responseData.message === 'edited' || responseData.message === 'added' || responseData.message === 'alreadyExists') {
							_this.hotelHramba.fk_hotel_lokacija = responseData.hotelLokacija.id;
							_this.hotelHrambaEdit();
						} else {
							_this.showAlert('Neveljaven odziv strežnika pri dodajanju lokacije!', _this.ALERT_TYPE_ERROR);
							console.error('Neveljaven response message: ' + responseData.message);
							_this.stopProgress();
						}
					}).catch(function (error) {
						_this.stopProgress();
						if (error.response) {
							if (error.response.status === 400) {
								if (error.response.data.internalCode === 600) {
									_this.showAlert('Neznana napaka na strežniku (lokacija)!', _this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 601) {
									_this.showAlert('Napaka pri podatkovni bazi (lokacija)!', _this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 602) {
									_this.showAlert('Uporabnik nima dostopa do hotela gum (lokacija)!', _this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 603) {
									_this.showAlert('Napaka pri validaciji na strežniku pri dodajanju lokacije (lokacija)!', _this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 605) {
									_this.showAlert('Neuspešno shranjevanje lokacije (lokacija)!', _this.ALERT_TYPE_ERROR);
									console.error(error.response.data.message);
								} else {
									_this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (lokacija)!', _this.ALERT_TYPE_ERROR);
									console.error(error.response.data.internalCode, error.response.data.message);
								}
							} else {
								_this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (lokacija)!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.status, error.response.data.message);
							}
						} else if (error.request) {
							_this.showAlert('Napaka: strežnik se ni odzval (lokacija)!', _this.ALERT_TYPE_ERROR);
							console.error('The request was made but no response was received:', error.request);
						} else {
							_this.showAlert('Napaka pri pošiljanju zahteve na strežnik (lokacija)!', _this.ALERT_TYPE_ERROR);
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				} else {
					this.hotelHrambaEdit();
				}
			}
		},
		hotelHrambaEdit: function hotelHrambaEdit() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].hotelHrambaEdit(this.hotelHramba).then(function (responseData) {
				if (responseData.message === 'edited' || responseData.message === 'added') {
					_this2.$emit('emit_success', responseData.hotelHramba, _this2.mode, _this2.manageMode_actionCommited);
					_this2.$refs.modal.hide();
				} else {
					_this2.showAlert('Neveljaven odziv strežnika (hramba)!', _this2.ALERT_TYPE_ERROR);
					console.error('Neveljaven response message: ' + responseData.message);
				}
				_this2.stopProgress();
			}).catch(function (error) {
				_this2.stopProgress();
				if (error.response) {
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							_this2.showAlert('Neznana napaka na strežniku (hramba)!', _this2.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							_this2.showAlert('Napaka pri podatkovni bazi (hramba)!', _this2.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							_this2.showAlert('Uporabnik nima dostopa do hotela gum (hramba)!', _this2.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							_this2.showAlert('Napaka pri validaciji na strežniku (hramba)!', _this2.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 604) {
							_this2.showAlert('Hramba ni najdena!', _this2.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 605) {
							_this2.showAlert('Neuspešno shranjevanje hrambe (hramba)!', _this2.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else {
							_this2.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (hramba)!', _this2.ALERT_TYPE_ERROR);
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						_this2.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ') (hramba)!', _this2.ALERT_TYPE_ERROR);
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					_this2.showAlert('Napaka: strežnik se ni odzval (hramba)!', _this2.ALERT_TYPE_ERROR);
					console.error('The request was made but no response was received:', error.request);
				} else {
					_this2.showAlert('Napaka pri pošiljanju zahteve na strežnik (hramba)!', _this2.ALERT_TYPE_ERROR);
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		clearModalData: function clearModalData() {
			if (this.mode === this.mode_MANAGESTORITVE3) {
				this.storitveOfHrambaTable_props.empty_text = '';
				this.storitveOfHrambaTable_props.empty_filtered_text = 'Ni zadetkov';
				this.storitveOfHrambaTable_props.page = 1;
				this.storitveOfHrambaTable_props.size = 5;
				this.storitveOfHrambaTable_props.total = 0;
				this.storitveOfHrambaTable_props.isLoading = false;
				this.storitveOfHrambaTable_props.inputFilter.fk_hotel_hramba = null;
				this.storitveOfHrambaTable_props.inputFilter.with_archived = true;
				this.storitveOfHrambaTable_props.inputFilter.textFilterTimeout = null;
			}
			this.title = '';
			this.stopProgress();
			this.showAlert();
			this.okButton.label = '';
			this.mode = this.mode_UNKNOWN0;
			this.hotelHramba = {
				id: 0,
				fk_hotel_stranka: null,
				fk_hotel_lokacija: null
			};
			this.manageMode_actionCommited = false;
			this.clearHotelStranka();
			this.selectedLocation = null;
			this.hotelStranke_searched = null;
		},
		startProgress: function startProgress() {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function stopProgress() {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function showAlert(message, type, seconds) {
			var _this3 = this;

			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(function () {
					_this3.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		showHotelStoritveOfHrambaTable: function showHotelStoritveOfHrambaTable() {
			this.collapseHotelStoritveOfHrambaTableIcon = 'fa fa-chevron-up';
		},
		hideHotelStoritveOfHrambaTable: function hideHotelStoritveOfHrambaTable() {
			this.collapseHotelStoritveOfHrambaTableIcon = 'fa fa-chevron-down';
		},
		hotelHrambaAddGive_click: function hotelHrambaAddGive_click() {
			var modalInput = {
				mode: 1,
				hotelStoritev: null,
				hotelHramba: this.hotelHramba
			};
			this.$refs.editHotelStoritevModal.showModal(modalInput);
		},
		hotelHrambaAddTake_click: function hotelHrambaAddTake_click(item) {
			var modalInput = {
				mode: 2,
				hotelStoritev: item,
				hotelHramba: this.hotelHramba
			};
			this.$refs.editHotelStoritevModal.showModal(modalInput);
		},
		hotelHrambaAddSwitch_click: function hotelHrambaAddSwitch_click(item) {
			var modalInput = {
				mode: 3,
				hotelStoritev: item,
				hotelHramba: this.hotelHramba
			};
			this.$refs.editHotelStoritevModal.showModal(modalInput);
		},
		hotelHrambaEdit_click: function hotelHrambaEdit_click(item) {
			var modalInput = {
				mode: 4,
				hotelStoritev: item,
				hotelHramba: this.hotelHramba
			};
			this.$refs.editHotelStoritevModal.showModal(modalInput);
		},
		emit_edit_hotel_storitev: function emit_edit_hotel_storitev(storitev, mode) {
			if (mode === 1) {
				this.showAlert('Gume  #' + storitev.id + ' uspešno oddane.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
			} else if (mode === 2) {
				this.showAlert('Gume  #' + storitev.id + ' uspešno izdane.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
			} else if (mode === 3) {
				this.showAlert('Zamenjava dodana.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
			} else if (mode === 4) {
				this.showAlert('Storitev #' + storitev.id + ' urejena.', this.ALERT_TYPE_SUCCESS, 3);
				this.$emit('emit_hotelStoritev_changed');
				this.manageMode_actionCommited = true;
				this.$refs.hotelStoritveOfHrambaTable.refresh();
			} else {
				this.showAlert('Neznana akcija.', this.ALERT_TYPE_ERROR, 3);
				console.error('Neznana akcija emit_edit_hotel_storitev', storitev, mode);
			}
		},
		emit_comment_added_to_hotel_storitev: function emit_comment_added_to_hotel_storitev() {
			this.$emit('emit_hotelStoritev_changed');
			this.$refs.hotelStoritveOfHrambaTable.refresh();
		},
		getHotelstoritveOfHrambaTable_items: function getHotelstoritveOfHrambaTable_items(ctx) {
			var _this4 = this;

			this.storitveOfHrambaTable_props.isLoading = true;
			return __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getHotelStoritveFiltered(ctx, this.storitveOfHrambaTable_props.inputFilter).then(function (responseData) {
				_this4.storitveOfHrambaTable_props.isLoading = false;
				if (responseData.message === 'success') {
					_this4.storitveOfHrambaTable_props.empty_text = 'Ni vnosov';
					_this4.storitveOfHrambaTable_props.total = responseData.items.total;
					_this4.storitveOfHrambaItems = responseData.items.data;
					return responseData.items.data;
				} else {
					_this4.showAlert('Neznana odziv strežnika!', _this4.ALERT_TYPE_ERROR);
					_this4.storitveOfHrambaTable_props.empty_text = 'Napaka pri pridobivanju storitev hrambe';
					_this4.storitveOfHrambaTable_props.total = 0;
					console.error('Neveljaven odziv strežnika: ', responseData.message);
					_this4.storitveOfHrambaItems = [];
					return [];
				}
			}).catch(function (error) {
				_this4.storitveOfHrambaTable_props.isLoading = false;
				if (error.response) {
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							_this4.showAlert('Neznana napaka na strežniku!', _this4.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							_this4.showAlert('Napaka pri podatkovni bazi!', _this4.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							_this4.showAlert('Uporabnik nima dostopa do hotela gum!', _this4.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							_this4.showAlert('Napaka pri validaciji na strežniku!', _this4.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 604) {
							_this4.showAlert('Hramba ni najdena!', _this4.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 605) {
							_this4.showAlert('Neuspešno shranjevanje hrambe!', _this4.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else {
							_this4.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', _this4.ALERT_TYPE_ERROR);
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						_this4.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', _this4.ALERT_TYPE_ERROR);
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					_this4.showAlert('Napaka: strežnik se ni odzval!', _this4.ALERT_TYPE_ERROR);
					console.error('The request was made but no response was received:', error.request);
				} else {
					_this4.showAlert('Napaka pri pošiljanju zahteve na strežnik!', _this4.ALERT_TYPE_ERROR);
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		getDemensionsLabel: function getDemensionsLabel(item) {
			var dimensions = JSON.parse(item.dimensions);
			return dimensions.width + '/' + dimensions.heigth + 'R' + dimensions.diameter;
		},
		getSeasonLabel: function getSeasonLabel(item) {
			var selectedOption = __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].season_options.find(function (element) {
				return element.value === item.season;
			});
			if (selectedOption) {
				return selectedOption.text;
			}
			return '';
		},
		getRimsLabel: function getRimsLabel(item) {
			var selectedOption = __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].rims_options.find(function (element) {
				return element.value === item.rims;
			});
			if (selectedOption) {
				return selectedOption.text;
			}
			return '';
		},
		getRimsAditionalLabel: function getRimsAditionalLabel(item) {
			var label = '';
			if (item.rims_cover === 1 && item.rims_screw === 1) {
				label = 'S pokrovi in vijaki';
			} else if (item.rims_cover === 1) {
				label = 'S pokrovi';
			} else if (item.rims_screw === 1) {
				label = 'Z vijaki';
			}
			return label;
		},
		hotelStoritevStatus: function hotelStoritevStatus(item) {
			if (item.date_take && item.fk_hotel_storitev_give) {
				var title = 'Gume so bile zamenjane z gumami #' + item.fk_hotel_storitev_give + ' dne ' + this.$options.filters.hr_date(item.date_take);
				if (item.fk_hotel_storitev_take) {
					title += '\nDodane pa so bile kot zamenjava za gume #' + item.fk_hotel_storitev_take + ' dne ' + this.$options.filters.hr_date(item.date_give);
				}
				return {
					label: 'Zamenjane',
					variant: 'warning',
					class: '',
					title: title
				};
			} else if (item.date_take) {
				return {
					label: 'Prevzete',
					variant: 'danger',
					class: '',
					title: 'Gume so bile prevzete dne ' + this.$options.filters.hr_date(item.date_take)
				};
			} else if (item.fk_hotel_storitev_take) {
				return {
					label: 'Zamenjane',
					variant: 'success',
					class: '',
					title: 'Gume so bile oddane v skladišče dne ' + this.$options.filters.hr_date(item.date_give) + ' kot zamenjava za gume #' + item.fk_hotel_storitev_take
				};
			} else {
				return {
					label: 'Oddane',
					variant: 'success',
					class: '',
					title: 'Gume so bile oddane v skladišče dne ' + this.$options.filters.hr_date(item.date_give)
				};
			}
		},
		exportHotelStoritev: function exportHotelStoritev(item) {
			var _this5 = this;

			this.showAlert();
			var loader = __WEBPACK_IMPORTED_MODULE_5_ladda__["a" /* create */](this.$refs['hotelStoritevPdfExportButton-' + item.id]);
			loader.start();
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].exportHotelStoritev(item.id).then(function (response) {
				loader.stop();
				var fileLink = document.createElement('a');
				fileLink.href = URL.createObjectURL(response.data);
				fileLink.setAttribute('download', response.headers['content-disposition'].split('filename=')[1]);
				fileLink.click();
				URL.revokeObjectURL(fileLink.href);
			}).catch(function (error) {
				loader.stop();
				if (error.response) {
					_this5.showAlert('Napaka pri prenosu pdf-a!', _this5.ALERT_TYPE_ERROR);
				} else if (error.request) {
					_this5.showAlert('Napaka pri prenosu pdf-a: strežnik se ni odzval!', _this5.ALERT_TYPE_ERROR);
					console.error('The request was made but no response was received:', error.request);
				} else {
					_this5.showAlert('Napaka pri pošiljanju zahteve za prenos pdf-a na strežnik!', _this5.ALERT_TYPE_ERROR);
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		initializeHotelLokacijeOptions: function initializeHotelLokacijeOptions() {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchHotelLokacije({ qs: '#initialize', freeOnly: false }).then(function (hotelLokacije) {
				_this6.hotelLokacije_initOptions = hotelLokacije;
				_this6.hotelLokacije_searched = hotelLokacije;
			}).catch(function (error) {
				_this6.hotelLokacije_initOptions = [];
				_this6.hotelLokacije_searched = [];
				if (error.response) {
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							console.error(error.response.data.message);
						} else {
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					console.error('The request was made but no response was received:', error.request);
				} else {
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		hotelLokacijeSelect_load: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function (loading, search, vm) {
			if (!vm.hotelLokacije_searchEmpty) {
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchHotelLokacije({ qs: search, freeOnly: false }).then(function (hotelLokacije) {
					loading(false);
					vm.hotelLokacije_searched = hotelLokacije;
				}).catch(function (error) {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
			} else {
				loading(false);
			}
		}, 500),
		hotelLokacijeSelect_change: function hotelLokacijeSelect_change(hotelLokacija) {
			if (hotelLokacija && hotelLokacija.id) {
				this.hotelHramba.fk_hotel_lokacija = hotelLokacija.id;
				this.selectedLocation = hotelLokacija.title;
			} else if (hotelLokacija) {
				this.selectedLocation = hotelLokacija;
				this.hotelHramba.fk_hotel_lokacija = -1;
			} else {
				if (this.hotelHramba.fk_hotel_lokacija !== -1) {
					this.hotelHramba.fk_hotel_lokacija = null;
					this.hotelLokacije_searched = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.hotelLokacije_initOptions));
				}
			}
		},
		hotelLokacijeSelect_search: function hotelLokacijeSelect_search(search, loading) {
			this.hotelLokacijeSelect_change(search);
			if (search && search !== '') {
				this.hotelLokacije_searchEmpty = false;
				loading(true);
				this.hotelLokacijeSelect_load(loading, search, this);
			} else if (search === '' && this.hotelHramba.fk_hotel_lokacija == null) {
				this.hotelLokacije_searched = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.hotelLokacije_initOptions));
				this.hotelLokacije_searchEmpty = true;
			}
		},
		load_hotelStranke: function load_hotelStranke() {
			var _this7 = this;

			this.hotelStranke_options = [];
			__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchHotelStranke('#initialize').then(function (hotelStranke) {
				_this7.hotelStranke_options = hotelStranke;
			}).catch(function (error) {
				if (error) {
					console.log(error);
				}
			});
		},
		hotelStrankeSelect_load: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function (loading, search, vm) {
			if (!vm.hotelStranke_searchEmpty) {
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].searchHotelStranke(search).then(function (hotelStranke) {
					loading(false);
					vm.hotelStranke_searched = hotelStranke;
				}).catch(function (error) {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
			} else {
				loading(false);
			}
		}, 500),
		hotelStrankeSelect_change: function hotelStrankeSelect_change(hotelStranka) {
			if (hotelStranka) {
				this.hotel_stranka_selected = hotelStranka;
				this.hotelHramba.fk_hotel_stranka = hotelStranka.id;
			} else {
				this.hotelStranke_searched = null;
				this.hotelHramba.fk_hotel_stranka = null;
				this.clearHotelStranka();
			}
		},

		hotelStrankeSelect_search: function hotelStrankeSelect_search(search, loading) {
			if (search && search !== '') {
				this.hotelStranke_searchEmpty = false;
				loading(true);
				this.hotelStrankeSelect_load(loading, search, this);
			} else if (search === '' && this.hotel_stranka_selected == null) {
				this.hotelStranke_searched = null;
				this.hotelStranke_searchEmpty = true;
			}
		},
		hotelStrankaAdding_click: function hotelStrankaAdding_click() {
			var modalInput = {
				mode: 1,
				hotelStranka: null
			};
			this.$refs.editHotelStrankaModal.showModal(modalInput);
		},
		hotelStrankaEdit_click: function hotelStrankaEdit_click() {
			var modalInput = {
				mode: 2,
				hotelStranka: this.hotel_stranka_selected
			};
			this.$refs.editHotelStrankaModal.showModal(modalInput);
		},
		emit_edit_hotel_stranka: function emit_edit_hotel_stranka(hotelStranka, mode) {
			if (mode === 1) {
				this.all_hotelStranke.push(hotelStranka);
				this.hotel_stranka_selected = hotelStranka;
				this.hotelHramba.fk_hotel_stranka = hotelStranka.id;
				this.$emit('emit_hotelStranke_changed');
			} else if (mode === 2) {
				this.hotel_stranka_selected = hotelStranka;
				this.hotelHramba.fk_hotel_stranka = hotelStranka.id;
				this.$emit('emit_hotelStranke_changed');
			} else {
				this.showAlert('Neznana akcija pri urejanju stranke.', this.ALERT_TYPE_ERROR, 3);
				console.error('Neznana akcija emit_edit_hotel_stranka', hotelStranka, mode);
			}
		},
		clearHotelStranka: function clearHotelStranka() {
			this.hotel_stranka_selected = {
				id: 0,
				first_name: '',
				last_name: '',
				title: '',
				email: '',
				phone_number: '',
				address: '',
				city: '',
				registration_number: '',
				vehicle: '',
				external: 1,
				is_company: 0
			};
		},
		hotelStoritveOfHrambaTable_rowClicked: function hotelStoritveOfHrambaTable_rowClicked(item, index) {
			this.hotelHrambaEdit_click(item);
		},
		getHotelComentar: function getHotelComentar(item) {
			if (item.hotel_komentarji.length > 0) {
				var tmpLabel = '';
				if (item.hotel_komentarji[0].content == null) {
					tmpLabel = '';
				} else if (item.hotel_komentarji[0].content.length > 70) {
					tmpLabel += item.hotel_komentarji[0].content.substring(0, 70);
					tmpLabel += '...';
				} else {
					tmpLabel = item.hotel_komentarji[0].content;
				}
				return {
					label: tmpLabel,
					title: item.hotel_komentarji[0].content
				};
			} else {
				return {
					label: ' / ',
					title: 'Ni komentarjev'
				};
			}
		}
	},
	data: function data() {
		return {
			manageMode_actionCommited: false,
			isLoading: false,
			title: '',
			okButton: {
				label: '',
				progress: false,
				disabled: false
			},
			hotelStrankaEditButoon: {
				label: 'Uredi',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_ADDING1: 1,
			mode_EDITING2: 2,
			mode_MANAGESTORITVE3: 3,
			mode: 0,
			hotelHramba: {
				id: 0,
				fk_hotel_lokacija: null,
				fk_hotel_stranka: null
			},
			storitveOfHrambaTable_props: {
				fields: [{ key: 'id', label: '#', sortable: true, class: '' }, { key: 'num_tires', label: 'Št. gum', sortable: true, class: 'tdHotelStoritveStGum' }, { key: 'manufacturer', label: 'Znamka', sortable: true, class: '' }, { key: 'dimensions', label: 'Dimenzije', sortable: false, class: '' }, { key: 'season', label: 'Sezona', sortable: true, class: '' }, { key: 'rims', label: 'Platišča', sortable: true, class: '' }, { key: 'date', label: 'Datum storitve', filsortable: true, class: 'tdHotelStoritveDatum' }, { key: 'last_comment', label: 'Zadnji komentar', filsortable: true, class: 'tdLastHotelKomentar' }, { key: 'status', label: 'Status', sortable: false, class: 'tdHotelStoritveStatus' }, { key: 'actions', label: '', sortable: false, class: 'tdHotelStoritveActions' }],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 5,
				total: 0,
				isLoading: false,
				inputFilter: {
					fk_hotel_hramba: null,
					with_archived: true
				},
				textFilterTimeout: null,
				options_numRowsOnPage: [{ value: 5, text: '5' }, { value: 10, text: '10' }, { value: 50, text: '50' }]
			},
			storitveOfHrambaItems: [],
			external_options: [{ text: 'External', value: 1 }, { text: 'Internal', value: 0 }],
			hotelLokacije_searched: [],
			hotelLokacije_initOptions: [],
			hotelLokacije_searchEmpty: false,
			selectedLocation: null,
			hotelStranke_searchEmpty: false,
			hotel_stranka_selected: {
				id: 0,
				first_name: '',
				last_name: '',
				title: '',
				email: '',
				phone_number: '',
				address: '',
				city: '',
				registration_number: '',
				vehicle: '',
				external: 1,
				is_company: 0
			},
			hotelStranke_options: null,
			hotelStranke_searched: null,
			hotelStranka_adding: false,
			hotelStranka_editing: false
		};
	},
	watch: {},
	computed: {
		formDisabled: function formDisabled() {
			if (this.mode === this.mode_MANAGESTORITVE3 || this.mode === this.mode_UNKNOWN0) {
				return true;
			}
			return false;
		},
		modalSize: function modalSize() {
			if (this.mode === this.mode_ADDING1 || this.mode === this.mode_EDITING2) {
				return 'md';
			} else if (this.mode === this.mode_MANAGESTORITVE3) {
				return 'huge';
			}
			return '';
		},
		hotelLokacije_options: function hotelLokacije_options() {
			if (this.hotelLokacije_searched.length !== 0) {
				return this.hotelLokacije_searched;
			} else if (this.hotelLokacije_initOptions.length === 0) {
				this.initializeHotelLokacijeOptions();
				return this.hotelLokacije_initOptions;
			}
		},
		all_hotelStranke: function all_hotelStranke() {
			if (this.hotelStranke_searched != null) {
				return this.hotelStranke_searched;
			}if (this.hotelStranke) {
				return this.hotelStranke;
			} else {
				if (this.hotelStranke_options == null) {
					this.load_hotelStranke();
				}
				return this.hotelStranke_options;
			}
		},
		stranka_card_cols: function stranka_card_cols() {
			if (this.mode === this.mode_ADDING1 || this.mode === this.mode_EDITING2) {
				return 12;
			} else {
				return 4;
			}
		},
		feedback_lokacija: function feedback_lokacija() {
			if (this.hotelHramba.fk_hotel_lokacija === -1) {
				return 'Lokacija se bo samodejno dodala.';
			}
			return '';
		},
		state_lokacija: function state_lokacija() {
			if (this.hotelHramba.fk_hotel_lokacija === -1) {
				return true;
			}
			return false;
		},
		user: function user() {
			return this.$store.getters.user;
		},
		userCanEdit: function userCanEdit() {
			if (__WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].isModerator(this.user.role) || __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].isAdmin(this.user.role) || __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created: function created() {}
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHotelStoritevModal_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2679f472_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelStoritevModal_vue__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1070)
  __webpack_require__(1071)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2679f472"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHotelStoritevModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2679f472_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelStoritevModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2679f472_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelStoritevModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns__);








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'edit-hotel-storitev-modal',
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
	},
	props: {
		hotelStoritevDistincManufacturers: {
			type: Array,
			required: false
		}
	},
	methods: {
		showModal: function showModal(modalInput) {
			this.mode = modalInput.mode;
			this.initModal(modalInput.hotelStoritev, modalInput.hotelHramba);
		},
		initModal: function initModal(hotelStoritev, hotelHramba) {
			if (this.mode === this.mode_GIVE1) {
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = -1;
				if (!hotelHramba.id || hotelHramba.id < 1) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba');
				} else {
					this.hotelStoritev.fk_hotel_hramba = hotelHramba.id;
					this.hotelStoritev.fk_hotel_stranka = hotelHramba.fk_hotel_stranka;
					this.hotelStoritev.num_tires = 4;
					this.hotelStoritev.dimensions = {
						width: '205',
						heigth: '55',
						diameter: '16'
					};
					this.hotelStoritev.season = 'L';
					this.hotelStoritev.rims = 'BREZ';
					this.hotelStoritev.date_give = new Date();
					this.title = 'Oddaja pnevmatik v hrambo #' + this.hotelStoritev.fk_hotel_hramba;
					this.okButton.label = 'Dodaj';
				}
			} else if (this.mode === this.mode_TAKE2) {
				this.hotelKomentar.linked_to = hotelStoritev.id;
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = hotelStoritev.id;
				if (!hotelStoritev) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba ali storitev');
				} else {
					this.initHotelStoritev(hotelStoritev, hotelHramba);
					this.title = 'Izdaja pnevmatik #' + this.hotelStoritev.id;
					this.okButton.label = 'Izdaj';
				}
			} else if (this.mode === this.mode_SWITCH3) {
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = -1;
				if (!hotelStoritev) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba ali storitev');
				} else {
					this.inittakeOfSwitch(hotelStoritev);
					this.hotelStoritev.fk_hotel_hramba = hotelHramba.id;
					this.hotelStoritev.fk_hotel_stranka = hotelHramba.fk_hotel_stranka;
					this.hotelStoritev.num_tires = 4;
					this.hotelStoritev.dimensions = {
						width: '205',
						heigth: '55',
						diameter: '16'
					};
					this.hotelStoritev.season = 'L';
					this.hotelStoritev.rims = 'BREZ';
					this.hotelStoritev.date_give = new Date();
					this.title = 'Zamenjava pnevmatik #' + hotelStoritev.id;
					this.okButton.label = 'Zamenjaj';
				}
			} else if (this.mode === this.mode_EDITING4) {
				this.hotelKomentar.linked_to = hotelStoritev.id;
				this.komentarjiOfStoritevTable_props.inputFilter.linked_to = hotelStoritev.id;
				if (!hotelStoritev) {
					this.title = 'Napaka';
					this.mode = this.mode_UNKNOWN0;
					this.showAlert('Napaka: neveljavna hramba ali storitev');
				} else {
					this.initHotelStoritev(hotelStoritev, hotelHramba);
					this.title = 'Urejanje storitve #' + this.hotelStoritev.id;
					this.okButton.label = 'Shrani';
				}
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initHotelStoritev: function initHotelStoritev(hotelStoritev, hotelHramba) {
			this.hotelStoritev.id = hotelStoritev.id;
			this.hotelStoritev.fk_hotel_hramba = hotelStoritev.fk_hotel_hramba;
			this.hotelStoritev.fk_hotel_stranka = hotelHramba.fk_hotel_stranka;
			this.hotelStoritev.num_tires = hotelStoritev.num_tires;
			this.hotelStoritev.dimensions = JSON.parse(hotelStoritev.dimensions);
			this.hotelStoritev.manufacturer = hotelStoritev.manufacturer;
			this.hotelStoritev.season = hotelStoritev.season;
			this.hotelStoritev.rims = hotelStoritev.rims;
			this.hotelStoritev.rims_cover = hotelStoritev.rims_cover;
			this.hotelStoritev.rims_screw = hotelStoritev.rims_screw;
			this.hotelStoritev.year = hotelStoritev.year;
			this.hotelStoritev.wear = hotelStoritev.wear;
			this.hotelStoritev.note_give = hotelStoritev.note_give;
			this.hotelStoritev.responsible_mechanic_give = hotelStoritev.responsible_mechanic_give;
			this.hotelStoritev.date_give = hotelStoritev.date_give != null ? Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(hotelStoritev.date_give, __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].dbDtFormat) : null;
			if (this.mode === this.mode_TAKE2) {
				this.hotelStoritev.date_take = new Date();
			} else if (this.mode === this.mode_EDITING4) {
				this.hotelStoritev.note_take = hotelStoritev.note_take;
				this.hotelStoritev.responsible_mechanic_take = hotelStoritev.responsible_mechanic_take;
				this.hotelStoritev.date_take = hotelStoritev.date_take != null ? Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["parse"])(hotelStoritev.date_take, __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].dbDtFormat) : null;
			}
		},
		inittakeOfSwitch: function inittakeOfSwitch(hotelStoritev) {
			this.hotelStoritev.fk_hotel_storitev_take = hotelStoritev.id;
			this.takeOfSwitch_date_give = hotelStoritev.date_give;
			var lastComment = '';
			if (hotelStoritev.hotel_komentarji.length > 0) {
				lastComment += hotelStoritev.hotel_komentarji[0].content;
			} else {
				lastComment += ' / ';
			}
			var manufacturer = hotelStoritev.manufacturer != null || hotelStoritev.manufacturer === '' ? hotelStoritev.manufacturer : ' - ';
			this.takeOfSwitch = 'Izdaja <b>' + hotelStoritev.num_tires + ' ' + this.getSeasonLabel(hotelStoritev) + '</b> gum <b>' + this.getDemensionsLabel(hotelStoritev) + '</b>,' + this.getRimsLabel(hotelStoritev) + '<b>' + this.getRimsAditionalLabel(hotelStoritev) + '</b> znamke <b>' + manufacturer + '</b>' + '<br> Zadnji komentar: ' + lastComment;
		},
		getDemensionsLabel: function getDemensionsLabel(item) {
			var dimensions = JSON.parse(item.dimensions);
			return dimensions.width + '/' + dimensions.heigth + 'R' + dimensions.diameter;
		},
		getSeasonLabel: function getSeasonLabel(item) {
			if (item.season === 'L') {
				return 'letnih';
			} else if (item.season === 'Z') {
				return 'zimskih';
			} else if (item.season === 'ZL') {
				return 'celoletnih';
			} else {
				return '';
			}
		},
		getRimsLabel: function getRimsLabel(item) {
			if (item.rims === 'BREZ') {
				return ' <b>brez platišč</b> ';
			} else if (item.rims === 'ALU') {
				return ' z <b>ALU platišči</b> ';
			} else if (item.rims === 'FE') {
				return ' z <b>platišči</b> ';
			} else {
				return '';
			}
		},
		getRimsAditionalLabel: function getRimsAditionalLabel(item) {
			var label = '';
			if (item.rims_cover === 1 && item.rims_screw === 1) {
				label = '(S pokrovi in vijaki)';
			} else if (item.rims_cover === 1) {
				label = '(S pokrovi)';
			} else if (item.rims_screw === 1) {
				label = '(Z vijaki)';
			}
			return label;
		},
		onOkModal: function onOkModal() {
			var _this = this;

			if (this.mode === this.mode_GIVE1 || this.mode === this.mode_TAKE2 || this.mode === this.mode_SWITCH3 || this.mode === this.mode_EDITING4) {
				if (this.validateForm) {
					this.startProgress();
					this.hideAlert();
					__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].hotelStoritevEdit(this.hotelStoritev, this.mode, this.komentarjiOfStoritevTable_props.items).then(function (responseData) {
						if (responseData.message === 'addedGive' || responseData.message === 'addedTake' || responseData.message === 'addedSwitch' || responseData.message === 'editing') {
							_this.$emit('emit_success', responseData.hotelStoritev, _this.mode);
							_this.$refs.modal.hide();
						} else {
							_this.showAlert('Neveljaven odziv strežnika!', _this.ALERT_TYPE_ERROR);
							console.error('Neveljaven response message: ' + responseData.message);
						}
						_this.stopProgress();
					}).catch(function (error) {
						_this.stopProgress();
						if (error.response) {
							if (error.response.status === 400) {
								if (error.response.data.internalCode === 600) {
									_this.showAlert({ message: 'Neznana napaka na strežniku!', type: _this.ALERT_TYPE_ERROR });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 601) {
									_this.showAlert({ message: 'Napaka pri podatkovni bazi!', type: _this.ALERT_TYPE_ERROR });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 602) {
									_this.showAlert({ message: 'Uporabnik nima dostopa do hotela gum!', type: _this.ALERT_TYPE_ERROR });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 603) {
									_this.showAlert({ message: 'Napaka pri validaciji na strežniku!', type: _this.ALERT_TYPE_ERROR });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 604) {
									_this.showAlert({ message: 'Hramba ni najdena!', type: _this.ALERT_TYPE_ERROR });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 605) {
									_this.showAlert({ message: 'Neuspešno shranjevanje hrambe!', type: _this.ALERT_TYPE_ERROR });
									console.error(error.response.data.message);
								} else {
									_this.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this.ALERT_TYPE_ERROR });
									console.error(error.response.data.internalCode, error.response.data.message);
								}
							} else {
								_this.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this.ALERT_TYPE_ERROR });
								console.error(error.response.status, error.response.data.message);
							}
						} else if (error.request) {
							_this.showAlert({ message: 'Napaka: strežnik se ni odzval!', type: _this.ALERT_TYPE_ERROR });
							console.error('The request was made but no response was received:', error.request);
						} else {
							_this.showAlert({ message: 'Napaka pri pošiljanju zahteve na strežnik!', type: _this.ALERT_TYPE_ERROR });
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				} else {
					this.showAlert({ message: 'Nepravilno izpolnjen obrazec!', type: this.ALERT_TYPE_ERROR });
					this.stopProgress();
				}
			} else {
				this.$refs.modal.hide();
			}
		},
		clearModalData: function clearModalData() {
			this.title = '';
			this.stopProgress();
			this.okButton.label = '';
			this.message.type = null;
			this.message.text = null;
			this.mode = this.mode_UNKNOWN0;
			this.hotelHramba = null;
			this.hotelStoritev = {
				id: 0,
				fk_hotel_hramba: null,
				fk_hotel_stranka: null,
				num_tires: null,
				dimensions: {
					width: null,
					heigth: null,
					diameter: null
				},
				manufacturer: null,
				season: null,
				rims: null,
				rims_cover: 0,
				rims_screw: 0,
				year: null,
				wear: null,
				note_give: null,
				responsible_mechanic_give: null,
				date_give: null,
				note_take: null,
				responsible_mechanic_take: null,
				date_take: null,
				fk_hotel_storitev_take: null
			};
			this.hotelKomentar = {
				id: 0,
				linked_to: null,
				content: null
			};
			this.takeOfSwitch = null;
			this.takeOfSwitch_date_give = null;
			this.komentarjiOfStoritevTable_props.page = 1;
			this.komentarjiOfStoritevTable_props.size = 5;
			this.komentarjiOfStoritevTable_props.total = 0;
			this.komentarjiOfStoritevTable_props.isLoading = 0;
			this.komentarjiOfStoritevTable_props.inputFilter.linked_to = null;
			this.komentarjiOfStoritevTable_props.items = [];
		},
		startProgress: function startProgress() {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function stopProgress() {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		startKomentarProgress: function startKomentarProgress() {
			this.isLoading = true;
			this.addHotelKomentarButton.disabled = true;
			this.addHotelKomentarButton.progress = true;
		},
		stopKomentarProgress: function stopKomentarProgress() {
			this.isLoading = false;
			this.addHotelKomentarButton.disabled = false;
			this.addHotelKomentarButton.progress = false;
		},
		showAlert: function showAlert(alert) {
			var _this2 = this;

			var targetMessage = this.message;
			if (alert.message && alert.type && alert.seconds) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
				setTimeout(function () {
					_this2.hideAlert(alert.target);
				}, alert.seconds * 1000);
			} else if (alert.message && alert.type) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
			} else if (alert.message) {
				targetMessage.type = 'primary';
				targetMessage.text = alert.message;
			} else {
				targetMessage.type = null;
				targetMessage.text = null;
			}
		},
		hideAlert: function hideAlert(target) {
			var targetMessage = this.message;
			targetMessage.type = null;
			targetMessage.text = null;
		},
		loadManufacturers: function loadManufacturers() {
			var _this3 = this;

			this.manufacturer_initOptions = [];
			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].hotelStoritevInitParams({ 'manufacturer': true }).then(function (responseData) {
				if (responseData.message === 'success') {
					_this3.manufacturer_initOptions = responseData.distinctManufacturers;
				} else {
					console.error('Neveljaven odziv strežnika: ', responseData.message);
				}
			}).catch(function (error) {
				if (error.response) {
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							console.error(error.response.data.message);
						} else {
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					console.error('The request was made but no response was received:', error.request);
				} else {
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		addHotelKomentar: function addHotelKomentar() {
			var _this4 = this;

			if (this.mode === this.mode_GIVE1 || this.mode === this.mode_SWITCH3) {
				this.komentarjiOfStoritevTable_props.items.unshift({ 'created_at': new Date(), 'first_name': this.user.first_name, 'content': this.hotelKomentar.content });
				this.hotelKomentar.id = 0;
				this.hotelKomentar.content = null;
			} else {
				this.startKomentarProgress();
				this.hideAlert();
				__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].hotelKomentarEdit(this.hotelKomentar).then(function (responseData) {
					if (responseData.message === 'added') {
						_this4.$emit('emit_comment_added');
						_this4.$refs.komentarjiOfStoritevTable.refresh();
						_this4.hotelKomentar.id = 0;
						_this4.hotelKomentar.content = null;
					} else {
						_this4.showAlert('Neveljaven odziv strežnika!', _this4.ALERT_TYPE_ERROR);
						console.error('Neveljaven response message: ' + responseData.message);
					}
					_this4.stopKomentarProgress();
				}).catch(function (error) {
					_this4.stopKomentarProgress();
					if (error.response) {
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								_this4.showAlert({ message: 'Neznana napaka na strežniku!', type: _this4.ALERT_TYPE_ERROR });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								_this4.showAlert({ message: 'Napaka pri podatkovni bazi!', type: _this4.ALERT_TYPE_ERROR });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								_this4.showAlert({ message: 'Uporabnik nima dostopa do hotela gum!', type: _this4.ALERT_TYPE_ERROR });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								_this4.showAlert({ message: 'Napaka pri validaciji na strežniku!', type: _this4.ALERT_TYPE_ERROR });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 604) {
								_this4.showAlert({ message: 'Komentar ni najden!', type: _this4.ALERT_TYPE_ERROR });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 605) {
								_this4.showAlert({ message: 'Neuspešno shranjevanje komentarja!', type: _this4.ALERT_TYPE_ERROR });
								console.error(error.response.data.message);
							} else {
								_this4.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this4.ALERT_TYPE_ERROR });
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							_this4.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this4.ALERT_TYPE_ERROR });
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						_this4.showAlert({ message: 'Napaka: strežnik se ni odzval!', type: _this4.ALERT_TYPE_ERROR });
						console.error('The request was made but no response was received:', error.request);
					} else {
						_this4.showAlert({ message: 'Napaka pri pošiljanju zahteve na strežnik!', type: _this4.ALERT_TYPE_ERROR });
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
			}
		},
		komentarjiOfStoritevTable_items: function komentarjiOfStoritevTable_items(ctx) {
			var _this5 = this;

			this.komentarjiOfStoritevTable_props.isLoading = true;
			return __WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].getHotelKomentarjiFiltered(ctx, this.komentarjiOfStoritevTable_props.inputFilter).then(function (responseData) {
				_this5.komentarjiOfStoritevTable_props.isLoading = false;
				if (responseData.message === 'success') {
					_this5.komentarjiOfStoritevTable_props.empty_text = 'Ni komentarjev';
					_this5.komentarjiOfStoritevTable_props.total = responseData.items.total;
					_this5.komentarjiOfStoritevTable_props.items = responseData.items.data;
					return responseData.items.data;
				} else {
					_this5.showAlert('Neznana odziv strežnika!', _this5.ALERT_TYPE_ERROR);
					_this5.komentarjiOfStoritevTable_props.empty_text = 'Napaka pri pridobivanju storitev komentarjev';
					_this5.komentarjiOfStoritevTable_props.total = 0;
					console.error('Neveljaven odziv strežnika: ', responseData.message);
					return [];
				}
			}).catch(function (error) {
				_this5.komentarjiOfStoritevTable_props.isLoading = false;
				if (error.response) {
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							_this5.showAlert('Neznana napaka na strežniku!', _this5.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							_this5.showAlert('Napaka pri podatkovni bazi!', _this5.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							_this5.showAlert('Uporabnik nima dostopa do hotela gum!', _this5.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							_this5.showAlert('Napaka pri validaciji na strežniku!', _this5.ALERT_TYPE_ERROR);
							console.error(error.response.data.message);
						} else {
							_this5.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', _this5.ALERT_TYPE_ERROR);
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						_this5.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', _this5.ALERT_TYPE_ERROR);
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					_this5.showAlert('Napaka: strežnik se ni odzval!', _this5.ALERT_TYPE_ERROR);
					console.error('The request was made but no response was received:', error.request);
				} else {
					_this5.showAlert('Napaka pri pošiljanju zahteve na strežnik!', _this5.ALERT_TYPE_ERROR);
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
			});
		},
		rimsCover_Changed: function rimsCover_Changed() {
			this.hotelStoritev.rims_cover = this.hotelStoritev.rims_cover === 1 ? 0 : 1;
		},
		rimsScrew_Changed: function rimsScrew_Changed() {
			this.hotelStoritev.rims_screw = this.hotelStoritev.rims_screw === 1 ? 0 : 1;
		},

		manufacturerSearch: function manufacturerSearch(data) {
			if (data !== '') {
				this.hotelStoritev.manufacturer = data;
			}
		}
	},
	data: function data() {
		return {
			isLoading: false,
			title: '',
			okButton: {
				label: '',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_GIVE1: 1,
			mode_TAKE2: 2,
			mode_SWITCH3: 3,
			mode_EDITING4: 4,
			mode: 0,
			hotelHramba: null,
			hotelLokacija: null,
			hotelStoritev: {
				id: 0,
				fk_hotel_hramba: null,
				fk_hotel_stranka: null,
				num_tires: null,
				dimensions: {
					width: null,
					heigth: null,
					diameter: null
				},
				manufacturer: null,
				season: null,
				rims: null,
				rims_cover: 0,
				rims_screw: 0,
				year: null,
				wear: null,
				note_give: null,
				responsible_mechanic_give: null,
				date_give: null,
				note_take: null,
				responsible_mechanic_take: null,
				date_take: null,
				fk_hotel_storitev_take: null
			},
			settings: __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */],
			takeOfSwitch: null,
			takeOfSwitch_date_give: null,
			manufacturer_initOptions: null,
			hotelKomentar: {
				id: 0,
				linked_to: null,
				content: null
			},
			addHotelKomentarButton: {
				label: 'Dodaj',
				progress: false,
				disabled: false
			},
			komentarjiOfStoritevTable_props: {
				fields: [{ key: 'created_at', label: 'Dodan', sortable: true, class: 'tdHotelKomentarCreatedAt' }, { key: 'user', label: 'Uporabnik', sortable: true, class: 'tdHotelKomentarUser' }, { key: 'content', label: 'Vsebina', sortable: true, class: 'tdHotelKomentarContent' }],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 5,
				total: 0,
				isLoading: false,
				inputFilter: {
					linked_to: null
				},
				options_numRowsOnPage: [{ value: 5, text: '5' }, { value: 10, text: '10' }, { value: 50, text: '50' }],
				items: []
			},
			localKomentarjiOfStoritevTable: []
		};
	},
	watch: {},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		state_responsible_mechanic_give: function state_responsible_mechanic_give() {
			if (this.hotelStoritev.responsible_mechanic_give && this.hotelStoritev.responsible_mechanic_give.length > 0) {
				return true;
			}
			return false;
		},
		invalidFeedback_responsible_mechanic_give: function invalidFeedback_responsible_mechanic_give() {
			if (this.hotelStoritev.responsible_mechanic_give || this.formDisabled) {
				this.hideAlert();
				return '';
			}
			return 'Odgovoren mehanik je obvezen';
		},
		state_date_give: function state_date_give() {
			if (this.hotelStoritev.date_give) {
				return true;
			}
			return false;
		},
		invalidFeedback_date_give: function invalidFeedback_date_give() {
			if (this.hotelStoritev.date_give || this.formDisabled) {
				return '';
			}
			return 'Datum oddaje je obvezen';
		},
		state_responsible_mechanic_take: function state_responsible_mechanic_take() {
			if (this.mode === this.mode_TAKE2) {
				if (this.hotelStoritev.responsible_mechanic_take && this.hotelStoritev.responsible_mechanic_take.length > 0) {
					return true;
				}
				return false;
			}
			return '';
		},
		invalidFeedback_responsible_mechanic_take: function invalidFeedback_responsible_mechanic_take() {
			if (this.mode === this.mode_TAKE2 && !this.formDisabled) {
				if (this.hotelStoritev.responsible_mechanic_take) {
					this.hideAlert();
					return '';
				}
				return 'Odgovoren mehanik je obvezen';
			}
			return '';
		},
		state_date_take: function state_date_take() {
			if (this.mode === this.mode_TAKE2) {
				if (this.hotelStoritev.date_take) {
					return true;
				}
				return false;
			}
			return true;
		},
		invalidFeedback_date_take: function invalidFeedback_date_take() {
			if (this.mode === this.mode_TAKE2 && !this.formDisabled) {
				if (this.hotelStoritev.date_take) {
					return '';
				}
				return 'Datum izdaje je obvezen';
			}
			return '';
		},

		validateForm: function validateForm() {
			if (!this.state_dimensions_width || !this.state_dimensions_height || !this.state_dimensions_diameter) {
				return false;
			}
			if ((this.mode === this.mode_GIVE1 || this.mode === this.mode_SWITCH3) && this.state_responsible_mechanic_give && this.state_date_give && this.state_date_take) {
				return true;
			} else if (this.mode === this.mode_TAKE2 && this.state_responsible_mechanic_take && this.state_date_give && this.state_date_take) {
				return true;
			} else if (this.mode === this.mode_EDITING4 && this.state_responsible_mechanic_give && this.state_date_give) {
				return true;
			}
			return false;
		},
		formDisabled: function formDisabled() {
			if (__WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].isModerator(this.user.role) || __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].isAdmin(this.user.role) || __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].isSkrbnikGum(this.user.role)) {
				return false;
			} else {
				return true;
			}
		},
		modalSize: function modalSize() {
			return 'lg';
		},
		mainCardHeader: function mainCardHeader() {
			if (this.mode === this.mode_GIVE1 || this.mode === this.mode_SWITCH3) {
				return 'Podatki o oddaji';
			} else if (this.mode === this.mode_TAKE2) {
				return 'Podatki o izdaji';
			} else if (this.mode === this.mode_EDITING4) {
				return 'Podatki o storitvi';
			} else {
				return 'Neznan način';
			}
		},
		manufacturer_Options: function manufacturer_Options() {
			if (this.hotelStoritevDistincManufacturers && this.hotelStoritevDistincManufacturers.length > 0) {
				return this.hotelStoritevDistincManufacturers;
			} else {
				if (this.manufacturer_initOptions == null) {
					this.loadManufacturers();
				}
				return this.manufacturer_initOptions;
			}
		},
		state_dimensions_width: function state_dimensions_width() {
			if (this.hotelStoritev.dimensions.width && this.hotelStoritev.dimensions.width.length > 3) {
				return false;
			}
			return true;
		},
		invalidFeedback_dimensions_width: function invalidFeedback_dimensions_width() {
			if (this.hotelStoritev.dimensions.width && this.hotelStoritev.dimensions.width.length > 3) {
				return 'Neveljavna širina';
			}
			return '';
		},
		state_dimensions_height: function state_dimensions_height() {
			if (this.hotelStoritev.dimensions.heigth && this.hotelStoritev.dimensions.heigth.length > 2) {
				return false;
			}
			return true;
		},
		invalidFeedback_dimensions_height: function invalidFeedback_dimensions_height() {
			if (this.hotelStoritev.dimensions.heigth && this.hotelStoritev.dimensions.heigth.length > 2) {
				return 'Neveljavna višina';
			}
			return '';
		},
		state_dimensions_diameter: function state_dimensions_diameter() {
			if (this.hotelStoritev.dimensions.diameter && this.hotelStoritev.dimensions.diameter.length > 2) {
				return false;
			}
			return true;
		},
		invalidFeedback_dimensions_diameter: function invalidFeedback_dimensions_diameter() {
			if (this.hotelStoritev.dimensions.diameter && this.hotelStoritev.dimensions.diameter.length > 2) {
				return 'Neveljaven premer';
			}
			return '';
		}
	},
	created: function created() {}
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'edit-hotel-stranka-modal',
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
	},
	props: {},
	methods: {
		showModal: function showModal(modalData) {
			this.mode = modalData.mode;
			this.initModal(modalData.hotelStranka);
		},
		initModal: function initModal(hotelStranka) {
			if (this.mode === this.mode_ADDING1) {
				this.title = 'Dodajanje nove stranke';
				this.okButton.label = 'Dodaj';
			} else if (this.mode === this.mode_EDITING2) {
				this.title = 'Urejanje stranke št. ';
				this.hotelStranka = this.initHotelStranka(hotelStranka);
				this.okButton.label = 'Shrani';
			} else {
				this.title = 'Neznan način';
				this.mode = this.mode_UNKNOWN0;
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initHotelStranka: function initHotelStranka(hotelStranka) {
			return {
				id: hotelStranka.id,
				first_name: hotelStranka.first_name,
				last_name: hotelStranka.last_name,
				title: hotelStranka.title,
				address: hotelStranka.address,
				city: hotelStranka.city,
				email: hotelStranka.email,
				phone_number: hotelStranka.phone_number,
				registration_number: hotelStranka.registration_number,
				vehicle: hotelStranka.vehicle,
				external: hotelStranka.external,
				is_company: hotelStranka.is_company
			};
		},
		onOkModal: function onOkModal() {
			var _this = this;

			if (this.formDisabled) {
				this.$refs.modal.hide();
			} else if (this.validateForm) {
				this.startProgress();
				this.showAlert();
				__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].hotelStrankaEdit(this.hotelStranka).then(function (responseData) {
					if (responseData.message === 'edited' || responseData.message === 'added') {
						_this.$emit('emit_success', responseData.hotelStranka, _this.mode);
						_this.$refs.modal.hide();
					} else {
						_this.showAlert('Neveljaven odziv strežnika!', _this.ALERT_TYPE_ERROR);
						console.error('Neveljaven response message: ' + responseData.message);
					}
					_this.stopProgress();
				}).catch(function (error) {
					_this.stopProgress();
					if (error.response) {
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								_this.showAlert('Neznana napaka na strežniku!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								_this.showAlert('Napaka pri podatkovni bazi!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								_this.showAlert('Uporabnik nima dostopa do hotela gum!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								_this.showAlert('Napaka pri validaciji na strežniku!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 604) {
								_this.showAlert('Hramba ni najdena!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 605) {
								_this.showAlert('Neuspešno shranjevanje hrambe!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.data.message);
							} else {
								_this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', _this.ALERT_TYPE_ERROR);
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							_this.showAlert('Neznana napaka na strežniku (status: ' + error.response.status + ')!', _this.ALERT_TYPE_ERROR);
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						_this.showAlert('Napaka: strežnik se ni odzval!', _this.ALERT_TYPE_ERROR);
						console.error('The request was made but no response was received:', error.request);
					} else {
						_this.showAlert('Napaka pri pošiljanju zahteve na strežnik!', _this.ALERT_TYPE_ERROR);
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
			} else {
				this.showAlert('Nepravilno izpolnjen obrazec!', this.ALERT_TYPE_ERROR);
				this.stopProgress();
			}
		},
		hotelStrankaButton_click: function hotelStrankaButton_click() {
			console.log('ok');
		},
		clearModalData: function clearModalData() {
			this.title = '';
			this.stopProgress();
			this.showAlert();
			this.okButton.label = '';
			this.mode = this.mode_UNKNOWN0;
			this.hotelStranka = {
				id: 0,
				first_name: null,
				last_name: null,
				title: null,
				email: null,
				phone_number: null,
				address: null,
				city: null,
				registration_number: null,
				vehicle: null,
				external: 1,
				is_company: 0
			};
		},
		startProgress: function startProgress() {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function stopProgress() {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function showAlert(message, type, seconds) {
			var _this2 = this;

			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(function () {
					_this2.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		formatRegistrationNumber: function formatRegistrationNumber() {
			this.hotelStranka.registration_number = this.hotelStranka.registration_number.replace(' ', '');
			this.hotelStranka.registration_number = this.hotelStranka.registration_number.replace('-', '');
			if (this.hotelStranka.registration_number.length > 9) {
				this.hotelStranka.registration_number = this.hotelStranka.registration_number.substring(0, 10);
			}
		}
	},
	data: function data() {
		return {
			isLoading: false,
			title: '',
			okButton: {
				label: '',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_ADDING1: 1,
			mode_EDITING2: 2,
			mode: 0,
			hotelStranka: {
				id: 0,
				first_name: '',
				last_name: '',
				title: '',
				email: '',
				phone_number: '',
				address: '',
				city: '',
				registration_number: '',
				vehicle: '',
				external: 1,
				is_company: 0
			}
		};
	},
	watch: {},
	computed: {
		state_first_name: function state_first_name() {
			if (this.hotelStranka.first_name && this.hotelStranka.first_name.length > 0 || this.hotelStranka.is_company === 1) {
				return true;
			}
			return false;
		},
		invalidFeedback_first_name: function invalidFeedback_first_name() {
			if (this.hotelStranka.first_name || this.hotelStranka.is_company === 1) {
				this.showAlert();
				return '';
			}
			return 'Ime je obvezno';
		},
		state_last_name: function state_last_name() {
			if (this.hotelStranka.last_name && this.hotelStranka.last_name.length > 0 || this.hotelStranka.is_company === 1) {
				return true;
			}
			return false;
		},
		invalidFeedback_last_name: function invalidFeedback_last_name() {
			if (this.hotelStranka.last_name || this.hotelStranka.is_company === 1) {
				this.showAlert();
				return '';
			}
			return 'Priimek je obvezen';
		},
		state_title: function state_title() {
			if (this.hotelStranka.title && this.hotelStranka.title.length > 0 || this.hotelStranka.is_company === 0) {
				return true;
			}
			return false;
		},
		invalidFeedback_title: function invalidFeedback_title() {
			if (this.hotelStranka.title || this.hotelStranka.is_company === 0) {
				this.showAlert();
				return '';
			}
			return 'Naziv je obvezen';
		},
		state_email: function state_email() {
			var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!this.hotelStranka.email || this.hotelStranka.email.length < 1 || emailRegex.test(this.hotelStranka.email)) {
				return true;
			}
			return false;
		},
		invalidFeedback_email: function invalidFeedback_email() {
			var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (this.hotelStranka.email && this.hotelStranka.email.length > 0 && !emailRegex.test(this.hotelStranka.email)) {
				return 'Nepravilna oblika emaila';
			}

			return '';
		},
		state_registration_number: function state_registration_number() {
			if (!this.hotelStranka.registration_number || this.hotelStranka.registration_number && this.hotelStranka.registration_number.length < 11) {
				return true;
			}
			return false;
		},
		invalidFeedback_registration_number: function invalidFeedback_registration_number() {
			if (!this.hotelStranka.registration_number || this.hotelStranka.registration_number && this.hotelStranka.registration_number.length >= 10) {
				return 'Največ 10 znakov';
			}

			return '';
		},

		validateForm: function validateForm() {
			if (this.state_first_name && this.state_last_name && this.state_title && this.state_email && this.state_registration_number) {
				return true;
			}
			return false;
		},
		formDisabled: function formDisabled() {
			return false;
		},
		modalSize: function modalSize() {
			if (this.mode === this.mode_ADDING1 || this.mode === this.mode_EDITING2) {
				return 'md';
			}
			return '';
		}
	},
	created: function created() {}
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'hotel-lokacije-modal',
	components: {
		Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
	},
	methods: {
		showModal: function showModal(mode) {
			this.mode = mode;
			this.initModal();
		},
		initModal: function initModal() {
			if (this.mode === this.mode_NORMAL1) {
				this.title = 'Lokacije';
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
			}
			this.$refs.modal.show();
		},
		onOkModal: function onOkModal() {
			this.$refs.modal.hide();
		},
		clearModalData: function clearModalData() {
			this.title = '';
			this.addLocation_stopProgress();
			this.hideAlert();
			this.hideAlert('messageHotelLocationsTable');
			this.hideAlert('messageHotelLocationsAdd');
			this.hideAlert('messageHotelLocationsRemove');
			this.mode = this.mode_UNKNOWN0;
			this.newHotelLokacija = {
				id: 0,
				title: null
			};
			this.hotelLokacijeTableToggleFilters();
			this.hotelLokacijeTable_props.empty_text = '';
			this.hotelLokacijeTable_props.empty_filtered_text = 'Ni zadetkov';
			this.hotelLokacijeTable_props.page = 1;
			this.hotelLokacijeTable_props.size = 10;
			this.hotelLokacijeTable_props.total = 0;
			this.hotelLokacijeTable_props.isLoading = false;
			this.hotelLokacijeTable_props.textFilterTimeout = null;
		},
		addLocation_startProgress: function addLocation_startProgress() {
			this.addHotelLocation_isLoading = true;
			this.addHotelLocationButton.disabled = true;
			this.addHotelLocationButton.progress = true;
		},
		addLocation_stopProgress: function addLocation_stopProgress() {
			this.addHotelLocation_isLoading = false;
			this.addHotelLocationButton.disabled = false;
			this.addHotelLocationButton.progress = false;
		},
		showAlert: function showAlert(alert) {
			var _this = this;

			var targetMessage = this.message;
			if (alert.target && alert.target === 'messageHotelLocationsAdd') {
				targetMessage = this.messageHotelLocationsAdd;
			} else if (alert.target && alert.target === 'messageHotelLocationsTable') {
				targetMessage = this.messageHotelLocationsTable;
			} else if (alert.target && alert.target === 'messageHotelLocationsRemove') {
				targetMessage = this.messageHotelLocationsRemove;
			}
			if (alert.message && alert.type && alert.seconds) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
				setTimeout(function () {
					_this.hideAlert(alert.target);
				}, alert.seconds * 1000);
			} else if (alert.message && alert.type) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
			} else if (alert.message) {
				targetMessage.type = 'primary';
				targetMessage.text = alert.message;
			} else {
				targetMessage.type = null;
				targetMessage.text = null;
			}
		},
		hideAlert: function hideAlert(target) {
			var targetMessage = this.message;
			if (target && target === 'messageHotelLocationsAdd') {
				targetMessage = this.messageHotelLocationsAdd;
			} else if (target && target === 'messageHotelLocationsTable') {
				targetMessage = this.messageHotelLocationsTable;
			} else if (target && target === 'messageHotelLocationsRemove') {
				targetMessage = this.messageHotelLocationsRemove;
			}
			targetMessage.type = null;
			targetMessage.text = null;
		},
		hotelLokacijeTableFilter_change: function hotelLokacijeTableFilter_change(value) {
			this.$refs.hotelLokacijeTable.refresh();
		},
		hotelLokacijeTableTextFilter_change: function hotelLokacijeTableTextFilter_change(value) {
			var _this2 = this;

			if (this.hotelLokacijeTable_props.textFilterTimeout !== null) {
				clearTimeout(this.hotelLokacijeTable_props.textFilterTimeout);
			}
			this.hotelLokacijeTable_props.textFilterTimeout = setTimeout(function () {
				_this2.$refs.hotelLokacijeTable.refresh();
			}, __WEBPACK_IMPORTED_MODULE_2__settings_js__["a" /* default */].filterTimeoutLength);
		},
		hotelLokacijeTableRefresh_click: function hotelLokacijeTableRefresh_click() {
			this.$refs.hotelLokacijeTable.refresh();
		},
		hotelLokacijeTableToggleFilter_click: function hotelLokacijeTableToggleFilter_click() {
			this.hotelLokacijeTableToggleFilters();
			this.$refs.hotelLokacijeTable.refresh();
		},
		hotelLokacijeTableToggleFilters: function hotelLokacijeTableToggleFilters() {
			this.hotelLokacijeTable_props.inputFilter.title = null;
		},
		hotelLokacijeTable_items: function hotelLokacijeTable_items(ctx) {
			var _this3 = this;

			this.hotelLokacijeTable_props.isLoading = true;
			this.hideAlert('messageHotelLocationsTable');
			return __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].getHotelLokacijeFiltered(ctx, this.hotelLokacijeTable_props.inputFilter).then(function (responseData) {
				_this3.hotelLokacijeTable_props.isLoading = false;
				if (responseData.message === 'success') {
					_this3.hotelLokacijeTable_props.empty_text = 'Ni vnosov';
					_this3.hotelLokacijeTable_props.total = responseData.items.total;
					return responseData.items.data;
				} else {
					_this3.showAlert({ message: 'Neveljaven odziv strežnika!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
					_this3.hotelLokacijeTable_props.empty_text = 'Napaka pri pridobivanju lokacij';
					_this3.hotelLokacijeTable_props.total = 0;
					console.error('Neveljaven odziv strežnika: ', responseData.message);
					return [];
				}
			}).catch(function (error) {
				_this3.hotelLokacijeTable_props.isLoading = false;
				if (error.response) {
					if (error.response.status === 400) {
						if (error.response.data.internalCode === 600) {
							_this3.showAlert({ message: 'Neznana napaka na strežniku!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 601) {
							_this3.showAlert({ message: 'Napaka pri podatkovni bazi!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 602) {
							_this3.showAlert({ message: 'Uporabnik nima dostopa do hotela gum!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
							console.error(error.response.data.message);
						} else if (error.response.data.internalCode === 603) {
							_this3.showAlert({ message: 'Napaka pri validaciji na strežniku!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
							console.error(error.response.data.message);
						} else {
							_this3.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
							console.error(error.response.data.internalCode, error.response.data.message);
						}
					} else {
						_this3.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
						console.error(error.response.status, error.response.data.message);
					}
				} else if (error.request) {
					_this3.showAlert({ message: 'Napaka: strežnik se ni odzval!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
					console.error('The request was made but no response was received:', error.request);
				} else {
					_this3.showAlert({ message: 'Napaka pri pošiljanju zahteve na strežnik!', type: _this3.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable' });
					console.error('Something happened in setting up the request that triggered an Error:', error.message);
				}
				_this3.hotelLokacijeTable_props.empty_text = 'Napaka pri pridobivanju lokacij';
				_this3.hotelLokacijeTable_props.total = 0;
				return [];
			});
		},
		hotelLokacijeTable_rowClicked: function hotelLokacijeTable_rowClicked(data) {
			console.log('row clicked', data.item);
		},
		hotelLokacijaAdd_click: function hotelLokacijaAdd_click(data) {
			var _this4 = this;

			if (this.validateForm) {
				this.addLocation_startProgress();
				this.hideAlert('messageHotelLocationsAdd');
				__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].hotelLokacijaEdit(this.newHotelLokacija).then(function (responseData) {
					if (responseData.message === 'edited' || responseData.message === 'added') {
						_this4.showAlert({ message: 'Lokacija ' + responseData.hotelLokacija.title + ' dodana!', type: _this4.ALERT_TYPE_SUCCESS, seconds: 2, target: 'messageHotelLocationsAdd' });
						_this4.newHotelLokacija = {
							id: 0,
							title: null
						};
						_this4.$refs.hotelLokacijeTable.refresh();
					} else {
						_this4.showAlert({ message: 'Neveljaven odziv strežnika!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
						console.error('Neveljaven response message: ' + responseData.message);
					}
					_this4.addLocation_stopProgress();
				}).catch(function (error) {
					_this4.addLocation_stopProgress();
					if (error.response) {
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								_this4.showAlert({ message: 'Neznana napaka na strežniku!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								_this4.showAlert({ message: 'Napaka pri podatkovni bazi!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								_this4.showAlert({ message: 'Uporabnik nima dostopa do hotela gum!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								_this4.showAlert({ message: 'Napaka pri validaciji na strežniku!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 607) {
								_this4.showAlert({ message: 'Lokacija s tem nazivom že obstaja!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
								console.error(error.response.data.message);
							} else {
								_this4.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							_this4.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						_this4.showAlert({ message: 'Napaka: strežnik se ni odzval!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
						console.error('The request was made but no response was received:', error.request);
					} else {
						_this4.showAlert({ message: 'Napaka pri pošiljanju zahteve na strežnik!', type: _this4.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
			} else {
				this.showAlert({ message: 'Nepravilno oblika naziva!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd' });
				this.addLocation_stopProgress();
			}
		},
		hotelLokacijaStatus: function hotelLokacijaStatus(item) {
			if (item.hotel_hrambe_on_location && item.hotel_hrambe_on_location.length > 0) {
				var title = '{ ';
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(item.hotel_hrambe_on_location), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var hrambaOnLocattion = _step.value;

						title += hrambaOnLocattion.id + ' ';
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				title += ' }';
				return {
					label: 'Zasedena(' + item.hotel_hrambe_on_location.length + ')',
					variant: 'danger',
					class: '',
					title: 'Lokacija je vezana na hrambe ' + title + '.'
				};
			} else {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Lokacija je prosta'
				};
			}
		},
		hotelLokacijaRemove_click: function hotelLokacijaRemove_click(item) {
			var _this5 = this;

			this.$bvModal.msgBoxConfirm('Želite izbrisati lokacijo ' + item.title + '?', {
				title: 'Potrdite brisanje lokacije',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(function (value) {
				if (value === true) {
					__WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].removeHotelLokacija(item.id).then(function (responseData) {
						_this5.showAlert({ message: 'Lokacija ' + responseData.hotelLokacija.title + ' odstranjena!', type: _this5.ALERT_TYPE_SUCCESS, seconds: 2, target: 'messageHotelLocationsRemove' });
						_this5.$refs.hotelLokacijeTable.refresh();
					}).catch(function (error) {
						_this5.addLocation_stopProgress();
						if (error.response) {
							if (error.response.status === 400) {
								if (error.response.data.internalCode === 600) {
									_this5.showAlert({ message: 'Neznana napaka na strežniku!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 601) {
									_this5.showAlert({ message: 'Napaka pri podatkovni bazi!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 602) {
									_this5.showAlert({ message: 'Uporabnik nima dostopa do hotela gum!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 603) {
									_this5.showAlert({ message: 'Napaka pri validaciji na strežniku!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 605) {
									_this5.showAlert({ message: 'Lokacija ni prosta!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 606) {
									_this5.showAlert({ message: 'Napaka pri brisanju lokacije!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
									console.error(error.response.data.message);
								} else {
									_this5.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
									console.error(error.response.data.internalCode, error.response.data.message);
								}
							} else {
								_this5.showAlert({ message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
								console.error(error.response.status, error.response.data.message);
							}
						} else if (error.request) {
							_this5.showAlert({ message: 'Napaka: strežnik se ni odzval!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
							console.error('The request was made but no response was received:', error.request);
						} else {
							_this5.showAlert({ message: 'Napaka pri pošiljanju zahteve na strežnik!', type: _this5.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove' });
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	data: function data() {
		return {
			title: '',
			addHotelLocationButton: {
				label: '',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			messageHotelLocationsAdd: {
				type: null,
				text: null
			},
			messageHotelLocationsTable: {
				type: null,
				text: null
			},
			messageHotelLocationsRemove: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_NORMAL1: 1,
			mode: 0,
			newHotelLokacija: {
				id: 0,
				title: null
			},
			hotelLokacijeTable_props: {
				fields: [{ key: 'id', label: 'Št. lokacije', sortable: true, class: '' }, { key: 'title', label: 'Naziv', sortable: true, class: '' }, { key: 'status', label: 'Status', class: '' }, { key: 'actions', label: '#', sortable: false, class: '' }],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 10,
				total: 0,
				isLoading: false,
				inputFilter: {
					title: null
				},
				textFilterTimeout: null,
				options_numRowsOnPage: [{ value: 10, text: '10' }, { value: 50, text: '50' }, { value: 100, text: '100' }]
			}
		};
	},
	watch: {},
	computed: {
		state_title: function state_title() {
			if (this.newHotelLokacija.title && this.newHotelLokacija.title.length > 0) {
				return true;
			}
			return false;
		},
		invalidFeedback_title: function invalidFeedback_title() {
			if (this.newHotelLokacija.title && this.newHotelLokacija.title.length > 0) {
				return '';
			}
			return '';
		},
		hotelLokacijaAddTitle: function hotelLokacijaAddTitle() {
			if (this.newHotelLokacija.title && this.newHotelLokacija.title.length > 0) {
				return 'Dodaj lokacijo';
			}
			return 'Naziv mora vsebovati vsaj en znak';
		},

		validateForm: function validateForm() {
			if (this.state_title) {
				return true;
			}
			return false;
		},
		formDisabled: function formDisabled() {
			if (this.mode === this.mode_UNKNOWN0) {
				return true;
			}
			return false;
		},
		modalSize: function modalSize() {
			return 'lg';
		}
	},
	created: function created() {}
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		default_label: {
			type: String,
			required: false
		},
		value: {
			required: false
		},
		compact: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	methods: {
		click_Vse: function click_Vse(evt) {
			this.allSelected = true;
			this.title = this.defaultItemLabel;
			this.$emit('input', null);
		},

		click_Item: function click_Item(item) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _item = _step.value;

					_item.active = false;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			item.active = true;
			this.title = item.label;
			this.allSelected = false;
			this.$emit('input', item.value);
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.title) {
				return this.title;
			} else if (this.default_label) {
				return this.default_label;
			} else {
				return this.default_label_empty;
			}
		}
	},
	data: function data() {
		return {
			title: 'Vse',
			defaultItemLabel: 'Vse',
			selectedValue: null,
			multiselect: false,
			allSelected: true,
			items: [{
				label: 'External',
				value: 1,
				active: false
			}, {
				label: 'Internal',
				value: 0,
				active: false
			}]
		};
	},
	created: function created() {}
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'seasonFilter-dropdown',
	methods: {
		click_Item: function click_Item(item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_Vse: function click_Vse(evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem: function selectItem(value) {
			this.selectedItems = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (this.multiselect) {
						if (value) {
							if (value === item.value) {
								item.active = !item.active;
							}
						} else {
							item.active = false;
						}
					} else {
						if (value) {
							if (value === item.value) {
								item.active = true;
							} else {
								item.active = false;
							}
						} else {
							item.active = false;
						}
					}
					if (item.active) {
						this.selectedItems.push(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear: function clear() {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.selectedItems.length === 0) {
				return this.defaultItemLabel;
			} else if (this.selectedItems.length === 1) {
				return this.selectedItems[0].label;
			} else {
				return this.selectedItems[0].label + ' ...';
			}
		}
	},
	data: function data() {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			items: [{
				label: 'Celoletne',
				value: 'ZL',
				active: false
			}, {
				label: 'Letne',
				value: 'L',
				active: false
			}, {
				label: 'Zimske',
				value: 'Z',
				active: false
			}]
		};
	}
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		default_label: {
			type: String,
			required: false
		},
		value: {
			required: false
		},
		compact: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	methods: {
		click_Vse: function click_Vse(evt) {
			this.allSelected = true;
			this.title = this.defaultItemLabel;
			this.$emit('input', null);
		},

		click_Item: function click_Item(item) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _item = _step.value;

					_item.active = false;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			item.active = true;
			this.title = item.label;
			this.allSelected = false;
			this.$emit('input', item.value);
		}
	},
	computed: {
		selectedTitle: function selectedTitle() {
			if (this.title) {
				return this.title;
			} else if (this.default_label) {
				return this.default_label;
			} else {
				return this.default_label_empty;
			}
		}
	},
	data: function data() {
		return {
			title: 'Vse',
			defaultItemLabel: 'Vse',
			selectedValue: null,
			multiselect: false,
			allSelected: true,
			items: [{
				label: 'Proste',
				value: 0,
				active: false
			}, {
				label: 'Zasedene',
				value: 1,
				active: false
			}]
		};
	},
	created: function created() {}
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['text'],
	methods: {
		onClose: function onClose() {
			this.$emit('dismissed');
		}
	}
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);




var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

var DEFAULT_OPTIONS = {
  format: 'HH:mm',
  hideClearButton: false,
  minuteInterval: 1,
  secondInterval: 1,
  hourRange: null,
  hideDisabledHours: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueTimepicker',
  props: {
    value: { type: Object, default: function _default() {} },
    id: { type: String },
    name: { type: String },
    disabled: { type: Boolean, default: false },
    format: { type: String },
    hideClearButton: { type: Boolean, default: false },
    minuteInterval: { type: [Number, String] },
    secondInterval: { type: [Number, String] },
    hourRange: { type: Array },
    hideDisabledHours: { type: Boolean, default: false },
    inputClass: { type: String },
    placeholder: { type: String }
  },

  data: function data() {
    return {
      timeValue: {},

      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,

      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    opts: function opts() {
      var options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, DEFAULT_OPTIONS);

      if (this.format && this.format.length) {
        options.format = String(this.format);
      }

      if (this.hideClearButton) {
        options.hideClearButton = true;
      }

      if (this.isNumber(this.minuteInterval)) {
        options.minuteInterval = +this.minuteInterval;
      }

      if (!options.minuteInterval || options.minuteInterval < 1 || options.minuteInterval > 60) {
        if (options.minuteInterval === 0) {
          options.minuteInterval = 60;
        } else {
          if (options.minuteInterval > 60) {
            window.console.warn('\'minute-interval\' should be less than 60. Current value is ' + this.minuteInterval);
          } else if (options.minuteInterval < 1) {
            window.console.warn('\'minute-interval\' should be NO less than 1. Current value is ' + this.minuteInterval);
          }
          options.minuteInterval = 1;
        }
      }

      if (this.isNumber(this.secondInterval)) {
        options.secondInterval = +this.secondInterval;
      }

      if (!options.secondInterval || options.secondInterval < 1 || options.secondInterval > 60) {
        if (options.secondInterval === 0) {
          options.secondInterval = 60;
        } else {
          if (options.secondInterval > 60) {
            window.console.warn('\'second-interval\' should be less than 60. Current value is ' + this.secondInterval);
          } else if (options.secondInterval < 1) {
            window.console.warn('\'second-interval\' should be NO less than 1. Current value is ' + this.secondInterval);
          }
          options.secondInterval = 1;
        }
      }

      if (this.hourRange && Array.isArray(this.hourRange)) {
        options.hourRange = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.hourRange));
      }

      if (this.hideDisabledHours) {
        options.hideDisabledHours = true;
      }

      return options;
    },
    formatString: function formatString() {
      return this.opts.format || DEFAULT_OPTIONS.format;
    },
    displayTime: function displayTime() {
      var formatString = String(this.formatString);
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    inputIsEmpty: function inputIsEmpty() {
      return this.formatString === this.displayTime;
    },
    showClearBtn: function showClearBtn() {
      if (this.hideClearButton || this.disabled) {
        return false;
      }
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    },
    baseOn12Hours: function baseOn12Hours() {
      return this.hourType === 'h' || this.hourType === 'hh';
    },
    hourRangeIn24HrFormat: function hourRangeIn24HrFormat() {
      var _this = this;

      if (this.opts.hourRange && this.opts.hourRange.length) {
        var range = [];
        this.opts.hourRange.forEach(function (value) {
          if (value instanceof Array) {
            if (value.length > 2) {
              window.console.warn('Nested array within `hour-range` must contain no more than two items. Only the first two items of', value, 'will be taking into account.');
            }

            var start = value[0];
            var end = value[1] || value[0];

            if (_this.is12hRange(start)) {
              start = _this.translate12hRange(start);
            }
            if (_this.is12hRange(end)) {
              end = _this.translate12hRange(end);
            }

            for (var i = +start; i <= +end; i++) {
              if (range.indexOf(i) === -1) {
                range.push(i);
              }
            }
          } else {
            if (_this.is12hRange(value)) {
              value = _this.translate12hRange(value);
            }
            if (range.indexOf(value) === -1) {
              range.push(value);
            }
          }
        });
        range.sort(function (l, r) {
          return l - r;
        });
        return range;
      }
      if (this.opts.hourRange && !this.opts.hourRange.length) {
        window.console.log('NOTICE: The `hour-range` array is empty (length === 0)');
        return [];
      }
      return false;
    },
    restrictedHourRange: function restrictedHourRange() {
      if (!this.hourRangeIn24HrFormat) {
        return false;
      }
      if (this.baseOn12Hours) {
        var range = this.hourRangeIn24HrFormat.map(function (value) {
          if (value === 12) {
            return '12p';
          } else if (value === 24) {
            return '12a';
          }
          return value > 12 ? value % 12 + 'p' : value + 'a';
        });
        return range;
      }
      return this.hourRangeIn24HrFormat;
    },
    has: function has() {
      var result = {
        am: true,
        pm: true
      };

      if (this.hourRangeIn24HrFormat && this.hourRangeIn24HrFormat.length) {
        var range = [].concat([], this.hourRangeIn24HrFormat);
        result.am = range.some(this.hasAm);
        result.pm = range.some(this.hasPm);
      }

      return result;
    }
  },

  watch: {
    'opts.format': function optsFormat(newValue) {
      this.renderFormat(newValue);
    },
    'opts.minuteInterval': function optsMinuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    'opts.secondInterval': function optsSecondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    value: {
      deep: true,
      handler: function handler() {
        this.readValues();
      }
    },
    displayTime: function displayTime() {
      this.fillValues();
    },
    disabled: function disabled(toDisabled) {
      if (toDisabled && this.showDropdown) {
        this.showDropdown = false;
      }
    }
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
          if (i === 0) {
            return '12';
          }
          return String(i);
        case 'k':
          return String(i + 1);
        case 'hh':
          if (i === 0) {
            return '12';
          }
          return i < 10 ? '0' + i : String(i);
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      var _this2 = this;

      newFormat = newFormat || this.opts.format || DEFAULT_OPTIONS.format;

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      this.$nextTick(function () {
        _this2.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.baseOn12Hours ? 12 : 24;
      var hours = [];
      for (var i = 0; i < hoursCount; i++) {
        hours.push(this.formatValue(this.hourType, i));
      }
      this.hours = hours;
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.opts.secondInterval || DEFAULT_OPTIONS.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.opts.minuteInterval || DEFAULT_OPTIONS.minuteInterval;
      } else {
        return;
      }

      var result = [];
      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          result.push(this.formatValue(this.minuteType, i));
        } else {
          result.push(this.formatValue(this.secondType, i));
        }
      }

      if (listType === 'minute') {
        this.minutes = result;
      } else {
        this.seconds = result;
      }
    },
    renderApmList: function renderApmList() {
      var apms = [];
      if (this.apmType) {
        apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
      }
      this.apms = apms;
    },
    readValues: function readValues() {
      var timeValue = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.value || {}));
      var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(timeValue);

      if (values.length === 0) {
        timeValue[this.hourType] = '';
        timeValue[this.minuteType] = '';
        if (this.secondType) {
          timeValue[this.secondType] = '';
        }
        if (this.apmType) {
          timeValue[this.apmType] = '';
        }
      } else {
        if (values.indexOf(this.hourType) > -1) {
          this.hour = timeValue[this.hourType];
        }
        if (values.indexOf(this.minuteType) > -1) {
          this.minute = timeValue[this.minuteType];
        }
        if (values.indexOf(this.secondType) > -1) {
          this.second = timeValue[this.secondType];
        } else {
          this.second = 0;
        }
        if (values.indexOf(this.apmType) > -1) {
          this.apm = timeValue[this.apmType];
        }
      }
      this.timeValue = timeValue;
    },
    fillValues: function fillValues() {
      var _this3 = this;

      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var apmValue = this.baseOn12Hours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (_this3.baseOn12Hours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (_this3.baseOn12Hours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (_this3.baseOn12Hours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
    },
    updateTimeValue: function updateTimeValue(fullVals) {
      if (!fullVals) {
        return;
      }

      var fullValues = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, fullVals);

      var baseTimeValue = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.timeValue || {}));
      var timeValue = {};

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key] || '';
      });

      this.$emit('input', JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(timeValue)));
      this.$emit('change', {
        data: fullVals,
        displayTime: String(this.displayTime)
      });
    },
    is12hRange: function is12hRange(value) {
      return (/^\d{1,2}(a|p|A|P)$/.test(value)
      );
    },
    translate12hRange: function translate12hRange(value) {
      var valueT = value.match(/^(\d{1,2})(a|p|A|P)$/);
      if (+valueT[1] === 12) {
        return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 0 : 12);
      }
      return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 12 : 0);
    },
    hasAm: function hasAm(value) {
      return value < 12 || value === 24;
    },
    hasPm: function hasPm(value) {
      return value >= 12 && value < 24;
    },
    isDisabledHour: function isDisabledHour(value) {
      if (this.restrictedHourRange) {
        if (this.baseOn12Hours) {
          if (!this.apm || !this.apm.length) {
            return false;
          } else {
            var token = this.apm.toLowerCase() === 'am' ? 'a' : 'p';
            return this.restrictedHourRange.indexOf('' + +value + token) === -1;
          }
        } else {
          return this.restrictedHourRange.indexOf(+value) === -1;
        }
      }
      return false;
    },
    forceApmSelection: function forceApmSelection() {
      if (!this.apm || !this.apm.length) {
        if (this.has.am) {
          this.apm = this.apmType === 'A' ? 'AM' : 'am';
        } else if (this.has.pm) {
          this.apm = this.apmType === 'A' ? 'PM' : 'pm';
        }
      }
    },
    emptyApmSelection: function emptyApmSelection() {
      if (this.hour === '' && this.minute === '' && this.second === '') {
        this.apm = '';
      }
    },
    isNumber: function isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    toggleDropdown: function toggleDropdown() {
      if (this.disabled) {
        return;
      }
      this.showDropdown = !this.showDropdown;

      this.showDropdown ? this.$emit('open') : this.$emit('close');

      if (this.restrictedHourRange && this.baseOn12Hours) {
        if (this.showDropdown) {
          this.forceApmSelection();
        } else {
          this.emptyApmSelection();
        }
      }
    },
    select: function select(type, value) {
      if (type === 'hour') {
        if (this.isDisabledHour(value)) {
          return;
        }
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        if (!this.has[value.toLowerCase()]) {
          return;
        }
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      if (this.disabled) {
        return;
      }
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MessageBox__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_toastr__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_calendar__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue2_timepicker__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_numeral_filter__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_currency_input__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_select_dist_vue_select_css__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_multiselect_dist_vue_multiselect_min_css__);























__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_currency_input__["a" /* default */], {
	globalOptions: {
		currency: 'EUR',
		locale: 'sl'
	}
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__filters__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_lodash___default.a, { name: 'lodash' });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_numeral_filter__["a" /* default */], {
	locale: 'sl'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('app-mbox', __WEBPACK_IMPORTED_MODULE_7__components_MessageBox__["a" /* default */]);
__webpack_require__(1117);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('vue-toastr', __WEBPACK_IMPORTED_MODULE_8_vue_toastr__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_11_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-multiselect', __WEBPACK_IMPORTED_MODULE_14_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-timepicker', __WEBPACK_IMPORTED_MODULE_13_vue2_timepicker__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_v_calendar___default.a, {
	locales: {
		'sl-SI': {
			firstDayOfWeek: 2,
			masks: {
				L: 'DD. MM. YYYY',
				weekdays: 'WW'
			}
		}
	}
});

var fb = __webpack_require__(170);

var ebus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, {
	$bus: {
		get: function get() {
			return ebus;
		}
	}
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
	data: function data() {
		return {
			moneyFormatter: new Intl.NumberFormat('sl', { style: 'currency', currency: 'EUR' })
		};
	}
});

var app = void 0;
fb.auth.onAuthStateChanged(function (fbUser) {
	if (!app) {
		if (fbUser) {
			var loginUser = {
				id: fbUser.uid,
				display_name: fbUser.displayName,
				email: fbUser.email,
				phoneNumber: fbUser.phoneNumber,
				photoURL: fbUser.photoURL,
				creationTime: fbUser.metadata.creationTime,
				lastSignInTime: fbUser.metadata.lastSignInTime
			};

			fbUser.getIdToken().then(function (idToken) {
				__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setToken', idToken);
				__WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
				__WEBPACK_IMPORTED_MODULE_9__service__["a" /* default */].getUser(loginUser).then(function (response) {
					loginUser.dbid = response.data.id;
					loginUser.first_name = response.data.first_name;
					loginUser.last_name = response.data.last_name;
					loginUser.role = response.data.role;
					loginUser.last_access_at = response.data.last_access_at;
					loginUser.last_access_ip = response.data.last_access_ip;

					__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setUser', loginUser);
				}).catch(function (error) {
					if (error) {
						__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setUser', null);
						__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setToken', null);
					}
				});
			}).catch(function (error) {
				if (error) {
					__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setUser', null);
					__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setToken', null);
				}
			});
		} else {
			__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setUser', null);
			__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setToken', null);
		}
		if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.token) {
			__WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.token;
		}
		app = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
			el: '#app',
			router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
			store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
			template: '<App/>',
			components: {
				App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
			},
			created: function created() {}
		});
	}
});

fb.auth.onIdTokenChanged(function (fbUser) {
	if (fbUser) {
		fbUser.getIdToken().then(function (idToken) {
			__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setToken', idToken);
			__WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + idToken;
		}).catch(function (error) {
			if (error) {
				console.error(error);
			}
		});
	}
});

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a0872c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(623)
  __webpack_require__(625)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a0872c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a0872c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */,
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Full__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Dashboard__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Tabla__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Izdaja__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Kupci__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Prilivi__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Profile__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Uporabniki__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Login__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Povracila__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Aktivnosti__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_HotelGum__ = __webpack_require__(1064);



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
	mode: 'hash',
	linkActiveClass: 'open active',
	scrollBehavior: function scrollBehavior() {
		return { y: 0 };
	},
	routes: [{
		path: '/',
		name: 'Zaloga',
		redirect: function redirect(to) {
			if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user) {
				return 'auth';
			} else if (__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].hotelGumRoles.includes(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user.role)) {
				return 'hotel';
			} else if (__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].poprodajaRoles.includes(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user.role)) {
				return 'izdaja';
			} else {
				return 'dashboard';
			}
		},
		component: __WEBPACK_IMPORTED_MODULE_4__containers_Full__["a" /* default */],
		children: [{
			path: '/dashboard',
			name: 'Domov',
			component: __WEBPACK_IMPORTED_MODULE_5__views_Dashboard__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles)
			}
		}, {
			path: '/aktivnosti',
			name: 'Aktivnosti',
			component: __WEBPACK_IMPORTED_MODULE_14__views_Aktivnosti__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles)
			}
		}, {
			path: '/tabla',
			name: 'Tabla vozil',
			component: __WEBPACK_IMPORTED_MODULE_6__views_Tabla__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles)
			}
		}, {
			path: '/izdaja',
			name: 'Izdaja vozil',
			component: __WEBPACK_IMPORTED_MODULE_7__views_Izdaja__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].poprodajaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles))
			}
		}, {
			path: '/kupci',
			name: 'Kupci',
			component: __WEBPACK_IMPORTED_MODULE_8__views_Kupci__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles)
			}
		}, {
			path: '/prilivi',
			name: 'Prilivi',
			component: __WEBPACK_IMPORTED_MODULE_9__views_Prilivi__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles)
			}
		}, {
			path: '/povracila',
			name: 'Povracila',
			component: __WEBPACK_IMPORTED_MODULE_13__views_Povracila__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles)
			}
		}, {
			path: '/profile',
			name: 'Profil',
			component: __WEBPACK_IMPORTED_MODULE_10__views_Profile__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].vozilaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles)
			}
		}, {
			path: '/nastavitve',
			redirect: '/nastavitve/uporabniki',
			name: 'Nastavitve',
			component: {
				render: function render(c) {
					return c('router-view');
				}
			},
			children: [{
				path: 'uporabniki',
				name: 'Uporabniki',
				component: __WEBPACK_IMPORTED_MODULE_11__views_Uporabniki__["a" /* default */]
			}],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles
			}
		}, {
			path: '/hotel',
			name: 'Hotel gum',
			component: __WEBPACK_IMPORTED_MODULE_15__views_HotelGum__["a" /* default */],
			meta: {
				requiresAuth: true,
				permissions: __WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].poprodajaRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].hotelGumRoles.concat(__WEBPACK_IMPORTED_MODULE_3__settings_js__["a" /* default */].highPermissionsRoles))
			}
		}]
	}, {
		path: '/auth',
		redirect: '/auth/login',
		name: 'Auth',
		component: {
			render: function render(c) {
				return c('router-view');
			}
		},
		children: [{
			path: '/auth/login',
			name: 'Prijava',
			component: __WEBPACK_IMPORTED_MODULE_12__views_Login__["a" /* default */]
		}]
	}]
});
router.beforeEach(function (to, from, next) {
	var requiresAuth = to.matched.some(function (record) {
		return record.meta.requiresAuth;
	});
	if (requiresAuth && !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user) {
		next('/auth/login');
	} else {
		var isAccessDenied = to.matched.some(function (record) {
			if (record.meta.permissions) {
				return !record.meta.permissions.includes(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user.role);
			} else {
				return false;
			}
		});
		if (isAccessDenied) {
			next(false);
		} else {
			next();
		}
	}
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4185740a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4185740a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4185740a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f609a0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f609a0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f609a0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6053ffd2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6053ffd2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6053ffd2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{key:item.name,staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de9d752_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de9d752_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de9d752_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4315dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4315dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4315dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"https://avtotehnika-celje.si"}},[_vm._v("ATC Tabla vozil")]),_vm._v(" © 2018 Avtotehnika Celje d.o.o.")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"https://avtotehnika-celje.si"}},[_vm._v("ATC BI")])])])}]


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e576152_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e576152_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e576152_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1aeca92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(644)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1aeca92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1aeca92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[(_vm.user.photoURL === null || _vm.user.photoURL === '')?_c('div',{staticClass:"avatar_hrs avatar-bg"},[_vm._v(_vm._s(_vm._f("short_name")(_vm.user.display_name)))]):_c('img',{staticClass:"img-avatar",attrs:{"src":_vm.user.photoURL,"alt":_vm.user.email}})]),_vm._v(" "),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v(_vm._s(_vm.user.display_name))])]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-envelope-o"}),_vm._v(" Obvestila"),_c('b-badge',{attrs:{"variant":"success"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":"/profile"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Profil")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logOut}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Odjava")])],2)}
var staticRenderFns = []


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{staticClass:"d-md-down-none"},[_c('i',{staticClass:"icon-bell"})]),_vm._v(" "),_c('HeaderDropdown')],1),_vm._v(" "),_c('button',{staticClass:"navbar-toggler aside-menu-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})])],1)}
var staticRenderFns = []


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d54cc7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(660)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d54cc7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d54cc7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b759259_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b759259_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b759259_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7effc454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7effc454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7effc454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efd91af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efd91af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efd91af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45013087_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45013087_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45013087_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ccee04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ccee04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ccee04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f43544f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f43544f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f43544f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n\t\t\t"),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n\t\t\t"),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607eba8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607eba8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607eba8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n\t\t\t\t"+_vm._s(_vm.name)+"\n\t\t\t")])]:[_vm._v("\n\t\t\t"+_vm._s(_vm.name)+"\n\t\t")]],2)}
var staticRenderFns = []


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7348862c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7348862c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7348862c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:(item.label)?[_c('SidebarNavLabel',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"label":item.label,"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(332);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6caf4bce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6caf4bce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6caf4bce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa05a12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(694)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa05a12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa05a12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine1ChartExample_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine1ChartExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 342,
	"./af.js": 342,
	"./ar": 343,
	"./ar-dz": 344,
	"./ar-dz.js": 344,
	"./ar-kw": 345,
	"./ar-kw.js": 345,
	"./ar-ly": 346,
	"./ar-ly.js": 346,
	"./ar-ma": 347,
	"./ar-ma.js": 347,
	"./ar-sa": 348,
	"./ar-sa.js": 348,
	"./ar-tn": 349,
	"./ar-tn.js": 349,
	"./ar.js": 343,
	"./az": 350,
	"./az.js": 350,
	"./be": 351,
	"./be.js": 351,
	"./bg": 352,
	"./bg.js": 352,
	"./bm": 353,
	"./bm.js": 353,
	"./bn": 354,
	"./bn.js": 354,
	"./bo": 355,
	"./bo.js": 355,
	"./br": 356,
	"./br.js": 356,
	"./bs": 357,
	"./bs.js": 357,
	"./ca": 358,
	"./ca.js": 358,
	"./cs": 359,
	"./cs.js": 359,
	"./cv": 360,
	"./cv.js": 360,
	"./cy": 361,
	"./cy.js": 361,
	"./da": 362,
	"./da.js": 362,
	"./de": 363,
	"./de-at": 364,
	"./de-at.js": 364,
	"./de-ch": 365,
	"./de-ch.js": 365,
	"./de.js": 363,
	"./dv": 366,
	"./dv.js": 366,
	"./el": 367,
	"./el.js": 367,
	"./en-SG": 368,
	"./en-SG.js": 368,
	"./en-au": 369,
	"./en-au.js": 369,
	"./en-ca": 370,
	"./en-ca.js": 370,
	"./en-gb": 371,
	"./en-gb.js": 371,
	"./en-ie": 372,
	"./en-ie.js": 372,
	"./en-il": 373,
	"./en-il.js": 373,
	"./en-nz": 374,
	"./en-nz.js": 374,
	"./eo": 375,
	"./eo.js": 375,
	"./es": 376,
	"./es-do": 377,
	"./es-do.js": 377,
	"./es-us": 378,
	"./es-us.js": 378,
	"./es.js": 376,
	"./et": 379,
	"./et.js": 379,
	"./eu": 380,
	"./eu.js": 380,
	"./fa": 381,
	"./fa.js": 381,
	"./fi": 382,
	"./fi.js": 382,
	"./fo": 383,
	"./fo.js": 383,
	"./fr": 384,
	"./fr-ca": 385,
	"./fr-ca.js": 385,
	"./fr-ch": 386,
	"./fr-ch.js": 386,
	"./fr.js": 384,
	"./fy": 387,
	"./fy.js": 387,
	"./ga": 388,
	"./ga.js": 388,
	"./gd": 389,
	"./gd.js": 389,
	"./gl": 390,
	"./gl.js": 390,
	"./gom-latn": 391,
	"./gom-latn.js": 391,
	"./gu": 392,
	"./gu.js": 392,
	"./he": 393,
	"./he.js": 393,
	"./hi": 394,
	"./hi.js": 394,
	"./hr": 395,
	"./hr.js": 395,
	"./hu": 396,
	"./hu.js": 396,
	"./hy-am": 397,
	"./hy-am.js": 397,
	"./id": 398,
	"./id.js": 398,
	"./is": 399,
	"./is.js": 399,
	"./it": 400,
	"./it-ch": 401,
	"./it-ch.js": 401,
	"./it.js": 400,
	"./ja": 402,
	"./ja.js": 402,
	"./jv": 403,
	"./jv.js": 403,
	"./ka": 404,
	"./ka.js": 404,
	"./kk": 405,
	"./kk.js": 405,
	"./km": 406,
	"./km.js": 406,
	"./kn": 407,
	"./kn.js": 407,
	"./ko": 408,
	"./ko.js": 408,
	"./ku": 409,
	"./ku.js": 409,
	"./ky": 410,
	"./ky.js": 410,
	"./lb": 411,
	"./lb.js": 411,
	"./lo": 412,
	"./lo.js": 412,
	"./lt": 413,
	"./lt.js": 413,
	"./lv": 414,
	"./lv.js": 414,
	"./me": 415,
	"./me.js": 415,
	"./mi": 416,
	"./mi.js": 416,
	"./mk": 417,
	"./mk.js": 417,
	"./ml": 418,
	"./ml.js": 418,
	"./mn": 419,
	"./mn.js": 419,
	"./mr": 420,
	"./mr.js": 420,
	"./ms": 421,
	"./ms-my": 422,
	"./ms-my.js": 422,
	"./ms.js": 421,
	"./mt": 423,
	"./mt.js": 423,
	"./my": 424,
	"./my.js": 424,
	"./nb": 425,
	"./nb.js": 425,
	"./ne": 426,
	"./ne.js": 426,
	"./nl": 427,
	"./nl-be": 428,
	"./nl-be.js": 428,
	"./nl.js": 427,
	"./nn": 429,
	"./nn.js": 429,
	"./pa-in": 430,
	"./pa-in.js": 430,
	"./pl": 431,
	"./pl.js": 431,
	"./pt": 432,
	"./pt-br": 433,
	"./pt-br.js": 433,
	"./pt.js": 432,
	"./ro": 434,
	"./ro.js": 434,
	"./ru": 435,
	"./ru.js": 435,
	"./sd": 436,
	"./sd.js": 436,
	"./se": 437,
	"./se.js": 437,
	"./si": 438,
	"./si.js": 438,
	"./sk": 439,
	"./sk.js": 439,
	"./sl": 440,
	"./sl.js": 440,
	"./sq": 441,
	"./sq.js": 441,
	"./sr": 442,
	"./sr-cyrl": 443,
	"./sr-cyrl.js": 443,
	"./sr.js": 442,
	"./ss": 444,
	"./ss.js": 444,
	"./sv": 445,
	"./sv.js": 445,
	"./sw": 446,
	"./sw.js": 446,
	"./ta": 447,
	"./ta.js": 447,
	"./te": 448,
	"./te.js": 448,
	"./tet": 449,
	"./tet.js": 449,
	"./tg": 450,
	"./tg.js": 450,
	"./th": 451,
	"./th.js": 451,
	"./tl-ph": 452,
	"./tl-ph.js": 452,
	"./tlh": 453,
	"./tlh.js": 453,
	"./tr": 454,
	"./tr.js": 454,
	"./tzl": 455,
	"./tzl.js": 455,
	"./tzm": 456,
	"./tzm-latn": 457,
	"./tzm-latn.js": 457,
	"./tzm.js": 456,
	"./ug-cn": 458,
	"./ug-cn.js": 458,
	"./uk": 459,
	"./uk.js": 459,
	"./ur": 460,
	"./ur.js": 460,
	"./uz": 461,
	"./uz-latn": 462,
	"./uz-latn.js": 462,
	"./uz.js": 461,
	"./vi": 463,
	"./vi.js": 463,
	"./x-pseudo": 464,
	"./x-pseudo.js": 464,
	"./yo": 465,
	"./yo.js": 465,
	"./zh-cn": 466,
	"./zh-cn.js": 466,
	"./zh-hk": 467,
	"./zh-hk.js": 467,
	"./zh-tw": 468,
	"./zh-tw.js": 468
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 720;

/***/ }),
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.1.0","/home/node/app"]],"_from":"vue-chartjs@3.1.0","_id":"vue-chartjs@3.1.0","_inBundle":false,"_integrity":"sha512-cp70zluNJdN57J907hSzjp4jayF6O0ayBJ/alZprHx+BvbVe+nL+QF3TOPSSao3UoenCopYJybmDi/RWYb7afw==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.1.0","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.1.0","saveSpec":null,"fetchSpec":"3.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.1.0.tgz","_spec":"3.1.0","_where":"/home/node/app","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.1.0"}

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine2ChartExample_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine2ChartExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine3ChartExample_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine3ChartExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartExample_vue__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__ = __webpack_require__(472);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialBoxChartExample_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialBoxChartExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalloutChartExample_vue__ = __webpack_require__(474);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalloutChartExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('b-dropdown',{staticClass:"float-right",attrs:{"variant":"transparent p-0","right":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"icon-settings"})]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Another action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Something else here...")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":""}},[_vm._v("Disabled action")])],2),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v("9.823")]),_vm._v(" "),_c('p',[_vm._v("April")])],1),_vm._v(" "),_c('card-line1-chart-example',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"70px"},attrs:{"height":"70"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-info",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('b-dropdown',{staticClass:"float-right",attrs:{"variant":"transparent p-0","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"icon-location-pin"})]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Another action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Something else here...")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":""}},[_vm._v("Disabled action")])],2),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v("9.823")]),_vm._v(" "),_c('p',[_vm._v("Marec")])],1),_vm._v(" "),_c('card-line2-chart-example',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"70px"},attrs:{"height":"70"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-warning",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('b-dropdown',{staticClass:"float-right",attrs:{"variant":"transparent p-0","right":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"icon-settings"})]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Another action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Something else here...")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":""}},[_vm._v("Disabled action")])],2),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v("9.823")]),_vm._v(" "),_c('p',[_vm._v("Februar")])],1),_vm._v(" "),_c('card-line3-chart-example',{staticClass:"chart-wrapper",staticStyle:{"height":"70px"},attrs:{"height":"70"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-danger",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('b-dropdown',{staticClass:"float-right",attrs:{"variant":"transparent p-0","right":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"icon-settings"})]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Another action")]),_vm._v(" "),_c('b-dropdown-item',[_vm._v("Something else here...")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":""}},[_vm._v("Disabled action")])],2),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v("9.823")]),_vm._v(" "),_c('p',[_vm._v("Januar")])],1),_vm._v(" "),_c('card-bar-chart-example',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"70px"},attrs:{"height":"70"}})],1)],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('h4',{staticClass:"card-title mb-0",attrs:{"id":"traffic"}},[_vm._v("Promet")]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("April 2018")])]),_vm._v(" "),_c('b-col',{staticClass:"d-none d-md-block",attrs:{"sm":"7"}},[_c('b-button',{staticClass:"float-right",attrs:{"type":"button","variant":"primary"}},[_c('i',{staticClass:"icon-cloud-download"})]),_vm._v(" "),_c('b-button-toolbar',{staticClass:"float-right",attrs:{"aria-label":"Toolbar with buttons group"}},[_c('b-form-radio-group',{staticClass:"mr-3",attrs:{"id":"radiosBtn","buttons":"","button-variant":"outline-secondary","name":"radiosBtn"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('b-form-radio',{staticClass:"mx-0",attrs:{"value":"Day"}},[_vm._v("Dan")]),_vm._v(" "),_c('b-form-radio',{staticClass:"mx-0",attrs:{"value":"Month"}},[_vm._v("Mesec")]),_vm._v(" "),_c('b-form-radio',{staticClass:"mx-0",attrs:{"value":"Year"}},[_vm._v("Leto")])],1)],1)],1)],1),_vm._v(" "),_c('main-chart-example',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"height":"300"}}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('ul',[_c('li',[_c('div',{staticClass:"text-muted"},[_vm._v("Prodaja")]),_vm._v(" "),_c('strong',[_vm._v("29.703 Vozil (40%)")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"height":"{}","precision":1,"variant":"success","value":40}})],1),_vm._v(" "),_c('li',{staticClass:"d-none d-md-table-cell"},[_c('div',{staticClass:"text-muted"},[_vm._v("Priliv")]),_vm._v(" "),_c('strong',[_vm._v("4.093 Vozil (5%)")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"height":"{}","precision":1,"variant":"info","value":5}})],1),_vm._v(" "),_c('li',[_c('div',{staticClass:"text-muted"},[_vm._v("Novi")]),_vm._v(" "),_c('strong',[_vm._v("78.706 Vozil (60%)")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"height":"{}","precision":1,"variant":"warning","value":60}})],1),_vm._v(" "),_c('li',{staticClass:"d-none d-md-table-cell"},[_c('div',{staticClass:"text-muted"},[_vm._v("Rabljenih")]),_vm._v(" "),_c('strong',[_vm._v("22.123 Vozil (80%)")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"height":"{}","precision":1,"variant":"danger","value":80}})],1),_vm._v(" "),_c('li',{staticClass:"d-none d-md-table-cell"},[_c('div',{staticClass:"text-muted"},[_vm._v("Uspešnost")]),_vm._v(" "),_c('strong',[_vm._v("40.15%")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"height":"{}","precision":1,"value":40}})],1)])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{attrs:{"header":"Promet & Prodaja"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"4"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('Callout',{attrs:{"variant":"info"}},[_c('small',{staticClass:"text-muted"},[_vm._v("Nova vozila")]),_c('br'),_vm._v(" "),_c('strong',{staticClass:"h4"},[_vm._v("9,123")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('callout-chart-example',{attrs:{"data":[35, 23, 56, 22, 97, 23, 64],"variant":"#20a8d8","width":"80","height":"30"}})],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('Callout',{attrs:{"variant":"danger"}},[_c('small',{staticClass:"text-muted"},[_vm._v("Rabljena vozila")]),_c('br'),_vm._v(" "),_c('strong',{staticClass:"h4"},[_vm._v("22,643")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('callout-chart-example',{attrs:{"data":[65, 59, 84, 84, 51, 55, 40],"variant":"#f86c6b","width":"80","height":"30"}})],1)])],1)],1),_vm._v(" "),_c('hr',{staticClass:"mt-0"}),_vm._v(" "),_c('ul',{staticClass:"horizontal-bars"},[_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tPonedeljek\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":34,"variant":"info"}}),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":78,"variant":"danger"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tTorek\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":56,"variant":"info"}}),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":94,"variant":"danger"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tSreda\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":12,"variant":"info"}}),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":67,"variant":"danger"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tČetrtek\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":43,"variant":"info"}}),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":91,"variant":"danger"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tPetek\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":22,"variant":"info"}}),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":73,"variant":"danger"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tSobota\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":53,"variant":"info"}}),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":82,"variant":"danger"}})],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tNedelja\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":9,"variant":"info"}}),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":69,"variant":"danger"}})],1)]),_vm._v(" "),_c('li',{staticClass:"legend"},[_c('b-badge',{attrs:{"pill":"","variant":"info"}}),_vm._v(" "),_c('small',[_vm._v("Nova vozila")]),_vm._v("   "),_c('b-badge',{attrs:{"pill":"","variant":"danger"}}),_vm._v(" "),_c('small',[_vm._v("Rabljena vozila")])],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"4"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('Callout',{attrs:{"variant":"warning"}},[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem")]),_c('br'),_vm._v(" "),_c('strong',{staticClass:"h4"},[_vm._v("78,623")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('callout-chart-example',{attrs:{"data":[35, 23, 56, 22, 97, 23, 64],"variant":"#f8cb00","width":"80","height":"30"}})],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('Callout',{attrs:{"variant":"success"}},[_c('small',{staticClass:"text-muted"},[_vm._v("Ipsom")]),_c('br'),_vm._v(" "),_c('strong',{staticClass:"h4"},[_vm._v("49,123")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('callout-chart-example',{attrs:{"data":[65, 59, 84, 84, 51, 55, 40],"variant":"#4dbd74","width":"80px","height":"30"}})],1)])],1)],1),_vm._v(" "),_c('hr',{staticClass:"mt-0"}),_vm._v(" "),_c('ul',{staticClass:"horizontal-bars type-2"},[_c('li',[_c('i',{staticClass:"icon-user"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Renaul")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("43%")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":43,"variant":"warning"}})],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-user-female"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Nissan")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("37%")]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":37,"variant":"warning"}})],1)]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-user"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("VW")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("191,235 "),_c('span',{staticClass:"text-muted small"},[_vm._v("(56%)")])]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":56,"variant":"success"}})],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-user"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("BMW")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("51,223 "),_c('span',{staticClass:"text-muted small"},[_vm._v("(15%)")])]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":15,"variant":"success"}})],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-user"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Toyota")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("37,564 "),_c('span',{staticClass:"text-muted small"},[_vm._v("(11%)")])]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":11,"variant":"success"}})],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-user"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Audi")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("27,319 "),_c('span',{staticClass:"text-muted small"},[_vm._v("(8%)")])]),_vm._v(" "),_c('div',{staticClass:"bars"},[_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","value":8,"variant":"success"}})],1)]),_vm._v(" "),_c('li',{staticClass:"divider text-center"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link","size":"sm"}},[_c('i',{staticClass:"icon-options"})])],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"4"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('Callout',[_c('small',{staticClass:"text-muted"},[_vm._v("CTR")]),_c('br'),_vm._v(" "),_c('strong',{staticClass:"h4"},[_vm._v("23%")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('callout-chart-example',{attrs:{"data":[78, 81, 80, 45, 34, 12, 40],"width":"80px","height":"30"}})],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('Callout',{attrs:{"variant":"primary"}},[_c('small',{staticClass:"text-muted"},[_vm._v("Rate")]),_c('br'),_vm._v(" "),_c('strong',{staticClass:"h4"},[_vm._v("5%")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('callout-chart-example',{attrs:{"data":[35, 23, 56, 22, 97, 23, 64],"variant":"#20a8d8","width":"80px","height":"30"}})],1)])],1)],1),_vm._v(" "),_c('hr',{staticClass:"mt-0"}),_vm._v(" "),_c('ul',{staticClass:"icons-list"},[_c('li',[_c('i',{staticClass:"icon-screen-desktop bg-primary"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title"},[_vm._v("Renault Clio")]),_vm._v(" "),_c('small',[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"small text-muted"},[_vm._v("Prodanih ta mesec")]),_vm._v(" "),_c('strong',[_vm._v("1.924")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link"}},[_c('i',{staticClass:"icon-settings"})])],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-screen-smartphone bg-info"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title"},[_vm._v("Renault Megan")]),_vm._v(" "),_c('small',[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"small text-muted"},[_vm._v("Prodanih ta mesec")]),_vm._v(" "),_c('strong',[_vm._v("1.224")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link"}},[_c('i',{staticClass:"icon-settings"})])],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-screen-smartphone bg-warning"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title"},[_vm._v("Renault Laguna")]),_vm._v(" "),_c('small',[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"small text-muted"},[_vm._v("Prodanih ta mesec")]),_vm._v(" "),_c('strong',[_vm._v("1.163")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link"}},[_c('i',{staticClass:"icon-settings"})])],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-user bg-danger"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title"},[_vm._v("Renault Koleos")]),_vm._v(" "),_c('small',[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"small text-muted"},[_vm._v("Prodanih ta mesec")]),_vm._v(" "),_c('strong',[_vm._v("928")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link"}},[_c('i',{staticClass:"icon-settings"})])],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-social-spotify bg-success"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title"},[_vm._v("Renault Captur")]),_vm._v(" "),_c('small',[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"small text-muted"},[_vm._v("Prodanih ta mesec")]),_vm._v(" "),_c('strong',[_vm._v("893")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link"}},[_c('i',{staticClass:"icon-settings"})])],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-cloud-download bg-danger"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title"},[_vm._v("Nissan Juke")]),_vm._v(" "),_c('small',[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"small text-muted"},[_vm._v("Prodanih ta mesec")]),_vm._v(" "),_c('strong',[_vm._v("121.924")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link"}},[_c('i',{staticClass:"icon-settings"})])],1)]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon-camera bg-warning"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title"},[_vm._v("Nissan Qashqai")]),_vm._v(" "),_c('small',[_vm._v("Lorem ipsum dolor sit amet")])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"small text-muted"},[_vm._v("Prodanih ta mesec")]),_vm._v(" "),_c('strong',[_vm._v("12.125")])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"variant":"link"}},[_c('i',{staticClass:"icon-settings"})])],1)]),_vm._v(" "),_c('li',{staticClass:"divider text-center"},[_c('b-button',{staticClass:"text-muted",attrs:{"size":"sm","variant":"link"}},[_c('i',{staticClass:"icon-options"})])],1)])],1)],1),_vm._v(" "),_c('b-table',{staticClass:"mb-0 table-outline",attrs:{"responsive":"sm","hover":"","items":_vm.tableItems,"fields":_vm.tableFields,"head-variant":"light"},scopedSlots:_vm._u([{key:"avatar",fn:function(item){return _c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":item.value.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"avatar-status",class:{ 'bg-success': item.value.status == 'success',	'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }})])}},{key:"user",fn:function(item){return _c('div',{},[_c('div',[_vm._v(_vm._s(item.value.name))]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_c('span',[(item.value.new)?[_vm._v("Novo")]:[_vm._v("Ponovitev")]],2),_vm._v(" | Dodan: "+_vm._s(item.value.registered)+"\n\t\t\t\t\t\t\t")])])}},{key:"country",fn:function(item){return _c('i',{staticClass:"h4 mb-0",class:_vm.flag(item.value.flag),attrs:{"title":item.value.flag,"id":item.value.flag}})}},{key:"usage",fn:function(item){return _c('div',{},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"float-left"},[_c('strong',[_vm._v(_vm._s(item.value.value)+"%")])]),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(item.value.period))])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":_vm.variant(item.value.value)},model:{value:(item.value.value),callback:function ($$v) {_vm.$set(item.value, "value", $$v)},expression:"item.value.value"}})],1)}},{key:"payment",fn:function(item){return _c('i',{class:item.value.icon,staticStyle:{"font-size":"24px"}})}},{key:"activity",fn:function(item){return _c('div',{},[_c('div',{staticClass:"small text-muted"},[_vm._v("Zadnja prijava")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.value))])])}}])},[_c('i',{staticClass:"flag-icon flag-icon-pw h1",attrs:{"title":"pw","id":"pw"}})])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabla_vue__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425a59a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabla_vue__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(759)
  __webpack_require__(760)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-425a59a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabla_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425a59a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabla_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425a59a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabla_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopulateDataModal_vue__ = __webpack_require__(478);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eece7a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateDataModal_vue__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(766)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopulateDataModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eece7a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateDataModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eece7a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateDataModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Osveži podatke","ok-title":"Zaključi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep1),expression:"showStep1"}],staticClass:"dUpload"},[_c('vue-dropzone',{ref:"dzZalogaRenault",staticClass:"dzPopulateData renault",attrs:{"id":"dropzoneZaloga","include-styling":true,"options":_vm.usZalogaRenault}}),_vm._v(" "),_c('vue-dropzone',{ref:"dzProdajaRenault",staticClass:"dzPopulateData renault",attrs:{"id":"dropzoneProdaja","include-styling":true,"options":_vm.usProdajaRenault}}),_vm._v(" "),_c('vue-dropzone',{ref:"dzZalogaDacia",staticClass:"dzPopulateData dacia",attrs:{"id":"dropzoneZaloga","include-styling":true,"options":_vm.usZalogaDacia}}),_vm._v(" "),_c('vue-dropzone',{ref:"dzProdajaDacia",staticClass:"dzPopulateData dacia",attrs:{"id":"dropzoneProdaja","include-styling":true,"options":_vm.usProdajaDacia}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep2),expression:"showStep2"}],staticClass:"dProcessing"},[_vm._v("\n\t\t\tObdelava podatkov ...\n\t\t\t"),_c('b-progress',{staticClass:"mb-2",attrs:{"value":100,"variant":"success","striped":"","animated":_vm.animate}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep3),expression:"showStep3"}],domProps:{"innerHTML":_vm._s(_vm.uploadResultMessage)}})])}
var staticRenderFns = []


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopulateVegaModal_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a235ddd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateVegaModal_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(895)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopulateVegaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a235ddd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateVegaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a235ddd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateVegaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Osveži podatke Vega","ok-title":"Zaključi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep1),expression:"showStep1"}],staticClass:"dUpload"},[_c('vue-dropzone',{ref:"dzVega",staticClass:"dzPopulateData vega",attrs:{"id":"dropzoneVega","include-styling":true,"options":_vm.usVega}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep2),expression:"showStep2"}],staticClass:"dProcessing"},[_vm._v("\n\t\t\tObdelava podatkov ...\n\t\t\t"),_c('b-progress',{staticClass:"mb-2",attrs:{"value":100,"variant":"success","striped":"","animated":_vm.animate}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep3),expression:"showStep3"}],domProps:{"innerHTML":_vm._s(_vm.uploadResultMessage)}}),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type && _vm.message.type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))])],1)}
var staticRenderFns = []


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopulateNissanModal_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d924eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateNissanModal_vue__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(898)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopulateNissanModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d924eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateNissanModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d924eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopulateNissanModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Osveži podatke Nissan","ok-title":"Zaključi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep1),expression:"showStep1"}],staticClass:"dUpload"},[_c('vue-dropzone',{ref:"dzZalogaNissan",staticClass:"dzPopulateData nissan",attrs:{"id":"dropzoneZalogaNissan","include-styling":true,"options":_vm.usZalogaNissan}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep2),expression:"showStep2"}],staticClass:"dProcessing"},[_vm._v("\n\t\t\tObdelava podatkov ...\n\t\t\t"),_c('b-progress',{staticClass:"mb-2",attrs:{"value":100,"variant":"success","striped":"","animated":_vm.animate}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep3),expression:"showStep3"}],domProps:{"innerHTML":_vm._s(_vm.uploadResultMessage)}}),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type && _vm.message.type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))])],1)}
var staticRenderFns = []


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RezervirajVoziloModal_vue__ = __webpack_require__(521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_538d9525_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RezervirajVoziloModal_vue__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(901)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RezervirajVoziloModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_538d9525_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RezervirajVoziloModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_538d9525_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RezervirajVoziloModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.kupciLoading)?_c('div',[_c('loading',{attrs:{"active":_vm.kupciLoading,"is-full-page":false},on:{"update:active":function($event){_vm.kupciLoading=$event}}})],1):_c('div',[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('v-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.userCanEdit),expression:"userCanEdit"}],ref:"kupci",attrs:{"options":_vm.vsiKupci,"label":"full_name","placeholder":"Izberi kupca ..."},on:{"input":_vm.kupciSelect_change,"search":_vm.kupciSelect_search},model:{value:(_vm.izbran_kupec),callback:function ($$v) {_vm.izbran_kupec=$$v},expression:"izbran_kupec"}},[_c('template',{slot:"no-options"},[_vm._v("Kupec ni najden")])],2)],1)],1)],1),_vm._v(" "),(_vm.prikazi_obrazec)?_c('b-form',{on:{"submit":_vm.novKupec_Submit,"reset":_vm.novKupec_Reset}},[((_vm.izbran_kupec == null))?_c('b-form-radio-group',{staticClass:"mb-3",attrs:{"disabled":(_vm.izbran_kupec != null)},model:{value:(_vm.obrazec.is_company),callback:function ($$v) {_vm.$set(_vm.obrazec, "is_company", $$v)},expression:"obrazec.is_company"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v("Fizična oseba")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":true}},[_vm._v("Podjetje")])],1):_vm._e(),_vm._v(" "),(_vm.obrazec.is_company == true)?_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"title"}},[_vm._v("Naziv")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"title","type":"text","required":"","min":"2","max":"150","disabled":(_vm.izbran_kupec != null),"placeholder":"Naziv podjetja"},model:{value:(_vm.obrazec.title),callback:function ($$v) {_vm.$set(_vm.obrazec, "title", $$v)},expression:"obrazec.title"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"contact_name"}},[_vm._v("Kontaktna oseba")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"contact_name","type":"text","required":"","min":"2","max":"150","disabled":(_vm.izbran_kupec != null),"placeholder":"Ime in priimek"},model:{value:(_vm.obrazec.contact_name),callback:function ($$v) {_vm.$set(_vm.obrazec, "contact_name", $$v)},expression:"obrazec.contact_name"}})],1)],1)],1):_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Ime:","label-for":"kupec_ime"}},[_c('b-form-input',{attrs:{"id":"kupec_ime","type":"text","required":"","min":"2","max":"150","disabled":(_vm.izbran_kupec != null),"placeholder":"Ime kupca"},model:{value:(_vm.obrazec.first_name),callback:function ($$v) {_vm.$set(_vm.obrazec, "first_name", $$v)},expression:"obrazec.first_name"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Priimek:","label-for":"kupec_priimek"}},[_c('b-form-input',{attrs:{"id":"kupec_priimek","type":"text","required":"","min":"2","max":"150","disabled":(_vm.izbran_kupec != null),"placeholder":"Priimek kupca"},model:{value:(_vm.obrazec.last_name),callback:function ($$v) {_vm.$set(_vm.obrazec, "last_name", $$v)},expression:"obrazec.last_name"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email:","label-for":"kupec_email"}},[_c('b-form-input',{attrs:{"id":"kupec_email","type":"email","required":"","disabled":(_vm.izbran_kupec != null),"placeholder":"Elektronski naslov kupca"},model:{value:(_vm.obrazec.email),callback:function ($$v) {_vm.$set(_vm.obrazec, "email", $$v)},expression:"obrazec.email"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Telefonska številka:","label-for":"kupec_telefon"}},[_c('b-form-input',{attrs:{"id":"kupec_telefon","type":"text","disabled":(_vm.izbran_kupec != null),"placeholder":"Telefonska številka kupca"},model:{value:(_vm.obrazec.phone_number),callback:function ($$v) {_vm.$set(_vm.obrazec, "phone_number", $$v)},expression:"obrazec.phone_number"}})],1)],1),_vm._v(" "),_c('b-col')],1),_vm._v(" "),((_vm.izbran_kupec == null))?_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"mr-2",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Dodaj")]),_vm._v(" "),_c('b-button',{staticClass:"mr-2",attrs:{"type":"reset","variant":"danger"}},[_vm._v("Počisti")])],1)],1):_vm._e()],1):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Rezerviraj vozilo","busy":_vm.in_progress,"ok-title":"Potrdi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Prodajalec")]),_vm._v(" "),_c('v-select',{ref:"prodajalci",attrs:{"options":_vm.vsiProdajalci,"disabled":_vm.prodajalci_disabled,"label":"full_name","placeholder":"Izberi prodajalca ..."},model:{value:(_vm.prodajalci_selected),callback:function ($$v) {_vm.prodajalci_selected=$$v},expression:"prodajalci_selected"}})],1)],1)],1),_vm._v(" "),_c('pick-kupec-inline',{ref:"pickKupec",attrs:{"kupci":_vm.kupci,"title":"Kupec"},model:{value:(_vm.kupec_selected),callback:function ($$v) {_vm.kupec_selected=$$v},expression:"kupec_selected"}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',{attrs:{"for":"trajanje"}},[_vm._v("Čas rezervacije (v dneh)")]),_vm._v(" "),_c('b-form-input',{attrs:{"disabled":_vm.trajanja_disabled,"type":"number","id":"trajanje","placeholder":"Trajanje rezervacije v dneh"},model:{value:(_vm.trajanje_value),callback:function ($$v) {_vm.trajanje_value=$$v},expression:"trajanje_value"}})],1)],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.action_message_type && _vm.action_message_type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.action_message && _vm.action_message !== ''}},[_vm._v(_vm._s(_vm.action_message))])],1)}
var staticRenderFns = []


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdajVoziloModal_vue__ = __webpack_require__(523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609b3848_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProdajVoziloModal_vue__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(906)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdajVoziloModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609b3848_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProdajVoziloModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609b3848_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProdajVoziloModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Prodaj vozilo","busy":_vm.in_progress,"ok-title":"Potrdi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('b-form',{ref:"form"},[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Prodajalec")]),_vm._v(" "),_c('v-select',{ref:"prodajalci",attrs:{"options":_vm.vsiProdajalci,"disabled":_vm.prodajalci_disabled,"label":"full_name","placeholder":"Izberi prodajalca ..."},model:{value:(_vm.prodajalci_selected),callback:function ($$v) {_vm.prodajalci_selected=$$v},expression:"prodajalci_selected"}})],1)],1)],1),_vm._v(" "),_c('pick-kupec-inline',{directives:[{name:"show",rawName:"v-show",value:(!_vm.external),expression:"!external"}],ref:"pickKupec",attrs:{"kupci":_vm.kupci,"title":"Kupec"},model:{value:(_vm.kupec_selected),callback:function ($$v) {_vm.kupec_selected=$$v},expression:"kupec_selected"}}),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.external),expression:"external"}]},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Kupec:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.externalKupecHr),callback:function ($$v) {_vm.externalKupecHr=$$v},expression:"externalKupecHr"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Datum prodaje*:","label-for":"datum_prodaje"}},[_c('b-form-input',{ref:"datum_prodaje",attrs:{"id":"datum_prodaje","type":"date","required":"","placeholder":"Datum prodaje"},model:{value:(_vm.datum_prodaje),callback:function ($$v) {_vm.datum_prodaje=$$v},expression:"datum_prodaje"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Datum planirane izdaje*:","label-for":"datum_planirane_izdaje"}},[_c('b-form-input',{ref:"datum_planirane_izdaje",attrs:{"id":"datum_planirane_izdaje","type":"date","required":"","placeholder":"Datum planirane izdaje"},model:{value:(_vm.datum_planirane_izdaje),callback:function ($$v) {_vm.datum_planirane_izdaje=$$v},expression:"datum_planirane_izdaje"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Urejeno financiranje*:"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',{model:{value:(_vm.urejeno_financiranje),callback:function ($$v) {_vm.urejeno_financiranje=$$v},expression:"urejeno_financiranje"}},[_c('b-form-radio',{attrs:{"value":"true"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"false"}},[_vm._v("Ne")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Vloženo*:"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',{model:{value:(_vm.vlozeno),callback:function ($$v) {_vm.vlozeno=$$v},expression:"vlozeno"}},[_c('b-form-radio',{attrs:{"value":"true"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"false"}},[_vm._v("Ne")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Podpisano*:"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',{model:{value:(_vm.podpisano),callback:function ($$v) {_vm.podpisano=$$v},expression:"podpisano"}},[_c('b-form-radio',{attrs:{"value":"true"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"false"}},[_vm._v("Ne")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Financiranje RCI*:"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',{model:{value:(_vm.financiranje_rci),callback:function ($$v) {_vm.financiranje_rci=$$v},expression:"financiranje_rci"}},[_c('b-form-radio',{attrs:{"value":"true"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"false"}},[_vm._v("Ne")])],1)],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.action_message_type && _vm.action_message_type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.action_message && _vm.action_message !== ''}},[_vm._v(_vm._s(_vm.action_message))])],1)],1)}
var staticRenderFns = []


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DobavavKoncesijoModal_vue__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a8f565_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DobavavKoncesijoModal_vue__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(909)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DobavavKoncesijoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a8f565_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DobavavKoncesijoModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a8f565_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DobavavKoncesijoModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Dobava v koncesijo","ok-title":"Potrdi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Lokacija")]),_vm._v(" "),_c('v-select',{ref:"lokacija",attrs:{"options":_vm.lokacija_options,"placeholder":"Izberi lokacijo ..."},model:{value:(_vm.lokacija_selected),callback:function ($$v) {_vm.lokacija_selected=$$v},expression:"lokacija_selected"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Datum dobave:","label-for":"datum_dobave"}},[_c('b-form-input',{ref:"datum_dobave",attrs:{"id":"datum_dobave","type":"date","required":"","placeholder":"Datum dobave"},model:{value:(_vm.datum_dobave),callback:function ($$v) {_vm.datum_dobave=$$v},expression:"datum_dobave"}})],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZadrzanoModal_vue__ = __webpack_require__(525);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908633dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZadrzanoModal_vue__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(912)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZadrzanoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908633dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZadrzanoModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908633dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZadrzanoModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Zadrži vozilo","ok-title":"Potrdi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Lastnik")]),_vm._v(" "),_c('v-select',{ref:"lastnik",attrs:{"options":_vm.lastnik_options,"placeholder":"Izberi lastnika ..."},model:{value:(_vm.lastnik_selected),callback:function ($$v) {_vm.lastnik_selected=$$v},expression:"lastnik_selected"}})],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StanjeFilterDropdown_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e674c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StanjeFilterDropdown_vue__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(915)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StanjeFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e674c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StanjeFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e674c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StanjeFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Stanje")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusFilterDropdown_vue__ = __webpack_require__(527);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357196c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusFilterDropdown_vue__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(918)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357196c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357196c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Status")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LokacijeFilterDropdown_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e652720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LokacijeFilterDropdown_vue__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(921)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LokacijeFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e652720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LokacijeFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e652720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LokacijeFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",staticClass:"m-2",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Lokacija")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdajaFilterDropdown_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6892548e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProdajaFilterDropdown_vue__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(924)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdajaFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6892548e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProdajaFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6892548e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProdajaFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",staticClass:"m-2",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Status prodaje")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpombaVozilaModal_vue__ = __webpack_require__(530);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ecfb6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpombaVozilaModal_vue__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(927)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpombaVozilaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ecfb6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpombaVozilaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ecfb6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpombaVozilaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Opomba vozila","ok-title":"Posodobi","cancel-title":"Prekliči"},on:{"ok":_vm.onOkModal}},[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',{attrs:{"for":"opomba"}},[_vm._v("Opomba")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"opomba","type":"text","max":"5000"},model:{value:(_vm.opomba),callback:function ($$v) {_vm.opomba=$$v},expression:"opomba"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"akcijski"}},[_vm._v("Akcijski:")])]),_vm._v(" "),_c('b-col',[_c('b-form-group',[_c('b-form-checkbox',{attrs:{"id":"akcijski","value":"1","unchecked-value":"0"},model:{value:(_vm.akcijski),callback:function ($$v) {_vm.akcijski=$$v},expression:"akcijski"}})],1)],1),_vm._v(" "),_c('b-col'),_vm._v(" "),_c('b-col')],1)],1)}
var staticRenderFns = []


/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlacilaModal_vue__ = __webpack_require__(533);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb646b5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlacilaModal_vue__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(932)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bb646b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlacilaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb646b5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlacilaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb646b5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlacilaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */,
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Plačilo","ok-title":"Potrdi","cancel-title":"Prekliči","size":"lg"},on:{"hidden":_vm.onHiddenModal}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Prodajalec:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.prodajalec),callback:function ($$v) {_vm.prodajalec=$$v},expression:"prodajalec"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Kupec:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.kupec),callback:function ($$v) {_vm.kupec=$$v},expression:"kupec"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Šasija:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.ogrodje),callback:function ($$v) {_vm.ogrodje=$$v},expression:"ogrodje"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Vozilo:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.vozilo),callback:function ($$v) {_vm.vozilo=$$v},expression:"vozilo"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Št. računa (RNS):"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.st_racuna),callback:function ($$v) {_vm.st_racuna=$$v},expression:"st_racuna"}})],1)],1),_vm._v(" "),(_vm.showUpdateFromMFilesButton)?_c('b-col',{staticClass:"cUpdate",attrs:{"cols":"1"}},[_c('b-button',{ref:"aUpdate",staticClass:"bUpdate",attrs:{"data-style":"zoom-in","size":"sm","title":"Pridobi podatke iz M-Files"},on:{"click":function($event){$event.stopPropagation();_vm.click_updateData($event)}}},[_c('i',{staticClass:"fa fa-file ladda-label"})])],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Datum računa (RNS):"}},[_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.datum_racuna),"disabled":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Znesek računa (RNS):"}},[_c('currency-input',{staticClass:"form-control input_significent",attrs:{"disabled":""},model:{value:(_vm.znesek_racuna),callback:function ($$v) {_vm.znesek_racuna=$$v},expression:"znesek_racuna"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracila"},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"6"}},[_vm._v("Prodajna cena:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('currency-input',{staticClass:"form-control input_significent",attrs:{"disabled":""},model:{value:(_vm.prodajna_cena),callback:function ($$v) {_vm.prodajna_cena=$$v},expression:"prodajna_cena"}})],1)],1),_vm._v(" "),_vm._l((_vm.nakazila),function(nakazilo){return _c('b-row',{key:'nakazilo-' + nakazilo.id,staticClass:"r_placilo r_povracila"},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"3"}},[_vm._v("\n\t\t\t\t"+_vm._s(nakazilo.tip)+"\n\t\t\t")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-input',{attrs:{"type":"text","value":nakazilo.opomba,"disabled":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[(nakazilo.datum !== 'MM/DD/YYYY')?_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(nakazilo.datum),"disabled":""}}):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":""},model:{value:(nakazilo.znesek),callback:function ($$v) {_vm.$set(nakazilo, "znesek", $$v)},expression:"nakazilo.znesek"}})],1)],1)}),_vm._v(" "),_c('b-row',{staticClass:"r_povracila"},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"6"}},[_vm._v("Povračila (skupaj):")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('currency-input',{staticClass:"form-control input_significent",attrs:{"disabled":""},model:{value:(_vm.povracila_skupaj),callback:function ($$v) {_vm.povracila_skupaj=$$v},expression:"povracila_skupaj"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("Podaljsano jamstvo znesek:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('currency-input',{staticClass:"form-control input_significent",attrs:{"disabled":""},model:{value:(_vm.podaljsanoJamstvoZnesek),callback:function ($$v) {_vm.podaljsanoJamstvoZnesek=$$v},expression:"podaljsanoJamstvoZnesek"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("Myr znesek:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('currency-input',{staticClass:"form-control input_significent",attrs:{"disabled":""},model:{value:(_vm.myrZnesek),callback:function ($$v) {_vm.myrZnesek=$$v},expression:"myrZnesek"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('h5',{staticClass:"placila_sekcija"},[_vm._v("Razlika:")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}}),_vm._v(" "),_c('b-col',{staticClass:"l_izracun",attrs:{"cols":"3"}},[_c('b-form-input',{class:_vm.razlikaClass,attrs:{"type":"text","disabled":""},model:{value:(_vm.razlikaFormatted),callback:function ($$v) {_vm.razlikaFormatted=$$v},expression:"razlikaFormatted"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Prodajalec potrdil:"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datumProdajalecPotrdil),"type":"text","disabled":""}})],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Sekretar potrdil:"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datumSekretarPotrdil),"type":"text","disabled":""}})],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Moderator potrdil:"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datumModeratorPotrdil),"type":"text","disabled":""}})],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Računovodja potrdil:"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datumRacunovodjaPotrdil),"type":"text","disabled":""}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type && _vm.message.type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"align-self":"start"}}),_vm._v(" "),_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.stopPropagation();_vm.click_cancelModal($event)}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","title":_vm.gumbPotrdiTitle,"disabled":_vm.potrdiDisabled},on:{"click":function($event){$event.stopPropagation();_vm.click_okModal($event)}}},[_vm._v("Potrdi")])],1)],1)],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle_text,"ok-title":_vm.ok_text,"cancel-title":_vm.modalCancelTitle,"busy":_vm.modalIsBusy},on:{"ok":_vm.modal_okClick}},[_c('b-form',{ref:"form",attrs:{"novalidate":""}},[(_vm.modalErrorMsg)?_c('app-mbox',{attrs:{"text":_vm.modalErrorMsg.message},on:{"dismissed":_vm.clear_error_msg}}):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-horizontal","label-cols":"2","label":"Datum","label-for":"datum"}},[(_vm.modalPriliv.id >= 0 && !_vm.readOnly)?_c('v-date-picker',{ref:"datum",attrs:{"id":"datum","max-date":new Date(Date.now()),"is-required":true,"input-props":{
								class: "form-control dt_border gdt_border",
								placeholder: "DD. MM. YYYY",
								required: true
							},"mode":"single","locale":"sl-SI"},model:{value:(_vm.modalPriliv.datum),callback:function ($$v) {_vm.$set(_vm.modalPriliv, "datum", $$v)},expression:"modalPriliv.datum"}}):_c('b-form-input',{attrs:{"id":"datum","type":"text","value":_vm._f("hr_date")(_vm.modalPriliv.datum),"disabled":_vm.readOnly}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Naziv","label-cols":"2","label":"Naziv","label-for":"naziv"}},[_c('b-form-input',{attrs:{"type":"text","id":"naziv","disabled":_vm.readOnly},model:{value:(_vm.modalPriliv.naziv),callback:function ($$v) {_vm.$set(_vm.modalPriliv, "naziv", $$v)},expression:"modalPriliv.naziv"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Referenca","label-cols":"2","label":"Referenca","label-for":"referenca"}},[_c('b-form-input',{attrs:{"type":"text","id":"referenca","disabled":_vm.readOnly},model:{value:(_vm.modalPriliv.referenca),callback:function ($$v) {_vm.$set(_vm.modalPriliv, "referenca", $$v)},expression:"modalPriliv.referenca"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Znesek","label-cols":"2","label":"Znesek","label-for":"znesek"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"znesek","disabled":_vm.readOnly},model:{value:(_vm.modalPriliv.znesek),callback:function ($$v) {_vm.$set(_vm.modalPriliv, "znesek", $$v)},expression:"modalPriliv.znesek"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Placnik","label-cols":"2","label":"Placnik","label-for":"placnik"}},[_c('b-form-input',{attrs:{"type":"text","id":"placnik","disabled":_vm.readOnly},model:{value:(_vm.modalPriliv.placnik),callback:function ($$v) {_vm.$set(_vm.modalPriliv, "placnik", $$v)},expression:"modalPriliv.placnik"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Ogrodje","label-cols":"2","label":"Ogrodje","label-for":"ogrodje"}},[_c('v-select',{attrs:{"id":"ogrodje","label":"ogrodje","options":_vm.ogrodja_options,"taggable":true,"filterable":false,"placeholder":"Izberi vozilo ...","disabled":_vm.readOnly},on:{"input":function($event){_vm.voziloSelect_change($event)},"search":_vm.vozilaSelect_search},model:{value:(_vm.modalPriliv.ogrodje),callback:function ($$v) {_vm.$set(_vm.modalPriliv, "ogrodje", $$v)},expression:"modalPriliv.ogrodje"}},[_c('template',{slot:"no-options"},[_vm._v("Vnesite VIN številko vozila")])],2)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NaloziDatotekoModal_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4280c381_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NaloziDatotekoModal_vue__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(939)
  __webpack_require__(940)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4280c381"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NaloziDatotekoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4280c381_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NaloziDatotekoModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4280c381_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NaloziDatotekoModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle_text,"ok-title":_vm.ok_text,"cancel-title":_vm.modalCancelTitle,"busy":_vm.modalIsBusy},on:{"ok":_vm.modal_okClick}},[_c('b-row',[(_vm.showFrom === 'mapa')?_c('b-col',[_c('b-col',[_c('b-form-file',{attrs:{"multiple":"","placeholder":_vm.upload_placeholder,"drop-placeholder":"Povleci datoteko..."},model:{value:(_vm.import_files),callback:function ($$v) {_vm.import_files=$$v},expression:"import_files"}})],1)],1):_c('b-col',[_vm._v("\n\t\t\t\t\tKlic iz neznanega view-a/modala\n\t\t\t\t")])],1),_vm._v(" "),_c('b-alert',{staticClass:"error_message",attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.modal_cancelClick($event)}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{ref:"aOk",attrs:{"variant":"primary","data-style":"zoom-in"},on:{"click":function($event){$event.stopPropagation();_vm.modal_okClick($event)}}},[_c('span',{staticClass:"ladda-label"},[_vm._v(_vm._s(_vm.ok_text))])])],1)],1)],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZeljenaIzstavitevRacunaModal_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4c613f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZeljenaIzstavitevRacunaModal_vue__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(943)
  __webpack_require__(944)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e4c613f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZeljenaIzstavitevRacunaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4c613f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZeljenaIzstavitevRacunaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4c613f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZeljenaIzstavitevRacunaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle,"ok-title":_vm.modalOkTitle,"cancel-title":_vm.modalCancelTitle},on:{"ok":function($event){_vm.modal_okClick($event)},"cancel":function($event){_vm.modal_cancelClick($event)}}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-form',{attrs:{"inline":""}},[_c('label',{staticClass:"mr-2 mb-1 mt-1"},[_vm._v("Datum: ")]),_vm._v(" "),_c('v-date-picker',{ref:"datumZeljeneIzstavitveRacunaRef",attrs:{"min-date":new Date(Date.now()),"is-required":true,"input-props":{
					class: "form-control",
					placeholder: "DD. MM. YYYY",
					required: true
				},"mode":"single","locale":"sl-SI"},model:{value:(_vm.datumZeljeneIzstavitveRacuna),callback:function ($$v) {_vm.datumZeljeneIzstavitveRacuna=$$v},expression:"datumZeljeneIzstavitveRacuna"}}),_vm._v(" "),_c('label',{staticClass:"ml-3 mr-2 mt-1 mb-1"},[_vm._v("Ura: ")]),_vm._v(" "),_c('v-timepicker',{ref:"uraZeljeneIzstavitveRacunaRef",attrs:{"format":"HH : mm","hour-range":[7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],"hide-disabled-hours":"","hide-clear-button":"","minute-interval":10,"input-class":"zeljenaIzstavitevRacunaTimepicker"},model:{value:(_vm.uraZeljeneIzstavitveRacuna),callback:function ($$v) {_vm.uraZeljeneIzstavitveRacuna=$$v},expression:"uraZeljeneIzstavitveRacuna"}}),_vm._v(" "),_c('b-button',{ref:"removeDatumZeljeneIzstavitveRacuna",staticClass:"m-1",attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();_vm.click_removeDatumZeljeneIzstavitve()}}},[_c('i',{staticClass:"fa fa-remove"})])],1),_vm._v(" "),_c('b-alert',{class:_vm.message_class,attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))])],1)}
var staticRenderFns = []


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DodajanjeStKupoprodajnePogodbeModal_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b62d0f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DodajanjeStKupoprodajnePogodbeModal_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(947)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18b62d0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DodajanjeStKupoprodajnePogodbeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b62d0f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DodajanjeStKupoprodajnePogodbeModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b62d0f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DodajanjeStKupoprodajnePogodbeModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Št. kupoprodajne podobe","size":"sm"},on:{"hidden":_vm.clearModal}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Št. kupoprodajne pogodbe:"}},[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.stKupoprodajnePogodbe),callback:function ($$v) {_vm.stKupoprodajnePogodbe=$$v},expression:"stKupoprodajnePogodbe"}})],1)],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type && _vm.message.type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.stopPropagation();_vm.click_cancelModal($event)}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.click_okModal($event)}}},[_vm._v("Nastavi")])],1)],1)],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"no-close-on-backdrop":"","title":"Mapa vozila","size":"xl"},on:{"hidden":_vm.clearModalData}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Podrobnosti","active":""}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Šasija:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.ogrodje),callback:function ($$v) {_vm.ogrodje=$$v},expression:"ogrodje"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Datum nakupa:"}},[_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.datum_nakupa),"disabled":""}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Datum planirane dobave:"}},[_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.datum_planirane_dobave),"disabled":""}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Datum koncesije:"}},[_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.koncesija_datum),"disabled":""}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"3"}},[_vm._v("Financiranje RCI:")]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":""},model:{value:(_vm.financiranje_rci),callback:function ($$v) {_vm.financiranje_rci=$$v},expression:"financiranje_rci"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("RCI Lizing (št. pogodbe):")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.rci_lizing),callback:function ($$v) {_vm.rci_lizing=$$v},expression:"rci_lizing"}})],1),_vm._v(" "),_c('b-col',{staticClass:"l_znesek"},[_vm._v("RCI Kredit (št. pogodbe):")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.rci_kredit),callback:function ($$v) {_vm.rci_kredit=$$v},expression:"rci_kredit"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}}),_vm._v(" "),_c('b-col',[_vm._v("Leta")]),_vm._v(" "),_c('b-col',[_vm._v("KM")]),_vm._v(" "),_c('b-col',[_vm._v("Znesek")]),_vm._v(" "),_c('b-col',[_vm._v("Opomba")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"2"}},[_vm._v("Pod. jamstvo:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.podaljsano_jamstvo_picked),callback:function ($$v) {_vm.podaljsano_jamstvo_picked=$$v},expression:"podaljsano_jamstvo_picked"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.podaljsano_jamstvo_leta),callback:function ($$v) {_vm.podaljsano_jamstvo_leta=$$v},expression:"podaljsano_jamstvo_leta"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.podaljsano_jamstvo_km),callback:function ($$v) {_vm.podaljsano_jamstvo_km=$$v},expression:"podaljsano_jamstvo_km"}})],1),_vm._v(" "),_c('b-col',[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.podaljsano_jamstvo_znesek),callback:function ($$v) {_vm.podaljsano_jamstvo_znesek=$$v},expression:"podaljsano_jamstvo_znesek"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.podaljsano_jamstvo_opomba),callback:function ($$v) {_vm.podaljsano_jamstvo_opomba=$$v},expression:"podaljsano_jamstvo_opomba"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"2"}},[_vm._v("MYR.:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.myr_picked),callback:function ($$v) {_vm.myr_picked=$$v},expression:"myr_picked"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.myr_leta),callback:function ($$v) {_vm.myr_leta=$$v},expression:"myr_leta"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.myr_km),callback:function ($$v) {_vm.myr_km=$$v},expression:"myr_km"}})],1),_vm._v(" "),_c('b-col',[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.myr_znesek),callback:function ($$v) {_vm.myr_znesek=$$v},expression:"myr_znesek"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.myr_opomba),callback:function ($$v) {_vm.myr_opomba=$$v},expression:"myr_opomba"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_vm._v("Opomba")])],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"2"}},[_vm._v("Zavarovanje:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.zavarovanje_picked),callback:function ($$v) {_vm.zavarovanje_picked=$$v},expression:"zavarovanje_picked"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.zavarovanje_opomba),callback:function ($$v) {_vm.zavarovanje_opomba=$$v},expression:"zavarovanje_opomba"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"2"}},[_vm._v("GAP:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.gap_picked),callback:function ($$v) {_vm.gap_picked=$$v},expression:"gap_picked"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.gap_opomba),callback:function ($$v) {_vm.gap_opomba=$$v},expression:"gap_opomba"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"2"}},[_vm._v("BNI:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.bni_picked),callback:function ($$v) {_vm.bni_picked=$$v},expression:"bni_picked"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.bni_opomba),callback:function ($$v) {_vm.bni_opomba=$$v},expression:"bni_opomba"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"2"}},[_vm._v("Nulti servis:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.nulti_picked),callback:function ($$v) {_vm.nulti_picked=$$v},expression:"nulti_picked"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"2"}},[_vm._v("Čiščenje:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-radio-group',{staticClass:"rb_DaNe",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.ciscenje_picked),callback:function ($$v) {_vm.ciscenje_picked=$$v},expression:"ciscenje_picked"}},[_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Da")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Ne")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("Klic stranke:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.klic_stranke),callback:function ($$v) {_vm.klic_stranke=$$v},expression:"klic_stranke"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek",attrs:{"cols":"3"}},[_vm._v("Ostali dogovori:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(_vm.ostali_dogovori),callback:function ($$v) {_vm.ostali_dogovori=$$v},expression:"ostali_dogovori"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{staticClass:"b_removePotrdil",attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Prodajalec potrdil:"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datum_prodajalec_potrdil),"type":"text","disabled":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[((_vm.isRoleModerator || _vm.isRoleAdmin) && _vm.isProdajalecPotrdil)?_c('b-button',{staticClass:"b_iconaction",on:{"click":function($event){$event.stopPropagation();_vm.click_removeProdajalecPotrdil()}}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e()],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"b_removePotrdil",attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Sekretar potrdil:"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datum_sekretar_potrdil),"type":"text","disabled":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[((_vm.isRoleModerator || _vm.isRoleAdmin) && _vm.isProdajalecPotrdil && _vm.isSekretarPotrdil)?_c('b-button',{staticClass:"b_iconaction",on:{"click":function($event){$event.stopPropagation();_vm.click_removeSekretarPotrdil()}}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e()],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"b_removePotrdil",attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Moderator potrdil:"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datum_moderator_potrdil),"type":"text","disabled":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[((_vm.isRoleModerator || _vm.isRoleAdmin) && _vm.isProdajalecPotrdil && _vm.isSekretarPotrdil && _vm.isModeratorPotrdil)?_c('b-button',{staticClass:"b_iconaction",on:{"click":function($event){$event.stopPropagation();_vm.click_removeModeratorPotrdil()}}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e()],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"b_removePotrdil",attrs:{"align-self":"center"}},[(_vm.isProdajalecPotrdil)?_c('b-form-group',{attrs:{"label":"Računovodja potrdil:"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(_vm.datum_racunovodja_potrdil),"type":"text","disabled":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[((_vm.isRoleModerator || _vm.isRoleAdmin) && _vm.isProdajalecPotrdil && _vm.isSekretarPotrdil && _vm.isModeratorPotrdil && _vm.isRacunovodjaPotrdil)?_c('b-button',{staticClass:"b_iconaction",on:{"click":function($event){$event.stopPropagation();_vm.click_removeRacunovodjaPotrdil()}}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e()],1)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Finance"}},[_c('b-row',[_c('b-col',[_c('h5',{staticClass:"placila_sekcija"},[_vm._v("Račun RNS")])]),_vm._v(" "),_c('b-col',{staticClass:"cUpdate",attrs:{"cols":"1"}},[(_vm.showLockIcon)?_c('div',{attrs:{"title":_vm.moderatorUnlock ? 'Zakleni obrazec' : 'Odkleni obrazec'},on:{"click":function($event){$event.stopPropagation();_vm.click_toggleLock($event)}}},[(!_vm.moderatorUnlock)?_c('i',{staticClass:"fa fa-lock lockIcon"}):_vm._e(),_vm._v(" "),(_vm.moderatorUnlock)?_c('i',{staticClass:"fa fa-unlock lockIcon"}):_vm._e()]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"cUpdate",attrs:{"cols":"1"}},[(!_vm.isRoleProdajalec)?_c('b-button',{ref:"aUpdate",attrs:{"data-style":"zoom-in","size":"sm","title":"Pridobi podatke iz M-Files"},on:{"click":function($event){$event.stopPropagation();_vm.click_updateData($event)}}},[_c('i',{staticClass:"fa fa-file ladda-label"})]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Št. računa:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},model:{value:(_vm.st_racuna),callback:function ($$v) {_vm.st_racuna=$$v},expression:"st_racuna"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Datum:","label-for":"datum_racuna"}},[(_vm.modalDisabled || _vm.tabFinanceDisabled)?_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.datum_racuna),"disabled":""}}):_c('v-date-picker',{ref:"datumRacuna",attrs:{"id":"datum_racuna","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.datum_racuna),callback:function ($$v) {_vm.datum_racuna=$$v},expression:"datum_racuna"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[(!_vm.isRoleProdajalec)?_c('b-form-group',{attrs:{"label":"Znesek:"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},model:{value:(_vm.skupni_znesek),callback:function ($$v) {_vm.skupni_znesek=$$v},expression:"skupni_znesek"}})],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Prodajna cena:"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},model:{value:(_vm.prodajna_cena),callback:function ($$v) {_vm.prodajna_cena=$$v},expression:"prodajna_cena"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h5',{staticClass:"placila_sekcija"},[_vm._v("Nakazila")])])],1),_vm._v(" "),(_vm.modalDisabled || _vm.tabFinanceDisabled)?_c('b-row'):_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',[_c('label',[_vm._v("Tip:")]),_vm._v(" "),_c('v-select',{ref:"tipNakazila",attrs:{"options":_vm.tipi_nakazil,"create-option":_vm.tipNakazila_createOption,"taggable":true,"filterable":false,"placeholder":"Izberi tip ..."},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.label)+"\n\t\t\t\t\t\t\t\t\t")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.label)+"\n\t\t\t\t\t\t\t\t\t")]}}]),model:{value:(_vm.novo_nakazilo.tip),callback:function ($$v) {_vm.$set(_vm.novo_nakazilo, "tip", $$v)},expression:"novo_nakazilo.tip"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Opomba:"}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.novo_nakazilo.opomba),callback:function ($$v) {_vm.$set(_vm.novo_nakazilo, "opomba", $$v)},expression:"novo_nakazilo.opomba"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":"Datum:","label-for":"datum_placila"}},[_c('v-date-picker',{ref:"datumPlacila",attrs:{"id":"datum_placila","max-date":new Date(Date.now()),"is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.novo_nakazilo.datum),callback:function ($$v) {_vm.$set(_vm.novo_nakazilo, "datum", $$v)},expression:"novo_nakazilo.datum"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":"Znesek:"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},model:{value:(_vm.novo_nakazilo.znesek),callback:function ($$v) {_vm.$set(_vm.novo_nakazilo, "znesek", $$v)},expression:"novo_nakazilo.znesek"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{staticClass:"b_akcija b_iconaction",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_addNakazilo($event.target)}}},[_c('i',{staticClass:"fa fa-plus"})])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":"Kontrola:"}})],1)],1),_vm._v(" "),_vm._l((_vm.nakazila),function(nakazilo){return _c('b-row',{key:'nakazilo-' + nakazilo.id,staticClass:"r_placilo"},[_c('b-col',{attrs:{"cols":"2"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled|| _vm.tabFinanceDisabled},on:{"input":_vm.nakazilaChange},model:{value:(nakazilo.tip),callback:function ($$v) {_vm.$set(nakazilo, "tip", $$v)},expression:"nakazilo.tip"}}),_vm._v(" "),(nakazilo.tip === 'Rabljeno vozilo')?_c('b-input-group-append',[_c('b-input-group-text',{staticClass:"p-0"},[_c('b-button',{staticClass:"p-0",attrs:{"disabled":nakazilo.id < 1 || _vm.modalDisabled || _vm.tabFinanceDisabled,"title":_vm.getKupoprodajnaPogodbaTitle(nakazilo),"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_setKupoprodajnaPogodba(nakazilo, $event.target)}}},[_c('i',{staticClass:"fa fa-pencil buttonKupoprodajnaPogodba"})])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},on:{"input":_vm.nakazilaChange},model:{value:(nakazilo.opomba),callback:function ($$v) {_vm.$set(nakazilo, "opomba", $$v)},expression:"nakazilo.opomba"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[(_vm.modalDisabled || _vm.tabFinanceDisabled)?_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(nakazilo.datum),"type":"text","disabled":""}}):_c('v-date-picker',{attrs:{"max-date":new Date(Date.now()),"input-props":{
									class: "form-control dt_border gdt_border",
									placeholder: "DD. MM. YYYY"
								},"mode":"single","locale":"sl-SI"},on:{"input":_vm.nakazilaChange},model:{value:(nakazilo.datum),callback:function ($$v) {_vm.$set(nakazilo, "datum", $$v)},expression:"nakazilo.datum"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},on:{"input":_vm.nakazilaChange},model:{value:(nakazilo.znesek),callback:function ($$v) {_vm.$set(nakazilo, "znesek", $$v)},expression:"nakazilo.znesek"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{staticClass:"b_iconaction",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled,"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_removeNakazilo(nakazilo, $event.target)}}},[_c('i',{staticClass:"fa fa-remove"})])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[(nakazilo.ujemajocPrilivId != null && nakazilo.ujemajocPrilivId > 0)?_c('div',{attrs:{"id":'tooltip-priliv-' + nakazilo.ujemajocPrilivId},on:{"mouseover":function($event){_vm.getPrilivInfo(nakazilo.ujemajocPrilivId)}}},[_c('currency-input',{staticClass:"form-control prilivZnesek",attrs:{"disabled":""},model:{value:(nakazilo.ujemajocPrilivZnesek),callback:function ($$v) {_vm.$set(nakazilo, "ujemajocPrilivZnesek", $$v)},expression:"nakazilo.ujemajocPrilivZnesek"}})],1):_vm._e(),_vm._v(" "),(nakazilo.ujemajocPrilivId < 0)?_c('div',{attrs:{"id":'tooltip-priliv-' + nakazilo.ujemajocPrilivId}},[(nakazilo.st_kupoprodajne_pogodbe != '' && nakazilo.st_kupoprodajne_pogodbe != null)?_c('currency-input',{staticClass:"form-control prilivZnesek",attrs:{"disabled":""},model:{value:(nakazilo.ujemajocPrilivZnesek),callback:function ($$v) {_vm.$set(nakazilo, "ujemajocPrilivZnesek", $$v)},expression:"nakazilo.ujemajocPrilivZnesek"}}):_c('currency-input',{staticClass:"form-control prilivZnesekBrezUjemanja",attrs:{"disabled":""},model:{value:(nakazilo.ujemajocPrilivZnesek),callback:function ($$v) {_vm.$set(nakazilo, "ujemajocPrilivZnesek", $$v)},expression:"nakazilo.ujemajocPrilivZnesek"}})],1):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip-priliv-' + nakazilo.ujemajocPrilivId,"triggers":"hover"}},[(nakazilo.ujemajocPrilivId < 0)?_c('div',[(nakazilo.st_kupoprodajne_pogodbe != '' && nakazilo.st_kupoprodajne_pogodbe != null)?_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t\tŠt. kupoprodajne "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\tpogodbe: "),_c('b',[_vm._v(_vm._s(nakazilo.st_kupoprodajne_pogodbe))])]):_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t\tŠt. kupoprodajne "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\tpogodbe še ni vnesena\n\t\t\t\t\t\t\t\t\t")])]):_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\tDatum: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_date")(_vm.prilivHover.datum)))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\tPlačnik: "),_c('b',[_vm._v(_vm._s(_vm.prilivHover.placnik))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\tZnesek: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_money")(_vm.prilivHover.znesek))+" ")]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\tVir: "),_c('b',[_vm._v(_vm._s(_vm.prilivHover.vir))])])])],1)],1)}),_vm._v(" "),_vm._l((_vm.priliviBrezUjemanj),function(prilivBrezUjemanja){return _c('b-row',{key:'prilivBrezUjemanja-' + prilivBrezUjemanja.id,staticClass:"r_placilo"},[_c('b-col',{attrs:{"cols":"10"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{attrs:{"id":'tooltip-prilivBrezUjemanja-' + prilivBrezUjemanja.id},on:{"mouseover":function($event){_vm.getPrilivInfo(prilivBrezUjemanja.id)}}},[_c('currency-input',{staticClass:"form-control prilivZnesekBrezUjemanja",attrs:{"disabled":""},model:{value:(prilivBrezUjemanja.znesek),callback:function ($$v) {_vm.$set(prilivBrezUjemanja, "znesek", $$v)},expression:"prilivBrezUjemanja.znesek"}})],1),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip-prilivBrezUjemanja-' + prilivBrezUjemanja.id,"triggers":"hover"}},[_vm._v("\n\t\t\t\t\t\t\t\tDatum: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_date")(_vm.prilivHover.datum)))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tPlačnik: "),_c('b',[_vm._v(_vm._s(_vm.prilivHover.placnik))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tZnesek: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_money")(_vm.prilivHover.znesek)))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tVir: "),_c('b',[_vm._v(_vm._s(_vm.prilivHover.vir))])])],1)],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"7"}},[_c('h5',{staticClass:"placila_sekcija"},[_vm._v("Razlika:")])]),_vm._v(" "),_c('b-col',{staticClass:"l_izracun",attrs:{"cols":"2"}},[_c('b-form-input',{class:_vm.razlikaClass,attrs:{"type":"text","disabled":""},model:{value:(_vm.razlikaFormatted),callback:function ($$v) {_vm.razlikaFormatted=$$v},expression:"razlikaFormatted"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}}),_vm._v(" "),_c('b-col',{staticClass:"l_izracun",attrs:{"cols":"2"}},[_c('b-form-input',{staticClass:"input_total",attrs:{"type":"text","disabled":""},model:{value:(_vm.priliviSkupaj),callback:function ($$v) {_vm.priliviSkupaj=$$v},expression:"priliviSkupaj"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h5',{staticClass:"placila_sekcija"},[_vm._v("Povračila")])])],1),_vm._v(" "),(_vm.modalDisabled || _vm.tabFinanceDisabled)?_c('b-row'):_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Tip:")]),_vm._v(" "),_c('v-select',{ref:"tipPovracila",attrs:{"options":_vm.tipi_povracil,"create-option":_vm.tipPovracila_createOption,"taggable":true,"filterable":false,"placeholder":"Izberi tip ..."},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.label)+"\n\t\t\t\t\t\t\t\t\t")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.label)+"\n\t\t\t\t\t\t\t\t\t")]}}]),model:{value:(_vm.novo_povracilo.tip),callback:function ($$v) {_vm.$set(_vm.novo_povracilo, "tip", $$v)},expression:"novo_povracilo.tip"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Datum:","label-for":"datum_povracila"}},[_c('v-date-picker',{ref:"datumPovracila",attrs:{"id":"datum_povracila","max-date":new Date(Date.now()),"is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.novo_povracilo.datum),callback:function ($$v) {_vm.$set(_vm.novo_povracilo, "datum", $$v)},expression:"novo_povracilo.datum"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":"Znesek:"}},[_c('currency-input',{staticClass:"form-control",model:{value:(_vm.novo_povracilo.znesek),callback:function ($$v) {_vm.$set(_vm.novo_povracilo, "znesek", $$v)},expression:"novo_povracilo.znesek"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{staticClass:"b_akcija b_iconaction",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_addPovracilo($event.target)}}},[_c('i',{staticClass:"fa fa-plus"})])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":"Kontrola:"}})],1)],1),_vm._v(" "),_vm._l((_vm.povracila),function(povracilo){return _c('b-row',{key:'povracilo-' + povracilo.id,staticClass:"r_placilo"},[_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},model:{value:(povracilo.tip),callback:function ($$v) {_vm.$set(povracilo, "tip", $$v)},expression:"povracilo.tip"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[(_vm.modalDisabled || _vm.tabFinanceDisabled)?_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(povracilo.datum),"type":"text","disabled":""}}):_c('v-date-picker',{attrs:{"max-date":new Date(Date.now()),"input-props":{
									class: "form-control dt_border gdt_border",
									placeholder: "DD. MM. YYYY"
								},"mode":"single","locale":"sl-SI"},model:{value:(povracilo.datum),callback:function ($$v) {_vm.$set(povracilo, "datum", $$v)},expression:"povracilo.datum"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled},model:{value:(povracilo.znesek),callback:function ($$v) {_vm.$set(povracilo, "znesek", $$v)},expression:"povracilo.znesek"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{staticClass:"b_iconaction",attrs:{"disabled":_vm.modalDisabled || _vm.tabFinanceDisabled,"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_removePovracilo(povracilo, $event.target)}}},[_c('i',{staticClass:"fa fa-remove"})])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[(povracilo.ujemajocePovraciloDataId != null)?_c('div',{attrs:{"id":'tooltip-povraciloData-' + povracilo.ujemajocePovraciloDataId},on:{"mouseover":function($event){_vm.getPovraciloDataInfo(povracilo.ujemajocePovraciloDataId)}}},[_c('currency-input',{staticClass:"form-control prilivZnesek",attrs:{"disabled":""},model:{value:(povracilo.ujemajocePovraciloDataZnesek),callback:function ($$v) {_vm.$set(povracilo, "ujemajocePovraciloDataZnesek", $$v)},expression:"povracilo.ujemajocePovraciloDataZnesek"}})],1):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip-povraciloData-' + povracilo.ujemajocePovraciloDataId,"triggers":"hover"}},[_vm._v("\n\t\t\t\t\t\t\t\tDatum: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_date")(_vm.povraciloDataHover.creditnotedate)))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tZnesek: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_money")(_vm.povraciloDataHover.amount)))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tAction name: "),_c('b',[_vm._v(_vm._s(_vm.povraciloDataHover.action_name))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tSale channel: "),_c('b',[_vm._v(_vm._s(_vm.povraciloDataHover.sale_channel))])])],1)],1)}),_vm._v(" "),_vm._l((_vm.povracilaDataBrezUjemanja),function(povraciloDataBrezUjemanja){return _c('b-row',{key:'povraciloDataBrezUjemanja-' + povraciloDataBrezUjemanja.id,staticClass:"r_placilo"},[_c('b-col',{attrs:{"cols":"10"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{attrs:{"id":'tooltip-povraciloDataBrezUjemanja-' + povraciloDataBrezUjemanja.id},on:{"mouseover":function($event){_vm.getPovraciloDataInfo(povraciloDataBrezUjemanja.id)}}},[_c('currency-input',{staticClass:"form-control povracilaDataBrezUjemanja",attrs:{"disabled":""},model:{value:(povraciloDataBrezUjemanja.amount),callback:function ($$v) {_vm.$set(povraciloDataBrezUjemanja, "amount", $$v)},expression:"povraciloDataBrezUjemanja.amount"}})],1),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip-povraciloDataBrezUjemanja-' + povraciloDataBrezUjemanja.id,"triggers":"hover"}},[_vm._v("\n\t\t\t\t\t\t\t\tDatum: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_date")(_vm.povraciloDataHover.creditnotedate)))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tZnesek: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_money")(_vm.povraciloDataHover.amount)))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tAction name: "),_c('b',[_vm._v(_vm._s(_vm.povraciloDataHover.action_name))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tSale channel: "),_c('b',[_vm._v(_vm._s(_vm.povraciloDataHover.sale_channel))])])],1)],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"7"}},[_c('h5',{staticClass:"placila_sekcija"},[_vm._v("Skupaj:")])]),_vm._v(" "),_c('b-col',{staticClass:"l_izracun",attrs:{"cols":"2"}},[_c('b-form-input',{class:_vm.sestevekPovracilaClass,attrs:{"type":"text","disabled":""},model:{value:(_vm.sestevekPovracilaFormatted),callback:function ($$v) {_vm.sestevekPovracilaFormatted=$$v},expression:"sestevekPovracilaFormatted"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}}),_vm._v(" "),_c('b-col',{staticClass:"l_izracun",attrs:{"cols":"2"}},[_c('b-form-input',{staticClass:"input_total",attrs:{"type":"text","disabled":""},model:{value:(_vm.povracilaDataSkupaj),callback:function ($$v) {_vm.povracilaDataSkupaj=$$v},expression:"povracilaDataSkupaj"}})],1)],1)],2),_vm._v(" "),_c('b-tab',{attrs:{"title":"Oprema"}},[_c('b-row',[_c('b-col',[_c('h5',{staticClass:"placila_sekcija"},[_vm._v("Dodatna oprema (prodana/darilo)")])])],1),_vm._v(" "),(!_vm.modalDisabled)?_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Naziv:")]),_vm._v(" "),_c('v-select',{ref:"tipOpreme",attrs:{"options":_vm.tipi_opreme,"create-option":_vm.tipOpreme_createOption,"taggable":true,"filterable":false,"placeholder":"Izberi naziv ..."},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.label)+"\n\t\t\t\t\t\t\t\t\t")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(option.label)+"\n\t\t\t\t\t\t\t\t\t")]}}]),model:{value:(_vm.nova_oprema.tip),callback:function ($$v) {_vm.$set(_vm.nova_oprema, "tip", $$v)},expression:"nova_oprema.tip"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Opomba:"}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.nova_oprema.opomba),callback:function ($$v) {_vm.$set(_vm.nova_oprema, "opomba", $$v)},expression:"nova_oprema.opomba"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Naročeno:","label-for":"datum_narocila"}},[_c('v-date-picker',{ref:"datumNarocila",attrs:{"id":"datum_narocila","max-date":new Date(Date.now()),"is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.nova_oprema.datum_narocila),callback:function ($$v) {_vm.$set(_vm.nova_oprema, "datum_narocila", $$v)},expression:"nova_oprema.datum_narocila"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":"Znesek:"}},[_c('currency-input',{staticClass:"form-control",model:{value:(_vm.nova_oprema.znesek),callback:function ($$v) {_vm.$set(_vm.nova_oprema, "znesek", $$v)},expression:"nova_oprema.znesek"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{staticClass:"b_akcija b_iconaction",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_addOprema($event.target)}}},[_c('i',{staticClass:"fa fa-plus"})])],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.oprema),function(item){return _c('b-row',{key:'oprema-' + item.id,staticClass:"r_placilo"},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-input',{attrs:{"type":"text","disabled":_vm.modalDisabled},model:{value:(item.tip),callback:function ($$v) {_vm.$set(item, "tip", $$v)},expression:"item.tip"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(item.opomba),callback:function ($$v) {_vm.$set(item, "opomba", $$v)},expression:"item.opomba"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[(!_vm.modalDisabled)?_c('v-date-picker',{attrs:{"max-date":new Date(Date.now()),"input-props":{
									class: "form-control dt_border gdt_border",
									placeholder: "DD. MM. YYYY"
								},"mode":"single","locale":"sl-SI"},model:{value:(item.datum_narocila),callback:function ($$v) {_vm.$set(item, "datum_narocila", $$v)},expression:"item.datum_narocila"}}):_c('b-form-input',{attrs:{"value":_vm._f("hr_date")(item.datum_narocila),"type":"text","disabled":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(item.znesek),callback:function ($$v) {_vm.$set(item, "znesek", $$v)},expression:"item.znesek"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{staticClass:"b_iconaction",attrs:{"disabled":_vm.modalDisabled,"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_removeOprema(item, $event.target)}}},[_c('i',{staticClass:"fa fa-remove"})])],1)],1)})],2),_vm._v(" "),_c('b-tab',{attrs:{"title":"Bonusi"}},[_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("Bonus 1:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.bonus1),callback:function ($$v) {_vm.bonus1=$$v},expression:"bonus1"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("Bonus 2:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.bonus2),callback:function ($$v) {_vm.bonus2=$$v},expression:"bonus2"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("Bonus 3:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.bonus3),callback:function ($$v) {_vm.bonus3=$$v},expression:"bonus3"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("Bonus 4:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.bonus4),callback:function ($$v) {_vm.bonus4=$$v},expression:"bonus4"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("Bonus 5:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.bonus5),callback:function ($$v) {_vm.bonus5=$$v},expression:"bonus5"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"r_povracilo"},[_c('b-col',{staticClass:"l_znesek"},[_vm._v("Bonus 6:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('currency-input',{staticClass:"form-control",attrs:{"disabled":_vm.modalDisabled},model:{value:(_vm.bonus6),callback:function ($$v) {_vm.bonus6=$$v},expression:"bonus6"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Prilivi"}},[(this.prilivi.length)?_c('div',[_c('b-row',{staticClass:"prilivTableHeader"},[_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v("Datum")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('div',[_vm._v("Plačnik")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v("Znesek")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('div',[_vm._v("Vir")])])],1),_vm._v(" "),_vm._l((_vm.prilivi),function(priliv){return _c('b-row',{key:'priliv-' + priliv.id,staticClass:"prilivTable"},[_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v(_vm._s(_vm._f("hr_date")(priliv.datum)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('div',[_vm._v(_vm._s(priliv.placnik))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v(_vm._s(_vm._f("hr_money")(priliv.znesek)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('div',[_vm._v(_vm._s(priliv.vir))])])],1)})],2):_c('div',{staticClass:"text-center"},[_vm._v("\n\t\t\t\t\t\tNi prilivov\n\t\t\t\t\t")])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Povračila"}},[(this.povracilaData.length)?_c('div',[_c('b-row',{staticClass:"povraciloDataTableHeader"},[_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v("Datum")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',[_vm._v("Ogrodje")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v("Znesek")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v("Action name")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',[_vm._v("Sale channel")])])],1),_vm._v(" "),_vm._l((_vm.povracilaData),function(povraciloData){return _c('b-row',{key:'povraciloData-' + povraciloData.id,staticClass:"povraciloDataTable"},[_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v(_vm._s(_vm._f("hr_date")(povraciloData.creditnotedate)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',[_vm._v(_vm._s(povraciloData.chassis))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v(_vm._s(_vm._f("hr_money")(povraciloData.amount)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',[_vm._v(_vm._s(povraciloData.action_name))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',[_vm._v(_vm._s(povraciloData.sale_channel))])])],1)})],2):_c('div',{staticClass:"text-center"},[_vm._v("\n\t\t\t\t\t\tNi povračil\n\t\t\t\t\t")])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Datoteke"}},[(_vm.mapaExist)?_c('div',[_c('b-row',[_c('b-col',{staticClass:"datotekeHeader",attrs:{"align-self":"start"}},[_c('b',[_vm._v("Seznam datotek")])]),_vm._v(" "),_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{ref:"naloziDatoteko",staticClass:"upload",attrs:{"variant":"warning","size":"sm"},on:{"click":function($event){$event.stopPropagation();return _vm.naloziDatoteko_click($event)}}},[_c('i',{staticClass:"fa fa-cloud-upload"})])],1)],1),_vm._v(" "),_c('b-table',{ref:"datotekeTable",attrs:{"thead-class":"hidden_header","responsive":"xl","striped":"","show-empty":"","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","fields":_vm.datotekeTable_fields,"items":_vm.datoteke},scopedSlots:_vm._u([{key:"actions",fn:function(data){return [_c('b-button',{ref:"removeDatoteka",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.removeDatoteka_click(data.item)}}},[_c('i',{staticClass:"fa fa-remove"})]),_vm._v(" "),_c('b-button',{ref:"downloadDatoteka",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.downloadDatoteka_click(data.item)}}},[_c('i',{staticClass:"fa fa-download"})])]}},{key:"file_type",fn:function(data){return [_c('i',{staticClass:"fa no-padding",class:data.item.file_type})]}}])})],1):_c('div',{staticClass:"text-center"},[_vm._v("\n\t\t\t\t\t\tMapa še ni shranjena\n\t\t\t\t\t")])])],1),_vm._v(" "),_c('b-alert',{staticClass:"error_message",attrs:{"variant":_vm.message.type && _vm.message.type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"align-self":"start"}},[_c('b-button',{attrs:{"variant":"warning","title":_vm.gumbPlaciloTitle,"disabled":_vm.placiloDisabled},on:{"click":function($event){$event.stopPropagation();_vm.click_showPlacila($event.target)}}},[_vm._v("Plačilo")]),_vm._v(" "),(_vm.zeljenaIzstavitevRacunaShow)?_c('b-button',{attrs:{"variant":"warning","title":_vm.gumbZeljeniRacunTitle,"disabled":_vm.zeljenaIzstavitevRacunaDisabled},on:{"click":function($event){$event.stopPropagation();_vm.click_showModalZeljenaIzstavitevRacuna($event.target)}}},[(_vm.zeljenaIzstavitevRacuna != null)?_c('div',[_vm._v("Željen račun "+_vm._s(_vm._f("hr_datetime")(_vm.zeljenaIzstavitevRacuna))+" ")]):_c('div',[_vm._v("Željen račun")])]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.stopPropagation();_vm.onCancelModal($event)}}},[_vm._v("Prekliči")]),_vm._v(" "),(!_vm.modalDisabled)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.onOkModal($event)}}},[_vm._v("Shrani")]):_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.onCancelModal($event)}}},[_vm._v("Zapri")])],1)],1)],1)],1)],2),_vm._v(" "),_c('placila-modal',{ref:"placilaModal",on:{"userpotrdil-success":_vm.on_userPotrdilSuccess,"userpotrdil-canceled":_vm.on_userPotrdilCanceled}}),_vm._v(" "),_c('zeljena-izstavitev-racuna-modal',{ref:"zeljenaIzstavitevRacunaModal",on:{"success":_vm.on_success_zeljenaIzstavitevRacuna}}),_vm._v(" "),_c('dodajanje-st-kupoprodjane-pogodbe-modal',{ref:"dodajanjeStKupoprodajnePogodbeModal",on:{"success":_vm.on_success_stKupoprodajnePogodbe}}),_vm._v(" "),_c('edit-priliv-modal',{ref:"editPrilivModal"}),_vm._v(" "),_c('nalozi-datoteko-modal',{ref:"naloziDatotekoModal",on:{"success":_vm.onNaloziDatoteko_success}}),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)}
var staticRenderFns = []


/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"id":"infoModal","title":_vm.title,"size":"lg"},on:{"hide":_vm.resetModal}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-tabs',[_c('form',[_c('b-tab',{attrs:{"title":"Osnovni podatki","active":""}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"Ogrodje","label-for":"input-ogrodje","invalid-feedback":_vm.invalidFeedback_ogrodje,"state":_vm.state_ogrodje}},[_c('v-select',{attrs:{"id":"ogrodje","label":"ogrodje","options":_vm.ogrodja_options,"taggable":true,"filterable":false,"disabled":_vm.nacin === _vm.NACIN_UREJANJA,"placeholder":"Izberi vozilo ..."},on:{"input":function($event){_vm.voziloSelect_change($event)},"search":_vm.vozilaSelect_search},model:{value:(_vm.itemData1.ogrodje),callback:function ($$v) {_vm.$set(_vm.itemData1, "ogrodje", $$v)},expression:"itemData1.ogrodje"}},[_c('template',{slot:"no-options"},[_vm._v("Vnesite VIN številko vozila")])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"b-form-group":"","label":"Prodajna cena:"}},[_c('currency-input',{staticClass:"form-control",model:{value:(_vm.itemData1.prodajna_cena),callback:function ($$v) {_vm.$set(_vm.itemData1, "prodajna_cena", $$v)},expression:"itemData1.prodajna_cena"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Konto","label-for":"input-konto"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemData1.konto),expression:"itemData1.konto"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"input-konto"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.itemData1, "konto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Izberite konto")]),_vm._v(" "),_c('option',{attrs:{"value":"TV"}},[_vm._v("TV")]),_vm._v(" "),_c('option',{attrs:{"value":"RV0KM"}},[_vm._v("RV0KM")]),_vm._v(" "),_c('option',{attrs:{"value":"ND"}},[_vm._v("ND")]),_vm._v(" "),_c('option',{attrs:{"value":"900089"}},[_vm._v("900089")]),_vm._v(" "),_c('option',{attrs:{"value":"900033"}},[_vm._v("900033")]),_vm._v(" "),_c('option',{attrs:{"value":"906089"}},[_vm._v("906089")]),_vm._v(" "),_c('option',{attrs:{"value":"100003"}},[_vm._v("100003")]),_vm._v(" "),_c('option',{attrs:{"value":"106003"}},[_vm._v("106003")]),_vm._v(" "),_c('option',{attrs:{"value":"KIA"}},[_vm._v("KIA")]),_vm._v(" "),_c('option',{attrs:{"value":"MG"}},[_vm._v("MG")]),_vm._v(" "),_c('option',{attrs:{"value":"NISSAN"}},[_vm._v("NISSAN")])])])],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-ogrodje"}},[_vm._v("Ogrodje")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"input-ogrodje","readonly":""},model:{value:(_vm.itemData.ogrodje),callback:function ($$v) {_vm.$set(_vm.itemData, "ogrodje", $$v)},expression:"itemData.ogrodje"}})],1)],1)],1),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum prve registracije","label-for":"input-datum_prve_registracije"}},[_c('v-date-picker',{ref:"datum_prve_registracije",attrs:{"id":"input-datum_prve_registracije","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_prve_registracije),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_prve_registracije", $$v)},expression:"itemData1.datum_prve_registracije"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Prodamo ga lahko od","label-for":"input-datum_kdaj_ga_lahko_prodamo"}},[_c('v-date-picker',{ref:"datum_kdaj_ga_lahko_prodamo",attrs:{"id":"input-datum_kdaj_ga_lahko_prodamo","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_kdaj_ga_lahko_prodamo),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_kdaj_ga_lahko_prodamo", $$v)},expression:"itemData1.datum_kdaj_ga_lahko_prodamo"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Prodati ga moramo do","label-for":"input-datum_kdaj_ga_moramo_prodati"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_kdaj_ga_moramo_prodati",attrs:{"id":"input-datum_kdaj_ga_moramo_prodati","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_kdaj_ga_moramo_prodati),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_kdaj_ga_moramo_prodati", $$v)},expression:"itemData1.datum_kdaj_ga_moramo_prodati"}}):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Št. kilometrov","label-for":"input-st_kilometrov"}},[_c('b-form-input',{attrs:{"type":"number","id":"input-st_kilometrov"},model:{value:(_vm.itemData1.st_kilometrov),callback:function ($$v) {_vm.$set(_vm.itemData1, "st_kilometrov", $$v)},expression:"itemData1.st_kilometrov"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label":"Št. naročila vozila","label-for":"input-st_narocila_vozila"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-st_narocila_vozila"},model:{value:(_vm.itemData1.st_narocila_vozila),callback:function ($$v) {_vm.$set(_vm.itemData1, "st_narocila_vozila", $$v)},expression:"itemData1.st_narocila_vozila"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-st_narocila_vozila","value":_vm.itemData.st_narocila_vozila,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-st_narocila_kupca"}},[_vm._v("Št. naročila kupca")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-st_narocila_kupca"},model:{value:(_vm.itemData1.st_narocila_kupca),callback:function ($$v) {_vm.$set(_vm.itemData1, "st_narocila_kupca", $$v)},expression:"itemData1.st_narocila_kupca"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-st_narocila_kupca","value":_vm.itemData.st_narocila_kupca,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',{attrs:{"label":"Model","label-for":"input-libelle_modele"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_modele"},model:{value:(_vm.itemData1.libelle_modele),callback:function ($$v) {_vm.$set(_vm.itemData1, "libelle_modele", $$v)},expression:"itemData1.libelle_modele"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_modele","value":_vm.itemData.libelle_modele,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-group',{attrs:{"label":"Verzija","label-for":"input-libelle_version"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_version"},model:{value:(_vm.itemData1.libelle_version),callback:function ($$v) {_vm.$set(_vm.itemData1, "libelle_version", $$v)},expression:"itemData1.libelle_version"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_version","value":_vm.itemData.libelle_version,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Opcije","label-for":"input-libelle_options"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-textarea',{attrs:{"rows":2,"max-rows":6,"type":"text","id":"input-libelle_options"},model:{value:(_vm.itemData1.libelle_options),callback:function ($$v) {_vm.$set(_vm.itemData1, "libelle_options", $$v)},expression:"itemData1.libelle_options"}}):_c('b-form-textarea',{attrs:{"rows":2,"max-rows":6,"type":"text","id":"input-libelle_options","value":_vm.itemData.libelle_options,"readonly":""}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label":"Barva","label-for":"input-libelle_teinte"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_teinte"},model:{value:(_vm.itemData1.libelle_teinte),callback:function ($$v) {_vm.$set(_vm.itemData1, "libelle_teinte", $$v)},expression:"itemData1.libelle_teinte"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_teinte","value":_vm.itemData.libelle_teinte,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label":"Notranjost","label-for":"input-libelle_harmonie"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_harmonie"},model:{value:(_vm.itemData1.libelle_harmonie),callback:function ($$v) {_vm.$set(_vm.itemData1, "libelle_harmonie", $$v)},expression:"itemData1.libelle_harmonie"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_harmonie","value":_vm.itemData.libelle_harmonie,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Oblazinjenje","label-for":"input-libelle_sellerie"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_sellerie"},model:{value:(_vm.itemData1.libelle_sellerie),callback:function ($$v) {_vm.$set(_vm.itemData1, "libelle_sellerie", $$v)},expression:"itemData1.libelle_sellerie"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-libelle_sellerie","value":_vm.itemData.libelle_sellerie,"readonly":""}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-created_at"}},[_vm._v("Datum vnosa")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-created_at","readonly":""},model:{value:(_vm.itemData1.created_at),callback:function ($$v) {_vm.$set(_vm.itemData1, "created_at", $$v)},expression:"itemData1.created_at"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-created_at","readonly":""},model:{value:(_vm.itemData.created_at),callback:function ($$v) {_vm.$set(_vm.itemData, "created_at", $$v)},expression:"itemData.created_at"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-updated_at"}},[_vm._v("Datum spremembe")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-updated_at","readonly":""},model:{value:(_vm.itemData1.updated_at),callback:function ($$v) {_vm.$set(_vm.itemData1, "updated_at", $$v)},expression:"itemData1.updated_at"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-updated_at","readonly":""},model:{value:(_vm.itemData.updated_at),callback:function ($$v) {_vm.$set(_vm.itemData, "updated_at", $$v)},expression:"itemData.updated_at"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-source_file"}},[_vm._v("Vir")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-source_file","readonly":""},model:{value:(_vm.itemData1.source_file),callback:function ($$v) {_vm.$set(_vm.itemData1, "source_file", $$v)},expression:"itemData1.source_file"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-source_file","readonly":""},model:{value:(_vm.itemData.source_file),callback:function ($$v) {_vm.$set(_vm.itemData, "source_file", $$v)},expression:"itemData.source_file"}})],1)],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Podrobnosti 1"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-st_nm"}},[_vm._v("Št. nm")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-st_nm"},model:{value:(_vm.itemData1.st_nm),callback:function ($$v) {_vm.$set(_vm.itemData1, "st_nm", $$v)},expression:"itemData1.st_nm"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-st_nm","value":_vm.itemData.st_nm,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-konto_lastnika"}},[_vm._v("Konto lastnika")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-konto_lastnika"},model:{value:(_vm.itemData1.konto_lastnika),callback:function ($$v) {_vm.$set(_vm.itemData1, "konto_lastnika", $$v)},expression:"itemData1.konto_lastnika"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-konto_lastnika","value":_vm.itemData.konto_lastnika,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-drzava_fiche_gamme"}},[_vm._v("Država")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-drzava_fiche_gamme"},model:{value:(_vm.itemData1.drzava_fiche_gamme),callback:function ($$v) {_vm.$set(_vm.itemData1, "drzava_fiche_gamme", $$v)},expression:"itemData1.drzava_fiche_gamme"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-drzava_fiche_gamme","value":_vm.itemData.drzava_fiche_gamme,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-group',{attrs:{"label":"Tip naročila vozila","label-for":"input-tip_narocila_vozila","invalid-feedback":_vm.invalidFeedback_tip_narocila_vozila,"state":_vm.state_tip_narocila_vozila}},[_c('b-form-input',{attrs:{"type":"text","id":"input-tip_narocila_vozila","trim":""},model:{value:(_vm.itemData1.tip_narocila_vozila),callback:function ($$v) {_vm.$set(_vm.itemData1, "tip_narocila_vozila", $$v)},expression:"itemData1.tip_narocila_vozila"}})],1):_c('b-form-group',[_c('label',{attrs:{"for":"input-tip_narocila_vozila"}},[_vm._v("Tip naročila vozila")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"input-tip_narocila_vozila","value":_vm.itemData.tip_narocila_vozila,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-vozilo_na_borzi"}},[_vm._v("Vozilo na borzi")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemData1.vozilo_na_borzi),expression:"itemData1.vozilo_na_borzi"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"input-vozilo_na_borzi"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.itemData1, "vozilo_na_borzi", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Izberite")]),_vm._v(" "),_c('option',{attrs:{"value":"Da"}},[_vm._v("Da")]),_vm._v(" "),_c('option',{attrs:{"value":"Ne"}},[_vm._v("Ne")])]):_c('b-form-input',{attrs:{"type":"text","id":"input-vozilo_na_borzi","value":_vm.itemData.vozilo_na_borzi,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"id":"fieldset-obljubljeni_mada","label":"Obljubljeni mada","label-for":"obljubljeni_mada"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-select',{attrs:{"id":"input-obljubljeni_mada","options":_vm.weeks_options,"placeholder":"Izberi teden ...","hint":"Danes je","persistent-hint":""},model:{value:(_vm.itemData1.obljubljeni_mada),callback:function ($$v) {_vm.$set(_vm.itemData1, "obljubljeni_mada", $$v)},expression:"itemData1.obljubljeni_mada"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-obljubljeni_mada","value":_vm.itemData.obljubljeni_mada,"readonly":""}}),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('span',[_vm._v("Smo v "+_vm._s(_vm.current_week)+" tednu.")]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Predvideni mada","label-for":"input-predvideni_mada"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"predvideni_mada",attrs:{"id":"input-predvideni_mada","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.predvideni_mada),callback:function ($$v) {_vm.$set(_vm.itemData1, "predvideni_mada", $$v)},expression:"itemData1.predvideni_mada"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-predvideni_mada","value":_vm.itemData.predvideni_mada,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-staranje"}},[_vm._v("Staranje")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-staranje"},model:{value:(_vm.itemData1.staranje),callback:function ($$v) {_vm.$set(_vm.itemData1, "staranje", $$v)},expression:"itemData1.staranje"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-staranje","value":_vm.itemData.staranje,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Realni mada","label-for":"input-realni_mada"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"realni_mada",attrs:{"id":"input-realni_mada","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.realni_mada),callback:function ($$v) {_vm.$set(_vm.itemData1, "realni_mada", $$v)},expression:"itemData1.realni_mada"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-realni_mada","value":_vm.itemData.realni_mada,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-stanje_napredovanja"}},[_vm._v("Stanje napredovanja")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-stanje_napredovanja"},model:{value:(_vm.itemData1.stanje_napredovanja),callback:function ($$v) {_vm.$set(_vm.itemData1, "stanje_napredovanja", $$v)},expression:"itemData1.stanje_napredovanja"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-stanje_napredovanja","value":_vm.itemData.stanje_napredovanja,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-opomba_vozilo"}},[_vm._v("Opomba vozila")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-opomba_vozilo"},model:{value:(_vm.itemData1.opomba_vozilo),callback:function ($$v) {_vm.$set(_vm.itemData1, "opomba_vozilo", $$v)},expression:"itemData1.opomba_vozilo"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-opomba_vozilo","value":_vm.itemData.opomba_vozilo,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-model"}},[_vm._v("Model")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-model"},model:{value:(_vm.itemData1.model),callback:function ($$v) {_vm.$set(_vm.itemData1, "model", $$v)},expression:"itemData1.model"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-model","value":_vm.itemData.model,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-verzija"}},[_vm._v("Verzija")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-verzija"},model:{value:(_vm.itemData1.verzija),callback:function ($$v) {_vm.$set(_vm.itemData1, "verzija", $$v)},expression:"itemData1.verzija"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-verzija","value":_vm.itemData.verzija,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-opcije"}},[_vm._v("Opcije")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-opcije"},model:{value:(_vm.itemData1.opcije),callback:function ($$v) {_vm.$set(_vm.itemData1, "opcije", $$v)},expression:"itemData1.opcije"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-opcije","value":_vm.itemData.opcije,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-barva"}},[_vm._v("Barva")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-barva"},model:{value:(_vm.itemData1.barva),callback:function ($$v) {_vm.$set(_vm.itemData1, "barva", $$v)},expression:"itemData1.barva"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-barva","value":_vm.itemData.barva,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-notranjost"}},[_vm._v("Notranjost")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-notranjost"},model:{value:(_vm.itemData1.notranjost),callback:function ($$v) {_vm.$set(_vm.itemData1, "notranjost", $$v)},expression:"itemData1.notranjost"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-notranjost","value":_vm.itemData.notranjost,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-oblazinjenje"}},[_vm._v("Oblazinjenje")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-oblazinjenje"},model:{value:(_vm.itemData1.oblazinjenje),callback:function ($$v) {_vm.$set(_vm.itemData1, "oblazinjenje", $$v)},expression:"itemData1.oblazinjenje"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-oblazinjenje","value":_vm.itemData.oblazinjenje,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-nivo_kvalitete"}},[_vm._v("Nivo kvalitete")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-nivo_kvalitete"},model:{value:(_vm.itemData1.nivo_kvalitete),callback:function ($$v) {_vm.$set(_vm.itemData1, "nivo_kvalitete", $$v)},expression:"itemData1.nivo_kvalitete"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-nivo_kvalitete","value":_vm.itemData.nivo_kvalitete,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-sprememba"}},[_vm._v("Sprememba")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-sprememba"},model:{value:(_vm.itemData1.sprememba),callback:function ($$v) {_vm.$set(_vm.itemData1, "sprememba", $$v)},expression:"itemData1.sprememba"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-sprememba","value":_vm.itemData.sprememba,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum ZPS","label-for":"input-datum_zps"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_zps",attrs:{"id":"input-datum_zps","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_zps),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_zps", $$v)},expression:"itemData1.datum_zps"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-datum_zps","value":_vm.itemData.datum_zps,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum ZDS","label-for":"input-datum_zds"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_zds",attrs:{"id":"input-datum_zds","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_zds),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_zds", $$v)},expression:"itemData1.datum_zds"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-datum_zds","value":_vm.itemData.datum_zds,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-konto_naslovnika"}},[_vm._v("Konto naslovnika")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-konto_naslovnika"},model:{value:(_vm.itemData1.konto_naslovnika),callback:function ($$v) {_vm.$set(_vm.itemData1, "konto_naslovnika", $$v)},expression:"itemData1.konto_naslovnika"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-konto_naslovnika","value":_vm.itemData.konto_naslovnika,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-koda_prodajalca"}},[_vm._v("Koda prodajalca")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-koda_prodajalca"},model:{value:(_vm.itemData1.koda_prodajalca),callback:function ($$v) {_vm.$set(_vm.itemData1, "koda_prodajalca", $$v)},expression:"itemData1.koda_prodajalca"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-koda_prodajalca","value":_vm.itemData.koda_prodajalca,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label":"Realni madc","label-for":"input-realni_madc"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"realni_madc",attrs:{"id":"input-realni_madc","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.realni_madc),callback:function ($$v) {_vm.$set(_vm.itemData1, "realni_madc", $$v)},expression:"itemData1.realni_madc"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-realni_madc","value":_vm.itemData.realni_madc,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label":"Predvideni madc","label-for":"input-predvideni_madc"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"predvideni_madc",attrs:{"id":"input-predvideni_madc","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.predvideni_madc),callback:function ($$v) {_vm.$set(_vm.itemData1, "predvideni_madc", $$v)},expression:"itemData1.predvideni_madc"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-predvideni_madc","value":_vm.itemData.predvideni_madc,"readonly":""}})],1)],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Podrobnosti 2"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-pristanisce_vkrcanja"}},[_vm._v("Pristanišče vkrcanja")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-pristanisce_vkrcanja"},model:{value:(_vm.itemData1.pristanisce_vkrcanja),callback:function ($$v) {_vm.$set(_vm.itemData1, "pristanisce_vkrcanja", $$v)},expression:"itemData1.pristanisce_vkrcanja"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-pristanisce_vkrcanja","value":_vm.itemData.pristanisce_vkrcanja,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-ime_ladje"}},[_vm._v("Ime ladje")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-ime_ladje"},model:{value:(_vm.itemData1.ime_ladje),callback:function ($$v) {_vm.$set(_vm.itemData1, "ime_ladje", $$v)},expression:"itemData1.ime_ladje"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-ime_ladje","value":_vm.itemData.ime_ladje,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-rezervirano_vozilo"}},[_vm._v("Rezervirano vozilo")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemData1.rezervirano_vozilo),expression:"itemData1.rezervirano_vozilo"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"input-rezervirano_vozilo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.itemData1, "rezervirano_vozilo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Izberite")]),_vm._v(" "),_c('option',{attrs:{"value":"Da"}},[_vm._v("Da")]),_vm._v(" "),_c('option',{attrs:{"value":"Ne"}},[_vm._v("Ne")])]):_c('b-form-input',{attrs:{"type":"text","id":"input-rezervirano_vozilo","value":_vm.itemData.rezervirano_vozilo,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-maskirano_vozilo"}},[_vm._v("Maskirano vozilo")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemData1.maskirano_vozilo),expression:"itemData1.maskirano_vozilo"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"input-maskirano_vozilo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.itemData1, "maskirano_vozilo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Izberite")]),_vm._v(" "),_c('option',{attrs:{"value":"Da"}},[_vm._v("Da")]),_vm._v(" "),_c('option',{attrs:{"value":"Ne"}},[_vm._v("Ne")])]):_c('b-form-input',{attrs:{"type":"text","id":"input-maskirano_vozilo","value":_vm.itemData.maskirano_vozilo,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-skrito_vozilo"}},[_vm._v("Skrito vozilo")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemData1.skrito_vozilo),expression:"itemData1.skrito_vozilo"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"input-skrito_vozilo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.itemData1, "skrito_vozilo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Izberite")]),_vm._v(" "),_c('option',{attrs:{"value":"Da"}},[_vm._v("Da")]),_vm._v(" "),_c('option',{attrs:{"value":"Ne"}},[_vm._v("Ne")])]):_c('b-form-input',{attrs:{"type":"text","id":"input-skrito_vozilo","value":_vm.itemData.skrito_vozilo,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-viop"}},[_vm._v("VIOP")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemData1.viop),expression:"itemData1.viop"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"input-viop"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.itemData1, "viop", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Izberite")]),_vm._v(" "),_c('option',{attrs:{"value":"Da"}},[_vm._v("Da")]),_vm._v(" "),_c('option',{attrs:{"value":"Ne"}},[_vm._v("Ne")])]):_c('b-form-input',{attrs:{"type":"text","id":"input-viop","value":_vm.itemData.viop,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum fakturiranja","label-for":"input-datum_fakturiranja"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_fakturiranja",attrs:{"id":"input-datum_fakturiranja","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_fakturiranja),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_fakturiranja", $$v)},expression:"itemData1.datum_fakturiranja"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-datum_fakturiranja","value":_vm.itemData.datum_fakturiranja,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum vnosa NK","label-for":"input-datum_vnosa_nk"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_vnosa_nk",attrs:{"id":"input-datum_vnosa_nk","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_vnosa_nk),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_vnosa_nk", $$v)},expression:"itemData1.datum_vnosa_nk"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-datum_vnosa_nk","value":_vm.itemData.datum_vnosa_nk,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum DDK","label-for":"input-datum_ddk"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_ddk",attrs:{"id":"input-datum_ddk","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_ddk),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_ddk", $$v)},expression:"itemData1.datum_ddk"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-datum_ddk","value":_vm.itemData.datum_ddk,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum KDDK","label-for":"input-datum_kddk"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_kddk",attrs:{"id":"input-datum_kddk","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_kddk),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_kddk", $$v)},expression:"itemData1.datum_kddk"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-datum_kddk","value":_vm.itemData.datum_kddk,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-kupec"}},[_vm._v("Kupec")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-kupec"},model:{value:(_vm.itemData1.kupec),callback:function ($$v) {_vm.$set(_vm.itemData1, "kupec", $$v)},expression:"itemData1.kupec"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-kupec","value":_vm.itemData.kupec,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-konto_agenta_satelita"}},[_vm._v("Konto agenta satelita")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-konto_agenta_satelita"},model:{value:(_vm.itemData1.konto_agenta_satelita),callback:function ($$v) {_vm.$set(_vm.itemData1, "konto_agenta_satelita", $$v)},expression:"itemData1.konto_agenta_satelita"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-konto_agenta_satelita","value":_vm.itemData.konto_agenta_satelita,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-konto_destinacije"}},[_vm._v("Konto destinacije")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-konto_destinacije"},model:{value:(_vm.itemData1.konto_destinacije),callback:function ($$v) {_vm.$set(_vm.itemData1, "konto_destinacije", $$v)},expression:"itemData1.konto_destinacije"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-konto_destinacije","value":_vm.itemData.konto_destinacije,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-koda_prod"}},[_vm._v("Koda prod.")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-koda_prod"},model:{value:(_vm.itemData1.koda_prod),callback:function ($$v) {_vm.$set(_vm.itemData1, "koda_prod", $$v)},expression:"itemData1.koda_prod"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-koda_prod","value":_vm.itemData.koda_prod,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',{attrs:{"label":"Datum dodelitve","label-for":"input-dejanski_datum_dodelitve"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"dejanski_datum_dodelitve",attrs:{"id":"input-dejanski_datum_dodelitve","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.dejanski_datum_dodelitve),callback:function ($$v) {_vm.$set(_vm.itemData1, "dejanski_datum_dodelitve", $$v)},expression:"itemData1.dejanski_datum_dodelitve"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-dejanski_datum_dodelitve","value":_vm.itemData.dejanski_datum_dodelitve,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',{attrs:{"label":"Datum stornacije","label-for":"input-dejanski_datum_stornacije"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"dejanski_datum_stornacije",attrs:{"id":"input-dejanski_datum_stornacije","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.dejanski_datum_stornacije),callback:function ($$v) {_vm.$set(_vm.itemData1, "dejanski_datum_stornacije", $$v)},expression:"itemData1.dejanski_datum_stornacije"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-dejanski_datum_stornacije","value":_vm.itemData.dejanski_datum_stornacije,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-tip_kupca"}},[_vm._v("Tip kupca")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-tip_kupca"},model:{value:(_vm.itemData1.tip_kupca),callback:function ($$v) {_vm.$set(_vm.itemData1, "tip_kupca", $$v)},expression:"itemData1.tip_kupca"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-tip_kupca","value":_vm.itemData.tip_kupca,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-prodajni_kanal"}},[_vm._v("Prodajni kanal")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-prodajni_kanal"},model:{value:(_vm.itemData1.prodajni_kanal),callback:function ($$v) {_vm.$set(_vm.itemData1, "prodajni_kanal", $$v)},expression:"itemData1.prodajni_kanal"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-prodajni_kanal","value":_vm.itemData.prodajni_kanal,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-tip_nm"}},[_vm._v("Tip NM")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-tip_nm"},model:{value:(_vm.itemData1.tip_nm),callback:function ($$v) {_vm.$set(_vm.itemData1, "tip_nm", $$v)},expression:"itemData1.tip_nm"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-tip_nm","value":_vm.itemData.tip_nm,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-ime"}},[_vm._v("Ime")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-ime"},model:{value:(_vm.itemData1.ime),callback:function ($$v) {_vm.$set(_vm.itemData1, "ime", $$v)},expression:"itemData1.ime"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-ime","value":_vm.itemData.ime,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-email"}},[_vm._v("Email")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-email"},model:{value:(_vm.itemData1.email),callback:function ($$v) {_vm.$set(_vm.itemData1, "email", $$v)},expression:"itemData1.email"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-email","value":_vm.itemData.email,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-telefon_privatni"}},[_vm._v("Telefon")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-telefon_privatni"},model:{value:(_vm.itemData1.telefon_privatni),callback:function ($$v) {_vm.$set(_vm.itemData1, "telefon_privatni", $$v)},expression:"itemData1.telefon_privatni"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-telefon_privatni","value":_vm.itemData.telefon_privatni,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-st_pogodbe_v_advensysu"}},[_vm._v("Št. pogodbe")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-st_pogodbe_v_advensysu"},model:{value:(_vm.itemData1.st_pogodbe_v_advensysu),callback:function ($$v) {_vm.$set(_vm.itemData1, "st_pogodbe_v_advensysu", $$v)},expression:"itemData1.st_pogodbe_v_advensysu"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-st_pogodbe_v_advensysu","value":_vm.itemData.st_pogodbe_v_advensysu,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-stanje_narocila_kupca"}},[_vm._v("Stanje naročila kupca")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-stanje_narocila_kupca"},model:{value:(_vm.itemData1.stanje_narocila_kupca),callback:function ($$v) {_vm.$set(_vm.itemData1, "stanje_narocila_kupca", $$v)},expression:"itemData1.stanje_narocila_kupca"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-stanje_narocila_kupca","value":_vm.itemData.stanje_narocila_kupca,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-status_kvalitete"}},[_vm._v("Status kvalitete")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-status_kvalitete"},model:{value:(_vm.itemData1.status_kvalitete),callback:function ($$v) {_vm.$set(_vm.itemData1, "status_kvalitete", $$v)},expression:"itemData1.status_kvalitete"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-status_kvalitete","value":_vm.itemData.status_kvalitete,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Realni ara","label-for":"input-realni_ara"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"realni_ara",attrs:{"id":"input-realni_ara","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.realni_ara),callback:function ($$v) {_vm.$set(_vm.itemData1, "realni_ara", $$v)},expression:"itemData1.realni_ara"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-realni_ara","value":_vm.itemData.realni_ara,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-nef"}},[_vm._v("NEF")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-nef"},model:{value:(_vm.itemData1.nef),callback:function ($$v) {_vm.$set(_vm.itemData1, "nef", $$v)},expression:"itemData1.nef"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-nef","value":_vm.itemData.nef,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-ddo"}},[_vm._v("DDO")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-ddo"},model:{value:(_vm.itemData1.ddo),callback:function ($$v) {_vm.$set(_vm.itemData1, "ddo", $$v)},expression:"itemData1.ddo"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-ddo","value":_vm.itemData.ddo,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-ddpp"}},[_vm._v("DDPP")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-ddpp"},model:{value:(_vm.itemData1.ddpp),callback:function ($$v) {_vm.$set(_vm.itemData1, "ddpp", $$v)},expression:"itemData1.ddpp"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-ddpp","value":_vm.itemData.ddpp,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-blocage_financier"}},[_vm._v("Blocage financier")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-blocage_financier"},model:{value:(_vm.itemData1.blocage_financier),callback:function ($$v) {_vm.$set(_vm.itemData1, "blocage_financier", $$v)},expression:"itemData1.blocage_financier"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-blocage_financier","value":_vm.itemData.blocage_financier,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-blokada_komerciale"}},[_vm._v("Blokada komericale")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-blokada_komerciale"},model:{value:(_vm.itemData1.blokada_komerciale),callback:function ($$v) {_vm.$set(_vm.itemData1, "blokada_komerciale", $$v)},expression:"itemData1.blokada_komerciale"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-blokada_komerciale","value":_vm.itemData.blokada_komerciale,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-blokada_cata"}},[_vm._v("Blokada cata")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-blokada_cata"},model:{value:(_vm.itemData1.blokada_cata),callback:function ($$v) {_vm.$set(_vm.itemData1, "blokada_cata", $$v)},expression:"itemData1.blokada_cata"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-blokada_cata","value":_vm.itemData.blokada_cata,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-blokada_kvalitete"}},[_vm._v("Blokada kvalitete")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-blokada_kvalitete"},model:{value:(_vm.itemData1.blokada_kvalitete),callback:function ($$v) {_vm.$set(_vm.itemData1, "blokada_kvalitete", $$v)},expression:"itemData1.blokada_kvalitete"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-blokada_kvalitete","value":_vm.itemData.blokada_kvalitete,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-pgeo_bcv"}},[_vm._v("Pgeo bcv")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-pgeo_bcv"},model:{value:(_vm.itemData1.pgeo_bcv),callback:function ($$v) {_vm.$set(_vm.itemData1, "pgeo_bcv", $$v)},expression:"itemData1.pgeo_bcv"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-pgeo_bcv","value":_vm.itemData.pgeo_bcv,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-zadrzano_lastnik"}},[_vm._v("Zadrzano lastnik")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-zadrzano_lastnik"},model:{value:(_vm.itemData1.zadrzano_lastnik),callback:function ($$v) {_vm.$set(_vm.itemData1, "zadrzano_lastnik", $$v)},expression:"itemData1.zadrzano_lastnik"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-zadrzano_lastnik","value":_vm.itemData.zadrzano_lastnik,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-akcijski"}},[_vm._v("Akcijski")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-akcijski"},model:{value:(_vm.itemData1.akcijski),callback:function ($$v) {_vm.$set(_vm.itemData1, "akcijski", $$v)},expression:"itemData1.akcijski"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-akcijski","value":_vm.itemData.akcijski,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"input-koncesija_lokacija"}},[_vm._v("Koncesija lokacija")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-koncesija_lokacija"},model:{value:(_vm.itemData1.koncesija_lokacija),callback:function ($$v) {_vm.$set(_vm.itemData1, "koncesija_lokacija", $$v)},expression:"itemData1.koncesija_lokacija"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-koncesija_lokacija","value":_vm.itemData.koncesija_lokacija,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Koncesija prodajalec")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA)?_c('v-select',{ref:"prodajalci",attrs:{"options":_vm.vsiProdajalci,"label":"full_name","placeholder":"Izberi prodajalca ..."},model:{value:(_vm.prodajalci_selected),callback:function ($$v) {_vm.prodajalci_selected=$$v},expression:"prodajalci_selected"}}):(_vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-input',{attrs:{"type":"text","id":"input-koncesija_prodajalec","value":_vm.itemData1.koncesija_prodajalec,"disabled":""}}):_c('b-form-input',{attrs:{"type":"text","id":"input-koncesija_prodajalec","value":_vm.itemData.koncesija_prodajalec,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Koncesija datum","label-for":"input-koncesija_datum"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"koncesija_datum",attrs:{"id":"input-koncesija_datum","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.koncesija_datum),callback:function ($$v) {_vm.$set(_vm.itemData1, "koncesija_datum", $$v)},expression:"itemData1.koncesija_datum"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-koncesija_datum","value":_vm.itemData.koncesija_datum,"readonly":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label":"Datum izhoda iz oc","label-for":"input-datum_izhoda_iz_oc"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('v-date-picker',{ref:"datum_izhoda_iz_oc",attrs:{"id":"input-datum_izhoda_iz_oc","is-required":true,"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.itemData1.datum_izhoda_iz_oc),callback:function ($$v) {_vm.$set(_vm.itemData1, "datum_izhoda_iz_oc", $$v)},expression:"itemData1.datum_izhoda_iz_oc"}}):_c('b-form-input',{attrs:{"type":"text","id":"input-datum_izhoda_iz_oc","value":_vm.itemData.datum_izhoda_iz_oc,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"input-interna_opomba"}},[_vm._v("Interna opomba")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-textarea',{attrs:{"id":"input-interna_opomba","rows":2,"max-rows":6},model:{value:(_vm.itemData1.interna_opomba),callback:function ($$v) {_vm.$set(_vm.itemData1, "interna_opomba", $$v)},expression:"itemData1.interna_opomba"}}):_c('b-form-textarea',{attrs:{"id":"input-interna_opomba","rows":2,"max-rows":6,"value":_vm.itemData.interna_opomba,"readonly":""}})],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"input-opomba_narocilo_kupca"}},[_vm._v("Opomba naročila kupca")]),_vm._v(" "),(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-form-textarea',{attrs:{"id":"input-opomba_narocilo_kupca","rows":2,"max-rows":6},model:{value:(_vm.itemData1.opomba_narocilo_kupca),callback:function ($$v) {_vm.$set(_vm.itemData1, "opomba_narocilo_kupca", $$v)},expression:"itemData1.opomba_narocilo_kupca"}}):_c('b-form-textarea',{attrs:{"id":"input-opomba_narocilo_kupca","rows":2,"max-rows":6,"value":_vm.itemData.opomba_narocilo_kupca,"readonly":""}})],1)],1)],1)]),_vm._v(" "),_c('b-alert',{staticClass:"error_message",attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[(_vm.nacin === _vm.NACIN_DODAJANJA || _vm.nacin === _vm.NACIN_UREJANJA)?_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.modal_cancelClick($event)}}},[_vm._v("Prekliči")]):_vm._e(),_vm._v(" "),_c('b-button',{ref:"aOk",attrs:{"variant":"primary","data-style":"zoom-in","disabled":!_vm.vozilo_arhivirano},on:{"click":function($event){$event.stopPropagation();_vm.modal_okClick($event)}}},[_c('span',{staticClass:"ladda-label"},[_vm._v(_vm._s(_vm.ok_text))])])],1)],1)],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PodrobnostiVozilaZalogaCard_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e49aa80e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaZalogaCard_vue__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PodrobnostiVozilaZalogaCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e49aa80e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaZalogaCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e49aa80e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaZalogaCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Id:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.id))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Št. naročila vozila:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.st_narocila_vozila))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Konto lastnika:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.konto_lastnika))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Št. nm:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.st_nm))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Tip naročila:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.tip_narocila_vozila))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Vozilo na borzi:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.vozilo_na_borzi))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Obljubljeni mada:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.obljubljeni_mada))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Predevideni mada:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.predvideni_mada))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Realni mada:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.realni_mada))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Koda naslovnika:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.konto_naslovnika))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Koda prodajalca:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.koda_prodajalca))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Kupec:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.kupec))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Dobava v koncesijo:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.koncesija_datum))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("DVK Lokacija:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.koncesija_lokacija))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Zadržano:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.zadrzano_lastnik))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Opomba:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('div',{staticClass:"opomba_input_box"},[_vm._v(_vm._s(_vm.item.interna_opomba))])]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Akcijski:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("akcija_dane")(_vm.item.akcijski)))]),_vm._v(" "),(_vm.showAditionalParams)?_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Št. kilometrov:")])]):_vm._e(),_vm._v(" "),(_vm.showAditionalParams)?_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.st_kilometrov))]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Cena vozila brez opcij:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.vega_baseValueWithoutOptionsVatExcluded))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Cena barve:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.vega_coloursPclPriceVatExcluded))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Cena opcij:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.vega_additionalPclPriceVatExcluded))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Številka pogodbe:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.vega_contractNumber))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodajni kanal:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.vega_contractSalesChannel))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Stranka:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.vega_contractCustomerName))])],1),_vm._v(" "),(_vm.showAditionalParams)?_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Datum prve registracije:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_date")(_vm.item.datum_prve_registracije)))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodamo ga lahko od:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_date")(_vm.item.datum_kdaj_ga_lahko_prodamo)))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodati ga moramo do:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_date")(_vm.item.datum_kdaj_ga_moramo_prodati)))])],1):_vm._e(),_vm._v(" "),(_vm.showAditionalParams)?_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodajna cena:")])]),_vm._v(" "),(_vm.item.prodajna_cena != null && _vm.item.prodajna_cena > 0)?_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_money")(_vm.item.prodajna_cena)))]):_c('b-col',{attrs:{"sm":"2"}},[_vm._v(" / ")]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}})],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PodrobnostiVozilaCard_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1422f0bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaCard_vue__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PodrobnostiVozilaCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1422f0bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1422f0bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PodrobnostiVozilaCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Id:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.id))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Kupec:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.kupec))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Konto lastnika:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.konto_lastnika))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodajni kanal:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.prodajni_kanal))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Ime:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.ime))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Konto destinacije:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.konto_destinacije))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Tip kupca:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.tip_kupca))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Email:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.email))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Št. naročila vozila:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.st_narocila_vozila))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodajalec:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.koda_prod))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Telefon:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.telefon_privatni))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Datum vnosa N.K.:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.datum_vnosa_nk))])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Dobava v koncesijo:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.koncesija_datum))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("DVK Lokacija:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.koncesija_lokacija))]),_vm._v(" "),(_vm.showAditionalParams)?_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Št. kilometrov:")])]):_vm._e(),_vm._v(" "),(_vm.showAditionalParams)?_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm.item.st_kilometrov))]):_vm._e()],1),_vm._v(" "),(_vm.showAditionalParams)?_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Datum prve registracije:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_date")(_vm.item.datum_prve_registracije)))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodamo ga lahko od:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_date")(_vm.item.datum_kdaj_ga_lahko_prodamo)))]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodati ga moramo do:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_date")(_vm.item.datum_kdaj_ga_moramo_prodati)))])],1):_vm._e(),_vm._v(" "),(_vm.showAditionalParams)?_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Prodajna cena:")])]),_vm._v(" "),(_vm.item.prodajna_cena != null && _vm.item.prodajna_cena > 0)?_c('b-col',{attrs:{"sm":"2"}},[_vm._v(_vm._s(_vm._f("hr_money")(_vm.item.prodajna_cena)))]):_c('b-col',{attrs:{"sm":"2"}},[_vm._v(" / ")]),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}})],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",class:{ smalldt: (_vm.is_smalltext_class && _vm.showCompact) },attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-form',{staticClass:"date-dd"},[_c('b-row',[_c('b-col',{staticClass:"p-0",attrs:{"sm":"8"}},[_c('v-date-picker',{attrs:{"is-inline":"","max-date":_vm.noFutureValues ? new Date() : null,"is-expanded":"","mode":"range","locale":"sl-SI"},on:{"input":_vm.selected},model:{value:(_vm.izbranDatum),callback:function ($$v) {_vm.izbranDatum=$$v},expression:"izbranDatum"}}),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.click_pocisti($event)}}},[_vm._v("Odstrani")])],1),_vm._v(" "),_c('b-col',{staticClass:"tools",attrs:{"sm":"4"}},[_c('b-list-group',[_c('b-list-group-item',{attrs:{"href":"#zadnjiMesec"},on:{"click":function($event){$event.preventDefault();return _vm.click_prev30dni($event)}}},[_vm._v("Zadnjih 30 dni")]),_vm._v(" "),_c('b-list-group-item',{attrs:{"href":"#zadnjiTeden"},on:{"click":function($event){$event.preventDefault();return _vm.click_prev7dni($event)}}},[_vm._v("Zadnjih 7 dni")]),_vm._v(" "),_c('b-list-group-item',{attrs:{"href":"#danes"},on:{"click":function($event){$event.preventDefault();return _vm.click_1dan($event)}}},[_vm._v("Danes")]),_vm._v(" "),(_vm.noFutureValues == false)?_c('b-list-group-item',{attrs:{"href":"#naslednjiTeden"},on:{"click":function($event){$event.preventDefault();return _vm.click_next7dni($event)}}},[_vm._v("Naslednjih 7 dni")]):_c('b-list-group-item',{attrs:{"href":"#zadnje 3 mesece"},on:{"click":function($event){$event.preventDefault();return _vm.click_prev3mesece($event)}}},[_vm._v("Zadnje 3 mesece")]),_vm._v(" "),(_vm.noFutureValues == false)?_c('b-list-group-item',{attrs:{"href":"#naslednjiMesec"},on:{"click":function($event){$event.preventDefault();return _vm.click_next30dni($event)}}},[_vm._v("Naslednjih 30 dni")]):_c('b-list-group-item',{attrs:{"href":"#zadnjih 6 mesece"},on:{"click":function($event){$event.preventDefault();return _vm.click_prev6mesecev($event)}}},[_vm._v("Zadnjih 6 mesecev")]),_vm._v(" "),_c('b-list-group-item',{attrs:{"href":"#taMesec"},on:{"click":function($event){$event.preventDefault();return _vm.click_taMesec($event)}}},[_vm._v("Ta mesec")])],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KontoDestinacijeFilterDropdown_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a978b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KontoDestinacijeFilterDropdown_vue__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(978)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KontoDestinacijeFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a978b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KontoDestinacijeFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a978b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KontoDestinacijeFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Konto")]),_vm._v(" "),_vm._l((_vm.getItems),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCdpVehiclesStockModal_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204b5b46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCdpVehiclesStockModal_vue__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(981)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCdpVehiclesStockModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204b5b46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCdpVehiclesStockModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204b5b46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCdpVehiclesStockModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Osveži podatke CDP","ok-title":"Zaključi","cancel-title":"Prekliči","size":"lg"},on:{"ok":_vm.onOkModal}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep1),expression:"showStep1"}],staticClass:"dUpload"},[_c('vue-dropzone',{ref:"dzNewVehicles",staticClass:"dcImportCdpVehiclesStock new-vehicles",attrs:{"id":"dropzoneNewVehicles","include-styling":true,"options":_vm.usNewVehicles}}),_vm._v(" "),_c('vue-dropzone',{ref:"dzUsedVehicles",staticClass:"dcImportCdpVehiclesStock used-vehicles",attrs:{"id":"dropzoneUsedVehicles","include-styling":true,"options":_vm.usUsedVehicles}}),_vm._v(" "),_c('vue-dropzone',{ref:"dzdmv",staticClass:"dcImportCdpVehiclesStock dmv",attrs:{"id":"dropzonedmv","include-styling":true,"options":_vm.usDmv}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep2),expression:"showStep2"}],staticClass:"dProcessing"},[_vm._v("\n\t\t\tObdelava podatkov ...\n\t\t\t"),_c('b-progress',{staticClass:"mb-2",attrs:{"value":100,"variant":"success","striped":"","animated":_vm.animate}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep3),expression:"showStep3"}],domProps:{"innerHTML":_vm._s(_vm.uploadResultMessage)}})])}
var staticRenderFns = []


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCdpTraficModal_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b856215a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCdpTraficModal_vue__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(984)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCdpTraficModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b856215a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCdpTraficModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b856215a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCdpTraficModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Osveži podatke Trafic","ok-title":"Zaključi","cancel-title":"Prekliči","size":"lg"},on:{"ok":_vm.onOkModal}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep1),expression:"showStep1"}],staticClass:"dUpload"},[_c('vue-dropzone',{ref:"dzCdpTrafic",staticClass:"dcImportCdpTrafic trafic",attrs:{"id":"dropzoneCdpTrafic","include-styling":true,"options":_vm.usCdpTrafic}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep2),expression:"showStep2"}],staticClass:"dProcessing"},[_vm._v("\n\t\t\tObdelava podatkov ...\n\t\t\t"),_c('b-progress',{staticClass:"mb-2",attrs:{"value":100,"variant":"success","striped":"","animated":_vm.animate}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStep3),expression:"showStep3"}],domProps:{"innerHTML":_vm._s(_vm.uploadResultMessage)}})])}
var staticRenderFns = []


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultDropdownFilter_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce0fd5f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultDropdownFilter_vue__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(987)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultDropdownFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce0fd5f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultDropdownFilter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce0fd5f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultDropdownFilter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[(_vm.defaultHeader)?_c('b-dropdown-header',[_vm._v(_vm._s(_vm.defaultHeader))]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getVehicleBrandImage = function getVehicleBrandImage(logo) {
	var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

	return {
		'display': 'inline-block',
		'width': size + 'rem',
		'height': size + 'rem',
		'background-repeat': 'no-repeat',
		'background-position': 'center',
		'background-size': 'contain',
		'background-image': 'url( ' + getPublicImageUrl(logo) + ')'
	};
};

var getPublicImageUrl = function getPublicImageUrl(path) {
	if (path.startsWith('http')) {
		return path;
	}
	return "https://zaloga.avtotehnika-celje.si/" + path;
};

/* harmony default export */ __webpack_exports__["a"] = ({
	vehicleBrandImage: getVehicleBrandImage
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',{model:{value:(_vm.selectedTabIndex),callback:function ($$v) {_vm.selectedTabIndex=$$v},expression:"selectedTabIndex"}},[_c('b-tab',{attrs:{"title":"Zaloga"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-layers"}),_vm._v(" Zaloga vozil\n\t\t\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[(!_vm.exportActive)?_c('a',{staticClass:"btn btn-primary text-Secondary",attrs:{"title":"Izvozi vozila"},on:{"click":function($event){$event.preventDefault();return _vm.toggleExportActive($event)}}},[_c('i',{staticClass:"icon-cloud-download"})]):_vm._e(),_vm._v(" "),(_vm.exportActive)?_c('a',{class:(_vm.exportAll || _vm.selectedItems.length > 0) ? 'text-success btnConfirmExport' : 'text-danger btnConfirmExport'},[_vm._v(_vm._s((_vm.exportAll || _vm.selectedItems.length > 0) ? 'Izvoz ' + (_vm.exportAll ? _vm.totalRows : _vm.selectedItems.length) + ' vozil' : 'Izbrano mora biti vsaj 1 vozilo'))]):_vm._e(),_vm._v(" "),(_vm.exportActive && (_vm.exportAll || _vm.selectedItems.length > 0))?_c('a',{staticClass:"btn btn-primary text-success",attrs:{"title":"Potrdi izvoz'"},on:{"click":function($event){$event.preventDefault();return _vm.exportImportData($event)}}},[_c('i',{staticClass:"icon-check"})]):_vm._e(),_vm._v(" "),(_vm.exportActive)?_c('a',{staticClass:"btn btn-primary text-danger",attrs:{"title":"Prekliči izvoz"},on:{"click":function($event){$event.preventDefault();return _vm.toggleExportActive($event)}}},[_c('i',{staticClass:"icon-close"})]):_vm._e(),_vm._v(" "),(!_vm.exportActive)?_c('a',{staticClass:"btn btn-setting btnArhiv"},[_c('b-form-checkbox',{on:{"change":_vm.arhiv_Changed},model:{value:(_vm.inputFilter.arhiv),callback:function ($$v) {_vm.$set(_vm.inputFilter, "arhiv", $$v)},expression:"inputFilter.arhiv"}},[_vm._v("Arhiv")])],1):_vm._e(),_vm._v(" "),(!_vm.exportActive && false)?_c('a',{staticClass:"btn btn-setting btnNissan"},[_c('b-form-checkbox',{on:{"change":_vm.nissan_Changed},model:{value:(_vm.inputFilter.nissan),callback:function ($$v) {_vm.$set(_vm.inputFilter, "nissan", $$v)},expression:"inputFilter.nissan"}},[_vm._v("Nissan")])],1):_vm._e(),_vm._v(" "),(!_vm.exportActive)?_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#odstraniFilter","title":"Ponastavi filtre"},on:{"click":function($event){$event.preventDefault();return _vm.click_clearTableFilter($event)}}},[_c('i',{staticClass:"icon-action-undo"})]):_vm._e(),_vm._v(" "),(!_vm.exportActive && false)?_c('a',{staticClass:"btn btn-setting text-warning",attrs:{"href":"#osveziPodatke","title":"Uvozi Renault in Dacia"},on:{"click":function($event){$event.preventDefault();return _vm.click_openPopulateDataModal($event)}}},[_c('i',{staticClass:"icon-cloud-upload"})]):_vm._e(),_vm._v(" "),(!_vm.exportActive && false)?_c('a',{staticClass:"btn btn-primary text-info",attrs:{"href":"#uploadNissan","title":"Uvozi Nissan"},on:{"click":function($event){$event.preventDefault();return _vm.click_openPopulateNissanModal($event)}}},[_c('i',{staticClass:"icon-cloud-upload"})]):_vm._e(),_vm._v(" "),(!_vm.exportActive)?_c('a',{staticClass:"btn btn-setting text-primary",attrs:{"href":"#osveziVega","title":"Uvozi Vega"},on:{"click":function($event){$event.preventDefault();return _vm.click_openPopulateVegaModal($event)}}},[_c('i',{staticClass:"icon-cloud-upload"})]):_vm._e(),_vm._v(" "),(!_vm.exportActive)?_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#dodajVozilo","title":"Ročno dodaj vozilo"},on:{"click":function($event){$event.preventDefault();return _vm.click_addNew($event)}}},[_c('i',{staticClass:"icon-plus"})]):_vm._e()])]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Prodajalec")]),_vm._v(" "),_c('v-select',{ref:"prodajalci",attrs:{"options":_vm.prodajalci_options,"label":"full_name","placeholder":"Izberi prodajalca ..."},on:{"input":_vm.prodajalci_Changed},model:{value:(_vm.prodajalec_selected),callback:function ($$v) {_vm.prodajalec_selected=$$v},expression:"prodajalec_selected"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Kupec")]),_vm._v(" "),_c('v-select',{ref:"kupci",attrs:{"options":_vm.kupci_searched,"label":"full_name","placeholder":"Izberi kupca ..."},on:{"input":_vm.kupciSelect_change,"search":_vm.kupciSelect_search},model:{value:(_vm.kupec_selected),callback:function ($$v) {_vm.kupec_selected=$$v},expression:"kupec_selected"}},[_c('template',{slot:"no-options"},[_vm._v("Kupec ni najden")])],2)],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',[_c('label',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("Planirana dobava")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('datum-filter-dropdown',{ref:"obljubljenaDobavaDropdown",attrs:{"compact":false,"default_label":"Izberi obdobje ..."},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.obljubljenaDobava),callback:function ($$v) {_vm.$set(_vm.inputFilter, "obljubljenaDobava", $$v)},expression:"inputFilter.obljubljenaDobava"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{staticClass:"advanced_filter_lokacije"})],1),_vm._v(" "),_c('b-col'),_vm._v(" "),_c('b-col')],1)],1),_vm._v(" "),(_vm.selectedTabIndex === 0)?_c('b-table',{ref:"dataTable",attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","items":_vm.dataProvider,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"tbody-tr-class":_vm.rowClass},on:{"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"selected",fn:function(data){return [_c('b-form-checkbox',{attrs:{"disabled":_vm.exportAll,"checked":_vm.exportAll ? true : data.item.selected},on:{"change":function($event){_vm.selectItem_change(data.item)}}})]}},{key:"libelle_version",fn:function(data){return [_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"model_version",attrs:{"title":_vm.getTitle(data.item.libelle_version)}},[_vm._v(_vm._s(_vm._f("model_short_version")(data.item.libelle_version)))])]}},{key:"libelle_options",fn:function(data){return [(data.item.vega_additionalName != '' && data.item.vega_additionalName != 'null' && data.item.vega_additionalName != null)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"","title":_vm.getTitle(data.item.vega_additionalName)}},[_c('i',{staticClass:"i_options fa fa-gears fa-lg",staticStyle:{"padding":"2px"}})]):_vm._e(),_vm._v(" "),(data.item.vega_coloursName != '' && data.item.vega_coloursName != 'null' && data.item.vega_coloursName != null)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"","title":_vm.getTitle(data.item.vega_coloursName)}},[(data.item.barva != '' && data.item.barva != 'null' && data.item.barva != null)?_c('span',{staticStyle:{"line-height":"20px"}},[_vm._v(_vm._s(data.item.barva))]):_c('span',{staticStyle:{"line-height":"20px"}},[_c('i',{staticClass:"fa fa-tint",staticStyle:{"margin-left":"5px","margin-right":"5px"}})])]):_vm._e()]}},{key:"status",fn:function(data){return [(_vm.isReserved(data.item))?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"danger","title":_vm.getReservationInfo(data.item)}},[_vm._v("Rezervirano")]):_vm._e(),_vm._v(" "),(_vm.isSold(data.item))?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"success","title":_vm.getSoldInfo(data.item)}},[_vm._v("Prodano")]):_vm._e(),_vm._v(" "),(_vm.isKoncesija(data.item))?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"warning","title":_vm.getKoncesijaInfo(data.item)}},[_vm._v(_vm._s(_vm._f("koncesija_label")(data.item)))]):_vm._e()]}},{key:"actions",fn:function(data){return (!_vm.exportActive)?[_c('b-button',{staticClass:"mr-1 mb-1",attrs:{"size":"sm","disabled":_vm.isReservedDisabled(data.item.has_reservation, data.item.has_sold)},on:{"click":function($event){$event.stopPropagation();_vm.click_reserveItem(data.item.id)}}},[_vm._v("Rezerviraj")]),_vm._v(" "),_c('b-button',{staticClass:"mr-1 mb-1",class:{ disabled: _vm.isSold(data.item) },attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.click_sellItem(data.item)}}},[_vm._v("Prodaj")]),_vm._v(" "),_c('b-button',{staticClass:"mr-1 mb-1",class:{ disabled: _vm.isKoncesija(data.item) },attrs:{"size":"sm","variant":"warning"},on:{"click":function($event){$event.stopPropagation();_vm.click_dobavavKoncesijo(data.item)}}},[_vm._v("DK")])]:undefined}},{key:"row-details",fn:function(row){return [(row.item.source_file == 'zaloga')?_c('podrobnosti-vozila-zaloga-card',{ref:"PodrobnostiVozilaZalogaCard",attrs:{"item":row.item}}):_c('podrobnosti-vozila-card',{ref:"PodrobnostiVozilaCard",attrs:{"item":row.item}}),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b',[_vm._v("Opomba:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"opomba_input_box"},[_vm._v(_vm._s(row.item.interna_opomba))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_editOpomba(row, $event.target)}}},[_vm._v("Uredi")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-sm-left",attrs:{"sm":"4"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_showInfo(row, $event.target)}}},[_vm._v("Podrobnosti")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_showMapa(row, $event.target)}}},[_vm._v("Mapa")]),_vm._v(" "),(row.item.st_narocila_kupca == '' && row.item.has_sold && _vm.allowStorno())?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.click_stornirajProdajo(row.item.has_sold)}}},[_vm._v("Storniraj")]):_vm._e(),_vm._v(" "),(row.item.st_narocila_kupca == '' && row.item.has_reservation && _vm.allowStorno())?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){$event.stopPropagation();_vm.click_stornirajRezervacijo(row.item.has_reservation)}}},[_vm._v("Storniraj")]):_vm._e(),_vm._v(" "),(row.item.st_narocila_kupca == '' && (row.item.konto_destinacije == 'CENNM' || row.item.konto_destinacije == 'SVNCENNM' || row.item.konto_destinacije == 'SIDCENNM'))?_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_zadrzano(row.item.id)}}},[_vm._v("Zadržano")]):_vm._e(),_vm._v(" "),(_vm.showDeleteButton(row.item))?_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.clicl_deleteImportdata(row.item)}}},[_vm._v("Izbriši")]):_vm._e(),_vm._v(" "),(_vm.showArchiveButton(row.item))?_c('b-button',{attrs:{"variant":"warning","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_archiveImportdata(row.item)}}},[_vm._v("Arhiviraj")]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"text-sm-right",attrs:{"sm":"2"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":row.toggleDetails}},[_vm._v("Zapri")])],1)],1)]}}])},[_c('template',{slot:"top-row"},[(_vm.exportActive)?_c('td',[_c('b-form-checkbox',{model:{value:(_vm.exportAll),callback:function ($$v) {_vm.exportAll=$$v},expression:"exportAll"}})],1):_vm._e(),_vm._v(" "),_c('td',[_c('konto-filter-dropdown',{ref:"kontoDropdown",on:{"change":_vm.on_kontoFilterChange}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.vega_dhsVegaSalesId),callback:function ($$v) {_vm.$set(_vm.inputFilter, "vega_dhsVegaSalesId", $$v)},expression:"inputFilter.vega_dhsVegaSalesId"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.st_narocila_kupca),callback:function ($$v) {_vm.$set(_vm.inputFilter, "st_narocila_kupca", $$v)},expression:"inputFilter.st_narocila_kupca"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.st_narocila_vozila),callback:function ($$v) {_vm.$set(_vm.inputFilter, "st_narocila_vozila", $$v)},expression:"inputFilter.st_narocila_vozila"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.ogrodje),callback:function ($$v) {_vm.$set(_vm.inputFilter, "ogrodje", $$v)},expression:"inputFilter.ogrodje"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.vega_brand),callback:function ($$v) {_vm.$set(_vm.inputFilter, "vega_brand", $$v)},expression:"inputFilter.vega_brand"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.model),callback:function ($$v) {_vm.$set(_vm.inputFilter, "model", $$v)},expression:"inputFilter.model"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.verzija),callback:function ($$v) {_vm.$set(_vm.inputFilter, "verzija", $$v)},expression:"inputFilter.verzija"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.barva),callback:function ($$v) {_vm.$set(_vm.inputFilter, "barva", $$v)},expression:"inputFilter.barva"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.predvideni_mada),callback:function ($$v) {_vm.$set(_vm.inputFilter, "predvideni_mada", $$v)},expression:"inputFilter.predvideni_mada"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.vega_status),callback:function ($$v) {_vm.$set(_vm.inputFilter, "vega_status", $$v)},expression:"inputFilter.vega_status"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onInputChange},model:{value:(_vm.inputFilter.staranje),callback:function ($$v) {_vm.$set(_vm.inputFilter, "staranje", $$v)},expression:"inputFilter.staranje"}})],1),_vm._v(" "),_c('td',[_c('status-filter-dropdown',{ref:"statusDropdown",on:{"change":_vm.on_statusFilterChange}}),_vm._v(" "),_c('prodaja-filter-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProdajaDropdownVisible),expression:"isProdajaDropdownVisible"}],ref:"prodajaDropdown",on:{"change":_vm.on_prodajaFilterChange}}),_vm._v(" "),_c('lokacije-filter-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLokacijeDropdownVisible),expression:"isLokacijeDropdownVisible"}],ref:"lokacijeDropdown",on:{"change":_vm.on_lokacijeFilterChange}})],1),_vm._v(" "),_c('td')])],2):_vm._e(),_vm._v(" "),_c('nav',[_c('b-row',[_c('b-col',{attrs:{"sm":"10"}},[_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","limit":_vm.naviLimit,"hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.totalRows))])])],1)],1)],1),_vm._v(" "),_c('populate-data-modal',{ref:"populateDataModal",on:{"data-updated":_vm.on_dataUpdated}}),_vm._v(" "),_c('populate-vega-modal',{ref:"populateVegaModal",on:{"data-updated":_vm.on_dataUpdated}}),_vm._v(" "),_c('populate-nissan-modal',{ref:"populateNissanModal",on:{"data-updated":_vm.on_dataUpdated}}),_vm._v(" "),_c('rezerviraj-vozilo-modal',{ref:"rezervirajVoziloModal",attrs:{"prodajalci":_vm.prodajalci_options,"kupci":_vm.kupci_options},on:{"reservation-success":_vm.on_reservationSuccess}}),_vm._v(" "),_c('prodaj-vozilo-modal',{ref:"prodajVoziloModal",attrs:{"prodajalci":_vm.prodajalci_options,"kupci":_vm.kupci_options},on:{"sell-success":_vm.on_sellSuccess}}),_vm._v(" "),_c('dobava-v-koncesijo-modal',{ref:"dobavavKoncesijoModal",on:{"prodajavkoncesijo-success":_vm.on_prodajavkoncesijoSuccess}}),_vm._v(" "),_c('zadrzano-modal',{ref:"zadrzanoModal",on:{"zadrzano-success":_vm.on_zadrzanoSuccess}}),_vm._v(" "),_c('opomba-vozila-modal',{ref:"opombaVozilaModal",on:{"opomba-success":_vm.on_opombaSuccess}}),_vm._v(" "),_c('mapa-modal',{ref:"mapaModal"}),_vm._v(" "),_c('podrobnosti-vozila-modal',{ref:"podrobnostiVozilaModal",on:{"importdata_add":_vm.importdata_add,"importdata_edit":_vm.importdata_edit}})],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"CDP zaloga"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-layers"}),_vm._v(" CDP Zaloga vozil\n\t\t\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[_c('a',{staticClass:"btn btn-setting btnStickyHeader"},[_c('b-form-checkbox',{model:{value:(_vm.stickyHeader),callback:function ($$v) {_vm.stickyHeader=$$v},expression:"stickyHeader"}},[_vm._v("Pripeta glava")])],1),_vm._v(" "),_c('a',{staticClass:"btn btn-setting text-primary",attrs:{"title":"Uvozi Trafic"},on:{"click":function($event){$event.preventDefault();return _vm.click_openImportCdpTraficModal($event)}}},[_c('i',{staticClass:"icon-cloud-upload"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-setting text-success",attrs:{"title":"Uvozi CDP zalogo"},on:{"click":function($event){$event.preventDefault();return _vm.click_openImportCdpVehiclesStockModal($event)}}},[_c('i',{staticClass:"icon-cloud-upload"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-setting",attrs:{"title":"Ponastavi filtre"},on:{"click":function($event){$event.preventDefault();return _vm.click_clearcdpVehiclesStockTableFilter($event)}}},[_c('i',{staticClass:"icon-action-undo"})])])]),_vm._v(" "),_c('div',{class:_vm.stickyHeader ? 'table-scroll-wrapper' : ''},[(_vm.selectedTabIndex === 1)?_c('b-table',{ref:"cdpVehiclesStockTable",class:_vm.stickyHeader ? 'sticky-header-table' : '',attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","items":_vm.cdpVehiclesStockItems,"fields":_vm.cdpVehiclesStockTableProps.fields,"current-page":_vm.cdpVehiclesStockTableProps.currentPage,"per-page":_vm.cdpVehiclesStockTableProps.perPage},scopedSlots:_vm._u([{key:"model",fn:function(data){return [_c('div',{staticClass:"d-flex justify-content-center align-items-center h-100"},[(_vm.settings.vehicle_models.find(function (element) { return element.value === data.item.model.toLowerCase(); }))?_c('div',{style:(_vm.imagesTool.vehicleBrandImage(_vm.settings.vehicle_models.find(function (element) { return element.value === data.item.model.toLowerCase(); }).icon, 2)),attrs:{"title":data.item.model + ' ' + data.item.type}}):_c('div',{style:(_vm.imagesTool.vehicleBrandImage(_vm.settings.vehicle_models[0].icon, 2)),attrs:{"title":data.item.model + ' ' + data.item.type}})])]}},{key:"kind",fn:function(data){return [_c('div',{staticClass:"d-flex justify-content-center align-items-center h-100"},[(data.item.kind)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2",attrs:{"variant":_vm.settings.cdp_vehicle_stock_kind.find(function (element) { return element.value === data.item.kind; }).variant,"title":data.item.kind}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.settings.cdp_vehicle_stock_kind.find(function (element) { return element.value === data.item.kind; }).label)+"\n\t\t\t\t\t\t\t\t\t\t\t")]):_vm._e()],1)]}},{key:"delivery_date",fn:function(data){return [(data.item.delivery_date)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.delivery_date))+" ")]):_vm._e()]}},{key:"stock_status",fn:function(data){return [(data.item.stock_status === 'na zalogi')?_c('span',{staticClass:"ml-1 rounded-circle bg-success d-inline-block",staticStyle:{"width":"15px","height":"15px"},attrs:{"title":data.item.stock_status}}):_c('span',{staticClass:"ml-1 rounded-circle border border-success d-inline-block",staticStyle:{"width":"15px","height":"15px"},attrs:{"title":data.item.stock_status}}),_vm._v(" "),(data.item.sales_status === 'razpol.')?_c('span',{staticClass:"ml-1 rounded-circle bg-warning d-inline-block",staticStyle:{"width":"15px","height":"15px"},attrs:{"title":data.item.sales_status}}):_c('span',{staticClass:"ml-1 rounded-circle border border-danger d-inline-block",staticStyle:{"width":"15px","height":"15px"},attrs:{"title":data.item.sales_status}})]}},{key:"purchase_price",fn:function(data){return [(data.item.purchase_price)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.purchase_price))+" ")]):_vm._e()]}},{key:"dmv",fn:function(data){return [(data.item.dmv)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.dmv))+" ")]):_vm._e()]}},{key:"purchase_price_with_dmv",fn:function(data){return [(data.item.purchase_price_with_dmv)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.purchase_price_with_dmv))+" ")]):_vm._e()]}},{key:"due_date",fn:function(data){return [(data.item.due_date)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.due_date))+" ")]):_vm._e()]}},{key:"amount_due",fn:function(data){return [(data.item.amount_due)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.amount_due))+" ")]):_vm._e()]}},{key:"actions",fn:function(data){return [(data.item.paid_at)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge-lg",attrs:{"pill":"","variant":"success","title":_vm.cdpVehicleStockPaidTitle(data.item)}},[_vm._v("Plačano")]):_c('b-button',{staticClass:"mr-1 mb-1",attrs:{"variant":"primary","disabled":!_vm.userCanConfirmCdpVehicleStockPay},on:{"click":function($event){$event.stopPropagation();_vm.click_cdpVehicleStockPay(data.item)}}},[_vm._v("Potrdi plačilo")])]}}])},[_c('template',{slot:"top-row"},[_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCdpVehiclesStockFilterChange},model:{value:(_vm.cdpVehiclesStockTableProps.inputFilter.number),callback:function ($$v) {_vm.$set(_vm.cdpVehiclesStockTableProps.inputFilter, "number", $$v)},expression:"cdpVehiclesStockTableProps.inputFilter.number"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCdpVehiclesStockFilterChange},model:{value:(_vm.cdpVehiclesStockTableProps.inputFilter.vin),callback:function ($$v) {_vm.$set(_vm.cdpVehiclesStockTableProps.inputFilter, "vin", $$v)},expression:"cdpVehiclesStockTableProps.inputFilter.vin"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCdpVehiclesStockFilterChange},model:{value:(_vm.cdpVehiclesStockTableProps.inputFilter.registration_number),callback:function ($$v) {_vm.$set(_vm.cdpVehiclesStockTableProps.inputFilter, "registration_number", $$v)},expression:"cdpVehiclesStockTableProps.inputFilter.registration_number"}})],1),_vm._v(" "),_c('td',[_c('default-dropdown-filter',{ref:"cdpVehicleStockModelDropdown",attrs:{"items":_vm.cdpVehicleStockModelOptions},on:{"change":_vm.on_cdpVehicleStockModelFilterChange}})],1),_vm._v(" "),_c('td',[_c('default-dropdown-filter',{ref:"cdpVehicleStockKindDropdown",attrs:{"items":_vm.cdpVehicleStockKindOptions},on:{"change":_vm.on_cdpVehicleStockKindFilterChange}})],1),_vm._v(" "),_c('td',[_c('default-dropdown-filter',{ref:"cdpVehicleStockLocationsDropdown",attrs:{"items":_vm.locationOptions},on:{"change":_vm.on_cdpVehicleStockLocationFilterChange}})],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('datum-filter-dropdown',{ref:"cdpVehiclesStockDueDateDropdown",attrs:{"compact":false,"default_label":"Vse"},on:{"input":_vm.on_cdpDataUpdated},model:{value:(_vm.cdpVehiclesStockTableProps.inputFilter.due_date),callback:function ($$v) {_vm.$set(_vm.cdpVehiclesStockTableProps.inputFilter, "due_date", $$v)},expression:"cdpVehiclesStockTableProps.inputFilter.due_date"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCdpVehiclesStockFilterChange},model:{value:(_vm.cdpVehiclesStockTableProps.inputFilter.invoice_number),callback:function ($$v) {_vm.$set(_vm.cdpVehiclesStockTableProps.inputFilter, "invoice_number", $$v)},expression:"cdpVehiclesStockTableProps.inputFilter.invoice_number"}})],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('default-dropdown-filter',{ref:"cdpVehicleStockPaidDropdown",attrs:{"multiselect":false,"items":_vm.cdpVehicleStockPaidOptions},on:{"change":_vm.on_cdpVehicleStockPaidFilterChange}})],1)]),_vm._v(" "),_c('template',{slot:"bottom-row"},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[(_vm.cdpVehiclesStockTableProps.purchasePriceSum)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(_vm.cdpVehiclesStockTableProps.purchasePriceSum))+" ")]):_vm._e()]),_vm._v(" "),_c('td',[(_vm.cdpVehiclesStockTableProps.dmvSum)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(_vm.cdpVehiclesStockTableProps.dmvSum))+" ")]):_vm._e()]),_vm._v(" "),_c('td',[(_vm.cdpVehiclesStockTableProps.purchasePriceWithDmvSum)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(_vm.cdpVehiclesStockTableProps.purchasePriceWithDmvSum))+" ")]):_vm._e()]),_vm._v(" "),_c('td',[(_vm.cdpVehiclesStockTableProps.amountDueSum)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(_vm.cdpVehiclesStockTableProps.amountDueSum))+" ")]):_vm._e()]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])],2):_vm._e()],1),_vm._v(" "),_c('nav',[_c('b-row',[_c('b-col',{attrs:{"sm":"10"}},[(false)?_c('b-pagination',{attrs:{"total-rows":_vm.cdpVehiclesStockTableProps.totalRows,"per-page":_vm.cdpVehiclesStockTableProps.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","limit":_vm.cdpVehiclesStockTableProps.navLimit,"hide-goto-end-buttons":""},model:{value:(_vm.cdpVehiclesStockTableProps.currentPage),callback:function ($$v) {_vm.$set(_vm.cdpVehiclesStockTableProps, "currentPage", $$v)},expression:"cdpVehiclesStockTableProps.currentPage"}}):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.cdpVehiclesStockTableProps.totalRows))])])],1)],1)]),_vm._v(" "),_c('import-cdp-vehicles-stock-modal',{ref:"importCdpVehiclesStockModal",on:{"data-updated":_vm.on_cdpDataUpdated}}),_vm._v(" "),_c('import-cdp-trafic-modal',{ref:"importCdpTraficModal",on:{"data-updated":_vm.on_cdpDataUpdated}})],1)],1)],1)],1),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.cdpVehiclesStockTableProps.isLoading},on:{"update:active":function($event){_vm.$set(_vm.cdpVehiclesStockTableProps, "isLoading", $event)}}}),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)}
var staticRenderFns = []


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Izdaja_vue__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddc18d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Izdaja_vue__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(992)
  __webpack_require__(993)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ddc18d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Izdaja_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddc18d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Izdaja_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddc18d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Izdaja_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IzdajaModal_vue__ = __webpack_require__(554);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292c2c3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IzdajaModal_vue__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1001)
  __webpack_require__(1002)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-292c2c3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IzdajaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292c2c3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IzdajaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292c2c3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IzdajaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Izdaja vozila"},on:{"ok":_vm.onOkModal},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"align-self":"start"}},[(_vm.izdaja_id != null && _vm.userCanEdit)?_c('b-button',{attrs:{"variant":"warning","disabled":_vm.in_progress},on:{"click":function($event){$event.stopPropagation();return _vm.click_odstrani($event)}}},[_vm._v("Odstrani")]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary","disabled":_vm.in_progress},on:{"click":function($event){cancel()}}},[_vm._v("Prekliči")]),_vm._v(" "),(_vm.userCanEdit)?_c('b-button',{attrs:{"variant":"primary","disabled":_vm.in_progress},on:{"click":function($event){ok()}}},[_vm._v(_vm._s(_vm.ok_title))]):_vm._e()],1)],1)],1)]}}])},[_c('b-form',{ref:"form"},[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Prodajalec")]),_vm._v(" "),_c('v-select',{ref:"prodajalci",attrs:{"options":_vm.vsiProdajalci,"disabled":_vm.prodajalci_disabled,"label":"full_name","placeholder":"Izberi prodajalca ..."},model:{value:(_vm.prodajalci_selected),callback:function ($$v) {_vm.prodajalci_selected=$$v},expression:"prodajalci_selected"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',[_vm._v("Vozilo"),((_vm.vozilo_selected && _vm.vozilo_selected.id > 0))?_c('span',{staticClass:"model_name"},[_vm._v(" "+_vm._s(_vm.vozilo_selected.libelle_modele)+" ("+_vm._s(_vm.vozilo_selected.libelle_version)+")")]):_vm._e()]),_vm._v(" "),_c('v-select',{ref:"vozila",attrs:{"disabled":!_vm.userCanEdit,"options":_vm.vozila_options,"create-option":_vm.vozilaSelect_createOption,"taggable":true,"filterable":false,"label":"ogrodje","placeholder":"Izberi vozilo ..."},on:{"input":_vm.voziloSelect_change,"search":_vm.vozilaSelect_search},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(option.ogrodje)+"\n\t\t\t\t\t\t\t")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(option.ogrodje)+"\n\t\t\t\t\t\t\t")]}}]),model:{value:(_vm.vozilo_selected),callback:function ($$v) {_vm.vozilo_selected=$$v},expression:"vozilo_selected"}},[_c('template',{slot:"no-options"},[_vm._v("Vnesite VIN številko vozila")])],2)],1)],1)],1),_vm._v(" "),_c('pick-kupec-inline',{ref:"pickKupec",attrs:{"userCanEdit":_vm.userCanEdit,"kupci":_vm.kupci,"title":"Kupec"},model:{value:(_vm.kupec_selected),callback:function ($$v) {_vm.kupec_selected=$$v},expression:"kupec_selected"}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Datum izdaje*:","label-for":"datum_izdaje"}},[(_vm.userCanEdit)?_c('v-date-picker',{ref:"datum_izdaje",attrs:{"id":"datum_izdaje","is-required":true,"input-props":{
								class: "form-control dt_border gdt_border",
								placeholder: "DD. MM. YYYY",
								required: true
							},"min-date":_vm.dateRange.min,"max-date":_vm.dateRange.max,"mode":"single","locale":"sl-SI"},model:{value:(_vm.datum_izdaje),callback:function ($$v) {_vm.datum_izdaje=$$v},expression:"datum_izdaje"}}):_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.datum_izdaje),"disabled":""}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Čas izdaje*:","label-for":"cas_izdaje"}},[(_vm.userCanEdit)?_c('v-timepicker',{ref:"cas_izdaje",attrs:{"id":"cas_izdaje","format":"HH : mm","hour-range":[7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],"hide-disabled-hours":"","minute-interval":30,"placeholder":"HH : MM","input-class":"form-control"},model:{value:(_vm.cas_izdaje),callback:function ($$v) {_vm.cas_izdaje=$$v},expression:"cas_izdaje"}}):_c('b-form-input',{attrs:{"type":"text","value":_vm.getCasIzdajeText(),"disabled":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',{attrs:{"for":"opomba"}},[_vm._v("Opomba")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"opomba","disabled":!_vm.userCanEdit,"type":"text","max":"5000"},model:{value:(_vm.opomba),callback:function ($$v) {_vm.opomba=$$v},expression:"opomba"}})],1)],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.action_message_type && _vm.action_message_type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.action_message && _vm.action_message !== ''}},[_vm._v(_vm._s(_vm.action_message))])],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-calendar"}),_vm._v(" Koledar izdaj\n\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[(_vm.userCanEdit)?_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#dodajIzdajo"},on:{"click":function($event){$event.preventDefault();return _vm.click_openAddIzdaja($event)}}},[_c('i',{staticClass:"icon-share-alt"})]):_vm._e()])]),_vm._v(" "),_c('FullCalendar',{ref:"calendar",attrs:{"defaultView":"timeGridWeek","locale":_vm.calendarLocale,"header":_vm.calendarHeader,"buttonText":_vm.calendarButtonText,"plugins":_vm.calendarPlugins,"firstDay":"1","height":"auto","selectable":"true","selectOverlap":"false","slotLabelFormat":_vm.calendarSlotLabelFormat,"navLinks":"true","weekNumbers":"true","weekNumbersWithinDays":"true","allDaySlot":_vm.calendarAllDaySlot,"allDay":"false","slotDuration":"00:30:00","nowIndicator":"true","minTime":"09:00:00","maxTime":"16:30:00","displayEventTime":false,"displayEventEnd":false,"selectAllow":_vm.handleSelectAllow,"eventRender":_vm.handleEventRender,"events":_vm.handleEvents,"validRange":_vm.handleValidRange,"datesRender":_vm.handleDatesRender,"themeSystem":"bootstrap"},on:{"eventClick":_vm.handleEventClick,"dateClick":_vm.handleDateClick,"select":_vm.handleSelect}}),_vm._v(" "),_c('izdaja-modal',{ref:"izdajModal",attrs:{"kupci":_vm.vsiKupci},on:{"izdaja-success":_vm.on_izdajeSuccess,"izdaja-removed":_vm.on_izdajeRemoved}})],1)],1)],1),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)}
var staticRenderFns = []


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kupci_vue__ = __webpack_require__(555);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a1ab7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kupci_vue__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1006)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kupci_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a1ab7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kupci_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a1ab7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kupci_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditKupecModal_vue__ = __webpack_require__(556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c23832c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditKupecModal_vue__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1008)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditKupecModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c23832c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditKupecModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c23832c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditKupecModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle,"ok-title":_vm.modalOkTitle,"cancel-title":_vm.modalCancelTitle,"busy":_vm.modalIsBusy},on:{"ok":_vm.onOkModal}},[_c('b-form',{ref:"form",attrs:{"novalidate":""}},[(_vm.modalErrorMsg)?_c('app-mbox',{attrs:{"text":_vm.modalErrorMsg.message},on:{"dismissed":_vm.clear_error_msg}}):_vm._e(),_vm._v(" "),_c('b-form-radio-group',{staticClass:"mb-3",model:{value:(_vm.modalItem.is_company),callback:function ($$v) {_vm.$set(_vm.modalItem, "is_company", $$v)},expression:"modalItem.is_company"}},[_c('b-form-radio',{attrs:{"value":"false"}},[_vm._v("Fizična oseba")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"true"}},[_vm._v("Podjetje")])],1),_vm._v(" "),(_vm.modalItem.is_company == 'true')?_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"title"}},[_vm._v("Naziv")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"title","required":"","min":"2","max":"150"},model:{value:(_vm.modalItem.title),callback:function ($$v) {_vm.$set(_vm.modalItem, "title", $$v)},expression:"modalItem.title"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"contact_name"}},[_vm._v("Kontaktna oseba")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"contact_name","required":"","min":"2","max":"150"},model:{value:(_vm.modalItem.contact_name),callback:function ($$v) {_vm.$set(_vm.modalItem, "contact_name", $$v)},expression:"modalItem.contact_name"}})],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"first_name"}},[_vm._v("Ime")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"first_name","required":"","min":"2","max":"150"},model:{value:(_vm.modalItem.first_name),callback:function ($$v) {_vm.$set(_vm.modalItem, "first_name", $$v)},expression:"modalItem.first_name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"last_name"}},[_vm._v("Priimek")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"last_name","required":"","min":"2","max":"150"},model:{value:(_vm.modalItem.last_name),callback:function ($$v) {_vm.$set(_vm.modalItem, "last_name", $$v)},expression:"modalItem.last_name"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"email","id":"email","required":""},model:{value:(_vm.modalItem.email),callback:function ($$v) {_vm.$set(_vm.modalItem, "email", $$v)},expression:"modalItem.email"}})],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"phone_number"}},[_vm._v("Telefon")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"phone_number"},model:{value:(_vm.modalItem.phone_number),callback:function ($$v) {_vm.$set(_vm.modalItem, "phone_number", $$v)},expression:"modalItem.phone_number"}})],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"address"}},[_vm._v("Naslov")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"address"},model:{value:(_vm.modalItem.address),callback:function ($$v) {_vm.$set(_vm.modalItem, "address", $$v)},expression:"modalItem.address"}})],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-people"}),_vm._v(" Kartica kupca\n\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#dodajKupca"},on:{"click":function($event){$event.preventDefault();return _vm.click_openAddKupec($event)}}},[_c('i',{staticClass:"icon-user-follow"})])])]),_vm._v(" "),_c('b-container',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('b-row',{staticClass:"mb-3 justify-content-md-center"},[_c('b-col'),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-cols":"1","label":"Išči"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Vnesi iskani niz"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Počisti")])],1)],1)],1)],1),_vm._v(" "),_c('b-col')],1)],1),_vm._v(" "),_c('b-table',{ref:"dataTable",attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","items":_vm.dataProvider,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"is_company",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("type_format")(data.item.is_company))+"\n\t\t\t\t\t\t")]}},{key:"title",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("title_format")(data.item))+"\n\t\t\t\t\t\t")]}},{key:"actions",fn:function(data){return [_c('b-button',{staticClass:"m-1 seznamKupcevIconStyle",attrs:{"size":"sm","variant":"primary","title":"Uredi kupca"},on:{"click":function($event){$event.stopPropagation();_vm.click_openEditKupec(data, $event.target)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),(_vm.allowDelete())?_c('b-button',{staticClass:"m-1 seznamKupcevIconStyle",attrs:{"size":"sm","variant":"danger","title":"Izbriši kupca"},on:{"click":function($event){$event.stopPropagation();_vm.click_removeKupec(data, $event.target)}}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e()]}}])}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('edit-kupec-modal',{ref:"editModal",on:{"kupec_add":_vm.edit_add,"kupec_edit":_vm.edit_update},model:{value:(_vm.selectedKupec),callback:function ($$v) {_vm.selectedKupec=$$v},expression:"selectedKupec"}})],1)],1),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)}
var staticRenderFns = []


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Prilivi_vue__ = __webpack_require__(557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0163e36a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Prilivi_vue__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1012)
  __webpack_require__(1013)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0163e36a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Prilivi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0163e36a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Prilivi_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0163e36a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Prilivi_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirPrilivaDropdown_vue__ = __webpack_require__(558);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099e4523_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirPrilivaDropdown_vue__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1015)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirPrilivaDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099e4523_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirPrilivaDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099e4523_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirPrilivaDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Vir")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Znesek")]),_vm._v(" "),_c('b-dropdown-form',{staticClass:"znesek-dd"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('b-form-radio',{attrs:{"name":"mode","value":"single"},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}},[_vm._v("Točna vrednost")])],1),_vm._v(" "),_c('b-col',[_c('currency-input',{staticClass:"form-control",attrs:{"placeholder":"Znesek"},model:{value:(_vm.znesek),callback:function ($$v) {_vm.znesek=$$v},expression:"znesek"}})],1),_vm._v(" "),_c('b-col')],1),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('b-form-radio',{attrs:{"name":"mode","value":"range"},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}},[_vm._v("Razpon")])],1),_vm._v(" "),_c('b-col',[_c('currency-input',{staticClass:"form-control",attrs:{"placeholder":"Od"},model:{value:(_vm.znesek_od),callback:function ($$v) {_vm.znesek_od=$$v},expression:"znesek_od"}})],1),_vm._v(" "),_c('b-col',[_c('currency-input',{staticClass:"form-control",attrs:{"placeholder":"Do"},model:{value:(_vm.znesek_do),callback:function ($$v) {_vm.znesek_do=$$v},expression:"znesek_do"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mr-auto",attrs:{"cols":"auto"}},[_c('b-button',{on:{"click":function($event){$event.preventDefault();return _vm.click_pocisti($event)}}},[_vm._v("Počisti")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.click_potrdi($event)}}},[_vm._v("Potrdi")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UvoziPrilivModal_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f90a929_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UvoziPrilivModal_vue__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1021)
  __webpack_require__(1022)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f90a929"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UvoziPrilivModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f90a929_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UvoziPrilivModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f90a929_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UvoziPrilivModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Uvoz prilivov","body-class":_vm.modal_body_class,"size":_vm.modal_size}},[(!_vm.show_step_two)?_c('div',[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('b-form-radio-group',{model:{value:(_vm.tip_priliva),callback:function ($$v) {_vm.tip_priliva=$$v},expression:"tip_priliva"}},[_c('b-form-radio',{attrs:{"value":"lon"}},[_vm._v("LON (CSV, Excel)")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"vasco"}},[_vm._v("Vasco (Excel)")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"skb"}},[_vm._v("SKB (Xml)")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"trafic"}},[_vm._v("TRAFIC (CSV)")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"izvoz"}},[_vm._v("Izvoz (Email)")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.tip_priliva == 'lon' || _vm.tip_priliva == 'skb' || _vm.tip_priliva == 'vasco'|| _vm.tip_priliva == 'trafic')?_c('b-form-file',{attrs:{"placeholder":_vm.upload_placeholder,"drop-placeholder":"Povleci datoteko za uvoz ...","accept":_vm.upload_accept},model:{value:(_vm.import_file),callback:function ($$v) {_vm.import_file=$$v},expression:"import_file"}}):_vm._e(),_vm._v(" "),(_vm.tip_priliva == 'izvoz')?_c('b-form-textarea',{attrs:{"placeholder":"Vnesi besedilo za uvoz ...","rows":"6","max-rows":"9"},model:{value:(_vm.import_text),callback:function ($$v) {_vm.import_text=$$v},expression:"import_text"}}):_vm._e()],1)],1)],1):_c('div',[_c('b-table',{attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","table-class":"no_padding","items":_vm.import_table.items,"fields":_vm.import_table.fields},scopedSlots:_vm._u([{key:"selected",fn:function(data){return [_c('b-form-checkbox',{model:{value:(data.item.selected),callback:function ($$v) {_vm.$set(data.item, "selected", $$v)},expression:"data.item.selected"}})]}},{key:"ogrodje",fn:function(data){return [(data.item.id_vozila == null)?_c('v-select',{staticClass:"noVIN",attrs:{"options":_vm.ogrodja_options,"taggable":true,"filterable":false,"label":"ogrodje","placeholder":"Izberi vozilo ..."},on:{"input":function($event){_vm.voziloSelect_change($event,data.item.index)},"search":_vm.vozilaSelect_search},model:{value:(data.item.ogrodje),callback:function ($$v) {_vm.$set(data.item, "ogrodje", $$v)},expression:"data.item.ogrodje"}},[_c('template',{slot:"no-options"},[_vm._v("Vnesite VIN številko vozila")])],2):_c('v-select',{attrs:{"options":_vm.ogrodja_options,"taggable":true,"filterable":false,"label":"ogrodje","placeholder":"Izberi vozilo ..."},on:{"input":function($event){_vm.voziloSelect_change($event,data.item.index)},"search":_vm.vozilaSelect_search},model:{value:(data.item.ogrodje),callback:function ($$v) {_vm.$set(data.item, "ogrodje", $$v)},expression:"data.item.ogrodje"}},[_c('template',{slot:"no-options"},[_vm._v("Vnesite VIN številko vozila")])],2)]}},{key:"znesek",fn:function(data){return [_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.znesek)))])]}},{key:"datum",fn:function(data){return [_c('div',[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.datum))+" ")])]}}])},[_c('template',{slot:"HEAD_selected"},[_c('b-form-checkbox',{on:{"change":_vm.toggleSelectAll},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}})],1)],2)],1),_vm._v(" "),_c('b-alert',{class:_vm.message_class,attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"align-self":"start"}},[(false)?_c('b-button',{attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();_vm.click_showPlacila($event.target)}}},[_vm._v("Plačilo")]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.modal_cancelClick($event)}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{ref:"aOk",attrs:{"variant":"primary","data-style":"zoom-in"},on:{"click":function($event){$event.stopPropagation();_vm.modal_okClick($event)}}},[_c('span',{staticClass:"ladda-label"},[_vm._v(_vm._s(_vm.ok_text))])])],1)],1)],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-alert',{class:_vm.message_class,attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-wallet"}),_vm._v(" Prilivi\n\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#uvoziPrilive"},on:{"click":function($event){$event.preventDefault();_vm.click_openUvoziPrilive($event)}}},[_c('i',{staticClass:"icon-cloud-upload"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#urediPrliv"},on:{"click":function($event){$event.preventDefault();_vm.click_editPriliv()}}},[_c('i',{staticClass:"icon-plus"})])])]),_vm._v(" "),_c('b-table',{ref:"dataTable",attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","items":_vm.table_dataProvider,"fields":_vm.table.fields,"current-page":_vm.table.currentPage,"per-page":_vm.table.perPage,"filter":_vm.table.filter,"sort-by":_vm.table.sortBy,"sort-desc":_vm.table.sortDesc},on:{"update:sortBy":function($event){_vm.$set(_vm.table, "sortBy", $event)},"update:sortDesc":function($event){_vm.$set(_vm.table, "sortDesc", $event)},"row-clicked":_vm.table_rowClick},scopedSlots:_vm._u([{key:"znesek",fn:function(data){return [_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.znesek)))])]}},{key:"datum",fn:function(data){return [_c('span',[_vm._v("  "+_vm._s(_vm._f("hr_date")(data.item.datum))+" ")])]}},{key:"actions",fn:function(data){return [_c('b-button',{ref:"editPriliv",staticClass:"m-1 seznamPrilivovIconStyle",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_editPriliv(data.item)}}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v(" "),_c('b-button',{ref:"removePriliv",staticClass:"m-1 seznamPrilivovIconStyle",attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_removePriliv(data.item)}}},[_c('i',{staticClass:"fa fa-remove"})])]}}])},[_c('template',{slot:"top-row"},[_c('td',[_c('datum-filter-dropdown',{on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.datum),callback:function ($$v) {_vm.$set(_vm.inputFilter, "datum", $$v)},expression:"inputFilter.datum"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.ogrodje),callback:function ($$v) {_vm.$set(_vm.inputFilter, "ogrodje", $$v)},expression:"inputFilter.ogrodje"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.placnik),callback:function ($$v) {_vm.$set(_vm.inputFilter, "placnik", $$v)},expression:"inputFilter.placnik"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.naziv),callback:function ($$v) {_vm.$set(_vm.inputFilter, "naziv", $$v)},expression:"inputFilter.naziv"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.referenca),callback:function ($$v) {_vm.$set(_vm.inputFilter, "referenca", $$v)},expression:"inputFilter.referenca"}})],1),_vm._v(" "),_c('td',[_c('znesek-filter-dropdown',{on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.znesek),callback:function ($$v) {_vm.$set(_vm.inputFilter, "znesek", $$v)},expression:"inputFilter.znesek"}})],1),_vm._v(" "),_c('td',[_c('vir-filter-dropdown',{ref:"virPicker",on:{"change":_vm.table_virFilterChange}})],1),_vm._v(" "),_c('td')])],2),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.table.totalRows,"per-page":_vm.table.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.table.currentPage),callback:function ($$v) {_vm.$set(_vm.table, "currentPage", $$v)},expression:"table.currentPage"}})],1)],1)],1)],1),_vm._v(" "),_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('uvozi-priliv-modal',{ref:"uvoziModal",on:{"priliviPotrjeni-success":_vm.on_priliviPotrjeniSuccess}}),_vm._v(" "),_c('edit-priliv-modal',{ref:"editPrilivModal",on:{"priliv_add":_vm.edit_add,"priliv_edit":_vm.edit_update}})],1)}
var staticRenderFns = []


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8009dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1026)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8009dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8009dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPasswordModal_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09418f15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPasswordModal_vue__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1028)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPasswordModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09418f15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPasswordModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09418f15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPasswordModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle,"ok-title":_vm.modalOkTitle,"cancel-title":_vm.modalCancelTitle,"busy":_vm.modalIsBusy},on:{"ok":_vm.onOkModal,"cancel":_vm.onCancelModal}},[_c('b-form',{ref:"form",attrs:{"novalidate":""}},[(_vm.modalErrorMsg)?_c('app-mbox',{attrs:{"text":_vm.modalErrorMsg},on:{"dismissed":_vm.clear_error_msg}}):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"oldPassword2"}},[_vm._v("Prejšnje geslo")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","id":"OldPassword","min":"8","autocomplete":"off"},model:{value:(_vm.modalUser.oldPassword),callback:function ($$v) {_vm.$set(_vm.modalUser, "oldPassword", $$v)},expression:"modalUser.oldPassword"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"newPassword"}},[_vm._v("Novo geslo")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","id":"NewPassword","min":"8","autocomplete":"off"},model:{value:(_vm.modalUser.newPassword),callback:function ($$v) {_vm.$set(_vm.modalUser, "newPassword", $$v)},expression:"modalUser.newPassword"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"newPassword2"}},[_vm._v("Novo Geslo (ponovno)")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","id":"NewPassword2","min":"8","autocomplete":"off"},model:{value:(_vm.modalUser.newPassword2),callback:function ($$v) {_vm.$set(_vm.modalUser, "newPassword2", $$v)},expression:"modalUser.newPassword2"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPictureModal_vue__ = __webpack_require__(564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be41ea7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPictureModal_vue__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1031)
  __webpack_require__(1032)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserPictureModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be41ea7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPictureModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be41ea7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserPictureModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle,"ok-title":_vm.modalOkTitle,"cancel-title":_vm.modalCancelTitle,"busy":_vm.modalIsBusy},on:{"ok":_vm.onOkModal,"cancel":_vm.onCancelModal}},[_c('b-form',{ref:"form",attrs:{"novalidate":""}},[(_vm.modalErrorMsg)?_c('app-mbox',{attrs:{"text":_vm.modalErrorMsg},on:{"dismissed":_vm.clear_error_msg}}):_vm._e(),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"center-block profile-avatar"},[(_vm.imageDataPreview!=null)?_c('img',{staticClass:"img-avatar",attrs:{"src":_vm.imageDataPreview,"alt":_vm.modalUser.email}}):(_vm.modalUser.photoURL === null || _vm.modalUser.photoURL === '')?_c('div',{staticClass:"avatar_hrs_profile avatar-bg"},[_vm._v(_vm._s(_vm._f("short_name")(_vm.modalUser.display_name)))]):_c('img',{staticClass:"img-avatar",attrs:{"src":_vm.modalUser.photoURL,"alt":_vm.modalUser.email}})])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-file',{attrs:{"placeholder":_vm.upload_placeholder,"drop-placeholder":"Povleci sliko...","accept":_vm.upload_accept},on:{"change":_vm.previewImage}}),_vm._v(" "),_c('div',[_c('p',[_vm._v("Progress: "+_vm._s(_vm.uploadValue.toFixed()+"%")+"\n\t\t\t\t\t\t\t"),_c('progress',{attrs:{"id":"progress","max":"100"},domProps:{"value":_vm.uploadValue}})])])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"8"}},[_c('b-card',{attrs:{"no-body":true}},[_c('b-card-body',{staticClass:"p-0 clearfix"},[_c('div',{staticClass:"profile-avatar avatar-bg font-2xl mr-3 float-left"},[(_vm.user.photoURL === null || _vm.user.photoURL === '')?_c('div',{staticClass:"avatar_hrs_profile avatar-bg"},[_vm._v(_vm._s(_vm._f("short_name")(_vm.user.display_name)))]):_c('img',{staticClass:"img-avatar",attrs:{"src":_vm.user.photoURL,"alt":_vm.user.email}}),_vm._v(" "),_c('div',{staticClass:"actions p-2"},[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_openEditUserPicture($event.target)}}},[_vm._v("Uredi")]),_vm._v(" "),(_vm.user.photoURL !== null || _vm.user.photoURL !== '')?_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_removeUserPicture($event.target)}}},[_vm._v("Odstrani")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"h1 text-primary mb-0 pt-3"},[_vm._v(_vm._s(_vm.user.display_name)+" (#"+_vm._s(_vm.user.dbid)+")")]),_vm._v(" "),_c('div',{staticClass:"text-muted text-uppercase font-weight-bold font-xs"},[_vm._v(_vm._s(_vm.user.email))]),_vm._v(" "),_c('div',{staticClass:"text-muted text-uppercase mt-3 font-xs"},[_vm._v("Čas zadnje prijave: "),_c('b',[_vm._v(_vm._s(_vm.user.lastSignInTime))])]),_vm._v(" "),_c('div',{staticClass:"text-muted mt-1 font-xs"},[_vm._v("ČAS ZADNJEGA DOSTOPA: "),_c('b',[_vm._v(_vm._s(_vm.timestampIzpis(_vm.user.last_access_at)))])]),_vm._v(" "),_c('div',{staticClass:"text-muted mt-1 font-xs"},[_vm._v("IP ZADNJEGA DOSTOPA: "),_c('b',[_vm._v(_vm._s(_vm.user.last_access_ip))])]),_vm._v(" "),_c('div',{staticClass:"profil-geslo mr-4"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.click_openEditUserPassword($event.target)}}},[_vm._v("Spremeni geslo")])],1)])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"2","md":"2"}},[_c('b-card',[_c('div',{staticClass:"h1 text-muted text-right mb-4"},[_c('i',{staticClass:"icon-badge"})]),_vm._v(" "),_c('div',{staticClass:"h4 mb-0"},[_vm._v("10.200 €")]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v("Znesek prodaje")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-3 mb-0",attrs:{"height":"{}","variant":"info","value":25}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2","md":"2"}},[_c('b-card',[_c('div',{staticClass:"h1 text-muted text-right mb-4"},[_c('i',{staticClass:"icon-basket-loaded"})]),_vm._v(" "),_c('div',{staticClass:"h4 mb-0"},[_vm._v("38")]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v("Prodanih vozil")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-3 mb-0",attrs:{"height":"{}","variant":"warning","value":25}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2","md":"2"}},[_c('b-card',[_c('div',{staticClass:"h1 text-muted text-right mb-4"},[_c('i',{staticClass:"icon-pie-chart"})]),_vm._v(" "),_c('div',{staticClass:"h4 mb-0"},[_vm._v("28%")]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v("Delež prodaje")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-3 mb-0",attrs:{"height":"{}","value":28}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2","md":"2"}},[_c('b-card',[_c('div',{staticClass:"h1 text-muted text-right mb-4"},[_c('i',{staticClass:"icon-speedometer"})]),_vm._v(" "),_c('div',{staticClass:"h4 mb-0"},[_vm._v("5:34")]),_vm._v(" "),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v("Čas rezervacij")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-3 mb-0",attrs:{"height":"{}","variant":"danger","value":25}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('edit-user-password-modal',{ref:"EditUserPasswordModal",on:{"user_edit":_vm.edit_password}}),_vm._v(" "),_c('edit-user-picture-modal',{ref:"EditUserPictureModal",on:{"edit_picture":_vm.edit_picture}})],1),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)}
var staticRenderFns = []


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uporabniki_vue__ = __webpack_require__(565);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c1c1d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uporabniki_vue__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uporabniki_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c1c1d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uporabniki_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c1c1d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uporabniki_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserModal_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2ca236c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserModal_vue__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1037)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2ca236c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2ca236c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle,"ok-title":_vm.modalOkTitle,"cancel-title":_vm.modalCancelTitle,"busy":_vm.modalIsBusy},on:{"ok":_vm.onOkModal}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-form',{ref:"form"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_firstName,"state":_vm.state_firstName}},[_c('label',{attrs:{"for":"first_name"}},[_vm._v("Ime")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"first_name","required":""},model:{value:(_vm.modalUser.first_name),callback:function ($$v) {_vm.$set(_vm.modalUser, "first_name", $$v)},expression:"modalUser.first_name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_lastName,"state":_vm.state_lastName}},[_c('label',{attrs:{"for":"last_name"}},[_vm._v("Priimek")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"last_name","required":""},model:{value:(_vm.modalUser.last_name),callback:function ($$v) {_vm.$set(_vm.modalUser, "last_name", $$v)},expression:"modalUser.last_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_email,"state":_vm.state_email}},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{ref:"emailInputRef",attrs:{"type":"email","id":"emailInputId","disabled":!_vm.modalIsNew,"required":"","autocomplete":"off"},model:{value:(_vm.modalUser.email),callback:function ($$v) {_vm.$set(_vm.modalUser, "email", $$v)},expression:"modalUser.email"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_password,"state":_vm.state_password}},[_c('label',{attrs:{"for":"password"}},[_vm._v("Geslo")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","id":"password","autocomplete":"off"},model:{value:(_vm.modalUser.password),callback:function ($$v) {_vm.$set(_vm.modalUser, "password", $$v)},expression:"modalUser.password"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_password2,"state":_vm.state_password2}},[_c('label',{attrs:{"for":"first_name"}},[_vm._v("Geslo (ponovno)")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","id":"password2","autocomplete":"off"},model:{value:(_vm.modalUser.password2),callback:function ($$v) {_vm.$set(_vm.modalUser, "password2", $$v)},expression:"modalUser.password2"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',[_c('label',{attrs:{"for":"match_pattern"}},[_vm._v("Ujemanje (DISTRI NET)")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"match_pattern"},model:{value:(_vm.modalUser.match_pattern),callback:function ($$v) {_vm.$set(_vm.modalUser, "match_pattern", $$v)},expression:"modalUser.match_pattern"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"role_user"}},[_vm._v("Vloga")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-radio-group',{attrs:{"id":"role_user","options":_vm.role_options},model:{value:(_vm.modalUser.role),callback:function ($$v) {_vm.$set(_vm.modalUser, "role", $$v)},expression:"modalUser.role"}})],1)],1),_vm._v(" "),(this.modalUser.id > 0)?_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-card',{staticClass:"mb-0",attrs:{"header":"Podrobnosti"}},[_c('div',{staticClass:"mb-2"},[_vm._v("IP zadnjega dostopa: "),_c('b',[_vm._v(_vm._s(_vm.modalUser.last_access_ip_readonly))])]),_vm._v(" "),_c('div',{staticClass:"mb-2",domProps:{"innerHTML":_vm._s(this.timestampIzpis('Zadnji dostop', _vm.modalUser.last_access_at_readonly))}}),_vm._v(" "),_c('div',{staticClass:"mb-2",domProps:{"innerHTML":_vm._s(this.timestampIzpis('Dodan', _vm.modalUser.created_at_readonly))}})])],1)],1):_vm._e(),_vm._v(" "),(_vm.modalErrorMsg)?_c('app-mbox',{attrs:{"text":_vm.modalErrorMsg},on:{"dismissed":_vm.clear_error_msg}}):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-user"}),_vm._v(" Uporabniki\n\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#dodajUporabnika"},on:{"click":function($event){$event.preventDefault();return _vm.click_openAddUser($event)}}},[_c('i',{staticClass:"icon-user-follow"})])])]),_vm._v(" "),_c('b-table',{ref:"dataTable",attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","items":_vm.dataProvider,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"role",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("role_hr")(data.item.role))+"\n\t\t\t\t\t\t")]}},{key:"last_access_at",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.timestampIzpis(data.item.last_access_at))+"\n\t\t\t\t\t\t")]}},{key:"created_at",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.timestampIzpis(data.item.created_at))+"\n\t\t\t\t\t\t")]}},{key:"actions",fn:function(data){return [_c('b-button',{staticClass:"mr-2",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_removeUser(data, $event.target)}}},[_vm._v("\n\t\t\t\t\t\t\t\tOdstrani\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-button',{staticClass:"mr-2",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.click_openEditUser(data, $event.target)}}},[_vm._v("\n\t\t\t\t\t\t\t\tUredi\n\t\t\t\t\t\t\t")])]}}])}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('edit-user-modal',{ref:"editModal",on:{"user_add":_vm.edit_add,"user_edit":_vm.edit_update}})],1)],1),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)}
var staticRenderFns = []


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d976028_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d976028_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d976028_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('h1',[_vm._v("Prijava")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Prijavite se z uporabniškim računom")]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-user"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Uporabniško ime","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-4"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-lock"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Geslo","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-4",attrs:{"type":"submit","variant":"primary","disabled":_vm.loading}},[_vm._v("Prijava")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-0",attrs:{"variant":"link"}},[_vm._v("Ste pozabili geslo?")])],1)],1),_vm._v(" "),(_vm.error)?_c('app-mbox',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}}):_vm._e()],1)])],1),_vm._v(" "),_c('b-card',{staticClass:"text-white bg-primary py-5 d-md-down-none",staticStyle:{"width":"44%"},attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"text-center"},[_c('div',[_c('h2',[_vm._v("Težave s prijavo?")]),_vm._v(" "),_c('p',[_vm._v("V sistem se lahko prijavite samo z že obstoječim uporabniškim imenom in geslom. Če imate pri prijavi težave, nas lahko preko spodnjega obrazca kontaktirate.")]),_vm._v(" "),_c('b-button',{staticClass:"active mt-3",attrs:{"variant":"primary"}},[_vm._v("Pomoč")])],1)])],1)],1)],1)],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Povracila_vue__ = __webpack_require__(568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623ead72_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Povracila_vue__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1043)
  __webpack_require__(1044)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-623ead72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Povracila_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623ead72_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Povracila_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623ead72_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Povracila_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UvoziPovracilaModal_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b4dbe6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UvoziPovracilaModal_vue__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1046)
  __webpack_require__(1047)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45b4dbe6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UvoziPovracilaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b4dbe6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UvoziPovracilaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b4dbe6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UvoziPovracilaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Uvoz povračil","body-class":_vm.modal_body_class,"size":_vm.modal_size}},[(!_vm.show_step_two)?_c('div',[_c('b-row',[_c('b-col',[_c('b-form-group',[_c('b-form-radio-group',{model:{value:(_vm.tip_povracila),callback:function ($$v) {_vm.tip_povracila=$$v},expression:"tip_povracila"}},[_c('b-form-radio',{attrs:{"value":"excel_v2"}},[_vm._v("Excel (Xlsx)")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"excel"}},[_vm._v("Excel (Excel)")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.tip_povracila == 'excel_v2')?_c('b-form-file',{attrs:{"placeholder":_vm.upload_placeholder_v2,"drop-placeholder":"Povleci datoteko za uvoz ...","accept":_vm.upload_accept_v2},model:{value:(_vm.import_file),callback:function ($$v) {_vm.import_file=$$v},expression:"import_file"}}):_vm._e(),_vm._v(" "),(_vm.tip_povracila == 'excel')?_c('b-form-file',{attrs:{"placeholder":_vm.upload_placeholder,"drop-placeholder":"Povleci datoteko za uvoz ...","accept":_vm.upload_accept},model:{value:(_vm.import_file),callback:function ($$v) {_vm.import_file=$$v},expression:"import_file"}}):_vm._e()],1)],1)],1):_c('div',[_c('b-table',{ref:"dataTable",attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","table-class":"no_padding","items":_vm.import_table.items,"fields":_vm.import_table.fields},scopedSlots:_vm._u([{key:"selected",fn:function(data){return [_c('b-form-checkbox',{model:{value:(data.item.selected),callback:function ($$v) {_vm.$set(data.item, "selected", $$v)},expression:"data.item.selected"}})]}},{key:"chassis",fn:function(data){return [(data.item.id_vozila == null)?_c('div',{staticClass:"noVIN"},[_vm._v(" "+_vm._s(data.item.chassis)+" ")]):_c('div',[_vm._v(" "+_vm._s(data.item.chassis)+" ")])]}},{key:"amount",fn:function(data){return [_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.amount)))])]}},{key:"creditnotedate",fn:function(data){return [_c('div',[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.creditnotedate))+" ")])]}}])},[_c('template',{slot:"HEAD_selected"},[_c('b-form-checkbox',{on:{"change":_vm.toggleSelectAll},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}})],1)],2)],1),_vm._v(" "),_c('b-alert',{class:_vm.message_class,attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"align-self":"start"}},[(false)?_c('b-button',{attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();_vm.click_showPlacila($event.target)}}},[_vm._v("Plačilo")]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){_vm.modal_cancelClick($event)}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{ref:"aOk",attrs:{"variant":"primary","data-style":"zoom-in"},on:{"click":function($event){$event.stopPropagation();_vm.modal_okClick($event)}}},[_c('span',{staticClass:"ladda-label"},[_vm._v(_vm._s(_vm.ok_text))])])],1)],1)],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPovraciloModal_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab376aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPovraciloModal_vue__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1050)
  __webpack_require__(1051)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ab376aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPovraciloModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab376aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPovraciloModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab376aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPovraciloModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.modalTitle_text,"ok-title":_vm.ok_text,"cancel-title":_vm.modalCancelTitle,"busy":_vm.modalIsBusy},on:{"ok":_vm.modal_okClick}},[_c('b-form',{ref:"form",attrs:{"novalidate":""}},[(_vm.modalErrorMsg)?_c('app-mbox',{attrs:{"text":_vm.modalErrorMsg.message},on:{"dismissed":_vm.clear_error_msg}}):_vm._e(),_vm._v(" "),_c('b-row',[(!_vm.addNew)?_c('b-col',[_c('b-form-group',{ref:"formOgrodje",attrs:{"id":"fieldset-Ogrodje","label-cols":"3","label":"Šasija","label-for":"chassis","title":"chassis & Sasija"}},[(_vm.modalPovraciloData.id_vozila == null)?_c('div',{staticClass:"noVIN chassisText"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.modalPovraciloData.chassis)+"\n\t\t\t\t\t\t\t"),_c('b-button',{ref:"aUpdate",staticClass:"updateDataButton",attrs:{"data-style":"zoom-in","size":"sm","title":"Poveži povračilo z importdata"},on:{"click":function($event){$event.stopPropagation();_vm.click_updateData(_vm.modalPovraciloData.chassis, $event)}}},[_c('i',{staticClass:"fa fa-file ladda-label"})])],1):_c('div',{staticClass:"chassisText"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.modalPovraciloData.chassis)+"\n\t\t\t\t\t\t")])])],1):_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Ogrodje","label-cols":"3","label":"Šasija","label-for":"chassis","title":"chassis & Sasija"}},[_c('v-select',{attrs:{"id":"ogrodje","label":"ogrodje","options":_vm.ogrodja_options,"taggable":true,"filterable":false,"placeholder":"Izberi vozilo ..."},on:{"input":function($event){_vm.voziloSelect_change($event)},"search":_vm.vozilaSelect_search},model:{value:(_vm.modalPovraciloData.chassis),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "chassis", $$v)},expression:"modalPovraciloData.chassis"}},[_c('template',{slot:"no-options"},[_vm._v("Vnesite VIN številko vozila")])],2)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-horizontal","label-cols":"3","label":"Datum izdobave","label-for":"datum","title":"creditnotedate & Datum_izdobave"}},[(_vm.modalPovraciloData.id >= 0)?_c('v-date-picker',{ref:"datum",attrs:{"id":"datum","max-date":new Date(Date.now()),"is-required":true,"input-props":{
								class: "form-control dt_border gdt_border",
								placeholder: "DD. MM. YYYY",
								required: true
							},"mode":"single","locale":"sl-SI"},model:{value:(_vm.modalPovraciloData.creditnotedate),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "creditnotedate", $$v)},expression:"modalPovraciloData.creditnotedate"}}):_c('b-form-input',{attrs:{"id":"datum","type":"text","value":_vm._f("hr_date")(_vm.modalPovraciloData.creditnotedate),"disabled":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Sale_channel","label-cols":"3","label":"Prodajni kanal","label-for":"sale_channel","title":"sale_channel & Prodajni_kanal"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"sale_channel"},model:{value:(_vm.modalPovraciloData.sale_channel),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "sale_channel", $$v)},expression:"modalPovraciloData.sale_channel"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Amount","label-cols":"3","label":"Skupaj odobreno","label-for":"amount","title":"amount & Skupaj_odobreno"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"amount"},model:{value:(_vm.modalPovraciloData.amount),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "amount", $$v)},expression:"modalPovraciloData.amount"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Opomba","label-cols":"3","label":"Opomba","label-for":"opomba"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"opomba"},model:{value:(_vm.modalPovraciloData.opomba),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "opomba", $$v)},expression:"modalPovraciloData.opomba"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Status","label-cols":"3","label":"Status","label-for":"status"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"1"}},[_c('span',{staticClass:"fa statusColor",class:_vm.selectedStatus.classStatus})]),_vm._v(" "),_c('b-col',[_c('v-select',{attrs:{"options":_vm.status_options,"label":"label"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('span',{staticClass:"fa icon",class:option.classStatus}),_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(option.label)+"\n\t\t\t\t\t\t\t\t")]}}]),model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_vozilo_opis","label-cols":"3","label":"Vozilo","label-for":"v2_vozilo_opis"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_vozilo_opis"},model:{value:(_vm.modalPovraciloData.v2_vozilo_opis),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_vozilo_opis", $$v)},expression:"modalPovraciloData.v2_vozilo_opis"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_gc","label-cols":"3","label":"GC","label-for":"v2_gc"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_gc"},model:{value:(_vm.modalPovraciloData.v2_gc),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_gc", $$v)},expression:"modalPovraciloData.v2_gc"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_gc_odobreno","label-cols":"3","label":"GC_odobreno","label-for":"v2_gc_odobreno"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_gc_odobreno"},model:{value:(_vm.modalPovraciloData.v2_gc_odobreno),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_gc_odobreno", $$v)},expression:"modalPovraciloData.v2_gc_odobreno"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_marza_opcij","label-cols":"3","label":"Marza opcij","label-for":"v2_marza_opcij"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_marza_opcij"},model:{value:(_vm.modalPovraciloData.v2_marza_opcij),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_marza_opcij", $$v)},expression:"modalPovraciloData.v2_marza_opcij"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_marza_opcij_odobreno","label-cols":"3","label":"Marza opcij odobreno","label-for":"v2_marza_opcij_odobreno"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_marza_opcij_odobreno"},model:{value:(_vm.modalPovraciloData.v2_marza_opcij_odobreno),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_marza_opcij_odobreno", $$v)},expression:"modalPovraciloData.v2_marza_opcij_odobreno"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_dmv_dacia_zahtevano","label-cols":"3","label":"DMV Dacia zahtevano","label-for":"v2_dmv_dacia_zahtevano"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_dmv_dacia_zahtevano"},model:{value:(_vm.modalPovraciloData.v2_dmv_dacia_zahtevano),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_dmv_dacia_zahtevano", $$v)},expression:"modalPovraciloData.v2_dmv_dacia_zahtevano"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_dmv_dacia_odobreno","label-cols":"3","label":"DMV Dacia odobreno","label-for":"v2_dmv_dacia_odobreno"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_dmv_dacia_odobreno"},model:{value:(_vm.modalPovraciloData.v2_dmv_dacia_odobreno),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_dmv_dacia_odobreno", $$v)},expression:"modalPovraciloData.v2_dmv_dacia_odobreno"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka1_naziv","label-cols":"3","label":"KA1 naziv","label-for":"v2_ka1_naziv"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka1_naziv"},model:{value:(_vm.modalPovraciloData.v2_ka1_naziv),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka1_naziv", $$v)},expression:"modalPovraciloData.v2_ka1_naziv"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka1_zahtevano","label-cols":"3","label":"KA1 zahtevano","label-for":"v2_ka1_zahtevano"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka1_zahtevano"},model:{value:(_vm.modalPovraciloData.v2_ka1_zahtevano),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka1_zahtevano", $$v)},expression:"modalPovraciloData.v2_ka1_zahtevano"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka1_odobreno","label-cols":"3","label":"KA1 odobreno","label-for":"v2_ka1_odobreno"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka1_odobreno"},model:{value:(_vm.modalPovraciloData.v2_ka1_odobreno),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka1_odobreno", $$v)},expression:"modalPovraciloData.v2_ka1_odobreno"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka2_naziv","label-cols":"3","label":"KA2 naziv","label-for":"v2_ka2_naziv"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka2_naziv"},model:{value:(_vm.modalPovraciloData.v2_ka2_naziv),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka2_naziv", $$v)},expression:"modalPovraciloData.v2_ka2_naziv"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka2_zahtevano","label-cols":"3","label":"KA2 zahtevano","label-for":"v2_ka2_zahtevano"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka2_zahtevano"},model:{value:(_vm.modalPovraciloData.v2_ka2_zahtevano),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka2_zahtevano", $$v)},expression:"modalPovraciloData.v2_ka2_zahtevano"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka2_odobreno","label-cols":"3","label":"KA2 odobreno","label-for":"v2_ka2_odobreno"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka2_odobreno"},model:{value:(_vm.modalPovraciloData.v2_ka2_odobreno),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka2_odobreno", $$v)},expression:"modalPovraciloData.v2_ka2_odobreno"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka3_naziv","label-cols":"3","label":"KA3 naziv","label-for":"v2_ka3_naziv"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka3_naziv"},model:{value:(_vm.modalPovraciloData.v2_ka3_naziv),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka3_naziv", $$v)},expression:"modalPovraciloData.v2_ka3_naziv"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka3_zahtevano","label-cols":"3","label":"KA3 zahtevano","label-for":"v2_ka3_zahtevano"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka3_zahtevano"},model:{value:(_vm.modalPovraciloData.v2_ka3_zahtevano),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka3_zahtevano", $$v)},expression:"modalPovraciloData.v2_ka3_zahtevano"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_ka3_odobreno","label-cols":"3","label":"KA3 odobreno","label-for":"v2_ka3_odobreno"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_ka3_odobreno"},model:{value:(_vm.modalPovraciloData.v2_ka3_odobreno),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_ka3_odobreno", $$v)},expression:"modalPovraciloData.v2_ka3_odobreno"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_skupaj_zahtevano","label-cols":"3","label":"KA3 odobreno","label-for":"Skupaj zahtevano"}},[_c('currency-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_skupaj_zahtevano"},model:{value:(_vm.modalPovraciloData.v2_skupaj_zahtevano),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_skupaj_zahtevano", $$v)},expression:"modalPovraciloData.v2_skupaj_zahtevano"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_komentar","label-cols":"3","label":"Komentar","label-for":"v2_komentar"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_komentar"},model:{value:(_vm.modalPovraciloData.v2_komentar),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_komentar", $$v)},expression:"modalPovraciloData.v2_komentar"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-v2_komentar_uvoznik","label-cols":"3","label":"Komentar uvoznik","label-for":"v2_komentar_uvoznik"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"v2_komentar_uvoznik"},model:{value:(_vm.modalPovraciloData.v2_komentar_uvoznik),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "v2_komentar_uvoznik", $$v)},expression:"modalPovraciloData.v2_komentar_uvoznik"}})],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"header","title":"Klikni za prikaz starih parametrov"},on:{"click":_vm.toggleAdditionalDataCollapse},slot:"header"},[_c('b-row',[_c('b-col',[_vm._v("\n\t\t\t\t\t\t\tPrikažni stare parametre\n\t\t\t\t\t\t")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-form-checkbox',{attrs:{"size":"sm"},model:{value:(_vm.showOldData),callback:function ($$v) {_vm.showOldData=$$v},expression:"showOldData"}})],1)],1)],1),_vm._v(" "),(_vm.showOldData)?_c('b-card-body',[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Policy","label-cols":"3","label":"Policy","label-for":"policy"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"policy"},model:{value:(_vm.modalPovraciloData.policy),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "policy", $$v)},expression:"modalPovraciloData.policy"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Campaign","label-cols":"3","label":"Campaign","label-for":"campaign"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"campaign"},model:{value:(_vm.modalPovraciloData.campaign),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "campaign", $$v)},expression:"modalPovraciloData.campaign"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Action_name","label-cols":"3","label":"Action name","label-for":"action_name"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"action_name"},model:{value:(_vm.modalPovraciloData.action_name),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "action_name", $$v)},expression:"modalPovraciloData.action_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Month","label-cols":"3","label":"Month","label-for":"month"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"month"},model:{value:(_vm.modalPovraciloData.month),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "month", $$v)},expression:"modalPovraciloData.month"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Numdoc","label-cols":"3","label":"Numdoc","label-for":"numdoc"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","id":"numdoc"},model:{value:(_vm.modalPovraciloData.numdoc),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "numdoc", $$v)},expression:"modalPovraciloData.numdoc"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Dealer_name","label-cols":"3","label":"Dealer name","label-for":"dealer_name"}},[_c('b-form-input',{attrs:{"type":"text","id":"dealer_name"},model:{value:(_vm.modalPovraciloData.dealer_name),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "dealer_name", $$v)},expression:"modalPovraciloData.dealer_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Discount","label-cols":"3","label":"Discount","label-for":"discount"}},[_c('b-form-input',{attrs:{"type":"text","id":"discount"},model:{value:(_vm.modalPovraciloData.discount),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "discount", $$v)},expression:"modalPovraciloData.discount"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"fieldset-Contribution","label-cols":"3","label":"Contribution","label-for":"contribution"}},[_c('b-form-input',{attrs:{"type":"text","id":"contribution"},model:{value:(_vm.modalPovraciloData.contribution),callback:function ($$v) {_vm.$set(_vm.modalPovraciloData, "contribution", $$v)},expression:"modalPovraciloData.contribution"}})],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('b-alert',{class:_vm.message_class,attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))])],1)}
var staticRenderFns = []


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusPovracilaFilterDropdown_vue__ = __webpack_require__(571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72381712_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusPovracilaFilterDropdown_vue__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1054)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusPovracilaFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72381712_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusPovracilaFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72381712_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusPovracilaFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Status")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-alert',{class:_vm.message_class,attrs:{"variant":_vm.message.type && _vm.message.type === _vm.MESSAGE_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"icon-wallet"}),_vm._v(" Povračila\n\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#uvoziPovracila"},on:{"click":function($event){$event.preventDefault();_vm.click_openUvoziPovracila($event)}}},[_c('i',{staticClass:"icon-cloud-upload"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-setting",attrs:{"href":"#addPovracilo"},on:{"click":function($event){$event.preventDefault();_vm.click_editPovracilo()}}},[_c('i',{staticClass:"icon-plus"})])])]),_vm._v(" "),_c('b-table',{ref:"dataTable",attrs:{"responsive":"sm","show-empty":"","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","items":_vm.table_dataProvider,"fields":_vm.table.fields,"current-page":_vm.table.currentPage,"per-page":_vm.table.perPage,"filter":_vm.table.filter,"sort-by":_vm.table.sortBy,"sort-desc":_vm.table.sortDesc},on:{"update:sortBy":function($event){_vm.$set(_vm.table, "sortBy", $event)},"update:sortDesc":function($event){_vm.$set(_vm.table, "sortDesc", $event)},"row-clicked":_vm.table_rowClick},scopedSlots:_vm._u([{key:"chassis",fn:function(data){return [(data.item.id_vozila == null)?_c('span',{staticClass:"noVIN"},[_vm._v(" "+_vm._s(data.item.chassis))]):_c('span',[_vm._v(" "+_vm._s(data.item.chassis))])]}},{key:"amount",fn:function(data){return [_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.amount)))])]}},{key:"status",fn:function(data){return [(data.item.status == 0)?_c('b-badge',{attrs:{"variant":"light"}},[_vm._v("Bi naj dobili")]):_vm._e(),_vm._v(" "),(data.item.status == 1)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Smo zahtevali")]):_vm._e(),_vm._v(" "),(data.item.status == 2)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Smo dobili")]):_vm._e(),_vm._v(" "),(data.item.status == 3)?_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v("Modro")]):_vm._e()]}},{key:"creditnotedate",fn:function(data){return [_c('span',[_vm._v("  "+_vm._s(_vm._f("hr_date")(data.item.creditnotedate))+" ")])]}},{key:"actions",fn:function(data){return [_c('b-button',{ref:"editPovracilo",staticClass:"m-1 seznamPovracilIconStyle",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_editPovracilo(data.item)}}},[_c('i',{staticClass:"fa fa-pencil-square-o"})]),_vm._v(" "),_c('b-button',{ref:"removePovracilo",staticClass:"m-1 seznamPovracilIconStyle",attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.click_removePovracilo(data.item)}}},[_c('i',{staticClass:"fa fa-remove"})])]}}])},[_c('template',{slot:"top-row"},[_c('td',[_c('datum-filter-dropdown',{on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.datum),callback:function ($$v) {_vm.$set(_vm.inputFilter, "datum", $$v)},expression:"inputFilter.datum"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.chassis),callback:function ($$v) {_vm.$set(_vm.inputFilter, "chassis", $$v)},expression:"inputFilter.chassis"}})],1),_vm._v(" "),_c('td',[_c('znesek-filter-dropdown',{on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.amount),callback:function ($$v) {_vm.$set(_vm.inputFilter, "amount", $$v)},expression:"inputFilter.amount"}})],1),_vm._v(" "),_c('td',[_c('status-povracila-filter-dropdown',{ref:"statusPovracilaDropdown",on:{"change":_vm.on_statusPovracilaFilterChange}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.table_filterChange},model:{value:(_vm.inputFilter.sale_channel),callback:function ($$v) {_vm.$set(_vm.inputFilter, "sale_channel", $$v)},expression:"inputFilter.sale_channel"}})],1),_vm._v(" "),_c('td')]),_vm._v(" "),(_vm.table.filterSum != null)?_c('template',{slot:"bottom-row"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"sumLabel",attrs:{"colspan":"2"}},[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Skupni znesek povračil: "),_c('b',[_vm._v(_vm._s(_vm._f("hr_money")(_vm.table.filterSum)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_vm._e()],2),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.table.totalRows,"per-page":_vm.table.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.table.currentPage),callback:function ($$v) {_vm.$set(_vm.table, "currentPage", $$v)},expression:"table.currentPage"}})],1)],1)],1)],1),_vm._v(" "),_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('uvozi-povracila-modal',{ref:"uvoziPovracilaModal",on:{"povracilaPotrjena-success":_vm.on_povracilaPotrjenaSuccess}}),_vm._v(" "),_c('edit-povracilo-modal',{ref:"editPovraciloModal",on:{"povracilo_add":_vm.edit_add,"povracilo_edit":_vm.edit_update,"povracilo_id_vozila_find":_vm.edit_vozilo_find}})],1)}
var staticRenderFns = []


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aktivnosti_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e41f0830_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aktivnosti_vue__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1058)
  __webpack_require__(1059)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e41f0830"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aktivnosti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e41f0830_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aktivnosti_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e41f0830_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aktivnosti_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IzstavitevRacunaModal_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dabf3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IzstavitevRacunaModal_vue__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1061)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60dabf3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IzstavitevRacunaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dabf3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IzstavitevRacunaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dabf3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IzstavitevRacunaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":"Izstavitev računa","ok-title":"Izstavi","cancel-title":"Prekliči","size":"sm"},on:{"hidden":_vm.clearModal}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Šasija:"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.ogrodje),callback:function ($$v) {_vm.ogrodje=$$v},expression:"ogrodje"}})],1)],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type && _vm.message.type === _vm.ACTION_TYPE_ERROR ? 'danger' : 'primary',"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('template',{slot:"modal-footer"},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.stopPropagation();_vm.click_cancelModal($event)}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.buttonIzdajDisabled},on:{"click":function($event){$event.stopPropagation();_vm.click_okModal($event)}}},[_vm._v("Izstavi račun")])],1)],1)],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"cProdaja",attrs:{"header":"CDP zaloga vozil"}},[_c('b-table',{ref:"cdpVehiclesStockPaymentTable",staticClass:"tProdaja",attrs:{"show-empty":"","responsive":"sm","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","head-variant":"light","items":_vm.cdpVehiclesStockPaymentTable_dataProvider,"fields":_vm.cdpVehiclesStockPaymentTable.fields,"current-page":_vm.cdpVehiclesStockPaymentTable.currentPage,"per-page":_vm.cdpVehiclesStockPaymentTable.perPage},scopedSlots:_vm._u([{key:"purchase_price",fn:function(data){return [(data.item.purchase_price)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.purchase_price))+" ")]):_vm._e()]}},{key:"dmv",fn:function(data){return [(data.item.dmv)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.dmv))+" ")]):_vm._e()]}},{key:"purchase_price_with_dmv",fn:function(data){return [(data.item.purchase_price_with_dmv)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.purchase_price_with_dmv))+" ")]):_vm._e()]}},{key:"amount_due",fn:function(data){return [(data.item.amount_due)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_money")(data.item.amount_due))+" ")]):_vm._e()]}},{key:"due_date",fn:function(data){return [(data.item.due_date)?_c('span',[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.due_date))+" ")]):_vm._e()]}},{key:"actions",fn:function(data){return [(data.item.paid_at)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge-lg",attrs:{"pill":"","variant":"success","title":_vm.cdpVehicleStockPaidTitle(data.item)}},[_vm._v("Plačano")]):_c('b-button',{staticClass:"mr-1 mb-1",attrs:{"disabled":!_vm.userCanConfirmCdpVehicleStockPay,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.click_cdpVehicleStockPay(data.item)}}},[_vm._v("Potrdi plačilo")])]}}])}),_vm._v(" "),_c('nav',[_c('b-row',[_c('b-col',{attrs:{"sm":"10"}},[_c('b-pagination',{staticClass:"navigacija",attrs:{"total-rows":_vm.cdpVehiclesStockPaymentTable.totalRows,"per-page":_vm.cdpVehiclesStockPaymentTable.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","limit":_vm.cdpVehiclesStockPaymentTable.naviLimit},model:{value:(_vm.cdpVehiclesStockPaymentTable.currentPage),callback:function ($$v) {_vm.$set(_vm.cdpVehiclesStockPaymentTable, "currentPage", $$v)},expression:"cdpVehiclesStockPaymentTable.currentPage"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.cdpVehiclesStockPaymentTable.totalRows))])])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{staticClass:"cProdaja"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"align-self":"start"}},[_vm._v("\n\t\t\t\t\t\t\t\tPotrditve plačill\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-col',{staticClass:"filterRacunovodjaPotrdil",attrs:{"align-self":"end"}},[_c('datum-filter-dropdown',{ref:"racunovodja_potrdilDropdown",attrs:{"default_label":'Aktivni',"noFutureValues":true},on:{"input":_vm.onPotrditvePlacilTableFilterChange},model:{value:(_vm.potrditvePlacilTable_props.inputFilter.datum_racunovodja_potrdil),callback:function ($$v) {_vm.$set(_vm.potrditvePlacilTable_props.inputFilter, "datum_racunovodja_potrdil", $$v)},expression:"potrditvePlacilTable_props.inputFilter.datum_racunovodja_potrdil"}})],1)],1)],1),_vm._v(" "),_c('b-table',{ref:"potrditvePlacilTable",staticClass:"tProdaja",attrs:{"show-empty":"","responsive":"sm","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","head-variant":"light","items":_vm.potrditvePlacilTable_dataProvider,"fields":_vm.potrditvePlacilTable_props.fields,"current-page":_vm.potrditvePlacilTable_props.currentPage,"per-page":_vm.potrditvePlacilTable_props.perPage},on:{"row-clicked":_vm.potrditvePlacilTable_rowClick},scopedSlots:_vm._u([{key:"skupni_znesek",fn:function(data){return [(data.item.skupni_znesek && data.item.skupni_znesek > 0)?_c('div',[_vm._v(_vm._s(_vm._f("hr_money")(data.item.skupni_znesek)))]):_c('div',[_vm._v("/")])]}},{key:"prodajalec_potrditev",fn:function(data){return [(data.item.datum_prodajalec_potrdil)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Potrjeno dne "+_vm._s(_vm._f("hr_date")(data.item.datum_prodajalec_potrdil)))]):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Čaka na potrditev")])]}},{key:"sekretar_potrditev",fn:function(data){return [(data.item.datum_sekretar_potrdil)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Potrjeno dne "+_vm._s(_vm._f("hr_date")(data.item.datum_sekretar_potrdil)))]):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Čaka na potrditev")])]}},{key:"moderator_potrditev",fn:function(data){return [(data.item.datum_moderator_potrdil)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Potrjeno dne "+_vm._s(_vm._f("hr_date")(data.item.datum_moderator_potrdil)))]):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Čaka na potrditev")])]}},{key:"racunovodja_potrditev",fn:function(data){return [(data.item.datum_racunovodja_potrdil)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Potrjeno dne "+_vm._s(_vm._f("hr_date")(data.item.datum_racunovodja_potrdil)))]):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Čaka na potrditev")])]}}])},[_c('template',{slot:"top-row"},[_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onPotrditvePlacilTableTextFilterChange},model:{value:(_vm.potrditvePlacilTable_props.inputFilter.ogrodje),callback:function ($$v) {_vm.$set(_vm.potrditvePlacilTable_props.inputFilter, "ogrodje", $$v)},expression:"potrditvePlacilTable_props.inputFilter.ogrodje"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onPotrditvePlacilTableTextFilterChange},model:{value:(_vm.potrditvePlacilTable_props.inputFilter.libelle_modele),callback:function ($$v) {_vm.$set(_vm.potrditvePlacilTable_props.inputFilter, "libelle_modele", $$v)},expression:"potrditvePlacilTable_props.inputFilter.libelle_modele"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onPotrditvePlacilTableTextFilterChange},model:{value:(_vm.potrditvePlacilTable_props.inputFilter.libelle_version),callback:function ($$v) {_vm.$set(_vm.potrditvePlacilTable_props.inputFilter, "libelle_version", $$v)},expression:"potrditvePlacilTable_props.inputFilter.libelle_version"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onPotrditvePlacilTableTextFilterChange},model:{value:(_vm.potrditvePlacilTable_props.inputFilter.p_prodajalec_name),callback:function ($$v) {_vm.$set(_vm.potrditvePlacilTable_props.inputFilter, "p_prodajalec_name", $$v)},expression:"potrditvePlacilTable_props.inputFilter.p_prodajalec_name"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onPotrditvePlacilTableTextFilterChange},model:{value:(_vm.potrditvePlacilTable_props.inputFilter.st_racuna),callback:function ($$v) {_vm.$set(_vm.potrditvePlacilTable_props.inputFilter, "st_racuna", $$v)},expression:"potrditvePlacilTable_props.inputFilter.st_racuna"}})],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])],2),_vm._v(" "),_c('nav',[_c('b-row',[_c('b-col',{attrs:{"sm":"10"}},[_c('b-pagination',{staticClass:"navigacija",attrs:{"total-rows":_vm.potrditvePlacilTable_props.totalRows,"per-page":_vm.potrditvePlacilTable_props.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","limit":_vm.potrditvePlacilTable_props.naviLimit},model:{value:(_vm.potrditvePlacilTable_props.currentPage),callback:function ($$v) {_vm.$set(_vm.potrditvePlacilTable_props, "currentPage", $$v)},expression:"potrditvePlacilTable_props.currentPage"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.potrditvePlacilTable_props.totalRows))])])],1)],1)],1),_vm._v(" "),_c('mapa-modal',{ref:"mapaModal",on:{"userpotrdil-success":_vm.on_userPotrdilSuccess}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{staticClass:"cProdaja",attrs:{"header":"Izstavitve računov"}},[_c('b-table',{ref:"zeljeneIzstavitveRacunovTable",staticClass:"tProdaja",attrs:{"show-empty":"","responsive":"sm","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","head-variant":"light","items":_vm.zeljeneIzstavitveRacunovTable_dataProvider,"fields":_vm.zeljeneIzstavitveRacunovTable.fields,"current-page":_vm.zeljeneIzstavitveRacunovTable.currentPage,"per-page":_vm.zeljeneIzstavitveRacunovTable.perPage,"filter":_vm.zeljeneIzstavitveRacunovTable.filter},on:{"row-clicked":_vm.zeljeneIzstavitveRacunovTable_rowClick},scopedSlots:_vm._u([{key:"m_zeljena_izstavitev_racuna",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("hr_datetime")(data.item.m_zeljena_izstavitev_racuna))+"\n\t\t\t\t\t\t")]}},{key:"m_datum_izstavitve_racuna",fn:function(data){return [(data.item.m_datum_izstavitve_racuna)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Račun izstavljen dne "+_vm._s(_vm._f("hr_date")(data.item.m_datum_izstavitve_racuna)))]):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Čaka na izstavitev")])]}},{key:"pk_title",fn:function(data){return [(data.item.pk_is_company == 1)?_c('span',[_vm._v(_vm._s(data.item.pk_company_title)+" "),(data.item.pk_contact_name != '')?_c('span',[_vm._v("("+_vm._s(data.item.pk_contact_name)+")")]):_vm._e()]):_c('span',[_vm._v(_vm._s(data.item.pk_first_name)+" "+_vm._s(data.item.pk_last_name))])]}},{key:"pu_title",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(data.item.pu_last_name)+" "+_vm._s(data.item.pu_first_name)+"\n\t\t\t\t\t\t")]}}])}),_vm._v(" "),_c('nav',[_c('b-row',[_c('b-col',{attrs:{"sm":"10"}},[_c('b-pagination',{staticClass:"navigacija",attrs:{"total-rows":_vm.zeljeneIzstavitveRacunovTable.totalRows,"per-page":_vm.zeljeneIzstavitveRacunovTable.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","limit":_vm.zeljeneIzstavitveRacunovTable.naviLimit},model:{value:(_vm.zeljeneIzstavitveRacunovTable.currentPage),callback:function ($$v) {_vm.$set(_vm.zeljeneIzstavitveRacunovTable, "currentPage", $$v)},expression:"zeljeneIzstavitveRacunovTable.currentPage"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.zeljeneIzstavitveRacunovTable.totalRows))])])],1)],1)],1),_vm._v(" "),_c('izstavitev-racuna-modal',{ref:"izstavitevRacunaModal",on:{"izstavitevRacuna_success":_vm.izstavitevRacuna_success}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"cProdaja",attrs:{"header":"Testna vozila"}},[_c('b-table',{ref:"customKontoTable",staticClass:"tProdaja",attrs:{"show-empty":"","responsive":"sm","hover":"","empty-text":"Ni vnosov","empty-filtered-text":"Ni zadetkov","head-variant":"light","items":_vm.customKontoTable_dataProvider,"fields":_vm.customKontoTable.fields,"current-page":_vm.customKontoTable.currentPage,"per-page":_vm.customKontoTable.perPage,"filter":_vm.customKontoTable.filter},on:{"row-clicked":_vm.customKontoTable_rowClick},scopedSlots:_vm._u([{key:"libelle_options",fn:function(data){return [(data.item.libelle_options != '' && data.item.libelle_options != 'null' && data.item.libelle_options != null)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"","title":_vm.getTitle(data.item.libelle_options)}},[_c('i',{staticClass:"i_options fa fa-gears fa-lg",staticStyle:{"padding":"2px"}})]):_vm._e(),_vm._v(" "),(data.item.libelle_teinte != '' && data.item.libelle_teinte != 'null' && data.item.libelle_teinte != null)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"","title":_vm.getTitle(data.item.libelle_teinte)}},[(data.item.barva != '' && data.item.barva != 'null' && data.item.barva != null)?_c('span',{staticStyle:{"line-height":"20px"}},[_vm._v(_vm._s(data.item.barva))]):_c('span',{staticStyle:{"line-height":"20px"}},[_c('i',{staticClass:"fa fa-tint",staticStyle:{"margin-left":"5px","margin-right":"5px"}})])]):_vm._e()]}},{key:"status",fn:function(data){return [(_vm.isSold(data.item))?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"success","title":_vm.getSoldInfo(data.item)}},[_vm._v("Prodano")]):_vm._e()]}},{key:"datum_prve_registracije",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("hr_date")(data.item.datum_prve_registracije))+"\n\t\t\t\t\t\t")]}},{key:"datum_kdaj_ga_moramo_prodati",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("hr_date")(data.item.datum_kdaj_ga_moramo_prodati))+"\n\t\t\t\t\t\t")]}},{key:"datum_kdaj_ga_lahko_prodamo",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("hr_date")(data.item.datum_kdaj_ga_lahko_prodamo))+"\n\t\t\t\t\t\t")]}},{key:"prodajna_cena",fn:function(data){return [(data.item.prodajna_cena && data.item.prodajna_cena > 0)?_c('div',[_vm._v(_vm._s(_vm._f("hr_money")(data.item.prodajna_cena)))]):_c('div',[_vm._v("/")])]}},{key:"st_kilometrov",fn:function(data){return [(data.item.st_kilometrov)?_c('div',[_vm._v(_vm._s(data.item.st_kilometrov)+" km")]):_c('div',[_vm._v("/")])]}}])},[_c('template',{slot:"top-row"},[_c('td'),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCustomKontoTableFilterChange},model:{value:(_vm.customKontoTable.inputFilter.ogrodje),callback:function ($$v) {_vm.$set(_vm.customKontoTable.inputFilter, "ogrodje", $$v)},expression:"customKontoTable.inputFilter.ogrodje"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCustomKontoTableFilterChange},model:{value:(_vm.customKontoTable.inputFilter.model),callback:function ($$v) {_vm.$set(_vm.customKontoTable.inputFilter, "model", $$v)},expression:"customKontoTable.inputFilter.model"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCustomKontoTableFilterChange},model:{value:(_vm.customKontoTable.inputFilter.verzija),callback:function ($$v) {_vm.$set(_vm.customKontoTable.inputFilter, "verzija", $$v)},expression:"customKontoTable.inputFilter.verzija"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.onCustomKontoTableFilterChange},model:{value:(_vm.customKontoTable.inputFilter.barva),callback:function ($$v) {_vm.$set(_vm.customKontoTable.inputFilter, "barva", $$v)},expression:"customKontoTable.inputFilter.barva"}})],1),_vm._v(" "),_c('td',[_c('datum-filter-dropdown',{ref:"datum_prve_registracijeDropdown",on:{"input":_vm.onCustomKontoTableFilterChange},model:{value:(_vm.customKontoTable.inputFilter.datum_prve_registracije),callback:function ($$v) {_vm.$set(_vm.customKontoTable.inputFilter, "datum_prve_registracije", $$v)},expression:"customKontoTable.inputFilter.datum_prve_registracije"}})],1),_vm._v(" "),_c('td',[_c('datum-filter-dropdown',{ref:"datum_kdaj_ga_moramo_prodatiDropdown",on:{"input":_vm.onCustomKontoTableFilterChange},model:{value:(_vm.customKontoTable.inputFilter.datum_kdaj_ga_moramo_prodati),callback:function ($$v) {_vm.$set(_vm.customKontoTable.inputFilter, "datum_kdaj_ga_moramo_prodati", $$v)},expression:"customKontoTable.inputFilter.datum_kdaj_ga_moramo_prodati"}})],1),_vm._v(" "),_c('td',[_c('datum-filter-dropdown',{ref:"datum_kdaj_ga_lahko_prodamoDropdown",on:{"input":_vm.onCustomKontoTableFilterChange},model:{value:(_vm.customKontoTable.inputFilter.datum_kdaj_ga_lahko_prodamo),callback:function ($$v) {_vm.$set(_vm.customKontoTable.inputFilter, "datum_kdaj_ga_lahko_prodamo", $$v)},expression:"customKontoTable.inputFilter.datum_kdaj_ga_lahko_prodamo"}})],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])],2),_vm._v(" "),_c('nav',[_c('b-row',[_c('b-col',{attrs:{"sm":"10"}},[_c('b-pagination',{staticClass:"navigacija",attrs:{"total-rows":_vm.customKontoTable.totalRows,"per-page":_vm.customKontoTable.perPage,"prev-text":"Prejšnja","next-text":"Naslednja","limit":_vm.customKontoTable.naviLimit},model:{value:(_vm.customKontoTable.currentPage),callback:function ($$v) {_vm.$set(_vm.customKontoTable, "currentPage", $$v)},expression:"customKontoTable.currentPage"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.customKontoTable.totalRows))])])],1)],1)],1),_vm._v(" "),_c('podrobnosti-vozila-modal',{ref:"podrobnostiVozilaModal",on:{"importdata_edit":_vm.importdata_edit}}),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotelGum_vue__ = __webpack_require__(574);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c24188_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotelGum_vue__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1065)
  __webpack_require__(1066)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60c24188"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotelGum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c24188_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotelGum_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c24188_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotelGum_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHotelHrambaModal_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44874f8e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelHrambaModal_vue__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1068)
  __webpack_require__(1069)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44874f8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHotelHrambaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44874f8e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelHrambaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44874f8e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelHrambaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"no-close-on-backdrop":_vm.isLoading,"hide-header-close":_vm.isLoading,"title":_vm.title,"size":_vm.modalSize},on:{"hidden":_vm.clearModalData},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var cancel = ref.cancel;
return [_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{staticStyle:{"margin-right":"5px"},attrs:{"disabled":_vm.isLoading,"variant":"secondary"},on:{"click":function($event){cancel()}}},[_vm._v("Prekliči")]),_vm._v(" "),(!_vm.formDisabled)?_c('b-button',{attrs:{"disabled":_vm.okButton.disabled,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.onOkModal()}}},[_vm._v(_vm._s(_vm.okButton.label)+"\n\t\t\t\t\t\t\t"),(_vm.okButton.progress)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1):_vm._e()],1)],1)],1)]}}])},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":false},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),( _vm.mode === _vm.mode_SWITCH3)?_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"header":'Podatki o izdaji (#' + _vm.hotelStoritev.fk_hotel_storitev_take + ')'}},[_c('b-row',{staticClass:"mb-2"},[_c('b-col',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.takeOfSwitch)}})])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.mode === _vm.mode_GIVE1 || _vm.mode === _vm.mode_TAKE2 || _vm.mode === _vm.mode_SWITCH3 || _vm.mode === _vm.mode_EDITING4),expression:"mode === mode_GIVE1 || mode === mode_TAKE2 || mode === mode_SWITCH3 || mode === mode_EDITING4"}]},[_c('b-col',[_c('b-card',{attrs:{"header":_vm.mainCardHeader}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-num_tires","label":"Št. pnevmatik"}},[(_vm.mode === _vm.mode_GIVE1 || _vm.mode === _vm.mode_SWITCH3 || _vm.mode === _vm.mode_EDITING4)?_c('b-form-input',{attrs:{"disabled":_vm.formDisabled,"id":"input-num_tires","type":"number","min":"1"},model:{value:(_vm.hotelStoritev.num_tires),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "num_tires", $$v)},expression:"hotelStoritev.num_tires"}}):_vm._e(),_vm._v(" "),(_vm.mode === _vm.mode_TAKE2)?_c('b-form-input',{attrs:{"value":_vm.hotelStoritev.num_tires,"disabled":""}}):_vm._e()],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-manufacturer","label":"Znamka:"}},[((_vm.mode === _vm.mode_GIVE1 || _vm.mode === _vm.mode_SWITCH3 || _vm.mode === _vm.mode_EDITING4) && _vm.manufacturer_Options.length > 0)?_c('v-select',{attrs:{"options":_vm.manufacturer_Options,"taggable":true,"filterable":false,"placeholder":"Izberi znamko gume...","disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},on:{"search":_vm.manufacturerSearch},model:{value:(_vm.hotelStoritev.manufacturer),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "manufacturer", $$v)},expression:"hotelStoritev.manufacturer"}},[_c('template',{slot:"no-options"},[_vm._v("Ni znamk gum")])],2):(_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled)?_c('b-form-input',{attrs:{"type":"text","value":_vm.hotelStoritev.manufacturer,"disabled":""}}):_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.hotelStoritev.manufacturer),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "manufacturer", $$v)},expression:"hotelStoritev.manufacturer"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{staticClass:"infoCard",attrs:{"header":'Dimenzije: ' + _vm.hotelStoritev.dimensions.width  + '/' + _vm.hotelStoritev.dimensions.heigth + 'R' + _vm.hotelStoritev.dimensions.diameter}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_dimensions_width,"state":_vm.state_dimensions_width,"label":"Širina:","label-cols":"4"}},[_c('b-form-input',{attrs:{"type":"number","disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},model:{value:(_vm.hotelStoritev.dimensions.width),callback:function ($$v) {_vm.$set(_vm.hotelStoritev.dimensions, "width", $$v)},expression:"hotelStoritev.dimensions.width"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_dimensions_height,"state":_vm.state_dimensions_height,"label":"Višina:","label-cols":"4"}},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Vnesite višino ...","disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},model:{value:(_vm.hotelStoritev.dimensions.heigth),callback:function ($$v) {_vm.$set(_vm.hotelStoritev.dimensions, "heigth", $$v)},expression:"hotelStoritev.dimensions.heigth"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_dimensions_diameter,"state":_vm.state_dimensions_diameter,"label":"Premer:","label-cols":"4"}},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Vnesite premer ...","disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},model:{value:(_vm.hotelStoritev.dimensions.diameter),callback:function ($$v) {_vm.$set(_vm.hotelStoritev.dimensions, "diameter", $$v)},expression:"hotelStoritev.dimensions.diameter"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"infoCard",attrs:{"header":"Sezona"}},[_c('b-form-group',[_c('b-form-radio-group',{attrs:{"options":_vm.settings.season_options,"stacked":"","disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},model:{value:(_vm.hotelStoritev.season),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "season", $$v)},expression:"hotelStoritev.season"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-card',{staticClass:"infoCard",attrs:{"header":"Platišča"}},[_c('b-form-group',[_c('b-form-radio-group',{attrs:{"options":_vm.settings.rims_options,"stacked":"","disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},model:{value:(_vm.hotelStoritev.rims),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "rims", $$v)},expression:"hotelStoritev.rims"}}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"mt-2",attrs:{"checked":_vm.hotelStoritev.rims_cover === 1,"disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},on:{"change":_vm.rimsCover_Changed}},[_vm._v("Pokrovi")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"checked":_vm.hotelStoritev.rims_screw === 1,"disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled},on:{"change":_vm.rimsScrew_Changed}},[_vm._v("Vijaki")])],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.mode === _vm.mode_GIVE1 || _vm.mode === _vm.mode_TAKE2 || _vm.mode === _vm.mode_EDITING4)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-date_give","invalid-feedback":_vm.invalidFeedback_date_give,"state":_vm.state_date_give,"label":"Datum oddaje:"}},[(_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled)?_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.hotelStoritev.date_give),"disabled":""}}):_c('v-date-picker',{attrs:{"max-date":new Date(Date.now()),"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY"
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.hotelStoritev.date_give),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "date_give", $$v)},expression:"hotelStoritev.date_give"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-responsible_mechanic_give","invalid-feedback":_vm.invalidFeedback_responsible_mechanic_give,"state":_vm.state_responsible_mechanic_give,"label":"Odgovorni mehanik:"}},[_c('b-form-input',{attrs:{"disabled":_vm.mode === _vm.mode_TAKE2 || _vm.formDisabled,"id":"input-responsible_mechanic_give","placeholder":"Ime in priimek odgovornega mehanika"},model:{value:(_vm.hotelStoritev.responsible_mechanic_give),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "responsible_mechanic_give", $$v)},expression:"hotelStoritev.responsible_mechanic_give"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.mode === _vm.mode_TAKE2 || _vm.mode === _vm.mode_EDITING4)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-date_take","invalid-feedback":_vm.invalidFeedback_date_take,"state":_vm.state_date_take,"label":"Datum izdaje:"}},[(_vm.formDisabled)?_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.hotelStoritev.date_give),"disabled":""}}):_c('v-date-picker',{attrs:{"min-date":_vm.hotelStoritev.date_give,"max-date":new Date(Date.now()),"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY"
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.hotelStoritev.date_take),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "date_take", $$v)},expression:"hotelStoritev.date_take"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-responsible_mechanic_take","invalid-feedback":_vm.invalidFeedback_responsible_mechanic_take,"state":_vm.state_responsible_mechanic_take,"label":"Odgovorni mehanik:"}},[_c('b-form-input',{attrs:{"disabled":_vm.formDisabled,"id":"input-responsible_mechanic_take","placeholder":"Ime in priimek odgovornega mehanika"},model:{value:(_vm.hotelStoritev.responsible_mechanic_take),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "responsible_mechanic_take", $$v)},expression:"hotelStoritev.responsible_mechanic_take"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.mode === _vm.mode_SWITCH3)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-date_give","invalid-feedback":_vm.invalidFeedback_date_give,"state":_vm.state_date_give,"label":"Datum zamenjave:"}},[(_vm.formDisabled)?_c('b-form-input',{attrs:{"type":"text","value":_vm._f("hr_date")(_vm.hotelStoritev.date_give),"disabled":""}}):_c('v-date-picker',{attrs:{"min-date":_vm.takeOfSwitch_date_give,"max-date":new Date(Date.now()),"input-props":{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY"
									},"mode":"single","locale":"sl-SI"},model:{value:(_vm.hotelStoritev.date_give),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "date_give", $$v)},expression:"hotelStoritev.date_give"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-responsible_mechanic_give","invalid-feedback":_vm.invalidFeedback_responsible_mechanic_give,"state":_vm.state_responsible_mechanic_give,"label":"Odgovorni mehanik:"}},[_c('b-form-input',{attrs:{"disabled":_vm.formDisabled,"id":"input-responsible_mechanic_give","placeholder":"Ime in priimek odgovornega mehanika"},model:{value:(_vm.hotelStoritev.responsible_mechanic_give),callback:function ($$v) {_vm.$set(_vm.hotelStoritev, "responsible_mechanic_give", $$v)},expression:"hotelStoritev.responsible_mechanic_give"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.mode === _vm.mode_GIVE1 || _vm.mode === _vm.mode_TAKE2 || _vm.mode === _vm.mode_SWITCH3 || _vm.mode === _vm.mode_EDITING4)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',[_vm._v("\n\t\t\t\t\t\t\t\tKomentarji "),_c('span',{staticClass:"ml-2"})])],1)],1),_vm._v(" "),(!_vm.formDisabled)?_c('b-row',[_c('b-col',{attrs:{"cols":"10"}},[_c('b-form-group',{attrs:{"label-for":"input-hotel_komentar_content"}},[_c('b-form-textarea',{attrs:{"disabled":_vm.formDisabled,"id":"input-hotel_komentar_content","placeholder":"Vnesite komentar","type":"text","rows":3},model:{value:(_vm.hotelKomentar.content),callback:function ($$v) {_vm.$set(_vm.hotelKomentar, "content", $$v)},expression:"hotelKomentar.content"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-button',{attrs:{"disabled":_vm.addHotelKomentarButton.disabled || _vm.hotelKomentar.content == null || _vm.hotelKomentar.content === '',"title":_vm.hotelKomentar.content == null || _vm.hotelKomentar.content === '' ? 'Komentar mora imeti vsebino' : 'Dodaj komentar',"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.addHotelKomentar()}}},[_vm._v(_vm._s(_vm.addHotelKomentarButton.label)+"\n\t\t\t\t\t\t\t\t"),(_vm.addHotelKomentarButton.progress)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"komentarjiOfStoritevTable",attrs:{"responsive":"sm","striped":"","show-empty":"","hover":"","empty-text":_vm.komentarjiOfStoritevTable_props.empty_text,"empty-filtered-text":_vm.komentarjiOfStoritevTable_props.empty_filtered_text,"sort-desc":true,"current-page":_vm.komentarjiOfStoritevTable_props.page,"per-page":_vm.komentarjiOfStoritevTable_props.size,"fields":_vm.komentarjiOfStoritevTable_props.fields,"items":_vm.komentarjiOfStoritevTable_items},scopedSlots:_vm._u([{key:"user",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n\t\t\t\t\t\t\t")]}},{key:"created_at",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("hr_datetime")(data.item.created_at))+"\n\t\t\t\t\t\t\t")]}},{key:"content",fn:function(data){return [_c('div',[_vm._v(_vm._s(data.item.content))])]}}])}),_vm._v(" "),_vm._l((_vm.komentarjiOfStoritevTable_props.items),function(item){return _c('div',{key:item.id},[_c('div',{attrs:{"align":"center"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("hr_datetime")(item.created_at))+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"comment mb-3"},[_c('b',[_vm._v(_vm._s(item.first_name)+":")]),_vm._v(" "+_vm._s(item.content)+"\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t")])])}),_vm._v(" "),_c('nav',{staticClass:"nav"},[_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.komentarjiOfStoritevTable_props.total,"per-page":_vm.komentarjiOfStoritevTable_props.size,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.komentarjiOfStoritevTable_props.page),callback:function ($$v) {_vm.$set(_vm.komentarjiOfStoritevTable_props, "page", $$v)},expression:"komentarjiOfStoritevTable_props.page"}})],1),_vm._v(" "),_c('b-col',[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.komentarjiOfStoritevTable_props.total))])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.komentarjiOfStoritevTable_props.options_numRowsOnPage},model:{value:(_vm.komentarjiOfStoritevTable_props.size),callback:function ($$v) {_vm.$set(_vm.komentarjiOfStoritevTable_props, "size", $$v)},expression:"komentarjiOfStoritevTable_props.size"}})],1)],1)],1)],2)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type,"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))])],1)}
var staticRenderFns = []


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHotelStrankaModal_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d32a0e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelStrankaModal_vue__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1074)
  __webpack_require__(1075)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d32a0e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHotelStrankaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d32a0e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelStrankaModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d32a0e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHotelStrankaModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary editHotelHrambaModal",attrs:{"no-close-on-backdrop":_vm.isLoading,"hide-header-close":_vm.isLoading,"title":_vm.title,"size":_vm.modalSize},on:{"hidden":_vm.clearModalData},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var cancel = ref.cancel;
return [_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{staticStyle:{"margin-right":"5px"},attrs:{"disabled":_vm.isLoading,"variant":"secondary"},on:{"click":function($event){cancel()}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.okButton.disabled,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.onOkModal()}}},[_vm._v(_vm._s(_vm.okButton.label)+"\n\t\t\t\t\t\t\t"),(_vm.okButton.progress)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1)],1)],1)],1)]}}])},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":false},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.mode === _vm.mode_ADDING1 || _vm.mode === _vm.mode_EDITING2),expression:"mode === mode_ADDING1 || mode === mode_EDITING2"}]},[_c('b-col',[_c('b-row',[_c('b-col',[_c('b-form-radio-group',{staticClass:"mb-3",attrs:{"buttons":"","button-variant":"outline-primary"},model:{value:(_vm.hotelStranka.external),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "external", $$v)},expression:"hotelStranka.external"}},[_c('b-form-radio',{attrs:{"value":1}},[_vm._v("External")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":0}},[_vm._v("Internal")])],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',{staticClass:"mb-3",attrs:{"buttons":"","button-variant":"outline-primary"},model:{value:(_vm.hotelStranka.is_company),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "is_company", $$v)},expression:"hotelStranka.is_company"}},[_c('b-form-radio',{attrs:{"value":0}},[_vm._v("Fizična oseba")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":1}},[_vm._v("Podjetje")])],1)],1)],1),_vm._v(" "),_c('b-row'),_vm._v(" "),(_vm.hotelStranka.is_company)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Naziv:","label-for":"kupec_title","invalid-feedback":_vm.invalidFeedback_title,"state":_vm.state_title}},[_c('b-form-input',{attrs:{"id":"kupec_title","type":"text","placeholder":"Naziv stranke"},model:{value:(_vm.hotelStranka.title),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "title", $$v)},expression:"hotelStranka.title"}})],1)],1)],1):_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Ime:","label-for":"kupec_ime","invalid-feedback":_vm.invalidFeedback_first_name,"state":_vm.state_first_name}},[_c('b-form-input',{attrs:{"id":"kupec_ime","type":"text","placeholder":"Ime stranke"},model:{value:(_vm.hotelStranka.first_name),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "first_name", $$v)},expression:"hotelStranka.first_name"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Priimek:","label-for":"kupec_priimek","invalid-feedback":_vm.invalidFeedback_last_name,"state":_vm.state_last_name}},[_c('b-form-input',{attrs:{"id":"kupec_priimek","type":"text","placeholder":"Priimek stranke"},model:{value:(_vm.hotelStranka.last_name),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "last_name", $$v)},expression:"hotelStranka.last_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Email:","label-for":"kupec_email","invalid-feedback":_vm.invalidFeedback_email,"state":_vm.state_email}},[_c('b-form-input',{attrs:{"id":"kupec_email","type":"text","placeholder":"Elektronski naslov stranke"},model:{value:(_vm.hotelStranka.email),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "email", $$v)},expression:"hotelStranka.email"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Telefonska številka:","label-for":"kupec_telefon"}},[_c('b-form-input',{attrs:{"id":"kupec_telefon","type":"text","placeholder":"Telefonska številka stranke"},model:{value:(_vm.hotelStranka.phone_number),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "phone_number", $$v)},expression:"hotelStranka.phone_number"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-vehicle","label":"Vozilo:"}},[_c('b-form-input',{attrs:{"id":"input-vehicle","placeholder":"Naziv vozila"},model:{value:(_vm.hotelStranka.vehicle),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "vehicle", $$v)},expression:"hotelStranka.vehicle"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-registration_number","invalid-feedback":_vm.invalidFeedback_registration_number,"state":_vm.state_registration_number,"label":"Registrska številka:"}},[_c('b-form-input',{attrs:{"id":"input-registration_number","placeholder":"Registrska številka"},on:{"keyup":_vm.formatRegistrationNumber},model:{value:(_vm.hotelStranka.registration_number),callback:function ($$v) {_vm.$set(_vm.hotelStranka, "registration_number", $$v)},expression:"hotelStranka.registration_number"}})],1)],1)],1)],1)],1),_vm._v(" "),(_vm.mode === _vm.mode_UNKNOWN0)?_c('div',[_vm._v("\n\t\t\tNeznan način\n\t\t")]):_vm._e(),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type,"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))])],1)}
var staticRenderFns = []


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary editHotelHrambaModal",attrs:{"no-close-on-backdrop":_vm.isLoading,"hide-header-close":_vm.isLoading,"title":_vm.title,"size":_vm.modalSize},on:{"hidden":_vm.clearModalData},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var cancel = ref.cancel;
return [_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{staticStyle:{"margin-right":"5px"},attrs:{"disabled":_vm.isLoading,"variant":"secondary"},on:{"click":function($event){cancel()}}},[_vm._v("Prekliči")]),_vm._v(" "),(_vm.userCanEdit)?_c('b-button',{attrs:{"disabled":_vm.okButton.disabled,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.onOkModal()}}},[_vm._v(_vm._s(_vm.okButton.label)+"\n\t\t\t\t\t\t\t"),(_vm.okButton.progress)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1):_vm._e()],1)],1)],1)]}}])},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":false},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),(_vm.mode === _vm.mode_ADDING1 || _vm.mode === _vm.mode_EDITING2)?_c('b-row',[_c('b-col',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"card-actions"},[(_vm.userCanEdit)?_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Dodaj stranko"},on:{"click":function($event){$event.stopPropagation();return _vm.hotelStrankaAdding_click($event)}}},[_c('i',{staticClass:"icon-plus"})]):_vm._e()],1),_vm._v("\n\t\t\t\t\t\tStranka\n\t\t\t\t\t")]),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"input-fk_hotel_stranka"}},[_c('v-select',{ref:"hotelStranke",attrs:{"options":_vm.all_hotelStranke,"label":"title","placeholder":"Izberi stranko ...","disabled":!_vm.userCanEdit},on:{"input":_vm.hotelStrankeSelect_change,"search":_vm.hotelStrankeSelect_search},model:{value:(_vm.hotel_stranka_selected),callback:function ($$v) {_vm.hotel_stranka_selected=$$v},expression:"hotel_stranka_selected"}},[_c('template',{slot:"no-options"},[_vm._v("Kupec ni najden")])],2)],1),_vm._v(" "),(_vm.hotel_stranka_selected.id > 0)?_c('div',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',[_c('b-button',{staticClass:"noPointer",attrs:{"disabled":"","variant":"primary"}},[_vm._v(_vm._s(_vm.hotel_stranka_selected.external ? 'External' : 'Internal'))])],1),_vm._v(" "),_c('b-col',[_c('b-button',{staticClass:"noPointer",attrs:{"disabled":"","variant":"primary"}},[_vm._v(_vm._s(_vm.hotel_stranka_selected.is_company ? 'Podjetje' : 'Fizična oseba'))])],1)],1),_vm._v(" "),(_vm.hotel_stranka_selected.is_company)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Naziv:","label-for":"kupec_title"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.title),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "title", $$v)},expression:"hotel_stranka_selected.title"}})],1)],1)],1):_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Ime:","label-for":"kupec_ime"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.first_name),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "first_name", $$v)},expression:"hotel_stranka_selected.first_name"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Priimek:","label-for":"kupec_priimek"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.last_name),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "last_name", $$v)},expression:"hotel_stranka_selected.last_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Email:","label-for":"kupec_email"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.email),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "email", $$v)},expression:"hotel_stranka_selected.email"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Telefonska številka:","label-for":"kupec_telefon"}},[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.phone_number),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "phone_number", $$v)},expression:"hotel_stranka_selected.phone_number"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-vehicle","label":"Vozilo:"}},[_c('b-form-input',{attrs:{"disabled":""},model:{value:(_vm.hotel_stranka_selected.vehicle),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "vehicle", $$v)},expression:"hotel_stranka_selected.vehicle"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-registration_number","label":"Registrska številka:"}},[_c('b-form-input',{attrs:{"disabled":""},model:{value:(_vm.hotel_stranka_selected.registration_number),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "registration_number", $$v)},expression:"hotel_stranka_selected.registration_number"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-right"},[(_vm.hotel_stranka_selected.id > 0)?_c('b-button',{attrs:{"disabled":_vm.hotelStrankaEditButoon.disabled || !_vm.userCanEdit,"variant":"warning"},on:{"click":function($event){$event.stopPropagation();_vm.hotelStrankaEdit_click()}}},[_vm._v(_vm._s(_vm.hotelStrankaEditButoon.label)+"\n\t\t\t\t\t\t\t"),(_vm.hotelStrankaEditButoon.progress)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1):_vm._e()],1)],1),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n\t\t\t\t\t\tLokacija\n\t\t\t\t\t")]),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"input-fk_hotel_lokacija","valid-feedback":_vm.feedback_lokacija,"state":_vm.state_lokacija}},[_c('v-select',{ref:"hotelLokacije",attrs:{"options":_vm.hotelLokacije_options,"label":"title","taggable":true,"filterable":false,"placeholder":"Izberi lokacijo ...","disabled":!_vm.userCanEdit},on:{"input":_vm.hotelLokacijeSelect_change,"search":_vm.hotelLokacijeSelect_search},model:{value:(_vm.selectedLocation),callback:function ($$v) {_vm.selectedLocation=$$v},expression:"selectedLocation"}},[_c('template',{slot:"no-options"},[_vm._v("Lokacija ni najdena")])],2)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.mode === _vm.mode_MANAGESTORITVE3),expression:"mode === mode_MANAGESTORITVE3"}]},[_c('b-col',{attrs:{"cols":"9"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n\t\t\t\t\t\tStranka\n\t\t\t\t\t")]),_vm._v(" "),_c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"1"}},[_c('b-form-group',{attrs:{"label":"External:"}},[_c('b-form-input',{attrs:{"type":"text","value":_vm.hotel_stranka_selected.external ? 'Da' : 'Ne',"disabled":""}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.hotel_stranka_selected.is_company ? 'Naziv:' : 'Ime in priimek:',"label-for":"kupec_ime"}},[_c('b-form-input',{attrs:{"id":"kupec_ime","type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.title),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "title", $$v)},expression:"hotel_stranka_selected.title"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Email:","label-for":"kupec_email"}},[_c('b-form-input',{attrs:{"id":"kupec_email","type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.email),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "email", $$v)},expression:"hotel_stranka_selected.email"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Telefonska številka:","label-for":"kupec_telefon"}},[_c('b-form-input',{attrs:{"id":"kupec_telefon","type":"text","disabled":""},model:{value:(_vm.hotel_stranka_selected.phone_number),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "phone_number", $$v)},expression:"hotel_stranka_selected.phone_number"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-vehicle","label":"Vozilo:"}},[_c('b-form-input',{attrs:{"disabled":"","id":"input-vehicle"},model:{value:(_vm.hotel_stranka_selected.vehicle),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "vehicle", $$v)},expression:"hotel_stranka_selected.vehicle"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"input-registration_number","label":"Registrska številka:"}},[_c('b-form-input',{attrs:{"disabled":""},model:{value:(_vm.hotel_stranka_selected.registration_number),callback:function ($$v) {_vm.$set(_vm.hotel_stranka_selected, "registration_number", $$v)},expression:"hotel_stranka_selected.registration_number"}})],1)],1)],1)],1)])],1),_vm._v(" "),_c('b-col',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n\t\t\t\t\t\tLokacija\n\t\t\t\t\t")]),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"input-fk_hotel_lokacija","label":"Lokacija"}},[_c('b-form-input',{attrs:{"disabled":""},model:{value:(_vm.selectedLocation),callback:function ($$v) {_vm.selectedLocation=$$v},expression:"selectedLocation"}})],1)],1)],1)],1),_vm._v(" "),(_vm.mode === _vm.mode_MANAGESTORITVE3)?_c('b-row',[_c('b-col',[_c('b-card',[_c('loading',{attrs:{"active":_vm.storitveOfHrambaTable_props.isLoading,"is-full-page":false},on:{"update:active":function($event){_vm.$set(_vm.storitveOfHrambaTable_props, "isLoading", $event)}}}),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',[_vm._v("\n\t\t\t\t\t\t\tStoritve "),_c('span',{staticClass:"ml-2"})]),_vm._v(" "),_c('div',{staticClass:"card-actions"},[((_vm.storitveOfHrambaItems[0] && _vm.storitveOfHrambaItems[0].date_take !== null) && _vm.userCanEdit)?_c('b-button',{ref:"hotelHrambaAddGive",staticClass:"m-1 seznamHotelStoritveIconStyle",attrs:{"title":"Oddaja pnevmatik","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaAddGive_click()}}},[_c('i',{staticClass:"fa fa-long-arrow-right"})]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-table',{ref:"hotelStoritveOfHrambaTable",attrs:{"responsive":"sm","striped":"","show-empty":"","hover":"","empty-text":_vm.storitveOfHrambaTable_props.empty_text,"empty-filtered-text":_vm.storitveOfHrambaTable_props.empty_filtered_text,"sort-desc":true,"current-page":_vm.storitveOfHrambaTable_props.page,"per-page":_vm.storitveOfHrambaTable_props.size,"fields":_vm.storitveOfHrambaTable_props.fields,"items":_vm.getHotelstoritveOfHrambaTable_items},on:{"row-clicked":_vm.hotelStoritveOfHrambaTable_rowClicked},scopedSlots:_vm._u([{key:"dimensions",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.getDemensionsLabel(data.item))+"\n\t\t\t\t\t\t")]}},{key:"season",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.getSeasonLabel(data.item))+"\n\t\t\t\t\t\t")]}},{key:"rims",fn:function(data){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.getRimsLabel(data.item))+"\n\t\t\t\t\t\t\t"),(data.item.rims_cover === 1 || data.item.rims_screw === 1)?_c('span',{attrs:{"title":_vm.getRimsAditionalLabel(data.item)}},[_c('i',{staticClass:"fa fa-info-circle"})]):_vm._e()]}},{key:"date",fn:function(data){return [(data.item.date_take === null)?_c('div',[(data.item.responsible_mechanic_give)?_c('span',{attrs:{"title":'Odgovorni mehanik: ' + data.item.responsible_mechanic_give}},[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.date_give))+" ")]):_c('span',{attrs:{"title":'Odgovorni mehanik ni naveden'}},[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.date_give))+" ")])]):_c('div',[(data.item.responsible_mechanic_take)?_c('span',{attrs:{"title":'Odgovorni mehanik: ' + data.item.responsible_mechanic_take}},[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.date_take))+" ")]):_c('span',{attrs:{"title":'Odgovorni mehanik ni naveden'}},[_vm._v(" "+_vm._s(_vm._f("hr_date")(data.item.date_take))+" ")])])]}},{key:"status",fn:function(data){return [_c('b-badge',{class:_vm.hotelStoritevStatus(data.item).class,attrs:{"variant":_vm.hotelStoritevStatus(data.item).variant,"title":_vm.hotelStoritevStatus(data.item).title}},[_vm._v(" "+_vm._s(_vm.hotelStoritevStatus(data.item).label))])]}},{key:"last_comment",fn:function(data){return [_c('div',{attrs:{"title":_vm.getHotelComentar(data.item).title}},[_vm._v(" "+_vm._s(_vm.getHotelComentar(data.item).label))])]}},{key:"actions",fn:function(data){return [(data.item.date_take == null && _vm.userCanEdit)?_c('b-button',{ref:"hotelHrambaAddSwitch",staticClass:"m-1 seznamHotelStoritveIconStyle",attrs:{"variant":"success","title":"Menjava pnevmatik","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaAddSwitch_click(data.item)}}},[_c('i',{staticClass:"fa fa-arrows-h"})]):_vm._e(),_vm._v(" "),(data.item.date_take == null && _vm.userCanEdit)?_c('b-button',{ref:"hotelHrambaAddTake",staticClass:"m-1 seznamHotelStoritveIconStyle",attrs:{"variant":"warning","title":"Izdaja pnevmatik","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaAddTake_click(data.item)}}},[_c('i',{staticClass:"fa fa-long-arrow-left"})]):_vm._e(),_vm._v(" "),_c('b-button',{ref:"hotelHrambaEdit",staticClass:"m-1 seznamHotelStoritveIconStyle",attrs:{"variant":"primary","title":_vm.userCanEdit ? 'Uredi storitev' : 'Poglej storitev',"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaEdit_click(data.item)}}},[_c('i',{class:_vm.userCanEdit ? 'fa fa-pencil-square-o' : 'fa fa-search-plus'})]),_vm._v(" "),_c('b-button',{ref:'hotelStoritevPdfExportButton-' + data.item.id,staticClass:"m-1 seznamHotelStoritveIconStyle",attrs:{"data-style":"zoom-in","size":"sm","variant":"info","title":"Prenesi pdf"},on:{"click":function($event){$event.stopPropagation();_vm.exportHotelStoritev(data.item)}}},[_c('i',{staticClass:"fa fa fa-file-pdf-o ladda-label"})])]}}])}),_vm._v(" "),_c('nav',{staticClass:"nav"},[_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.storitveOfHrambaTable_props.total,"per-page":_vm.storitveOfHrambaTable_props.size,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.storitveOfHrambaTable_props.page),callback:function ($$v) {_vm.$set(_vm.storitveOfHrambaTable_props, "page", $$v)},expression:"storitveOfHrambaTable_props.page"}})],1),_vm._v(" "),_c('b-col',[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.storitveOfHrambaTable_props.total))])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.storitveOfHrambaTable_props.options_numRowsOnPage},model:{value:(_vm.storitveOfHrambaTable_props.size),callback:function ($$v) {_vm.$set(_vm.storitveOfHrambaTable_props, "size", $$v)},expression:"storitveOfHrambaTable_props.size"}})],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.mode === _vm.mode_UNKNOWN0)?_c('div',[_vm._v("\n\t\t\tNeznan način\n\t\t")]):_vm._e(),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type,"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('edit-hotel-storitev-modal',{ref:"editHotelStoritevModal",attrs:{"hotelStoritevDistincManufacturers":_vm.hotelStoritevDistincManufacturers},on:{"emit_success":_vm.emit_edit_hotel_storitev,"emit_comment_added":_vm.emit_comment_added_to_hotel_storitev}}),_vm._v(" "),_c('edit-hotel-stranka-modal',{ref:"editHotelStrankaModal",on:{"emit_success":_vm.emit_edit_hotel_stranka}})],1)}
var staticRenderFns = []


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotelLokacijeModal_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c77c9c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotelLokacijeModal_vue__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1079)
  __webpack_require__(1080)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c77c9c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotelLokacijeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c77c9c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotelLokacijeModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c77c9c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HotelLokacijeModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"modal-primary",attrs:{"title":_vm.title,"size":_vm.modalSize},on:{"hidden":_vm.clearModalData},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var cancel = ref.cancel;
return [_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"ma_pos",attrs:{"align-self":"end"}},[_c('b-button',{staticStyle:{"margin-right":"5px"},attrs:{"variant":"secondary"},on:{"click":function($event){cancel()}}},[_vm._v("Prekliči")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.onOkModal()}}},[_vm._v("Zapri")])],1)],1)],1)]}}])},[_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"header":"Dodajanje lokacije"}},[_c('loading',{attrs:{"active":_vm.addHotelLocationButton.progress,"is-full-page":false},on:{"update:active":function($event){_vm.$set(_vm.addHotelLocationButton, "progress", $event)}}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"invalid-feedback":_vm.invalidFeedback_title,"state":_vm.state_title}},[_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_c('b-form-input',{attrs:{"disabled":_vm.formDisabled,"id":"input-title1","type":"text"},model:{value:(_vm.newHotelLokacija.title),callback:function ($$v) {_vm.$set(_vm.newHotelLokacija, "title", $$v)},expression:"newHotelLokacija.title"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{ref:"hotelLokacijaAdd",staticClass:"m-1",attrs:{"disabled":_vm.addHotelLocationButton.disabled || _vm.formDisabled || !_vm.state_title,"title":_vm.hotelLokacijaAddTitle,"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelLokacijaAdd_click()}}},[_c('i',{staticClass:"fa fa-plus"})])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.messageHotelLocationsAdd.type,"show":_vm.messageHotelLocationsAdd.text && _vm.messageHotelLocationsAdd.text !== ''}},[_vm._v(_vm._s(_vm.messageHotelLocationsAdd.text))])],1)],1)],1),_vm._v(" "),(!_vm.formDisabled)?_c('b-row',[_c('b-col',[_c('b-card',[_c('loading',{attrs:{"active":_vm.hotelLokacijeTable_props.isLoading,"is-full-page":false},on:{"update:active":function($event){_vm.$set(_vm.hotelLokacijeTable_props, "isLoading", $event)}}}),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n\t\t\t\t\t\tSeznam lokacij\n\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Osveži tabelo"},on:{"click":function($event){$event.stopPropagation();return _vm.hotelLokacijeTableRefresh_click($event)}}},[_c('i',{staticClass:"icon-refresh"})]),_vm._v(" "),_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Odstrani filtre"},on:{"click":function($event){$event.stopPropagation();return _vm.hotelLokacijeTableToggleFilter_click($event)}}},[_c('i',{staticClass:"icon-close"})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.messageHotelLocationsTable.text === null),expression:"messageHotelLocationsTable.text === null"}]},[_c('b-table',{ref:"hotelLokacijeTable",attrs:{"responsive":"sm","striped":"","show-empty":"","hover":"","empty-text":_vm.hotelLokacijeTable_props.empty_text,"empty-filtered-text":_vm.hotelLokacijeTable_props.empty_filtered_text,"sort-desc":true,"fields":_vm.hotelLokacijeTable_props.fields,"current-page":_vm.hotelLokacijeTable_props.page,"per-page":_vm.hotelLokacijeTable_props.size,"items":_vm.hotelLokacijeTable_items},on:{"row-clicked":_vm.hotelLokacijeTable_rowClicked},scopedSlots:_vm._u([{key:"status",fn:function(data){return [_c('b-badge',{class:_vm.hotelLokacijaStatus(data.item).class,attrs:{"variant":_vm.hotelLokacijaStatus(data.item).variant,"title":_vm.hotelLokacijaStatus(data.item).title}},[_vm._v(" "+_vm._s(_vm.hotelLokacijaStatus(data.item).label))])]}},{key:"actions",fn:function(data){return [(data.item.hotel_hrambe_on_location && data.item.hotel_hrambe_on_location.length === 0)?_c('b-button',{ref:"hotelHrambaEdit",staticClass:"m-1 seznamHotelHrambIconStyle",attrs:{"title":"Odstrani lokacjio","variant":"danger","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelLokacijaRemove_click(data.item)}}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e()]}}])},[_c('template',{slot:"top-row"},[_c('td'),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.hotelLokacijeTableTextFilter_change},model:{value:(_vm.hotelLokacijeTable_props.inputFilter.title),callback:function ($$v) {_vm.$set(_vm.hotelLokacijeTable_props.inputFilter, "title", $$v)},expression:"hotelLokacijeTable_props.inputFilter.title"}})],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])],2),_vm._v(" "),_c('nav',{staticClass:"nav"},[_c('b-row',{attrs:{"aligin-":""}},[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.hotelLokacijeTable_props.total,"per-page":_vm.hotelLokacijeTable_props.size,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.hotelLokacijeTable_props.page),callback:function ($$v) {_vm.$set(_vm.hotelLokacijeTable_props, "page", $$v)},expression:"hotelLokacijeTable_props.page"}})],1),_vm._v(" "),_c('b-col',[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.hotelLokacijeTable_props.total))])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.hotelLokacijeTable_props.options_numRowsOnPage},model:{value:(_vm.hotelLokacijeTable_props.size),callback:function ($$v) {_vm.$set(_vm.hotelLokacijeTable_props, "size", $$v)},expression:"hotelLokacijeTable_props.size"}})],1)],1)],1)],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.messageHotelLocationsTable.type,"show":_vm.messageHotelLocationsTable.text && _vm.messageHotelLocationsTable.text !== ''}},[_vm._v(_vm._s(_vm.messageHotelLocationsTable.text))]),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.messageHotelLocationsRemove.type,"show":_vm.messageHotelLocationsRemove.text && _vm.messageHotelLocationsRemove.text !== ''}},[_vm._v(_vm._s(_vm.messageHotelLocationsRemove.text))])],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-alert',{attrs:{"variant":_vm.message.type,"show":_vm.message.text && _vm.message.text !== ''}},[_vm._v(_vm._s(_vm.message.text))])],1)}
var staticRenderFns = []


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExternalFilterDropdown_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf8145c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExternalFilterDropdown_vue__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1083)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bf8145c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExternalFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf8145c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExternalFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf8145c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExternalFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active && !_vm.allSelected},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t\t"+_vm._s(item.label)+"\n\t\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeasonFilterDropdown_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bca150_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeasonFilterDropdown_vue__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1086)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeasonFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bca150_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeasonFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bca150_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeasonFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_c('b-dropdown-header',[_vm._v("Sezona")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusHotelHrambaFilterDropdown_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e956f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusHotelHrambaFilterDropdown_vue__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1089)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55e956f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusHotelHrambaFilterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e956f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusHotelHrambaFilterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e956f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusHotelHrambaFilterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"text":_vm.selectedTitle}},[_vm._l((_vm.items),function(item){return _c('b-dropdown-item',{key:item.value,attrs:{"active":item.active && !_vm.allSelected},on:{"click":function($event){_vm.click_Item(item)}}},[_vm._v("\n\t\t\t"+_vm._s(item.label)+"\n\t\t")])}),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active":_vm.allSelected},on:{"click":_vm.click_Vse}},[_vm._v(_vm._s(_vm.defaultItemLabel))])],2)}
var staticRenderFns = []


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('loading',{attrs:{"active":_vm.hotelHrambeTable_props.isLoading,"is-full-page":false},on:{"update:active":function($event){_vm.$set(_vm.hotelHrambeTable_props, "isLoading", $event)}}}),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n\t\t\t\t\t\tSeznam hramb\n\t\t\t\t\t\t"),_c('div',{staticClass:"card-actions"},[(!_vm.confirmationActive)?_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Kontrola"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleConfirmationActive($event)}}},[_c('i',{staticClass:"icon-eyeglass"})]):_vm._e(),_vm._v(" "),(_vm.confirmationActive)?_c('b-link',{class:_vm.selectedItems.length > 0 ? 'text-success btnConfirmStatus' : 'text-danger btnConfirmStatus'},[_vm._v(_vm._s(_vm.selectedItems.length > 0 ? 'Število izbranih hramb ' + _vm.selectedItems.length : 'Izbrana mora biti vsaj 1 hramba'))]):_vm._e(),_vm._v(" "),(_vm.confirmationActive && _vm.selectedItems.length > 0)?_c('b-link',{staticClass:"btn btn-primary text-success",attrs:{"title":"Potrdi kontrolo"},on:{"click":function($event){$event.preventDefault();return _vm.confirmHotelHrambe($event)}}},[_c('i',{staticClass:"icon-check"})]):_vm._e(),_vm._v(" "),(_vm.confirmationActive)?_c('b-link',{staticClass:"btn btn-primary text-danger",attrs:{"title":"Ponastavi kontrolo"},on:{"click":function($event){$event.preventDefault();return _vm.resetConfirmations($event)}}},[_c('i',{staticClass:"icon-trash"})]):_vm._e(),_vm._v(" "),(_vm.confirmationActive)?_c('b-link',{staticClass:"btn btn-primary text-danger",attrs:{"title":"Prekliči kontrolo"},on:{"click":function($event){$event.preventDefault();return _vm.toggleConfirmationActive($event)}}},[_c('i',{staticClass:"icon-close"})]):_vm._e(),_vm._v(" "),(_vm.userCanEdit && !_vm.confirmationActive)?_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Lokacije"},on:{"click":function($event){$event.stopPropagation();return _vm.hotelHrambeTableLokacije_click($event)}}},[_c('i',{staticClass:"icon-location-pin"})]):_vm._e(),_vm._v(" "),(!_vm.confirmationActive)?_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Osveži tabelo"},on:{"click":function($event){$event.stopPropagation();return _vm.hotelHrambeTableRefresh_click($event)}}},[_c('i',{staticClass:"icon-refresh"})]):_vm._e(),_vm._v(" "),(!_vm.confirmationActive)?_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Odstrani filtre"},on:{"click":function($event){$event.stopPropagation();return _vm.hotelHrambeTableToggleFilter_click($event)}}},[_c('i',{staticClass:"icon-close"})]):_vm._e(),_vm._v(" "),(_vm.userCanEdit && !_vm.confirmationActive)?_c('b-link',{staticClass:"card-header-action btn-setting",attrs:{"title":"Dodaj hrambo"},on:{"click":function($event){$event.stopPropagation();return _vm.addHotelHotelHramba_click($event)}}},[_c('i',{staticClass:"icon-plus"})]):_vm._e()],1)]),_vm._v(" "),_c('b-table',{ref:"hotelHrambeTable",attrs:{"responsive":"sm","striped":"","show-empty":"","hover":"","empty-text":_vm.hotelHrambeTable_props.empty_text,"empty-filtered-text":_vm.hotelHrambeTable_props.empty_filtered_text,"sort-desc":false,"fields":_vm.hotelHrambeTable_props.fields,"current-page":_vm.hotelHrambeTable_props.page,"per-page":_vm.hotelHrambeTable_props.size,"items":_vm.hotelHrambeTable_items,"tbody-tr-class":_vm.rowClass},on:{"row-clicked":_vm.hotelHrambeTable_rowClicked},scopedSlots:_vm._u([{key:"selected",fn:function(data){return [_c('b-form-checkbox',{attrs:{"disabled":data.item.date_confirmed != null,"checked":data.item.date_confirmed != null ? true : data.item.selected},on:{"change":function($event){_vm.selectItem_change(data.item)}}})]}},{key:"id",fn:function(data){return [_c('b',[_vm._v(_vm._s(data.item.id))])]}},{key:"hotel_stranka_external",fn:function(data){return [(data.item.hotel_stranka_external === 0)?_c('div',[_vm._v("Ne")]):(data.item.hotel_stranka_external === 1)?_c('div',[_vm._v("Da")]):_c('div',[_vm._v(" / ")])]}},{key:"hotel_storitev_season",fn:function(data){return [(data.item.hotel_storitev_season !== null)?_c('div',[_vm._v(_vm._s(_vm.getSeasonLabel(data.item.hotel_storitev_season)))]):_c('div',[_vm._v("/")])]}},{key:"hotel_storitev_date_give",fn:function(data){return [(data.item.hotel_storitev_date_give !== null)?_c('div',[_vm._v(_vm._s(_vm._f("hr_date")(data.item.hotel_storitev_date_give)))]):_c('div',[_vm._v("/")])]}},{key:"hotel_storitev_dimensions",fn:function(data){return [(data.item.hotel_storitev_dimensions !== null)?_c('div',[_vm._v(_vm._s(_vm.getDemensionsLabel(data.item.hotel_storitev_dimensions)))]):_c('div',[_vm._v("/")])]}},{key:"status",fn:function(data){return [_c('b-badge',{class:_vm.hotelHrambaStatus(data.item).class,attrs:{"variant":_vm.hotelHrambaStatus(data.item).variant,"title":_vm.hotelHrambaStatus(data.item).title}},[_vm._v(" "+_vm._s(_vm.hotelHrambaStatus(data.item).label))])]}},{key:"user_confirmed",fn:function(data){return [(data.item.user_confirmed != null)?_c('div',[_vm._v(_vm._s(data.item.user_confirmed_first_name)+" "+_vm._s(data.item.user_confirmed_last_name))]):_vm._e()]}},{key:"actions",fn:function(data){return [_c('div',[(_vm.userCanEdit && data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka && data.item.hotel_storitev_id !== null)?_c('b-button',{ref:"hotelHrambaAddSwitch",staticClass:"m-1 seznamHotelHrambIconStyle",attrs:{"title":"Menjava pnevmatik","variant":"success","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaAddSwitch_click(data.item)}}},[_c('i',{staticClass:"fa fa-arrows-h"})]):_vm._e(),_vm._v(" "),(_vm.userCanEdit && data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka && data.item.hotel_storitev_id !== null)?_c('b-button',{ref:"hotelHrambaAddTake",staticClass:"m-1 seznamHotelHrambIconStyle",attrs:{"title":"Izdaja pnevmatik","variant":"warning","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaAddTake_click(data.item)}}},[_c('i',{staticClass:"fa fa-long-arrow-left"})]):_vm._e(),_vm._v(" "),(_vm.userCanEdit && data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka && data.item.hotel_storitev_id === null)?_c('b-button',{ref:"hotelHrambaAddGive",staticClass:"m-1 seznamHotelHrambIconStyle lightWarning",attrs:{"title":"Oddaja pnevmatik","variant":"warning","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaAddGive_click(data.item)}}},[_c('i',{staticClass:"fa fa-long-arrow-right"})]):_vm._e(),_vm._v(" "),(data.item.fk_hotel_lokacija && data.item.fk_hotel_stranka)?_c('b-button',{ref:"hotelHrambaManageStoritve",staticClass:"m-1 seznamHotelHrambIconStyle",attrs:{"title":_vm.userCanEdit ? 'Uredi storitve' : 'Poglej storitve',"variant":"info","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaManageStorive_click(data.item)}}},[_c('i',{staticClass:"fa fa-cog"})]):_vm._e(),_vm._v(" "),_c('b-button',{ref:"hotelHrambaEdit",staticClass:"m-1 seznamHotelHrambIconStyle",attrs:{"title":_vm.userCanEdit ? 'Uredi hrambo' : 'Poglej hrambo',"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.hotelHrambaEdit_click(data.item)}}},[_c('i',{class:_vm.userCanEdit ? 'fa fa-pencil-square-o' : 'fa fa-search-plus'})])],1)]}}])},[_c('template',{slot:"top-row"},[(_vm.confirmationActive)?_c('td'):_vm._e(),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"number"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.id),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "id", $$v)},expression:"hotelHrambeTable_props.inputFilter.id"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.title),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "title", $$v)},expression:"hotelHrambeTable_props.inputFilter.title"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.registration_number),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "registration_number", $$v)},expression:"hotelHrambeTable_props.inputFilter.registration_number"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.vehicle),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "vehicle", $$v)},expression:"hotelHrambeTable_props.inputFilter.vehicle"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"text"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.hotelLokacija),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "hotelLokacija", $$v)},expression:"hotelHrambeTable_props.inputFilter.hotelLokacija"}})],1),_vm._v(" "),_c('td',[_c('external-filter-dropdown',{ref:"externalFilterDropdown",on:{"input":_vm.hotelHrambeTableFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.external),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "external", $$v)},expression:"hotelHrambeTable_props.inputFilter.external"}})],1),_vm._v(" "),_c('td',[_c('season-filter-dropdown',{ref:"seasonDropdown",on:{"change":_vm.on_seasonFilterChange}})],1),_vm._v(" "),_c('td',[_c('datum-filter-dropdown',{attrs:{"noFutureValues":true},on:{"input":_vm.hotelHrambeTableFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.datumStoritve),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "datumStoritve", $$v)},expression:"hotelHrambeTable_props.inputFilter.datumStoritve"}})],1),_vm._v(" "),_c('td',[_c('b-form',{attrs:{"inline":""}},[_c('b-form-input',{staticClass:"dimensionsWidthInputFilter mr-1 p-1",attrs:{"type":"number"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.dimensionsWidth),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "dimensionsWidth", $$v)},expression:"hotelHrambeTable_props.inputFilter.dimensionsWidth"}}),_vm._v("/\n\t\t\t\t\t\t\t\t\t"),_c('b-form-input',{staticClass:"dimensionsHeightDiameterInputFilter mr-1 ml-1 p-1",attrs:{"type":"number"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.dimensionsHeight),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "dimensionsHeight", $$v)},expression:"hotelHrambeTable_props.inputFilter.dimensionsHeight"}}),_vm._v("R\n\t\t\t\t\t\t\t\t\t"),_c('b-form-input',{staticClass:"dimensionsHeightDiameterInputFilter ml-1 p-1",attrs:{"type":"number"},on:{"input":_vm.hotelHrambeTableTextFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.dimensionsDiameter),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "dimensionsDiameter", $$v)},expression:"hotelHrambeTable_props.inputFilter.dimensionsDiameter"}})],1)],1),_vm._v(" "),_c('td',[_c('status-hotel-hramba-dropdown',{ref:"statusHotelHrambaFilterDropdown",on:{"input":_vm.hotelHrambeTableFilter_change},model:{value:(_vm.hotelHrambeTable_props.inputFilter.statusHotelHramba),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props.inputFilter, "statusHotelHramba", $$v)},expression:"hotelHrambeTable_props.inputFilter.statusHotelHramba"}})],1),_vm._v(" "),(!_vm.confirmationActive)?_c('td'):_vm._e()])],2),_vm._v(" "),_c('nav',{staticClass:"nav"},[_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.hotelHrambeTable_props.total,"per-page":_vm.hotelHrambeTable_props.size,"prev-text":"Prejšnja","next-text":"Naslednja","hide-goto-end-buttons":""},model:{value:(_vm.hotelHrambeTable_props.page),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props, "page", $$v)},expression:"hotelHrambeTable_props.page"}})],1),_vm._v(" "),_c('b-col',[_c('a',{staticClass:"page-link rows_total"},[_vm._v("Št. vrstic: "+_vm._s(_vm.hotelHrambeTable_props.total))])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.hotelHrambeTable_props.options_numRowsOnPage},model:{value:(_vm.hotelHrambeTable_props.size),callback:function ($$v) {_vm.$set(_vm.hotelHrambeTable_props, "size", $$v)},expression:"hotelHrambeTable_props.size"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('edit-hotel-hramba-modal',{ref:"editHotelHrambaModal",attrs:{"hotelStranke":_vm.hotelStranke_options,"hotelStoritevDistincManufacturers":_vm.hotelStoritevDistincManufacturers},on:{"emit_success":_vm.emit_edit_hotel_hramba,"emit_hotelStranke_changed":_vm.emit_hotelStranke_changed,"emit_hotelStoritev_changed":_vm.emit_hotelStoritev_changed}}),_vm._v(" "),_c('hotel-lokacije-modal',{ref:"hotelLokacijeModal"}),_vm._v(" "),_c('edit-hotel-storitev-modal',{ref:"editHotelStoritevModal",attrs:{"hotelStoritevDistincManufacturers":_vm.hotelStoritevDistincManufacturers},on:{"emit_success":_vm.emit_edit_hotel_storitev}}),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],1)}
var staticRenderFns = []


/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageBox_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b633aee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageBox_vue__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b633aee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageBox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b633aee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageBox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger alert-dismissible fade show mt-4",attrs:{"role":"alert"}},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"},on:{"click":_vm.onClose}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}
var staticRenderFns = []


/***/ }),
/* 1094 */,
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortName__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hrDate__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hrTime__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hrDateTime__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hrMoney__ = __webpack_require__(1100);






/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		Vue.filter('short_name', __WEBPACK_IMPORTED_MODULE_0__shortName__["a" /* default */]);
		Vue.filter('hr_date', __WEBPACK_IMPORTED_MODULE_1__hrDate__["a" /* default */]);
		Vue.filter('hr_time', __WEBPACK_IMPORTED_MODULE_2__hrTime__["a" /* default */]);
		Vue.filter('hr_datetime', __WEBPACK_IMPORTED_MODULE_3__hrDateTime__["a" /* default */]);
		Vue.filter('hr_money', __WEBPACK_IMPORTED_MODULE_4__hrMoney__["a" /* default */]);
	}
});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shortName;
function shortName(value) {
	if (value && value !== null && value !== '') {
		if (value.length > 2) {
			var pos = value.indexOf(' ');
			if (pos > -1 && pos + 2 < value.length) {
				return value.substr(0, 1) + value.substr(pos + 1, 1);
			} else {
				return value.substr(0, 2);
			}
		} else {
			return value;
		}
	} else {
		return '--';
	}
}

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hrDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_js__ = __webpack_require__(12);


function hrDate(value) {
	if (value && value !== null && value !== '') {
		return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(value, __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].viewDtFormat);
	} else {
		return '';
	}
}

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hrTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_js__ = __webpack_require__(12);


function hrTime(value) {
	if (value && value !== null && value !== '') {
		return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(value, __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].viewTimeFormat);
	} else {
		return '';
	}
}

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hrDateTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_js__ = __webpack_require__(12);


function hrDateTime(value) {
	if (value && value !== null && value !== '') {
		return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(value, __WEBPACK_IMPORTED_MODULE_1__settings_js__["a" /* default */].hrsDtFormat);
	} else {
		return '';
	}
}

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hrMoney;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);


function hrMoney(value) {
	var v = 0;
	if (value && value !== null && value !== '') {
		v = Number(value);
	}
	return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(v).format('0,0.00 $');
}

/***/ }),
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1ba95e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(3);
function injectStyle (context) {
  __webpack_require__(1105)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1ba95e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1ba95e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vue__time-picker time-picker"},[_c('input',{staticClass:"display-time",class:[_vm.inputClass, {'disabled': _vm.disabled}],attrs:{"type":"text","id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder || _vm.formatString,"disabled":_vm.disabled,"readonly":""},domProps:{"value":_vm.inputIsEmpty ? null : _vm.displayTime},on:{"click":_vm.toggleDropdown}}),_vm._v(" "),(!_vm.showDropdown && _vm.showClearBtn)?_c('span',{staticClass:"clear-btn",on:{"click":_vm.clearTime}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",on:{"click":_vm.toggleDropdown}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"select-list"},[_c('ul',{staticClass:"hours"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourType)}}),_vm._v(" "),_vm._l((_vm.hours),function(hr,hIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabledHour(hr)))?_c('li',{key:hIndex,class:{active: _vm.hour === hr},attrs:{"disabled":_vm.isDisabledHour(hr)},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){_vm.select('hour', hr)}}}):_vm._e()]})],2),_vm._v(" "),_c('ul',{staticClass:"minutes"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteType)}}),_vm._v(" "),_vm._l((_vm.minutes),function(m,mIndex){return _c('li',{key:mIndex,class:{active: _vm.minute === m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){_vm.select('minute', m)}}})})],2),_vm._v(" "),(_vm.secondType)?_c('ul',{staticClass:"seconds"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondType)}}),_vm._v(" "),_vm._l((_vm.seconds),function(s,sIndex){return _c('li',{key:sIndex,class:{active: _vm.second === s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){_vm.select('second', s)}}})})],2):_vm._e(),_vm._v(" "),(_vm.apmType)?_c('ul',{staticClass:"apms"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmType)}}),_vm._v(" "),_vm._l((_vm.apms),function(a,aIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && _vm.has[a.toLowerCase()]))?_c('li',{key:aIndex,class:{active: _vm.apm === a},attrs:{"disabled":!_vm.has[a.toLowerCase()]},domProps:{"textContent":_vm._s(a)},on:{"click":function($event){_vm.select('apm', a)}}}):_vm._e()]})],2):_vm._e()])])])}
var staticRenderFns = []


/***/ }),
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[585]);


// WEBPACK FOOTER //
// static/js/app.15d967051a38e711e00a.js